var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var _a, _emitter;
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import clsx from "clsx";
import React, { useEffect, useState, useRef, useMemo, createContext, useCallback, useContext, Fragment as Fragment$1 } from "react";
import require$$0, { createPortal } from "react-dom";
import BN from "bn.js";
import numberToBN from "number-to-bn";
import { Keccak } from "sha3";
import { Decimal } from "decimal.js";
import utf8 from "utf8";
import { TypedDataUtils, SignTypedDataVersion } from "@metamask/eth-sig-util";
import { Buffer as Buffer2 } from "buffer";
import { ActionErrorCode, ConnectDID, EnumRequestMethods } from "connect-did-sdk";
import GraphemeSplitter from "grapheme-splitter";
import { isMobileOnly, isMobile, isAndroid } from "react-device-detect";
import abcCopy from "abc-copy";
import UAParser from "ua-parser-js";
import { TransitionGroup, Transition } from "react-transition-group";
import { UNMOUNTED, EXITED, EXITING, ENTERED, ENTERING } from "react-transition-group/Transition";
import { proxy, snapshot, useSnapshot, ref } from "valtio";
import { merge, debounce, cloneDeep } from "lodash-es";
import Axios from "axios";
import Torus from "@toruslabs/torus-embed";
import Emittery from "emittery";
import { watchAccount, watchNetwork, signTypedData, signMessage, disconnect, connect, getNetwork, switchNetwork, sendTransaction } from "@wagmi/core";
import { parseUnits } from "viem";
import QR from "styled-qr-code";
import { Menu, Transition as Transition$1 } from "@headlessui/react";
import { useQuery, useMutation, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Color from "color";
import { CustomError as CustomError$1 } from "ts-custom-error";
const theme = "";
function CloseIcon(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.1098 11C1.80283 11 1.53916 10.8934 1.31877 10.6801C1.10626 10.4589 1 10.1943 1 9.88626C1 9.5782 1.11019 9.31754 1.33058 9.10427L4.41204 6L1.33058 2.91943C1.11019 2.69036 1 2.4297 1 2.13744C1 1.81359 1.10626 1.54897 1.31877 1.3436C1.53916 1.13033 1.80283 1.0237 2.1098 1.0237C2.41677 1.0237 2.68044 1.12638 2.90083 1.33175L5.9941 4.42417L9.09917 1.33175C9.31956 1.11058 9.58323 1 9.8902 1C10.1972 1 10.4569 1.11058 10.6694 1.33175C10.8898 1.54502 11 1.80569 11 2.11374C11 2.4139 10.8898 2.67852 10.6694 2.90758L7.57615 6L10.6576 9.09242C10.878 9.29779 10.9882 9.5624 10.9882 9.88626C10.9882 10.1943 10.878 10.4589 10.6576 10.6801C10.4451 10.8934 10.1814 11 9.86659 11C9.54388 11 9.27627 10.8934 9.06375 10.6801L5.9941 7.58768L2.93625 10.6801C2.70799 10.8934 2.43251 11 2.1098 11Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function ArrowLeftIcon(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.84775 0.351472C6.37912 -0.117157 5.61932 -0.117157 5.15069 0.351472L0.350691 5.15147C-0.117938 5.6201 -0.117938 6.3799 0.350691 6.84853L5.15069 11.6485C5.61932 12.1172 6.37912 12.1172 6.84775 11.6485C7.31638 11.1799 7.31638 10.4201 6.84775 9.95147L2.89628 6L6.84775 2.04853C7.31638 1.5799 7.31638 0.820101 6.84775 0.351472Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function LoadingIcon(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon animation-rotate-360-deg", props.className),
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 1.66667C3.15905 1.66667 1.66667 3.15905 1.66667 5C1.66667 6.84095 3.15905 8.33333 5 8.33333C6.84095 8.33333 8.33333 6.84095 8.33333 5C8.33333 4.53976 8.70643 4.16667 9.16667 4.16667C9.6269 4.16667 10 4.53976 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C5.46024 0 5.83333 0.373096 5.83333 0.833333C5.83333 1.29357 5.46024 1.66667 5 1.66667Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function ArrowRightTopIcon(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.9932 8.39249L12 1.92833C12 1.65074 11.9136 1.42776 11.7408 1.25939C11.5725 1.08646 11.3474 1 11.0655 1H4.60573C4.34197 1 4.12369 1.08646 3.95089 1.25939C3.77808 1.42776 3.69168 1.63026 3.69168 1.86689C3.69168 2.10353 3.78035 2.30375 3.95771 2.46758C4.13506 2.6314 4.34652 2.71331 4.59209 2.71331H6.96589L9.23738 2.6314L8.09823 3.64164L2.29332 9.45051C2.09777 9.65074 2 9.86917 2 10.1058C2 10.2605 2.04093 10.4061 2.12278 10.5427C2.20919 10.6746 2.3206 10.7838 2.45703 10.8703C2.59345 10.9568 2.74125 11 2.90041 11C3.13688 11 3.35289 10.9044 3.54843 10.7133L9.35334 4.89761L10.3765 3.75768L10.281 5.95563V8.40614C10.281 8.65643 10.3606 8.87031 10.5198 9.04778C10.6835 9.22071 10.8859 9.30717 11.1269 9.30717C11.3633 9.30717 11.5657 9.22071 11.734 9.04778C11.9068 8.87031 11.9932 8.65188 11.9932 8.39249Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function DeviceIcon(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "72",
      height: "72",
      viewBox: "0 0 72 72",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "72", height: "72", rx: "24", fill: "#00CB4C" }),
        /* @__PURE__ */ jsx("rect", { x: "0.5", y: "0.5", width: "71", height: "71", rx: "23.5", stroke: "#526279", strokeOpacity: "0.1" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M31.9746 34.3196C30.222 34.3196 28.6181 33.8501 27.1628 32.9112C25.7232 31.9724 24.5653 30.7127 23.689 29.1323C22.8127 27.5518 22.3746 25.7836 22.3746 23.8276C22.3746 21.9186 22.8127 20.1817 23.689 18.6169C24.5653 17.0521 25.731 15.8081 27.1863 14.8848C28.6416 13.9616 30.2377 13.5 31.9746 13.5C33.7271 13.5 35.331 13.9616 36.7863 14.8848C38.2416 15.7924 39.4073 17.0286 40.2836 18.5934C41.1599 20.1582 41.598 21.8873 41.598 23.7807C41.598 25.7523 41.1599 27.5362 40.2836 29.1323C39.423 30.7127 38.265 31.9724 36.8098 32.9112C35.3545 33.8501 33.7428 34.3196 31.9746 34.3196ZM16.577 56.3362C15.1531 56.3362 14.0342 56.0076 13.2205 55.3504C12.4068 54.6932 12 53.7934 12 52.6511C12 51.1489 12.4694 49.5763 13.4083 47.9333C14.3472 46.2746 15.6851 44.7254 17.422 43.2858C19.1746 41.8462 21.2792 40.6804 23.7359 39.7885C26.1927 38.8809 28.9389 38.4271 31.9746 38.4271C34.1183 38.4271 36.1056 38.6775 37.9364 39.1782C39.7829 39.6633 41.4416 40.3127 42.9125 41.1264C43.4288 43.2545 44.532 44.9993 46.222 46.3606V54.5289C46.222 55.1548 46.3394 55.7572 46.5741 56.3362H16.577ZM52.6298 30.165C53.9912 30.165 55.2274 30.4936 56.3384 31.1509C57.4494 31.8081 58.3335 32.6922 58.9907 33.8032C59.6636 34.9142 60 36.1425 60 37.4883C60 38.9748 59.5775 40.3127 58.7325 41.502C57.9032 42.6912 56.7218 43.6457 55.1883 44.3655L57.5589 46.7362C57.778 46.9709 57.8875 47.2291 57.8875 47.5108C57.8875 47.7924 57.7858 48.035 57.5824 48.2384L55.0474 50.7264L56.7609 52.5103C56.9643 52.7137 57.0738 52.9562 57.0895 53.2379C57.1051 53.5196 57.0034 53.7621 56.7843 53.9655L53.3809 57.3924C53.1619 57.5958 52.9271 57.6897 52.6768 57.6741C52.4264 57.6741 52.2152 57.5958 52.043 57.4394L50.0714 55.5616C49.7741 55.2643 49.6254 54.9201 49.6254 54.5289V44.2716C48.2954 43.677 47.2313 42.7773 46.4332 41.5724C45.6509 40.3518 45.2597 38.9905 45.2597 37.4883C45.2597 36.1425 45.5883 34.9142 46.2455 33.8032C46.9027 32.6922 47.7868 31.8081 48.8978 31.1509C50.0088 30.4936 51.2528 30.165 52.6298 30.165ZM52.6064 33.498C52.0117 33.498 51.4954 33.7171 51.0572 34.1553C50.6347 34.5778 50.4235 35.0863 50.4235 35.6809C50.4235 36.2756 50.6425 36.7919 51.0807 37.2301C51.5188 37.6526 52.0274 37.8638 52.6064 37.8638C53.201 37.8638 53.7095 37.6526 54.132 37.2301C54.5702 36.7919 54.7892 36.2756 54.7892 35.6809C54.7892 35.0863 54.5702 34.5778 54.132 34.1553C53.7095 33.7171 53.201 33.498 52.6064 33.498Z",
            fill: "#F9FBFC"
          }
        )
      ]
    }
  );
}
function DisconnectIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", className),
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: [
        /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_2282_156336)", children: /* @__PURE__ */ jsx(
          "path",
          {
            d: "M7.25 6.75L3.75 10M3.75 10L7.25 13.25M3.75 10H12.25M13.75 16.25H14.25C14.7804 16.25 15.2891 16.0393 15.6642 15.6642C16.0393 15.2891 16.25 14.7804 16.25 14.25V5.75C16.25 5.21957 16.0393 4.71086 15.6642 4.33579C15.2891 3.96071 14.7804 3.75 14.25 3.75H13.75",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ) }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2282_156336", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white", transform: "translate(2 2)" }) }) })
      ]
    }
  );
}
function InfoIcon(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8 16C9.09993 16 10.1328 15.7907 11.0986 15.3722C12.0644 14.9591 12.9148 14.385 13.6499 13.6499C14.385 12.9148 14.9591 12.0644 15.3722 11.0986C15.7907 10.1328 16 9.09993 16 8C16 6.90543 15.7907 5.87525 15.3722 4.90946C14.9591 3.94366 14.3823 3.09323 13.6419 2.35815C12.9068 1.62307 12.0563 1.04628 11.0905 0.627767C10.1247 0.209256 9.09188 0 7.99195 0C6.90275 0 5.87525 0.209256 4.90946 0.627767C3.94366 1.04628 3.09054 1.62307 2.3501 2.35815C1.61502 3.09323 1.03823 3.94366 0.619718 4.90946C0.206573 5.87525 0 6.90543 0 8C0 9.09993 0.209256 10.1328 0.627767 11.0986C1.04628 12.0644 1.62307 12.9148 2.35815 13.6499C3.09323 14.385 3.94366 14.9591 4.90946 15.3722C5.87525 15.7907 6.90543 16 8 16ZM8 14.1006C7.15761 14.1006 6.3662 13.9423 5.62575 13.6258C4.89068 13.3146 4.24413 12.8799 3.68612 12.3219C3.1281 11.7639 2.69081 11.1174 2.37425 10.3823C2.06304 9.64185 1.90744 8.84775 1.90744 8C1.90744 7.15761 2.06304 6.36888 2.37425 5.6338C2.69081 4.89336 3.1281 4.24413 3.68612 3.68612C4.24413 3.1281 4.89068 2.69349 5.62575 2.38229C6.36083 2.06573 7.14956 1.90744 7.99195 1.90744C8.84507 1.90744 9.63917 2.06573 10.3742 2.38229C11.1093 2.69349 11.7559 3.1281 12.3139 3.68612C12.8773 4.24413 13.3146 4.89336 13.6258 5.6338C13.9423 6.36888 14.1006 7.15761 14.1006 8C14.106 8.84775 13.9504 9.64185 13.6338 10.3823C13.3172 11.1174 12.8799 11.7639 12.3219 12.3219C11.7693 12.8799 11.1227 13.3146 10.3823 13.6258C9.64185 13.9423 8.84775 14.1006 8 14.1006ZM6.63984 12.0805H9.71429C9.90744 12.0805 10.0684 12.0188 10.1972 11.8954C10.3313 11.772 10.3984 11.611 10.3984 11.4125C10.3984 11.23 10.3313 11.0771 10.1972 10.9537C10.0684 10.8249 9.90744 10.7606 9.71429 10.7606H8.99799V7.50101C8.99799 7.24346 8.9336 7.03689 8.80483 6.88129C8.67606 6.72569 8.49095 6.64789 8.2495 6.64789H6.78471C6.59155 6.64789 6.4279 6.71227 6.29376 6.84105C6.16499 6.96445 6.1006 7.12005 6.1006 7.30785C6.1006 7.50101 6.16499 7.65929 6.29376 7.7827C6.4279 7.9061 6.59155 7.96781 6.78471 7.96781H7.50101V10.7606H6.63984C6.45205 10.7606 6.29108 10.8249 6.15694 10.9537C6.02817 11.0771 5.96378 11.23 5.96378 11.4125C5.96378 11.611 6.02817 11.772 6.15694 11.8954C6.29108 12.0188 6.45205 12.0805 6.63984 12.0805ZM7.9839 5.57746C8.28974 5.57746 8.54728 5.47015 8.75654 5.25553C8.97116 5.03555 9.07847 4.77532 9.07847 4.47485C9.07847 4.16365 8.97116 3.90074 8.75654 3.68612C8.54728 3.4715 8.28974 3.36418 7.9839 3.36418C7.68343 3.36418 7.42321 3.4715 7.20322 3.68612C6.9886 3.90074 6.88129 4.16365 6.88129 4.47485C6.88129 4.77532 6.9886 5.03555 7.20322 5.25553C7.42321 5.47015 7.68343 5.57746 7.9839 5.57746Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function DevicesIcon(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "24", height: "24", rx: "12", fill: "#E6EEFF" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.82485 16.7662C4.59907 16.7662 4.40423 16.6842 4.24036 16.5204C4.08012 16.3601 4 16.1671 4 15.9413C4 15.7155 4.08012 15.5207 4.24036 15.3568C4.40423 15.1929 4.59907 15.111 4.82485 15.111H14.4336C14.4336 15.2239 14.4336 15.3368 14.4336 15.4497C14.4372 15.5589 14.4391 15.67 14.4391 15.7829C14.4427 16.1544 14.5392 16.4821 14.7286 16.7662H4.82485ZM5.91192 15.6955V8.74706C5.91192 8.24814 6.0503 7.86576 6.32707 7.59991C6.60385 7.33042 6.98623 7.19568 7.47422 7.19568H17.2523C17.7112 7.19568 18.0681 7.31221 18.323 7.54529C18.5815 7.77836 18.7163 8.12068 18.7272 8.57226H7.77467C7.61807 8.57226 7.49789 8.61414 7.41413 8.6979C7.33402 8.78166 7.29396 8.90184 7.29396 9.05843V15.6955H5.91192ZM16.2308 16.8044C15.8921 16.8044 15.6244 16.7097 15.4278 16.5204C15.2311 16.331 15.1328 16.0724 15.1328 15.7447V10.3148C15.1328 9.98708 15.2311 9.72851 15.4278 9.53914C15.6244 9.34613 15.8921 9.24962 16.2308 9.24962H18.9348C19.2625 9.24962 19.5211 9.34613 19.7105 9.53914C19.9035 9.72851 20 9.98708 20 10.3148V15.7447C20 16.0724 19.9035 16.331 19.7105 16.5204C19.5211 16.7097 19.2625 16.8044 18.9348 16.8044H16.2308ZM16.3674 15.8102H18.7654C18.8565 15.8102 18.9257 15.7847 18.973 15.7337C19.024 15.6791 19.0495 15.6045 19.0495 15.5098V10.5497C19.0495 10.4514 19.024 10.3767 18.973 10.3258C18.9257 10.2748 18.8565 10.2493 18.7654 10.2493H16.3674C16.2727 10.2493 16.2017 10.2748 16.1543 10.3258C16.107 10.3731 16.0833 10.4459 16.0833 10.5443V15.5152C16.0833 15.6099 16.107 15.6828 16.1543 15.7337C16.2017 15.7847 16.2727 15.8102 16.3674 15.8102ZM16.8262 15.4989C16.6951 15.4989 16.6296 15.4315 16.6296 15.2967C16.6296 15.2348 16.6478 15.1857 16.6842 15.1492C16.7206 15.1092 16.768 15.0892 16.8262 15.0892H18.3011C18.363 15.0892 18.4122 15.1092 18.4486 15.1492C18.4887 15.1857 18.5087 15.2348 18.5087 15.2967C18.5087 15.4315 18.4395 15.4989 18.3011 15.4989H16.8262ZM17.1376 11.0523C17.0575 11.0523 16.9919 11.0268 16.9409 10.9758C16.89 10.9212 16.8645 10.8556 16.8645 10.7792C16.8645 10.699 16.89 10.6335 16.9409 10.5825C16.9956 10.5279 17.0611 10.5006 17.1376 10.5006H17.9788C18.0553 10.5006 18.1209 10.5279 18.1755 10.5825C18.2301 10.6335 18.2574 10.699 18.2574 10.7792C18.2574 10.8556 18.2301 10.9212 18.1755 10.9758C18.1245 11.0268 18.059 11.0523 17.9788 11.0523H17.1376Z",
            fill: "#2471FE"
          }
        )
      ]
    }
  );
}
function WarningIcon(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "24", height: "24", rx: "12", fill: "#FFD758", fillOpacity: "0.2" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.4195 5.83375L5.08949 16.7987C4.83449 17.2437 5.15449 17.8038 5.66949 17.8038H18.3295C18.8445 17.8038 19.1645 17.2487 18.9095 16.7987L12.5795 5.83375C12.3195 5.38875 11.6795 5.38875 11.4195 5.83375Z",
            fill: "#FFB02E"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.2988 13.7487C11.2988 14.1337 11.6088 14.4487 11.9988 14.4487C12.3888 14.4487 12.6988 14.1337 12.6988 13.7437V9.16375C12.6988 8.77875 12.3888 8.46375 11.9988 8.46375C11.6138 8.46375 11.2988 8.77375 11.2988 9.16375V13.7487Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.6988 15.7388C12.6988 16.1254 12.3854 16.4388 11.9988 16.4388C11.6122 16.4388 11.2988 16.1254 11.2988 15.7388C11.2988 15.3522 11.6122 15.0388 11.9988 15.0388C12.3854 15.0388 12.6988 15.3522 12.6988 15.7388Z",
            fill: "black"
          }
        )
      ]
    }
  );
}
function SwitchIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", props.className),
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.84686 5.79177C2.65468 5.97902 2.55859 6.20076 2.55859 6.457C2.56352 6.71323 2.65961 6.93004 2.84686 7.10743L6.46124 10.6331C6.63863 10.8105 6.85298 10.8992 7.10428 10.8992C7.36052 10.8992 7.56994 10.8179 7.73255 10.6553C7.90009 10.4878 7.98386 10.2759 7.98386 10.0196C7.98386 9.77326 7.89762 9.56876 7.72516 9.40615L6.24689 7.97962L5.45601 7.29961L6.79385 7.33657H16.56C16.8064 7.33657 17.0133 7.2528 17.1809 7.08526C17.3533 6.91772 17.4396 6.7083 17.4396 6.457C17.4396 6.20076 17.3533 5.98887 17.1809 5.82134C17.0133 5.64887 16.8064 5.56264 16.56 5.56264H6.79385L5.45601 5.60699L6.24689 4.92698L7.72516 3.50045C7.89762 3.34277 7.98386 3.13827 7.98386 2.88696C7.98386 2.6258 7.90009 2.41392 7.73255 2.25131C7.56994 2.08377 7.36052 2 7.10428 2C6.85298 2 6.63863 2.09362 6.46124 2.28087L2.84686 5.79177ZM17.1513 14.2082C17.3484 14.0259 17.4445 13.8066 17.4396 13.5504C17.4396 13.2942 17.3435 13.0774 17.1513 12.9L13.5443 9.37428C13.362 9.19688 13.1477 9.10819 12.9013 9.10819C12.645 9.10819 12.4332 9.19195 12.2656 9.35949C12.103 9.5221 12.0217 9.72906 12.0217 9.98037C12.0217 10.2317 12.1055 10.4386 12.273 10.6012L13.7513 12.0204L14.5496 12.7078L13.2117 12.6634H3.44556C3.18932 12.6634 2.97744 12.7497 2.8099 12.9221C2.64236 13.0897 2.55859 13.3016 2.55859 13.5578C2.55859 13.8091 2.64236 14.021 2.8099 14.1934C2.97744 14.361 3.18932 14.4448 3.44556 14.4448H13.2117L14.5496 14.4004L13.7513 15.0804L12.273 16.5069C12.1055 16.6646 12.0217 16.8691 12.0217 17.1204C12.0217 17.3816 12.103 17.5935 12.2656 17.7561C12.4332 17.9187 12.645 18 12.9013 18C13.1477 18 13.362 17.9088 13.5443 17.7265L17.1513 14.2082Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function CopyIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3 15.8218V7.49788C3 6.09101 3.76514 5.31971 5.16583 5.31971H6.15928V4.17817C6.15928 2.77131 6.92441 2 8.32511 2H10.565C11.3671 2 11.9842 2.21597 12.4902 2.72811L15.4952 5.801C16.0258 6.344 16.2171 6.9302 16.2171 7.83108V12.5083C16.2171 13.9152 15.4582 14.6865 14.0575 14.6865H13.064V15.8218C13.064 17.2287 12.2989 18 10.8982 18H5.16583C3.76514 18 3 17.2349 3 15.8218ZM12.3791 9.28114C12.9344 9.84882 13.064 10.3054 13.064 11.2002V13.0945H13.86C14.3845 13.0945 14.6251 12.8292 14.6251 12.3355V7.51639H12.2002C11.3548 7.51639 10.8488 7.01658 10.8488 6.17123V3.59198H8.51639C7.9919 3.59198 7.75125 3.86348 7.75125 4.35712V5.33822C8.30659 5.39375 8.7015 5.56653 9.13344 6.00463L12.3791 9.28114ZM12.0644 6.0108C12.0644 6.21442 12.157 6.30698 12.3606 6.30698H14.2117L12.0644 4.12881V6.0108ZM4.59198 15.6491C4.59198 16.1489 4.83263 16.408 5.35712 16.408H10.7007C11.2252 16.408 11.472 16.1489 11.472 15.6491V11.5087H8.60895C7.54146 11.5087 7.02931 11.0089 7.02931 9.93521V6.91169H5.35712C4.83263 6.91169 4.59198 7.17702 4.59198 7.67065V15.6491ZM8.72619 10.2067H11.3425L8.33745 7.16467V9.8118C8.33745 10.0833 8.46086 10.2067 8.72619 10.2067Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function PasteIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 18 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.6875 6.0625V3.48438C4.6875 2.61979 4.90885 1.96354 5.35156 1.51562C5.79948 1.0625 6.45312 0.835938 7.3125 0.835938H14.6016C15.4609 0.835938 16.112 1.0625 16.5547 1.51562C17.0026 1.96354 17.2266 2.61979 17.2266 3.48438V14.1406C17.2266 15 17.0026 15.6562 16.5547 16.1094C16.112 16.5625 15.4609 16.7891 14.6016 16.7891H12.6328V11.4766L7.24219 6.0625H4.6875ZM9.14844 3.72656H12.7656C12.9375 3.72656 13.0703 3.67448 13.1641 3.57031C13.263 3.46094 13.3125 3.33854 13.3125 3.20312V3.02344C13.3125 2.90365 13.2656 2.78646 13.1719 2.67188C13.0833 2.55729 12.9479 2.5 12.7656 2.5H9.14844C8.96094 2.5 8.82292 2.55729 8.73438 2.67188C8.64583 2.78646 8.60156 2.90365 8.60156 3.02344V3.20312C8.60156 3.33854 8.64844 3.46094 8.74219 3.57031C8.83594 3.67448 8.97135 3.72656 9.14844 3.72656ZM0.765625 18.2266V7.57031C0.765625 6.71094 0.986979 6.05729 1.42969 5.60938C1.8776 5.15625 2.53125 4.92969 3.39062 4.92969H6.08594C6.58073 4.92969 6.99219 4.98177 7.32031 5.08594C7.64844 5.1901 7.97656 5.41146 8.30469 5.75L12.4844 9.98438C12.7083 10.2135 12.8776 10.4349 12.9922 10.6484C13.112 10.862 13.1927 11.099 13.2344 11.3594C13.2812 11.6146 13.3047 11.9219 13.3047 12.2812V18.2266C13.3047 19.0911 13.0807 19.7474 12.6328 20.1953C12.1849 20.6484 11.5339 20.875 10.6797 20.875H3.39062C2.53125 20.875 1.8776 20.6484 1.42969 20.1953C0.986979 19.7474 0.765625 19.0911 0.765625 18.2266ZM2.5 18.0781C2.5 18.4219 2.58854 18.6849 2.76562 18.8672C2.94271 19.0495 3.20833 19.1406 3.5625 19.1406H10.5C10.8594 19.1406 11.125 19.0495 11.2969 18.8672C11.474 18.6849 11.5625 18.4219 11.5625 18.0781V12.5547H7.64844C7.04427 12.5547 6.59115 12.4062 6.28906 12.1094C5.99219 11.8125 5.84375 11.3594 5.84375 10.75V6.66406H3.57031C3.21094 6.66406 2.94271 6.75521 2.76562 6.9375C2.58854 7.11979 2.5 7.38021 2.5 7.71875V18.0781ZM7.80469 11.0781H11.375L7.32812 6.97656V10.6016C7.32812 10.7682 7.36458 10.8906 7.4375 10.9688C7.51562 11.0417 7.63802 11.0781 7.80469 11.0781Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function ScanIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.18652 6.44727C0.536133 6.44727 0.210938 6.11621 0.210938 5.4541V3.33594C0.210938 2.375 0.462891 1.64258 0.966797 1.13867C1.47656 0.634766 2.21777 0.382812 3.19043 0.382812H5.30859C5.9707 0.382812 6.30176 0.708008 6.30176 1.3584C6.30176 2.01465 5.9707 2.34277 5.30859 2.34277H3.34863C2.96191 2.34277 2.66602 2.44238 2.46094 2.6416C2.26172 2.83496 2.16211 3.13379 2.16211 3.53809V5.4541C2.16211 6.11621 1.83691 6.44727 1.18652 6.44727ZM16.7959 6.44727C16.1455 6.44727 15.8203 6.11621 15.8203 5.4541V3.53809C15.8203 3.13379 15.7178 2.83496 15.5127 2.6416C15.3076 2.44238 15.0146 2.34277 14.6338 2.34277H12.6738C12.0176 2.34277 11.6895 2.01465 11.6895 1.3584C11.6895 0.708008 12.0176 0.382812 12.6738 0.382812H14.8008C15.7734 0.382812 16.5117 0.634766 17.0156 1.13867C17.5254 1.64258 17.7803 2.375 17.7803 3.33594V5.4541C17.7803 6.11621 17.4521 6.44727 16.7959 6.44727ZM3.19043 17.9521C2.21777 17.9521 1.47656 17.7002 0.966797 17.1963C0.462891 16.6924 0.210938 15.96 0.210938 14.999V12.8721C0.210938 12.2158 0.536133 11.8877 1.18652 11.8877C1.83691 11.8877 2.16211 12.2158 2.16211 12.8721V14.7969C2.16211 15.2012 2.26172 15.5 2.46094 15.6934C2.66602 15.8926 2.96191 15.9922 3.34863 15.9922H5.30859C5.9707 15.9922 6.30176 16.3203 6.30176 16.9766C6.30176 17.627 5.9707 17.9521 5.30859 17.9521H3.19043ZM12.6738 17.9521C12.0176 17.9521 11.6895 17.627 11.6895 16.9766C11.6895 16.3203 12.0176 15.9922 12.6738 15.9922H14.6338C15.0146 15.9922 15.3076 15.8926 15.5127 15.6934C15.7178 15.5 15.8203 15.2012 15.8203 14.7969V12.8721C15.8203 12.2158 16.1455 11.8877 16.7959 11.8877C17.4521 11.8877 17.7803 12.2158 17.7803 12.8721V14.999C17.7803 15.96 17.5254 16.6924 17.0156 17.1963C16.5117 17.7002 15.7734 17.9521 14.8008 17.9521H12.6738ZM5.18555 13.3555C5.07422 13.3555 4.98047 13.3203 4.9043 13.25C4.83398 13.1797 4.79883 13.0889 4.79883 12.9775V9.92773C4.79883 9.81641 4.83398 9.72559 4.9043 9.65527C4.98047 9.58496 5.07422 9.5498 5.18555 9.5498H8.22656C8.33789 9.5498 8.42871 9.58496 8.49902 9.65527C8.5752 9.72559 8.61328 9.81641 8.61328 9.92773V12.9775C8.61328 13.0889 8.5752 13.1797 8.49902 13.25C8.42871 13.3203 8.33789 13.3555 8.22656 13.3555H5.18555ZM5.56348 12.5996H7.84863V10.3057H5.56348V12.5996ZM6.23145 11.9229V10.9736H7.18066V11.9229H6.23145ZM5.18555 8.78516C5.07422 8.78516 4.98047 8.75 4.9043 8.67969C4.83398 8.60352 4.79883 8.5127 4.79883 8.40723V5.35742C4.79883 5.25195 4.83398 5.16113 4.9043 5.08496C4.98047 5.00879 5.07422 4.9707 5.18555 4.9707H8.22656C8.33789 4.9707 8.42871 5.00879 8.49902 5.08496C8.5752 5.16113 8.61328 5.25195 8.61328 5.35742V8.40723C8.61328 8.5127 8.5752 8.60352 8.49902 8.67969C8.42871 8.75 8.33789 8.78516 8.22656 8.78516H5.18555ZM5.56348 8.02051H7.84863V5.73535H5.56348V8.02051ZM6.23145 7.36133V6.40332H7.18066V7.36133H6.23145ZM9.74707 8.78516C9.6416 8.78516 9.55078 8.75 9.47461 8.67969C9.4043 8.60352 9.36914 8.5127 9.36914 8.40723V5.35742C9.36914 5.25195 9.4043 5.16113 9.47461 5.08496C9.55078 5.00879 9.6416 4.9707 9.74707 4.9707H12.8057C12.9111 4.9707 12.999 5.00879 13.0693 5.08496C13.1455 5.16113 13.1836 5.25195 13.1836 5.35742V8.40723C13.1836 8.5127 13.1455 8.60352 13.0693 8.67969C12.999 8.75 12.9111 8.78516 12.8057 8.78516H9.74707ZM10.125 8.02051H12.4189V5.73535H10.125V8.02051ZM10.8018 7.36133V6.40332H11.751V7.36133H10.8018ZM9.47461 13.25V12.292H10.4326V13.25H9.47461ZM12.1201 13.25V12.292H13.0781V13.25H12.1201ZM10.8018 11.9229V10.9736H11.751V11.9229H10.8018ZM9.47461 10.6045V9.65527H10.4326V10.6045H9.47461ZM12.1201 10.6045V9.65527H13.0781V10.6045H12.1201Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function WarningOutlineIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 21 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "Vector",
          d: "M10.4993 6.33268C10.9577 6.33268 11.3327 6.70768 11.3327 7.16602V10.4993C11.3327 10.9577 10.9577 11.3327 10.4993 11.3327C10.041 11.3327 9.66602 10.9577 9.66602 10.4993V7.16602C9.66602 6.70768 10.041 6.33268 10.4993 6.33268ZM10.491 2.16602C5.89102 2.16602 2.16602 5.89935 2.16602 10.4993C2.16602 15.0993 5.89102 18.8327 10.491 18.8327C15.0993 18.8327 18.8327 15.0993 18.8327 10.4993C18.8327 5.89935 15.0993 2.16602 10.491 2.16602ZM10.4993 17.166C6.81602 17.166 3.83268 14.1827 3.83268 10.4993C3.83268 6.81602 6.81602 3.83268 10.4993 3.83268C14.1827 3.83268 17.166 6.81602 17.166 10.4993C17.166 14.1827 14.1827 17.166 10.4993 17.166ZM11.3327 14.666H9.66602V12.9993H11.3327V14.666Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function LoadingIconGradient(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 600 600",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: [
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("linearGradient", { id: "Gradient1", gradientTransform: "rotate(90)", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "currentColor", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "currentColor", stopOpacity: "0.5" })
          ] }),
          /* @__PURE__ */ jsxs("linearGradient", { id: "Gradient2", gradientTransform: "rotate(90)", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "currentColor", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "60%", stopColor: "currentColor", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "90%", stopColor: "currentColor", stopOpacity: "0.5" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "currentColor", stopOpacity: "0.65" })
          ] }),
          /* @__PURE__ */ jsx("pattern", { id: "Pattern", x: "0", y: "0", width: "600", height: "600", patternUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsxs("g", { transform: "rotate(0, 300, 300)", children: [
            /* @__PURE__ */ jsx("rect", { shapeRendering: "crispEdges", x: "0", y: "0", width: "300", height: "600", fill: "url(#Gradient1)" }),
            /* @__PURE__ */ jsx("rect", { shapeRendering: "crispEdges", x: "300", y: "0", width: "300", height: "600", fill: "url(#Gradient2)" })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "url(#Pattern)",
            fill: "transparent",
            strokeWidth: "75",
            strokeLinecap: "round",
            d: "M 364 58 A 250 250 0 1 1 235 58"
          }
        )
      ]
    }
  );
}
function SafeIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M40.0185 80C39.6472 80 39.2096 79.9204 38.7057 79.7613C38.2018 79.6287 37.6847 79.4298 37.1542 79.1646C31.5053 76.1412 26.7183 73.4096 22.7932 70.9697C18.8947 68.5563 15.752 66.1827 13.3651 63.8488C11.0047 61.515 9.28088 59.0088 8.19353 56.3302C7.10618 53.6251 6.5625 50.4823 6.5625 46.902V17.6231C6.5625 15.1036 7.05313 13.2339 8.0344 12.0139C9.01567 10.7674 10.5804 9.70661 12.7286 8.83143C13.5507 8.51318 14.7176 8.07558 16.2293 7.51865C17.7675 6.93519 19.4516 6.31195 21.2815 5.64893C23.138 4.95939 24.9812 4.29637 26.8111 3.65987C28.6676 3.02337 30.3517 2.45317 31.8633 1.94928C33.375 1.41886 34.5287 1.02105 35.3243 0.755843C36.0669 0.543676 36.8493 0.371291 37.6714 0.238687C38.4935 0.0795624 39.2759 0 40.0185 0C40.7346 0 41.5037 0.0795624 42.3258 0.238687C43.1745 0.371291 43.9701 0.543676 44.7127 0.755843C45.5083 1.02105 46.6487 1.41886 48.1339 1.94928C49.6455 2.45317 51.3164 3.03663 53.1463 3.69965C55.0027 4.33615 56.8592 4.98591 58.7157 5.64893C60.5721 6.31195 62.2562 6.92193 63.7679 7.47887C65.3061 8.0358 66.4863 8.48666 67.3084 8.83143C69.4566 9.73313 71.008 10.794 71.9628 12.0139C72.9441 13.2339 73.4347 15.1036 73.4347 17.6231V46.902C73.4347 50.4823 72.9043 53.6383 71.8435 56.37C70.8091 59.1016 69.0985 61.6609 66.7117 64.0477C64.3513 66.4081 61.2086 68.7817 57.2835 71.1686C53.385 73.582 48.5714 76.2473 42.843 79.1646C42.3391 79.4298 41.8352 79.6287 41.3313 79.7613C40.8274 79.9204 40.3898 80 40.0185 80Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M36.5309 55.5C37.9691 55.5 39.0565 54.9719 39.7929 53.9158L55.7233 30.962C55.988 30.588 56.1836 30.2195 56.3101 29.8564C56.4367 29.4824 56.5 29.1249 56.5 28.7838C56.5 27.8377 56.1548 27.0567 55.4644 26.4406C54.7856 25.8135 53.9456 25.5 52.9446 25.5C52.2542 25.5 51.6674 25.632 51.1841 25.896C50.7123 26.1491 50.2636 26.5891 49.8379 27.2162L36.4618 47.2987L29.7652 39.6254C29.0403 38.8223 28.1313 38.4208 27.0382 38.4208C26.0141 38.4208 25.1684 38.7343 24.501 39.3614C23.8337 39.9884 23.5 40.775 23.5 41.7211C23.5 42.1502 23.569 42.5572 23.7071 42.9422C23.8567 43.3163 24.1271 43.7068 24.5183 44.1139L33.4069 54.1304C34.2238 55.0435 35.2652 55.5 36.5309 55.5Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function MoreIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx("g", { id: "icon-more", children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "Union",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.9982 12.2692C8.89035 12.2692 9.61358 12.9925 9.61358 13.8846C9.61358 14.7768 8.89035 15.5 7.9982 15.5C7.10604 15.5 6.38281 14.7768 6.38281 13.8846C6.38281 12.9925 7.10604 12.2692 7.9982 12.2692ZM7.99829 6.88461C8.89044 6.88461 9.61368 7.60785 9.61368 8.5C9.61368 9.39215 8.89044 10.1154 7.99829 10.1154C7.10614 10.1154 6.38291 9.39215 6.38291 8.5C6.38291 7.60785 7.10614 6.88461 7.99829 6.88461ZM9.61368 3.11538C9.61368 2.22323 8.89044 1.5 7.99829 1.5C7.10614 1.5 6.38291 2.22323 6.38291 3.11539C6.38291 4.00754 7.10614 4.73077 7.99829 4.73077C8.89044 4.73077 9.61368 4.00754 9.61368 3.11538Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function PlusIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", className),
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: [
        /* @__PURE__ */ jsx("g", { id: "add_circle", clipPath: "url(#clip0_1851_12380)", children: /* @__PURE__ */ jsx(
          "path",
          {
            id: "Vector",
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z",
            fill: "#22C493"
          }
        ) }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_1851_12380", children: /* @__PURE__ */ jsx("rect", { width: "24", height: "24", fill: "white" }) }) })
      ]
    }
  );
}
function RevokeIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: [
        /* @__PURE__ */ jsx("g", { id: "Frame", clipPath: "url(#clip0_354_287366)", children: /* @__PURE__ */ jsx("g", { id: "Icon", children: /* @__PURE__ */ jsx("g", { id: "User", children: /* @__PURE__ */ jsx("g", { id: "user_x_fill", children: /* @__PURE__ */ jsx(
          "path",
          {
            id: "å½¢ç¶",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.33594 1.33203C5.49499 1.33203 4.0026 2.82442 4.0026 4.66536C4.0026 6.50631 5.49499 7.9987 7.33594 7.9987C9.17687 7.9987 10.6693 6.50631 10.6693 4.66536C10.6693 2.82442 9.17687 1.33203 7.33594 1.33203ZM7.33594 8.66536C5.73896 8.66536 4.28572 9.12783 3.21745 9.7797C2.68356 10.1055 2.22786 10.4896 1.89858 10.9064C1.57464 11.3165 1.33594 11.8074 1.33594 12.332C1.33594 12.8953 1.61003 13.3394 2.00438 13.656C2.3781 13.956 2.87048 14.1544 3.39404 14.2931C4.44571 14.5716 5.84994 14.6654 7.33594 14.6654C7.4896 14.6654 7.642 14.6644 7.79287 14.6622C8.01974 14.6591 8.22947 14.5408 8.34947 14.3481C8.4694 14.1555 8.4832 13.9151 8.38594 13.71C8.14034 13.192 8.0026 12.6124 8.0026 11.9987C8.0026 11.1639 8.2576 10.3907 8.69387 9.75016C8.82587 9.55636 8.84634 9.30756 8.74787 9.09483C8.6494 8.88203 8.44647 8.7367 8.21334 8.7119C7.92727 8.6815 7.63427 8.66536 7.33594 8.66536ZM11.0599 10.1131C10.7995 9.85276 10.3774 9.85276 10.1171 10.1131C9.85674 10.3734 9.85674 10.7956 10.1171 11.0559L11.0599 11.9987L10.117 12.9416C9.8566 13.2019 9.8566 13.624 10.117 13.8844C10.3773 14.1448 10.7994 14.1448 11.0598 13.8844L12.0026 12.9416L12.9455 13.8844C13.2058 14.1448 13.6279 14.1448 13.8883 13.8844C14.1486 13.624 14.1486 13.202 13.8883 12.9416L12.9455 11.9987L13.8882 11.056C14.1485 10.7956 14.1485 10.3735 13.8882 10.1132C13.6279 9.85283 13.2057 9.85283 12.9454 10.1132L12.0027 11.0559L11.0599 10.1131Z",
            fill: "currentColor"
          }
        ) }) }) }) }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_354_287366", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
}
function NervosIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 28 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: [
        /* @__PURE__ */ jsx("g", { id: "Nervos Network (CKB) .bit", clipPath: "url(#clip0_1465_56796)", children: /* @__PURE__ */ jsx("g", { id: "é¡µé¢-1", children: /* @__PURE__ */ jsx("g", { id: "Sign-Tansaction", children: /* @__PURE__ */ jsxs("g", { id: "Group-8", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "Rectangle-3",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14 0.5C21.732 0.5 28 6.76801 28 14.5C28 22.232 21.732 28.5 14 28.5C6.26801 28.5 0 22.232 0 14.5C0 6.76801 6.26801 0.5 14 0.5Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "Combined-Shape",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.40234 8.90039L13.474 13.9588H11.3701V20.1004H8.40234V8.90039ZM19.6023 8.90039V20.1004L14.5307 15.042H16.6346V8.90039H19.6023Z",
              fill: "black"
            }
          )
        ] }) }) }) }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_1465_56796", children: /* @__PURE__ */ jsx("rect", { width: "28", height: "28", fill: "white", transform: "translate(0 0.5)" }) }) })
      ]
    }
  );
}
function Exlaimation(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "exlaimation",
          d: "M40 80C45.4836 80 50.6333 78.9562 55.4489 76.8685C60.2644 74.7808 64.5094 71.8998 68.1837 68.2255C71.8859 64.5511 74.7808 60.3062 76.8685 55.4906C78.9562 50.6472 80 45.4836 80 40C80 34.5442 78.9422 29.4085 76.8267 24.5929C74.739 19.7495 71.8441 15.4906 68.142 11.8163C64.4676 8.11413 60.2227 5.21921 55.4071 3.13152C50.5915 1.04384 45.4419 0 39.9582 0C34.5024 0 29.3667 1.04384 24.5511 3.13152C19.7356 5.21921 15.4767 8.11413 11.7745 11.8163C8.10021 15.4906 5.21921 19.7495 3.13152 24.5929C1.04384 29.4085 0 34.5442 0 40C0 45.4836 1.04384 50.6472 3.13152 55.4906C5.24704 60.3062 8.14196 64.5511 11.8163 68.2255C15.4906 71.8998 19.7356 74.7808 24.5511 76.8685C29.3667 78.9562 34.5164 80 40 80ZM40 47.3069C38.0515 47.3069 37.0633 46.3048 37.0355 44.3006L36.5344 22.7975C36.5066 21.8511 36.8128 21.0717 37.453 20.4593C38.0932 19.8191 38.9283 19.499 39.9582 19.499C40.9603 19.499 41.7815 19.8191 42.4217 20.4593C43.0619 21.0995 43.382 21.8928 43.382 22.8392L42.8392 44.3006C42.8392 46.3048 41.8928 47.3069 40 47.3069ZM40 60.2505C38.8587 60.2505 37.8706 59.8608 37.0355 59.0814C36.2283 58.302 35.8246 57.3695 35.8246 56.2839C35.8246 55.1705 36.2283 54.2241 37.0355 53.4447C37.8706 52.6374 38.8587 52.2338 40 52.2338C41.1134 52.2338 42.0738 52.6235 42.881 53.4029C43.7161 54.1823 44.1336 55.1427 44.1336 56.2839C44.1336 57.3974 43.7161 58.3438 42.881 59.1232C42.0459 59.8747 41.0856 60.2505 40 60.2505Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function NoticeIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsxs("g", { id: "icon-notice", children: [
        /* @__PURE__ */ jsx("circle", { id: "Ellipse 357", cx: "9", cy: "9", r: "9", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            id: "3",
            d: "M8.99191 13.9555C9.34665 13.9555 9.64565 13.8288 9.8889 13.5754C10.1423 13.322 10.274 13.0179 10.2842 12.6632C10.2842 12.3186 10.1575 12.0196 9.9041 11.7662C9.65072 11.5128 9.34665 11.3861 8.99191 11.3861C8.64731 11.3861 8.34831 11.5128 8.09492 11.7662C7.84154 12.0196 7.71484 12.3186 7.71484 12.6632C7.71484 13.0179 7.84154 13.322 8.09492 13.5754C8.34831 13.8288 8.64731 13.9555 8.99191 13.9555ZM8.99191 10.3219C9.26557 10.3219 9.48348 10.2408 9.64565 10.0786C9.81795 9.91647 9.90917 9.70363 9.91931 9.44011L10.0409 5.09199C10.0511 4.78793 9.95985 4.53961 9.76728 4.34703C9.5747 4.14432 9.31625 4.04297 8.99191 4.04297C8.67771 4.04297 8.42433 4.14432 8.23175 4.34703C8.03918 4.53961 7.94796 4.78793 7.9581 5.09199L8.07972 9.44011C8.07972 9.70363 8.16587 9.91647 8.33817 10.0786C8.51048 10.2408 8.72839 10.3219 8.99191 10.3219Z",
            fill: "white"
          }
        )
      ] })
    }
  );
}
function FaceIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      width: "22",
      height: "21",
      viewBox: "0 0 22 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.9458 7.6333C1.06396 7.6333 0.623047 7.18555 0.623047 6.29004V3.83936C0.623047 2.67725 0.934082 1.78857 1.55615 1.17334C2.17822 0.55127 3.07373 0.240234 4.24268 0.240234H6.70361C7.59229 0.240234 8.03662 0.681152 8.03662 1.56299C8.03662 2.44482 7.59229 2.88574 6.70361 2.88574H4.52979C4.11963 2.88574 3.80518 2.98828 3.58643 3.19336C3.37451 3.39844 3.26855 3.71973 3.26855 4.15723V6.29004C3.26855 7.18555 2.82764 7.6333 1.9458 7.6333ZM20.0439 7.6333C19.1621 7.6333 18.7212 7.18555 18.7212 6.29004V4.15723C18.7212 3.71973 18.6118 3.39844 18.3931 3.19336C18.1743 2.98828 17.8599 2.88574 17.4497 2.88574H15.2861C14.3975 2.88574 13.9531 2.44482 13.9531 1.56299C13.9531 0.681152 14.3975 0.240234 15.2861 0.240234H17.7471C18.916 0.240234 19.8115 0.55127 20.4336 1.17334C21.0557 1.78857 21.3667 2.67725 21.3667 3.83936V6.29004C21.3667 7.18555 20.9258 7.6333 20.0439 7.6333ZM4.24268 20.9736C3.07373 20.9736 2.17822 20.6626 1.55615 20.0405C0.934082 19.4253 0.623047 18.5366 0.623047 17.3745V14.9238C0.623047 14.0283 1.06396 13.5806 1.9458 13.5806C2.82764 13.5806 3.26855 14.0283 3.26855 14.9238V17.0566C3.26855 17.4941 3.37451 17.8154 3.58643 18.0205C3.80518 18.2256 4.11963 18.3281 4.52979 18.3281H6.70361C7.59229 18.3281 8.03662 18.769 8.03662 19.6509C8.03662 20.5327 7.59229 20.9736 6.70361 20.9736H4.24268ZM15.2861 20.9736C14.3975 20.9736 13.9531 20.5327 13.9531 19.6509C13.9531 18.769 14.3975 18.3281 15.2861 18.3281H17.4497C17.8599 18.3281 18.1743 18.2256 18.3931 18.0205C18.6118 17.8154 18.7212 17.4941 18.7212 17.0566V14.9238C18.7212 14.0283 19.1621 13.5806 20.0439 13.5806C20.9258 13.5806 21.3667 14.0283 21.3667 14.9238V17.3745C21.3667 18.5366 21.0557 19.4253 20.4336 20.0405C19.8115 20.6626 18.916 20.9736 17.7471 20.9736H15.2861ZM7.24707 9.94043C6.98047 9.94043 6.7583 9.85156 6.58057 9.67383C6.40283 9.49609 6.31396 9.27051 6.31396 8.99707V7.61279C6.31396 7.34619 6.40283 7.12402 6.58057 6.94629C6.7583 6.76855 6.98047 6.67969 7.24707 6.67969C7.52051 6.67969 7.74268 6.76855 7.91357 6.94629C8.09131 7.11719 8.18018 7.33936 8.18018 7.61279V8.99707C8.18018 9.27051 8.09131 9.49609 7.91357 9.67383C7.74268 9.85156 7.52051 9.94043 7.24707 9.94043ZM10.1899 12.3193C9.90967 12.3193 9.68408 12.2476 9.51318 12.104C9.34912 11.9604 9.26709 11.7622 9.26709 11.5093C9.26709 11.2974 9.34229 11.1196 9.49268 10.9761C9.64307 10.8257 9.82764 10.7505 10.0464 10.7505H10.3027C10.3369 10.7505 10.3643 10.7402 10.3848 10.7197C10.4121 10.6992 10.4258 10.665 10.4258 10.6172V7.43848C10.4258 7.20605 10.4976 7.02148 10.6411 6.88477C10.7847 6.74121 10.9727 6.66943 11.2051 6.66943C11.4375 6.66943 11.6255 6.74121 11.769 6.88477C11.9126 7.02148 11.9844 7.20605 11.9844 7.43848V10.6274C11.9844 11.1743 11.8374 11.5947 11.5435 11.8887C11.2495 12.1758 10.8291 12.3193 10.2822 12.3193C10.2686 12.3193 10.2515 12.3193 10.231 12.3193C10.2173 12.3193 10.2036 12.3193 10.1899 12.3193ZM14.7427 9.94043C14.4692 9.94043 14.2437 9.85156 14.0659 9.67383C13.8882 9.49609 13.7993 9.27051 13.7993 8.99707V7.61279C13.7993 7.33936 13.8882 7.11719 14.0659 6.94629C14.2437 6.76855 14.4692 6.67969 14.7427 6.67969C15.0093 6.67969 15.228 6.76855 15.3989 6.94629C15.5767 7.12402 15.6655 7.34619 15.6655 7.61279V8.99707C15.6655 9.27051 15.5767 9.49609 15.3989 9.67383C15.228 9.85156 15.0093 9.94043 14.7427 9.94043ZM10.9487 15.5903C10.2925 15.5903 9.65674 15.4639 9.0415 15.2109C8.42627 14.958 7.92383 14.5991 7.53418 14.1343C7.45215 14.0454 7.39404 13.9565 7.35986 13.8677C7.32568 13.772 7.30859 13.6763 7.30859 13.5806C7.30859 13.355 7.38379 13.1704 7.53418 13.0269C7.68457 12.8765 7.87256 12.8013 8.09814 12.8013C8.22803 12.8013 8.3374 12.8286 8.42627 12.8833C8.51514 12.938 8.61084 13.0132 8.71338 13.1089C9.00049 13.396 9.34229 13.625 9.73877 13.7959C10.1353 13.96 10.5386 14.042 10.9487 14.042C11.3862 14.042 11.8032 13.9565 12.1997 13.7856C12.603 13.6147 12.9346 13.3892 13.1943 13.1089C13.3926 12.9038 13.5977 12.8013 13.8096 12.8013C14.0283 12.8013 14.2129 12.8765 14.3633 13.0269C14.5137 13.1704 14.5889 13.355 14.5889 13.5806C14.5889 13.6968 14.5718 13.8027 14.5376 13.8984C14.5034 13.9941 14.4487 14.0796 14.3735 14.1548C13.9224 14.606 13.3926 14.958 12.7842 15.2109C12.1826 15.4639 11.5708 15.5903 10.9487 15.5903Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function QRCodeIcon(props) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: clsx("icon", className),
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.27344 7.875C0.71875 7.875 -0.0078125 7.14844 -0.0078125 5.57812V3.04688C-0.0078125 1.47656 0.71875 0.75 2.27344 0.75H4.82812C6.39062 0.75 7.11719 1.47656 7.11719 3.04688V5.57812C7.11719 7.14844 6.39062 7.875 4.82812 7.875H2.27344ZM10.3828 7.875C8.82812 7.875 8.10156 7.14844 8.10156 5.57812V3.04688C8.10156 1.47656 8.82812 0.75 10.3828 0.75H12.9375C14.5 0.75 15.2266 1.47656 15.2266 3.04688V5.57812C15.2266 7.14844 14.5 7.875 12.9375 7.875H10.3828ZM2.10938 6.21094H5C5.3125 6.21094 5.45312 6.07812 5.45312 5.75781V2.875C5.45312 2.55469 5.3125 2.41406 5 2.41406H2.10938C1.78906 2.41406 1.65625 2.55469 1.65625 2.875V5.75781C1.65625 6.07812 1.78906 6.21094 2.10938 6.21094ZM10.2188 6.21094H13.1094C13.4219 6.21094 13.5625 6.07812 13.5625 5.75781V2.875C13.5625 2.55469 13.4219 2.41406 13.1094 2.41406H10.2188C9.89844 2.41406 9.76562 2.55469 9.76562 2.875V5.75781C9.76562 6.07812 9.89844 6.21094 10.2188 6.21094ZM2.75781 5.28906C2.625 5.28906 2.57812 5.23438 2.57812 5.07031V3.54688C2.57812 3.39844 2.625 3.33594 2.75781 3.33594H4.33594C4.46875 3.33594 4.53125 3.39844 4.53125 3.54688V5.07031C4.53125 5.23438 4.46875 5.28906 4.33594 5.28906H2.75781ZM10.8828 5.28906C10.75 5.28906 10.7031 5.23438 10.7031 5.07031V3.54688C10.7031 3.39844 10.75 3.33594 10.8828 3.33594H12.4531C12.5938 3.33594 12.6484 3.39844 12.6484 3.54688V5.07031C12.6484 5.23438 12.5938 5.28906 12.4531 5.28906H10.8828ZM2.27344 15.9844C0.71875 15.9844 -0.0078125 15.2578 -0.0078125 13.6875V11.1562C-0.0078125 9.58594 0.71875 8.85938 2.27344 8.85938H4.82812C6.39062 8.85938 7.11719 9.58594 7.11719 11.1562V13.6875C7.11719 15.2578 6.39062 15.9844 4.82812 15.9844H2.27344ZM8.71094 11.1484C8.57812 11.1484 8.53125 11.0938 8.53125 10.9375V9.40625C8.53125 9.25781 8.57812 9.19531 8.71094 9.19531H10.2812C10.4219 9.19531 10.4766 9.25781 10.4766 9.40625V10.9375C10.4766 11.0938 10.4219 11.1484 10.2812 11.1484H8.71094ZM12.9922 11.1484C12.8594 11.1484 12.8125 11.0938 12.8125 10.9375V9.40625C12.8125 9.25781 12.8594 9.19531 12.9922 9.19531H14.5703C14.7109 9.19531 14.7656 9.25781 14.7656 9.40625V10.9375C14.7656 11.0938 14.7109 11.1484 14.5703 11.1484H12.9922ZM2.10938 14.3203H5C5.3125 14.3203 5.45312 14.1797 5.45312 13.8672V10.9844C5.45312 10.6641 5.3125 10.5234 5 10.5234H2.10938C1.78906 10.5234 1.65625 10.6641 1.65625 10.9844V13.8672C1.65625 14.1797 1.78906 14.3203 2.10938 14.3203ZM10.875 13.2969C10.7422 13.2969 10.6953 13.2344 10.6953 13.0781V11.5469C10.6953 11.3984 10.7422 11.3438 10.875 11.3438H12.4453C12.5859 11.3438 12.6406 11.3984 12.6406 11.5469V13.0781C12.6406 13.2344 12.5859 13.2969 12.4453 13.2969H10.875ZM2.75781 13.3984C2.625 13.3984 2.57812 13.3438 2.57812 13.1797V11.6562C2.57812 11.5 2.625 11.4453 2.75781 11.4453H4.33594C4.46875 11.4453 4.53125 11.5 4.53125 11.6562V13.1797C4.53125 13.3438 4.46875 13.3984 4.33594 13.3984H2.75781ZM8.71094 15.4375C8.57812 15.4375 8.53125 15.3828 8.53125 15.2188V13.6953C8.53125 13.5469 8.57812 13.4844 8.71094 13.4844H10.2812C10.4219 13.4844 10.4766 13.5469 10.4766 13.6953V15.2188C10.4766 15.3828 10.4219 15.4375 10.2812 15.4375H8.71094ZM12.9922 15.4375C12.8594 15.4375 12.8125 15.3828 12.8125 15.2188V13.6953C12.8125 13.5469 12.8594 13.4844 12.9922 13.4844H14.5703C14.7109 13.4844 14.7656 13.5469 14.7656 13.6953V15.2188C14.7656 15.3828 14.7109 15.4375 14.5703 15.4375H12.9922Z",
          fill: "currentColor"
        }
      )
    }
  );
}
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["primary"] = "primary";
  ButtonVariant2["secondary"] = "secondary";
  ButtonVariant2["danger"] = "danger";
  ButtonVariant2["passkey"] = "passkey";
  return ButtonVariant2;
})(ButtonVariant || {});
const variantClasses$1 = {
  [
    "primary"
    /* primary */
  ]: "text-white bg-success hover:bg-success-hover active:bg-success-active disabled:cursor-no-drop disabled:opacity-50 disabled:bg-success",
  [
    "secondary"
    /* secondary */
  ]: "text-font-primary bg-secondary hover:bg-secondary-hover active:bg-secondary-active disabled:cursor-no-drop disabled:opacity-50 disabled:bg-secondary",
  [
    "danger"
    /* danger */
  ]: "text-white bg-danger hover:bg-danger-hover disabled:cursor-no-drop disabled:opacity-50 disabled:bg-danger",
  [
    "passkey"
    /* passkey */
  ]: "text-white transition-all duration-400 bg-passkey shadow-passkey hover:shadow-none active:shadow-none disabled:shadow-none disabled:cursor-no-drop disabled:bg-passkey"
};
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["small"] = "small";
  ButtonSize2["middle"] = "middle";
  ButtonSize2["large"] = "large";
  ButtonSize2["super"] = "super";
  return ButtonSize2;
})(ButtonSize || {});
const sizeClasses = {
  [
    "small"
    /* small */
  ]: "h-[38px] px-3 text-sm font-medium",
  [
    "middle"
    /* middle */
  ]: "h-[42px] px-4 text-base font-medium",
  [
    "large"
    /* large */
  ]: "h-[52px] px-4 text-base font-medium",
  [
    "super"
    /* super */
  ]: "h-[58px] px-4 text-base font-medium"
};
var ButtonShape = /* @__PURE__ */ ((ButtonShape2) => {
  ButtonShape2["default"] = "default";
  ButtonShape2["round"] = "round";
  return ButtonShape2;
})(ButtonShape || {});
const Button = ({
  size = "large",
  variant = "primary",
  loading = false,
  outlink = false,
  shape = "default",
  className,
  ...props
}) => {
  const getRadius = (newShape, newSize) => {
    let newRadius = "";
    if (newShape === "default") {
      switch (newSize) {
        case "small":
          newRadius = "rounded-lg";
          break;
        case "middle":
          newRadius = "rounded-xl";
          break;
        case "large":
          newRadius = "rounded-xl";
          break;
        case "super":
          newRadius = "rounded-xl";
          break;
      }
    } else if (newShape === "round") {
      switch (newSize) {
        case "small":
          newRadius = "rounded-[19px]";
          break;
        case "middle":
          newRadius = "rounded-[21px]";
          break;
        case "large":
          newRadius = "rounded-[26px]";
          break;
        case "super":
          newRadius = "rounded-[29px]";
          break;
      }
    }
    return newRadius;
  };
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ...props,
      className: clsx(
        "flex cursor-pointer items-center justify-center outline-0",
        variantClasses$1[variant],
        sizeClasses[size],
        getRadius(shape, size),
        className
      ),
      disabled: props.disabled === true || loading,
      children: [
        loading ? /* @__PURE__ */ jsx("span", { className: "mr-1.5 inline-flex", children: /* @__PURE__ */ jsx(LoadingIcon, { className: "h-5 w-5" }) }) : null,
        props.children,
        outlink ? /* @__PURE__ */ jsx(ArrowRightTopIcon, { className: "ml-3 h-2.5 w-2.5" }) : null
      ]
    }
  );
};
function Mask({ isOpen, zIndex = "z-[10]" }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        "fixed left-0 top-0 h-screen w-screen bg-mask-bg",
        isOpen ? "animation-fade-in" : "animation-fade-out",
        zIndex
      )
    }
  );
}
var ChainType = /* @__PURE__ */ ((ChainType2) => {
  ChainType2[ChainType2["ckb"] = 0] = "ckb";
  ChainType2[ChainType2["eth"] = 1] = "eth";
  ChainType2[ChainType2["btc"] = 2] = "btc";
  ChainType2[ChainType2["tron"] = 3] = "tron";
  ChainType2[ChainType2["fiat"] = 4] = "fiat";
  ChainType2[ChainType2["doge"] = 7] = "doge";
  ChainType2[ChainType2["bsc"] = 56] = "bsc";
  ChainType2[ChainType2["polygon"] = 137] = "polygon";
  return ChainType2;
})(ChainType || {});
var ChainId = /* @__PURE__ */ ((ChainId2) => {
  ChainId2[ChainId2["eth"] = 1] = "eth";
  ChainId2[ChainId2["ethGoerli"] = 5] = "ethGoerli";
  ChainId2[ChainId2["bsc"] = 56] = "bsc";
  ChainId2[ChainId2["bscTestnet"] = 97] = "bscTestnet";
  ChainId2[ChainId2["polygon"] = 137] = "polygon";
  ChainId2[ChainId2["polygonMumbai"] = 80001] = "polygonMumbai";
  ChainId2[ChainId2["tron"] = 728126428] = "tron";
  ChainId2[ChainId2["tronNile"] = 3448148188] = "tronNile";
  return ChainId2;
})(ChainId || {});
var CoinType = /* @__PURE__ */ ((CoinType2) => {
  CoinType2["btc"] = "0";
  CoinType2["doge"] = "3";
  CoinType2["eth"] = "60";
  CoinType2["trx"] = "195";
  CoinType2["ckb"] = "309";
  CoinType2["bsc"] = "9006";
  CoinType2["matic"] = "966";
  return CoinType2;
})(CoinType || {});
const CoinTypeToChainIdMap = {
  [
    "60"
    /* eth */
  ]: 1,
  [
    "9006"
    /* bsc */
  ]: 56,
  [
    "966"
    /* matic */
  ]: 137,
  [
    "195"
    /* trx */
  ]: 728126428
  /* tron */
};
const CoinTypeToTestNetChainIdMap = {
  [
    "60"
    /* eth */
  ]: 5,
  [
    "9006"
    /* bsc */
  ]: 97,
  [
    "966"
    /* matic */
  ]: 80001,
  [
    "195"
    /* trx */
  ]: 3448148188
  /* tronNile */
};
const CoinTypeToTorusHostMap = {
  [
    "60"
    /* eth */
  ]: "mainnet",
  [
    "9006"
    /* bsc */
  ]: "bsc_mainnet",
  [
    "966"
    /* matic */
  ]: "matic"
};
const CoinTypeToTorusHostTestNetMap = {
  [
    "60"
    /* eth */
  ]: "goerli",
  [
    "9006"
    /* bsc */
  ]: "bsc_testnet",
  [
    "966"
    /* matic */
  ]: "mumbai"
};
const CoinTypeToGenesisHash = {
  [
    "3"
    /* doge */
  ]: "1a91e3dace36e2be3bf030a65679fe821aa1d6ef92e7c9902eb318182c355691"
};
const ChainIdToCoinTypeMap = {
  1: "60",
  56: "9006",
  137: "966",
  728126428: "195"
  /* trx */
};
const ChainIdToCoinTypeTestNetMap = {
  5: "60",
  97: "9006",
  80001: "966",
  3448148188: "195"
  /* trx */
};
var SIGN_TYPE = /* @__PURE__ */ ((SIGN_TYPE2) => {
  SIGN_TYPE2[SIGN_TYPE2["noSign"] = 0] = "noSign";
  SIGN_TYPE2[SIGN_TYPE2["ckbMulti"] = 1] = "ckbMulti";
  SIGN_TYPE2[SIGN_TYPE2["ckbSingle"] = 2] = "ckbSingle";
  SIGN_TYPE2[SIGN_TYPE2["eth"] = 3] = "eth";
  SIGN_TYPE2[SIGN_TYPE2["tron"] = 4] = "tron";
  SIGN_TYPE2[SIGN_TYPE2["eth712"] = 5] = "eth712";
  SIGN_TYPE2[SIGN_TYPE2["ed25519"] = 6] = "ed25519";
  SIGN_TYPE2[SIGN_TYPE2["doge"] = 7] = "doge";
  SIGN_TYPE2[SIGN_TYPE2["webauthn"] = 8] = "webauthn";
  return SIGN_TYPE2;
})(SIGN_TYPE || {});
var CustomChain = /* @__PURE__ */ ((CustomChain2) => {
  CustomChain2["passkey"] = "passkey";
  CustomChain2["eth"] = "Ethereum";
  CustomChain2["bsc"] = "BNB Smart Chain";
  CustomChain2["tron"] = "TRON";
  CustomChain2["doge"] = "Dogecoin";
  CustomChain2["polygon"] = "Polygon";
  CustomChain2["torus"] = "Torus";
  return CustomChain2;
})(CustomChain || {});
const CKB = {
  name: "Nervos Network",
  symbol: "CKB",
  coinType: "309",
  decimals: 8,
  icon: "nervos-network",
  tokenId: "ckb_ckb",
  explorerTrx: "https://explorer.nervos.org/transaction/",
  testExplorerTrx: "https://explorer.nervos.org/aggron/transaction/"
};
const ETH = {
  name: "Ethereum",
  symbol: "ETH",
  coinType: "60",
  decimals: 18,
  icon: "ethereum",
  tokenId: "eth_eth",
  explorerTrx: "https://etherscan.io/tx/",
  testExplorerTrx: "https://goerli.etherscan.io/tx/"
};
const TRON = {
  name: "TRON",
  symbol: "TRX",
  coinType: "195",
  decimals: 6,
  icon: "tron",
  tokenId: "tron_trx",
  explorerTrx: "https://tronscan.org/#/transaction/",
  testExplorerTrx: "https://nile.tronscan.org/#/transaction/"
};
const BSC = {
  name: "BNB Smart Chain",
  symbol: "BNB",
  coinType: "9006",
  decimals: 18,
  icon: "binance-smart-chain",
  tokenId: "bsc_bnb",
  explorerTrx: "https://bscscan.com/tx/",
  testExplorerTrx: "https://testnet.bscscan.com/tx/"
};
const Polygon = {
  name: "Polygon",
  symbol: "MATIC",
  coinType: "966",
  decimals: 18,
  icon: "polygon",
  tokenId: "polygon_matic",
  explorerTrx: "https://polygonscan.com/tx/",
  testExplorerTrx: "https://mumbai.polygonscan.com/tx/"
};
const BTC = {
  name: "Bitcoin",
  symbol: "BTC",
  coinType: "0",
  decimals: 8,
  icon: "bitcoin",
  tokenId: "btc_btc",
  explorerTrx: "https://explorer.btc.com/btc/address/",
  testExplorerTrx: ""
};
const DOGE = {
  name: "Dogecoin",
  symbol: "DOGE",
  coinType: "3",
  decimals: 8,
  icon: "dogecoin",
  tokenId: "doge_doge",
  explorerTrx: "https://dogechain.info/tx/",
  testExplorerTrx: "https://dogechain.info/tx/"
};
const CoinTypeToChainMap = {
  [
    "60"
    /* eth */
  ]: ETH,
  [
    "9006"
    /* bsc */
  ]: BSC,
  [
    "966"
    /* matic */
  ]: Polygon,
  [
    "195"
    /* trx */
  ]: TRON,
  [
    "3"
    /* doge */
  ]: DOGE
};
const ChainIdToChainInfoMap = {
  [
    1
    /* eth */
  ]: {
    networkName: "Ethereum Mainnet",
    symbol: "ETH",
    decimals: 18,
    rpcUrl: "https://mainnet.infura.io/v3/",
    blockExplorerUrl: "https://etherscan.io"
  },
  [
    5
    /* ethGoerli */
  ]: {
    networkName: "Ethereum Goerli Testnet",
    symbol: "ETH",
    decimals: 18,
    rpcUrl: "https://goerli.infura.io/v3/",
    blockExplorerUrl: "https://goerli.etherscan.io"
  },
  [
    56
    /* bsc */
  ]: {
    networkName: "Binance Smart Chain Mainnet",
    symbol: "BNB",
    decimals: 18,
    rpcUrl: "https://bsc-dataseed1.binance.org",
    blockExplorerUrl: "https://bscscan.com"
  },
  [
    97
    /* bscTestnet */
  ]: {
    networkName: "Binance Smart Chain Testnet",
    symbol: "BNB",
    decimals: 18,
    rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545",
    blockExplorerUrl: "https://testnet.bscscan.com"
  },
  [
    137
    /* polygon */
  ]: {
    networkName: "Polygon Mainnet",
    symbol: "MATIC",
    decimals: 18,
    rpcUrl: "https://polygon-rpc.com/",
    blockExplorerUrl: "https://polygonscan.com"
  },
  [
    80001
    /* polygonMumbai */
  ]: {
    networkName: "Polygon Testnet Mumbai",
    symbol: "MATIC",
    decimals: 18,
    rpcUrl: "https://matic-mumbai.chainstacklabs.com",
    blockExplorerUrl: "https://mumbai.polygonscan.com"
  }
};
var CustomWallet = /* @__PURE__ */ ((CustomWallet2) => {
  CustomWallet2["metaMask"] = "MetaMask";
  CustomWallet2["trustWallet"] = "TrustWallet";
  CustomWallet2["imToken"] = "imToken";
  CustomWallet2["tokenPocket"] = "TokenPocket";
  CustomWallet2["oneKey"] = "OneKey";
  CustomWallet2["iToken"] = "iToken";
  CustomWallet2["tronLink"] = "TronLink";
  CustomWallet2["walletConnect"] = "WalletConnect";
  return CustomWallet2;
})(CustomWallet || {});
const errno = {
  success: 0,
  networkError: -1,
  failedToInitializeWallet: -2,
  // MetaMask
  metaMaskUserDeniedMessageSignature: 4001,
  metaMaskWalletRequestPermissions: -32002,
  metaMaskUserRejectedAccountAccess: -32603,
  metaMaskReplacementTransactionUnderpriced: "replacement transaction underpriced",
  metaMaskTransactionHasBeenAborted: "the transaction has been aborted",
  // WalletConnect
  walletConnectUserRejectedTheTransaction: "User rejected the transaction",
  walletConnectInsufficientFundsForTransfer: "insufficient funds for transfer",
  // TronLink
  tronLinkConfirmationDeclinedByUser: "Confirmation declined by user",
  tronLinkInsufficientBalance: "class org.tron.core.exception.ContractValidateException : Validate TransferContract error, no OwnerAccount.",
  tronLinkTypeErrorAddUpdateDataNotFunction: "transactionBuilder.addUpdateData",
  tronLinkAuthorizationRequestsAreBeingProcessed: 4e3,
  // imToken
  imTokenUserCanceled: "user_canceled",
  // coinbase wallet
  coinbaseWalletUsingMultipleWallet: "Request method eth_chainId is not supported",
  // Portal Wallet
  portalWalletInsufficientBalance: "input capacity not enough",
  portalWalletValidationFailure: "ValidationFailure(-31)",
  // torus
  torusUserCancelledLogin: "User cancelled login",
  torusUserClosedPopup: "user closed popup",
  // connect did sdk
  connectDidSdkAbort: ActionErrorCode.ABORT,
  connectDidSdkNotFound: ActionErrorCode.NOT_FOUND,
  connectDidSdkNotExist: ActionErrorCode.NOT_EXIST,
  connectDidSdkError: ActionErrorCode.ERROR,
  connectDidSdkSuccess: ActionErrorCode.SUCCESS
};
var TronLinkRequestAccountsResponseCode = /* @__PURE__ */ ((TronLinkRequestAccountsResponseCode2) => {
  TronLinkRequestAccountsResponseCode2[TronLinkRequestAccountsResponseCode2["ok"] = 200] = "ok";
  TronLinkRequestAccountsResponseCode2[TronLinkRequestAccountsResponseCode2["inQueue"] = 4e3] = "inQueue";
  TronLinkRequestAccountsResponseCode2[TronLinkRequestAccountsResponseCode2["userRejected"] = 4001] = "userRejected";
  return TronLinkRequestAccountsResponseCode2;
})(TronLinkRequestAccountsResponseCode || {});
const CYCLE_CALL_FUNCTION_TIME = 5e3;
const TOKEN_DECIMAL_PLACES = 8;
const CKB_TOKEN_DECIMAL_PLACES = 2;
var WalletProtocol = /* @__PURE__ */ ((WalletProtocol2) => {
  WalletProtocol2["metaMask"] = "metaMask";
  WalletProtocol2["tronLink"] = "tronLink";
  WalletProtocol2["torus"] = "torus";
  WalletProtocol2["tokenPocketUTXO"] = "tokenPocketUTXO";
  WalletProtocol2["walletConnect"] = "walletConnect";
  WalletProtocol2["webAuthn"] = "webAuthn";
  return WalletProtocol2;
})(WalletProtocol || {});
const CfAccessClient = {
  // 'Cf-Access-Client-Id': '4e00f1238fe24ac0c3d7870b10294716.access',
  // 'Cf-Access-Client-Secret': 'be225bb474d1f50e9c77ec10d1634b1d15270f5206b8b999e16be1ecb69c464d',
};
const WebAuthnApi = "https://webauthn-api.d.id";
const WebAuthnTestApi = "https://test-webauthn-api.d.id";
const DotbitIndexerApi = "https://indexer-v1.d.id";
const DotbitIndexerTestApi = "https://test-indexer.d.id";
const shadowDomRootStyle = `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit {
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
}

[type='radio']:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e");
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e");
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[16px\\] {
  left: 16px;
}
.left-\\[32px\\] {
  left: 32px;
}
.left-\\[48px\\] {
  left: 48px;
}
.left-\\[64px\\] {
  left: 64px;
}
.left-\\[80px\\] {
  left: 80px;
}
.right-0 {
  right: 0px;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[-16px\\] {
  right: -16px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.z-10 {
  z-index: 10;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[11\\] {
  z-index: 11;
}
.m-auto {
  margin: auto;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-9 {
  margin-bottom: 2.25rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-11 {
  margin-top: 2.75rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[12px\\] {
  height: 12px;
}
.h-\\[146px\\] {
  height: 146px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[19px\\] {
  height: 19px;
}
.h-\\[260px\\] {
  height: 260px;
}
.h-\\[270px\\] {
  height: 270px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[68px\\] {
  height: 68px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-screen {
  height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-3 {
  width: 0.75rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[102px\\] {
  width: 102px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[216px\\] {
  width: 216px;
}
.w-\\[218px\\] {
  width: 218px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[270px\\] {
  width: 270px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[68px\\] {
  width: 68px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[84\\%\\] {
  width: 84%;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[92\\%\\] {
  width: 92%;
}
.w-full {
  width: 100%;
}
.w-full-4px {
  width: calc(100% - 4px);
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-none {
  max-width: none;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-loggedin-button {
  flex: 1 1 calc(50% - 6px);
}
.flex-none {
  flex: none;
}
.shrink {
  flex-shrink: 1;
}
.grow {
  flex-grow: 1;
}
.basis-0 {
  flex-basis: 0px;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-no-drop {
  cursor: no-drop;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[19px\\] {
  border-radius: 19px;
}
.rounded-\\[21px\\] {
  border-radius: 21px;
}
.rounded-\\[26px\\] {
  border-radius: 26px;
}
.rounded-\\[29px\\] {
  border-radius: 29px;
}
.rounded-\\[32px\\] {
  border-radius: 32px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-\\[32px\\] {
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-\\[\\#1EA2EC5C\\] {
  border-color: #1EA2EC5C;
}
.border-\\[\\#5262791A\\] {
  border-color: #5262791A;
}
.border-\\[\\#B6C4D966\\] {
  border-color: #B6C4D966;
}
.border-\\[\\#BEC0C228\\] {
  border-color: #BEC0C228;
}
.border-\\[\\#F9CD4E5B\\] {
  border-color: #F9CD4E5B;
}
.border-\\[\\#F9CD4E5C\\] {
  border-color: #F9CD4E5C;
}
.border-\\[\\#bec0c229\\] {
  border-color: #bec0c229;
}
.border-amber-300\\/40 {
  border-color: rgb(252 211 77 / 0.4);
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.border-slate-300\\/40 {
  border-color: rgb(203 213 225 / 0.4);
}
.border-slate-600\\/10 {
  border-color: rgb(71 85 105 / 0.1);
}
.border-stone-300\\/20 {
  border-color: rgb(214 211 209 / 0.2);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.bg-\\[\\#11142D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 20 45 / var(--tw-bg-opacity));
}
.bg-\\[\\#7AAEEC29\\] {
  background-color: #7AAEEC29;
}
.bg-\\[\\#E3F6ED\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 246 237 / var(--tw-bg-opacity));
}
.bg-\\[\\#F6F7F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 247 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9CD4E28\\] {
  background-color: #F9CD4E28;
}
.bg-\\[\\#F9CD4E29\\] {
  background-color: #F9CD4E29;
}
.bg-\\[\\#FDEDBF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 237 191 / var(--tw-bg-opacity));
}
.bg-\\[unset\\] {
  background-color: unset;
}
.bg-amber-300\\/5 {
  background-color: rgb(252 211 77 / 0.05);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(255 107 107 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-mask-bg {
  background-color: rgba(27, 29, 33, 0.7);
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-secondary {
  background-color: rgba(82, 98, 121, 0.1);
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(34 196 147 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-passkey {
  background-image: linear-gradient(90deg, #00DF9B 0%, #0E7DFF 100%);
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-\\[52px\\] {
  padding-top: 52px;
}
.pt-\\[76px\\] {
  padding-top: 76px;
}
.pt-\\[82px\\] {
  padding-top: 82px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[12px\\] {
  line-height: 12px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-\\[20px\\] {
  line-height: 20px;
}
.leading-\\[22px\\] {
  line-height: 22px;
}
.leading-\\[normal\\] {
  line-height: normal;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-tight {
  line-height: 1.25;
}
.text-\\[\\#00A270\\] {
  --tw-text-opacity: 1;
  color: rgb(0 162 112 / var(--tw-text-opacity));
}
.text-\\[\\#31465C\\] {
  --tw-text-opacity: 1;
  color: rgb(49 70 92 / var(--tw-text-opacity));
}
.text-\\[\\#5F6570\\] {
  --tw-text-opacity: 1;
  color: rgb(95 101 112 / var(--tw-text-opacity));
}
.text-\\[\\#AC6E15\\] {
  --tw-text-opacity: 1;
  color: rgb(172 110 21 / var(--tw-text-opacity));
}
.text-\\[\\#D9D9D9\\] {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}
.text-\\[\\#FFB02E\\] {
  --tw-text-opacity: 1;
  color: rgb(255 176 46 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.text-font-primary {
  --tw-text-opacity: 1;
  color: rgb(18 19 20 / var(--tw-text-opacity));
}
.text-font-secondary {
  --tw-text-opacity: 1;
  color: rgb(176 184 191 / var(--tw-text-opacity));
}
.text-font-tips {
  --tw-text-opacity: 1;
  color: rgb(49 51 62 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-neutral-700 {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-success {
  --tw-text-opacity: 1;
  color: rgb(34 196 147 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
.text-zinc-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.decoration-1 {
  text-decoration-thickness: 1px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-loggedin-button {
  --tw-shadow: 0px 4px 6px 0px rgba(168, 168, 168, 0.05);
  --tw-shadow-colored: 0px 4px 6px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-passkey {
  --tw-shadow: 0px 4px 10px 0px rgba(83, 171, 255, 0.10), 0px 16px 24px 0px rgba(54, 120, 182, 0.10);;
  --tw-shadow-colored: 0px 4px 10px 0px var(--tw-shadow-color), 0px 16px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-toast {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-0 {
  outline-width: 0px;
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\2c width\\] {
  transition-property: height,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
/* For Webkit-based browsers (Chrome, Safari and Opera) */
.scrollbar-hide::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
.dialog-children-container {
    max-height: calc(100vh * 0.7);
  }
.icon {
    display: inline-block;
    vertical-align: middle;
    outline: unset;
    font-size: 1px;
  }
@keyframes rotate-360-deg {
    100% {
      transform: rotate(360deg);
    }
  }
.animation-rotate-360-deg {
    animation: rotate-360-deg 0.9s linear infinite;
  }
@keyframes fade-in {
    from {
      opacity: 0.1;
    }

    to {
      opacity: 1;
    }
  }
@keyframes fade-out {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }
@keyframes fade-in-up {
    from {
      transform: translate3d(0, 10px, 0);
      opacity: 0.1;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
@keyframes fade-out-down {
    from {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }

    to {
      transform: translate3d(0, 10px, 0);
      opacity: 0;
    }
  }
.animation-fade-in {
    animation: fade-in 0.15s cubic-bezier(0.75, 0.25, 0.25, 0.75) forwards;
  }
.animation-fade-out {
    animation: fade-out 0.15s cubic-bezier(0.75, 0.25, 0.25, 0.75) forwards;
  }
.animation-fade-in-up {
    animation: fade-in-up 0.15s cubic-bezier(0.75, 0.25, 0.25, 0.75) forwards;
  }
.animation-fade-out-down {
    animation: fade-out-down 0.15s cubic-bezier(0.75, 0.25, 0.25, 0.75) forwards;
  }
.bg-blur {
    backdrop-filter: blur(22px);
    background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255));
  }
.hover\\:bg-danger-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 86 86 / var(--tw-bg-opacity));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.hover\\:bg-secondary:hover {
  background-color: rgba(82, 98, 121, 0.1);
}
.hover\\:bg-secondary-5:hover {
  background-color: rgba(82, 98, 121, 0.05);
}
.hover\\:bg-secondary-hover:hover {
  background-color: rgba(82, 98, 121, 0.2);
}
.hover\\:bg-slate-600\\/10:hover {
  background-color: rgb(71 85 105 / 0.1);
}
.hover\\:bg-success-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 174 130 / var(--tw-bg-opacity));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.hover\\:opacity-70:hover {
  opacity: 0.7;
}
.hover\\:shadow-none:hover {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-emerald-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.focus\\:outline-offset-1:focus {
  outline-offset: 1px;
}
.focus\\:outline-emerald-400\\/20:focus {
  outline-color: rgb(52 211 153 / 0.2);
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-transparent:focus {
  --tw-ring-color: transparent;
}
.active\\:bg-secondary:active {
  background-color: rgba(82, 98, 121, 0.1);
}
.active\\:bg-secondary-active:active {
  background-color: rgba(82, 98, 121, 0.25);
}
.active\\:bg-slate-600\\/20:active {
  background-color: rgb(71 85 105 / 0.2);
}
.active\\:bg-success-active:active {
  --tw-bg-opacity: 1;
  background-color: rgb(27 157 117 / var(--tw-bg-opacity));
}
.active\\:text-red-500:active {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.active\\:opacity-60:active {
  opacity: 0.6;
}
.active\\:shadow-none:active {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:cursor-no-drop:disabled {
  cursor: no-drop;
}
.disabled\\:bg-danger:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(255 107 107 / var(--tw-bg-opacity));
}
.disabled\\:bg-secondary:disabled {
  background-color: rgba(82, 98, 121, 0.1);
}
.disabled\\:bg-success:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(34 196 147 / var(--tw-bg-opacity));
}
.disabled\\:bg-passkey:disabled {
  background-image: linear-gradient(90deg, #00DF9B 0%, #0E7DFF 100%);
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media not all and (min-width: 640px) {

  .max-sm\\:simple-router-mobile-max-h {
    max-height: calc(100vh * 0.9);
  }
}
@media (min-width: 640px) {

  .sm\\:max-h-\\[588px\\] {
    max-height: 588px;
  }
}
`;
let shadowDomRoot = null;
async function sleep(ms) {
  await new Promise((resolve) => setTimeout(resolve, ms));
}
function isHexStrict(hex) {
  return /^(-)?0x[0-9a-f]*$/i.test(String(hex));
}
function toBN(number) {
  try {
    return numberToBN(number);
  } catch (err) {
    throw new Error(`${String(err)} Given value: "${number}"`);
  }
}
function hexToNumber(value) {
  if (typeof value === "string" && !isHexStrict(value)) {
    throw new Error('Given value "' + value + '" is not a valid hex string.');
  }
  return toBN(value).toNumber();
}
function chainIdHexToNumber(chainId) {
  const _chainId = isHexStrict(chainId) ? hexToNumber(chainId) : chainId;
  return Number(_chainId);
}
function toChecksumAddress(address) {
  if (typeof address === "undefined")
    return "";
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address))
    throw new Error(`Given address "${address}" is not a valid Ethereum address.`);
  address = address.toLowerCase().replace(/^0x/i, "");
  const hash = new Keccak(256).update(address).digest("hex");
  const addressHash = hash.replace(/^0x/i, "");
  let checksumAddress = "0x";
  for (let i = 0; i < address.length; i++) {
    if (parseInt(addressHash[i], 16) > 7) {
      checksumAddress += address[i].toUpperCase();
    } else {
      checksumAddress += address[i];
    }
  }
  return checksumAddress;
}
function utf8ToHex(str) {
  str = utf8.encode(str);
  let hex = "";
  str = str.replace(/^(?:\u0000)*/, "");
  str = str.split("").reverse().join("");
  str = str.replace(/^(?:\u0000)*/, "");
  str = str.split("").reverse().join("");
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const n = code.toString(16);
    hex += n.length < 2 ? "0" + n : n;
  }
  return "0x" + hex;
}
function numberToHex(value) {
  if (!isFinite(Number(value)) && !isHexStrict(value)) {
    throw new Error('Given input "' + String(value) + '" is not a number.');
  }
  const number = toBN(value);
  const result = number.toString(16);
  return number.lt(new BN(0)) ? "-0x" + result.slice(1) : "0x" + result;
}
function toDecimal(value) {
  return new Decimal(value);
}
function mmJsonHashAndChainIdHex(typedData, chainId) {
  const mmHash = TypedDataUtils.eip712Hash(typedData, SignTypedDataVersion.V4).toString("hex");
  const chainIdHex = new BN(chainId).toString(16, 16);
  return mmHash + chainIdHex;
}
function convertTpUTXOSignature(base64SignData) {
  const buffer = Buffer2.from(base64SignData, "base64");
  if (buffer.length !== 65)
    throw new Error("Invalid signature length");
  const flagByte = buffer.readUInt8(0) - 27;
  if (flagByte > 15 || flagByte < 0) {
    throw new Error("Invalid signature parameter");
  }
  const decodeData = {
    compressed: !!(flagByte & 12),
    segwitType: !(flagByte & 8) ? null : !(flagByte & 4) ? "p2sh(p2wpkh)" : "p2wpkh",
    recovery: flagByte & 3,
    signature: buffer.slice(1)
  };
  const signData = Buffer2.concat([
    decodeData.signature,
    Buffer2.from([decodeData.recovery]),
    Buffer2.from([decodeData.compressed ? 1 : 0])
  ]);
  return "0x" + signData.toString("hex");
}
function isDogecoinChain(coinType) {
  return coinType === CoinType.doge;
}
function collapseString(inputString = "", head = 4, tail = 4, tokenStr = "...") {
  const splitter = new GraphemeSplitter();
  const split = splitter.splitGraphemes(inputString);
  if (split.length > 12) {
    return split.slice(0, head).join("") + tokenStr + split.slice(split.length - tail, split.length).join("");
  }
  return inputString;
}
function smartOpen(link) {
  if (isMobileOnly) {
    window.location.href = link;
  } else {
    window.open(link);
  }
}
async function copyText(text, el) {
  return abcCopy(text, {
    target: el
  });
}
async function checkWebAuthnSupport() {
  var _a2, _b, _c;
  if (typeof window !== "undefined") {
    const urlParams = new globalThis.URLSearchParams(window.location.search);
    const isDebug = urlParams.get("debug") === "true";
    if (isDebug) {
      return true;
    }
  }
  const uaParser = new UAParser((_a2 = globalThis.navigator) == null ? void 0 : _a2.userAgent);
  if (uaParser.getOS().name === "iOS" && parseInt(((_b = uaParser.getOS().version) == null ? void 0 : _b.split(".")[0]) ?? "0", 10) < 16 || uaParser.getOS().name === "Mac OS" && uaParser.getBrowser().name === "Safari" && parseInt(((_c = uaParser.getBrowser().version) == null ? void 0 : _c.split(".")[0]) ?? "0", 10) < 16) {
    return false;
  }
  if (uaParser.getDevice().vendor === "Huawei" || uaParser.getBrowser().name === "Huawei Browser") {
    return false;
  }
  if ("credentials" in globalThis.navigator && "PublicKeyCredential" in window) {
    try {
      const isAvailable = await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
      if (isAvailable) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  } else {
    return false;
  }
}
function checkICloudPasskeySupport() {
  var _a2, _b, _c;
  const uaParser = new UAParser((_a2 = globalThis.navigator) == null ? void 0 : _a2.userAgent);
  if (uaParser.getOS().name === "iOS" && parseInt(((_b = uaParser.getOS().version) == null ? void 0 : _b.split(".")[0]) ?? "0", 10) >= 16 || uaParser.getOS().name === "Mac OS" && uaParser.getBrowser().name === "Safari" && parseInt(((_c = uaParser.getBrowser().version) == null ? void 0 : _c.split(".")[0]) ?? "0", 10) >= 16) {
    return true;
  }
  return false;
}
function getShadowDomRoot() {
  let _shadowDomRoot;
  if (shadowDomRoot) {
    _shadowDomRoot = shadowDomRoot;
  } else {
    const el = document.createElement("wallet-bridge");
    document.body.appendChild(el);
    shadowDomRoot = el.attachShadow({ mode: "open" });
    const styleEl = document.createElement("style");
    styleEl.innerHTML = shadowDomRootStyle;
    shadowDomRoot.appendChild(styleEl);
    _shadowDomRoot = shadowDomRoot;
  }
  return _shadowDomRoot;
}
function isMetaMask(ethereum) {
  if (!(ethereum == null ? void 0 : ethereum.isMetaMask))
    return false;
  if (ethereum.isBraveWallet && !ethereum._events && !ethereum._state)
    return false;
  if (ethereum.isApexWallet)
    return false;
  if (ethereum.isAvalanche)
    return false;
  if (ethereum.isBackpack)
    return false;
  if (ethereum.isBifrost)
    return false;
  if (ethereum.isBitKeep)
    return false;
  if (ethereum.isBitski)
    return false;
  if (ethereum.isBlockWallet)
    return false;
  if (ethereum.isCoinbaseWallet)
    return false;
  if (ethereum.isDawn)
    return false;
  if (ethereum.isEnkrypt)
    return false;
  if (ethereum.isExodus)
    return false;
  if (ethereum.isFrame)
    return false;
  if (ethereum.isFrontier)
    return false;
  if (ethereum.isGamestop)
    return false;
  if (ethereum.isHyperPay)
    return false;
  if (ethereum.isImToken)
    return false;
  if (ethereum.isKuCoinWallet)
    return false;
  if (ethereum.isMathWallet)
    return false;
  if (ethereum.isOkxWallet || ethereum.isOKExWallet)
    return false;
  if (ethereum.isOneInchIOSWallet || ethereum.isOneInchAndroidWallet)
    return false;
  if (ethereum.isOpera)
    return false;
  if (ethereum.isPhantom)
    return false;
  if (ethereum.isPortal)
    return false;
  if (ethereum.isRabby)
    return false;
  if (ethereum.isRainbow)
    return false;
  if (ethereum.isStatus)
    return false;
  if (ethereum.isTalisman)
    return false;
  if (ethereum.isTally)
    return false;
  if (ethereum.isTokenPocket)
    return false;
  if (ethereum.isTokenary)
    return false;
  if (ethereum.isTrust || ethereum.isTrustWallet)
    return false;
  if (ethereum.isXDEFI)
    return false;
  if (ethereum.isZerion)
    return false;
  return true;
}
function shouldUseWalletConnect() {
  var _a2;
  const isMetaMaskInjected = typeof window !== "undefined" && typeof window.ethereum !== "undefined" && (((_a2 = window.ethereum.providers) == null ? void 0 : _a2.some(isMetaMask)) || window.ethereum.isMetaMask);
  return !isMetaMaskInjected;
}
function getWalletDeepLink(walletName, displayUri) {
  if (walletName === CustomWallet.metaMask) {
    return `metamask://wc?uri=${globalThis.encodeURIComponent(displayUri)}`;
  } else if (walletName === CustomWallet.trustWallet) {
    return `trust://wc?uri=${globalThis.encodeURIComponent(displayUri)}`;
  } else if (walletName === CustomWallet.imToken) {
    return `imtokenv2://wc?uri=${globalThis.encodeURIComponent(displayUri)}`;
  } else if (walletName === CustomWallet.tokenPocket) {
    return `tpoutside://wc?uri=${globalThis.encodeURIComponent(displayUri)}`;
  } else if (walletName === CustomWallet.oneKey) {
    return `onekey-wallet://wc?uri=${globalThis.encodeURIComponent(displayUri)}`;
  }
  return "";
}
function openDeepLink(deepLink) {
  if (!deepLink || !isMobile) {
    return;
  }
  if (deepLink.startsWith("http")) {
    const link = document.createElement("a");
    link.href = deepLink;
    link.target = "_blank";
    link.rel = "noreferrer noopener";
    link.click();
  } else {
    window.location.href = deepLink;
  }
}
async function loadScript(src, id) {
  var _a2;
  const script = "script";
  const firstScript = document.getElementsByTagName(script)[0];
  if (document.getElementById(id)) {
    await Promise.resolve();
    return;
  }
  const scriptElement = document.createElement(script);
  scriptElement.id = id;
  scriptElement.src = src;
  (_a2 = firstScript.parentNode) == null ? void 0 : _a2.insertBefore(scriptElement, firstScript);
  return await new Promise((resolve, reject) => {
    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
  });
}
function Portal({ children, customRootId, className }) {
  let portalRoot = null;
  const rootId = customRootId ?? "portal-root";
  const shadowDomRoot2 = getShadowDomRoot();
  if (shadowDomRoot2.getElementById(rootId) !== null) {
    portalRoot = shadowDomRoot2.getElementById(rootId);
    if (className && portalRoot !== null) {
      portalRoot.className = className;
    }
  } else {
    const divDOM = document.createElement("div");
    divDOM.id = rootId;
    shadowDomRoot2.appendChild(divDOM);
    portalRoot = divDOM;
    if (className) {
      portalRoot.className = className;
    }
  }
  useEffect(
    () => () => {
      if (portalRoot) {
        shadowDomRoot2 == null ? void 0 : shadowDomRoot2.removeChild(portalRoot);
      }
    },
    [portalRoot, shadowDomRoot2]
  );
  return createPortal(children, portalRoot);
}
function Modal({ isOpen, children, customRootId, className, zIndex = "z-[10]" }) {
  const [removeDOM, setRemoveDOM] = useState(!isOpen);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      setRemoveDOM(false);
    } else {
      setTimeout(() => {
        setRemoveDOM(true);
        document.body.style.overflow = "auto";
      }, 150);
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  return removeDOM ? null : /* @__PURE__ */ jsxs(Portal, { customRootId, className, children: [
    /* @__PURE__ */ jsx(Mask, { zIndex, isOpen }),
    /* @__PURE__ */ jsx("div", { className: clsx("fixed left-0 top-0 flex h-full w-full items-center justify-center", zIndex), children })
  ] });
}
function Header({ title, className, goBack, onClose, style }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style,
      className: clsx(
        "relative flex items-center rounded-t-[32px]",
        goBack != null ? "justify-around" : "justify-between",
        className
      ),
      children: [
        goBack != null ? /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(
              "absolute left-6 inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-lg hover:bg-secondary active:bg-secondary-active"
            ),
            onClick: goBack,
            children: /* @__PURE__ */ jsx(ArrowLeftIcon, { className: "h-3 w-3 text-[#D9D9D9]" })
          }
        ) : null,
        /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(
              "w-[84%] truncate text-2xl font-semibold leading-7 text-font-primary",
              goBack != null ? "text-center" : "text-left",
              "h-7"
            ),
            children: title
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(
              "absolute right-6 inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-lg hover:bg-secondary active:bg-secondary-active"
            ),
            onClick: onClose,
            children: /* @__PURE__ */ jsx(CloseIcon, { className: "h-3 w-3 text-[#D9D9D9]" })
          }
        )
      ]
    }
  );
}
function Dialog({
  isOpen,
  title,
  children,
  customRootId,
  containerXMargin = "mx-6",
  containerYMargin = "my-0",
  zIndex = "z-[10]",
  onClose,
  goBack
}) {
  return /* @__PURE__ */ jsx(Modal, { customRootId: customRootId ?? "dialog-root", isOpen, zIndex, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "box-border w-[92%] max-w-[400px] overflow-hidden rounded-[32px] border-2 border-solid border-[#5262791A] bg-white",
        isOpen ? "animation-fade-in-up" : "animation-fade-out-down"
      ),
      children: [
        /* @__PURE__ */ jsx(Header, { className: "p-6", title, goBack, onClose }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(
              "scrollbar-hide dialog-children-container overflow-y-auto",
              containerXMargin,
              containerYMargin
            ),
            children
          }
        )
      ]
    }
  ) });
}
var createRoot;
var m = require$$0;
if (process.env.NODE_ENV === "production") {
  createRoot = m.createRoot;
  m.hydrateRoot;
} else {
  var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  createRoot = function(c, o) {
    i.usingClientEntryPoint = true;
    try {
      return m.createRoot(c, o);
    } finally {
      i.usingClientEntryPoint = false;
    }
  };
}
let tipsCustomRootId = 0;
function Tips({ visible, title, content, confirmBtnText, onClose, onConfirm }) {
  const [isOpen, setIsOpen] = useState(visible);
  tipsCustomRootId = tipsCustomRootId + 1;
  const close = () => {
    onClose == null ? void 0 : onClose();
    setIsOpen(false);
  };
  const confirm = () => {
    onConfirm == null ? void 0 : onConfirm();
    setIsOpen(false);
  };
  return /* @__PURE__ */ jsxs(Dialog, { customRootId: `tips-${tipsCustomRootId}`, isOpen, title, onClose: close, zIndex: "z-[11]", children: [
    /* @__PURE__ */ jsx("div", { className: "mb-8 mt-2", children: content }),
    /* @__PURE__ */ jsx(Button, { className: "mb-6 w-full", shape: ButtonShape.round, onClick: confirm, children: confirmBtnText ?? "OK" })
  ] });
}
const createTips = (props) => {
  const tipsProps = {
    ...props,
    visible: true
  };
  const shadowDomRoot2 = getShadowDomRoot();
  const instance = React.createElement(Tips, tipsProps);
  createRoot(shadowDomRoot2).render(instance);
};
var TagVariant = /* @__PURE__ */ ((TagVariant2) => {
  TagVariant2["default"] = "default";
  TagVariant2["primary"] = "primary";
  return TagVariant2;
})(TagVariant || {});
const variantClasses = {
  [
    "default"
    /* default */
  ]: "text-font-tips bg-secondary",
  [
    "primary"
    /* primary */
  ]: "text-[#00A270] bg-[#E3F6ED]"
};
function Tag({ variant = "default", children, className }) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: clsx(
        "box-border inline-block rounded px-1 py-0.5 text-sm font-medium leading-none",
        variantClasses[variant],
        className
      ),
      children
    }
  );
}
var AlertType = /* @__PURE__ */ ((AlertType2) => {
  AlertType2["warning"] = "warning";
  return AlertType2;
})(AlertType || {});
const typeClasses = {
  [
    "warning"
    /* warning */
  ]: "text-[#AC6E15] bg-[#F9CD4E28] border-[#F9CD4E5B]"
};
function Alert({ type = "warning", children, className, icon }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("box-border flex items-center rounded-xl border p-3 leading-none", typeClasses[type], className),
      children: [
        icon ? /* @__PURE__ */ jsxs("span", { className: "flex", children: [
          icon,
          /* @__PURE__ */ jsx("span", { className: "mx-3 w-px bg-[#FDEDBF]" })
        ] }) : null,
        children
      ]
    }
  );
}
function getTransitionStyle(state) {
  switch (state) {
    case ENTERING:
      return { opacity: "100%" };
    case ENTERED:
      return { opacity: "100%" };
    case EXITING:
      return { opacity: "0%" };
    case EXITED:
      return { opacity: "0%" };
    case UNMOUNTED:
      return { opacity: "0%" };
  }
}
function SwapTransition({ children, className, duration }) {
  if (children.key === null || children.key === void 0)
    throw new Error("Child in SwapTransition must have a key");
  const [childRect, setChildRect] = useState();
  const [animating, setAnimating] = useState(false);
  const transitionRef = useRef(null);
  const observer = useMemo(
    () => new ResizeObserver((entries) => {
      setChildRect(entries[0].target.getBoundingClientRect());
    }),
    [setChildRect]
  );
  return /* @__PURE__ */ jsx(
    TransitionGroup,
    {
      className: clsx(
        className,
        "scrollbar-hide max-w-full transition-[height,width] ease-in-out",
        animating ? "overflow-hidden" : "overflow-scroll"
      ),
      style: { height: childRect == null ? void 0 : childRect.height, width: childRect == null ? void 0 : childRect.width, transitionDuration: `${duration}ms` },
      component: "div",
      children: /* @__PURE__ */ jsx(
        Transition,
        {
          unmountOnExit: true,
          appear: true,
          nodeRef: transitionRef,
          onEnter: () => {
            var _a2;
            setChildRect((_a2 = transitionRef.current) == null ? void 0 : _a2.getBoundingClientRect());
            observer.disconnect();
            observer.observe(transitionRef.current);
            setAnimating(true);
          },
          onEntered: () => {
            setAnimating(false);
          },
          timeout: duration,
          children: (state) => {
            return React.cloneElement(children, {
              transitionStyle: {
                transitionProperty: "opacity",
                transitionDuration: `${duration}ms`,
                transitionTimingFunction: "ease-in-out",
                ...getTransitionStyle(state)
              },
              transitionRef
            });
          }
        },
        children.key
      )
    }
  );
}
class CustomError extends Error {
  constructor(code, message) {
    super(message);
    __publicField(this, "code");
    this.code = code;
  }
}
Axios.defaults.withCredentials = true;
const WalletStateKey = "WalletStateV1";
const walletStateLocalStorage = globalThis.localStorage ? globalThis.localStorage.getItem(WalletStateKey) : null;
const localWalletState = walletStateLocalStorage ? JSON.parse(walletStateLocalStorage) : {
  protocol: void 0,
  address: void 0,
  coinType: void 0,
  walletName: void 0,
  hardwareWalletTipsShow: true,
  deviceData: void 0,
  ckbAddresses: [],
  masterNotes: void 0,
  masterDevice: void 0,
  deviceList: [],
  isTestNet: false,
  loggedInSelectAddress: true,
  canAddDevice: false,
  isSwitchAddress: false,
  iCloudPasskeySupport: false,
  customChains: [],
  customWallets: [],
  alias: ""
};
const walletState = proxy({
  ...localWalletState,
  deviceList: (_a = localWalletState.deviceList) == null ? void 0 : _a.map(
    (i) => typeof i === "string" ? { address: i } : i
  )
});
async function fetchAuthorizeInfo(api, address) {
  var _a2, _b, _c;
  const { isTestNet } = snapshot(walletState);
  const res = await Axios.post(
    `${api}/v1/webauthn/authorize-info`,
    {
      ckb_address: address
    },
    {
      headers: isTestNet ? { ...CfAccessClient } : {}
    }
  );
  if (((_a2 = res.data) == null ? void 0 : _a2.err_no) !== errno.success) {
    throw new CustomError((_b = res.data) == null ? void 0 : _b.err_no, (_c = res.data) == null ? void 0 : _c.err_msg);
  }
  return res.data.data;
}
function setAuthorizeState(data, address = "") {
  const record = {
    masterNotes: data.master_notes,
    masterDevice: data.master_device,
    canAddDevice: data.can_authorize !== 0,
    deviceList: data.ckb_address
  };
  if (address) {
    record.address = address;
    const { deviceData } = snapshot(walletState);
    if ((deviceData == null ? void 0 : deviceData.ckbAddr) === address) {
      record.deviceData = {
        ...deviceData,
        name: data.master_notes || deviceData.name,
        device: data.master_device || deviceData.device
      };
    }
  }
  setWalletState(record);
}
async function getAuthorizeInfo({ detectAssets = false } = {}) {
  const { protocol, isTestNet, address, isSwitchAddress, ckbAddresses } = snapshot(walletState);
  if (protocol !== WalletProtocol.webAuthn || !address)
    return;
  const api = isTestNet ? WebAuthnTestApi : WebAuthnApi;
  const data = await fetchAuthorizeInfo(api, address);
  if (data.can_authorize !== 0 || !detectAssets || isSwitchAddress || !(ckbAddresses && ckbAddresses.length > 0)) {
    setAuthorizeState(data, address);
    return;
  }
  let isSetAddress = false;
  for (const item of ckbAddresses) {
    const res = await fetchAuthorizeInfo(api, item);
    if (res.can_authorize !== 0) {
      isSetAddress = true;
      setAuthorizeState(res, item);
      break;
    }
  }
  if (!isSetAddress) {
    setAuthorizeState(data, address);
  }
}
async function getMastersAddress() {
  var _a2, _b, _c;
  const { protocol, isTestNet, deviceData } = snapshot(walletState);
  const cid = deviceData == null ? void 0 : deviceData.credential.rawId;
  if (protocol === WalletProtocol.webAuthn && cid) {
    const api = isTestNet ? WebAuthnTestApi : WebAuthnApi;
    const mastersAddress = await Axios.post(
      `${api}/v1/webauthn/get-masters-addr`,
      {
        cid
      },
      {
        headers: isTestNet ? { ...CfAccessClient } : {}
      }
    );
    if (((_a2 = mastersAddress.data) == null ? void 0 : _a2.err_no) === errno.success) {
      setWalletState({
        ckbAddresses: mastersAddress.data.data.ckb_address
      });
    } else {
      throw new CustomError((_b = mastersAddress.data) == null ? void 0 : _b.err_no, (_c = mastersAddress.data) == null ? void 0 : _c.err_msg);
    }
  }
}
async function getDotbitAlias() {
  var _a2, _b, _c, _d, _e;
  const { coinType, isTestNet, address } = snapshot(walletState);
  const api = isTestNet ? DotbitIndexerTestApi : DotbitIndexerApi;
  const aliasInfo = await Axios.post(
    `${api}/v1/reverse/record`,
    {
      type: "blockchain",
      key_info: { coin_type: coinType, key: address }
    },
    {
      headers: isTestNet ? { ...CfAccessClient } : {}
    }
  );
  if (((_a2 = aliasInfo.data) == null ? void 0 : _a2.err_no) === errno.success) {
    if ((_c = (_b = aliasInfo.data) == null ? void 0 : _b.data) == null ? void 0 : _c.account_alias) {
      setWalletState({
        alias: aliasInfo.data.data.account_alias
      });
    } else {
      setWalletState({
        alias: ""
      });
    }
  } else {
    throw new CustomError((_d = aliasInfo.data) == null ? void 0 : _d.err_no, (_e = aliasInfo.data) == null ? void 0 : _e.err_msg);
  }
}
async function backupDeviceData() {
  const { isTestNet, deviceData, address, masterNotes } = snapshot(walletState);
  if (masterNotes || (deviceData == null ? void 0 : deviceData.ckbAddr) !== address) {
    return;
  }
  const api = isTestNet ? WebAuthnTestApi : WebAuthnApi;
  const cfAccessClient = isTestNet ? CfAccessClient : {};
  const res = await fetch(`${api}/v1/webauthn/add-cid-info`, {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...cfAccessClient
    },
    body: JSON.stringify({
      ckb_addr: deviceData == null ? void 0 : deviceData.ckbAddr,
      cid: deviceData == null ? void 0 : deviceData.credential.rawId,
      notes: deviceData == null ? void 0 : deviceData.name,
      device: (deviceData == null ? void 0 : deviceData.device) || (deviceData == null ? void 0 : deviceData.name.split("-")[0])
    })
  }).then(async (res2) => await res2.json());
  return res;
}
const setWalletState = ({
  protocol,
  address,
  coinType,
  walletName,
  hardwareWalletTipsShow,
  deviceData,
  masterNotes,
  masterDevice,
  ckbAddresses,
  deviceList,
  isTestNet,
  loggedInSelectAddress,
  canAddDevice,
  isSwitchAddress,
  customChains,
  customWallets,
  alias
}, isSwitch = false) => {
  if (protocol) {
    walletState.protocol = protocol;
  }
  if (coinType) {
    walletState.coinType = coinType;
  }
  if (walletName) {
    walletState.walletName = walletName;
  }
  if (address) {
    walletState.address = address;
  }
  if (hardwareWalletTipsShow !== void 0) {
    walletState.hardwareWalletTipsShow = hardwareWalletTipsShow;
  }
  if (deviceData) {
    walletState.deviceData = merge(walletState.deviceData, deviceData);
  }
  if (ckbAddresses) {
    walletState.ckbAddresses = ckbAddresses;
  }
  if (isSwitch) {
    walletState.masterNotes = masterNotes;
    walletState.masterDevice = masterDevice;
  } else if (masterNotes) {
    walletState.masterNotes = masterNotes;
  } else if (masterDevice) {
    walletState.masterDevice = masterDevice;
  }
  if (deviceList) {
    walletState.deviceList = deviceList;
  }
  if (isTestNet !== void 0) {
    walletState.isTestNet = isTestNet;
  }
  if (loggedInSelectAddress !== void 0) {
    walletState.loggedInSelectAddress = loggedInSelectAddress;
  }
  if (canAddDevice !== void 0) {
    walletState.canAddDevice = canAddDevice;
  }
  if (isSwitchAddress !== void 0) {
    walletState.isSwitchAddress = isSwitchAddress;
  }
  if (customChains !== void 0) {
    walletState.customChains = customChains;
  }
  if (customWallets !== void 0) {
    walletState.customWallets = customWallets;
  }
  if (alias !== void 0) {
    walletState.alias = alias;
  }
  walletState.iCloudPasskeySupport = checkICloudPasskeySupport();
  globalThis.localStorage.setItem(WalletStateKey, JSON.stringify(walletState));
};
const resetWalletState = () => {
  walletState.protocol = void 0;
  walletState.coinType = void 0;
  walletState.walletName = void 0;
  walletState.address = void 0;
  walletState.deviceData = void 0;
  walletState.ckbAddresses = [];
  walletState.masterNotes = void 0;
  walletState.masterDevice = void 0;
  walletState.deviceList = [];
  walletState.canAddDevice = false;
  walletState.isSwitchAddress = false;
  walletState.alias = "";
  globalThis.localStorage.setItem(WalletStateKey, JSON.stringify(walletState));
};
function useWalletState() {
  const walletSnap = useSnapshot(walletState);
  return { walletSnap };
}
function getWalletState() {
  const walletSnap = snapshot(walletState);
  return { walletSnap };
}
class WalletContext {
  constructor({
    isTestNet,
    wagmiConfig,
    gtag,
    event
  }) {
    // sendTrx method
    __publicField(this, "provider");
    __publicField(this, "protocol");
    __publicField(this, "address");
    __publicField(this, "chainId");
    __publicField(this, "coinType");
    __publicField(this, "isTestNet", false);
    __publicField(this, "torusWallet");
    __publicField(this, "wagmiConfig");
    __publicField(this, "walletName");
    // event emitter
    __privateAdd(this, _emitter, new Emittery());
    __publicField(this, "gtag");
    __publicField(this, "event");
    this.isTestNet = isTestNet;
    this.wagmiConfig = wagmiConfig;
    if (gtag) {
      this.gtag = gtag;
    }
    if (event) {
      this.event = event;
    }
  }
  reportEvent(action, options) {
    try {
      if (this.gtag) {
        this.gtag("event", action, {
          event_category: options.category,
          event_label: options.label,
          value: options.value,
          non_interaction: options.nonInteraction,
          user_id: options.userId
        });
      } else if (this.event) {
        this.event(action, {
          category: options.category,
          label: options.label,
          value: options.value,
          nonInteraction: options.nonInteraction,
          userId: options.userId
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  async retrieveProvider({ coinType, walletName }) {
    const walletSnap = snapshot(walletState);
    if (walletSnap == null ? void 0 : walletSnap.address) {
      this.address = walletSnap == null ? void 0 : walletSnap.address;
    }
    if (walletName) {
      this.walletName = walletName;
    } else {
      this.walletName = walletSnap == null ? void 0 : walletSnap.walletName;
    }
    if (coinType) {
      this.coinType = coinType;
    } else {
      this.coinType = walletSnap == null ? void 0 : walletSnap.coinType;
    }
    if (this.coinType) {
      this.chainId = this.isTestNet ? CoinTypeToTestNetChainIdMap[this.coinType] : CoinTypeToChainIdMap[this.coinType];
    }
    if (this.walletName && this.coinType) {
      if (this.walletName === CustomChain.passkey) {
        this.protocol = WalletProtocol.webAuthn;
      } else if (this.walletName === CustomChain.torus) {
        this.protocol = WalletProtocol.torus;
      } else if (this.walletName === CustomWallet.walletConnect) {
        this.protocol = WalletProtocol.walletConnect;
      } else if (this.coinType === CoinType.doge) {
        this.protocol = WalletProtocol.tokenPocketUTXO;
      } else if (this.coinType === CoinType.trx) {
        this.protocol = WalletProtocol.tronLink;
      } else {
        this.protocol = WalletProtocol.metaMask;
      }
    } else {
      this.protocol = walletSnap == null ? void 0 : walletSnap.protocol;
    }
    switch (this.protocol) {
      case WalletProtocol.metaMask:
        await this.getMetaMaskProvider();
        break;
      case WalletProtocol.tronLink:
        await this.getTronLinkProvider();
        break;
      case WalletProtocol.torus:
        await this.getTorusProvider();
        break;
      case WalletProtocol.tokenPocketUTXO:
        await this.getTokenPocketUTXOProvider();
        break;
      case WalletProtocol.webAuthn:
        this.getConnectDIDProvider();
        break;
      case WalletProtocol.walletConnect:
        await this.getWalletConnectProvider();
        break;
    }
  }
  emitEvent(event, data) {
    void __privateGet(this, _emitter).emit(event, data);
  }
  async once(event) {
    return await __privateGet(this, _emitter).once(event);
  }
  addEventListener(event, callback) {
    __privateGet(this, _emitter).on(event, callback);
  }
  removeEventListener(event, callback) {
    __privateGet(this, _emitter).off(event, callback);
  }
  clearEventListeners() {
    __privateGet(this, _emitter).clearListeners();
  }
  async getMetaMaskProvider() {
    var _a2;
    if ((_a2 = this.torusWallet) == null ? void 0 : _a2.hideTorusButton) {
      this.torusWallet.hideTorusButton();
    }
    if (this.wagmiConfig) {
      if (shouldUseWalletConnect()) {
        const walletConnectConnector = this.wagmiConfig.connectors.find((item) => {
          return item.id === "walletConnect" && item.options.showQrModal === false;
        });
        this.provider = await walletConnectConnector.getProvider();
      } else {
        const metaMaskConnector = this.wagmiConfig.connectors.find((item) => {
          return this.walletName === "MetaMask" ? item.id === "metaMask" : item.id === "injected";
        });
        this.provider = await metaMaskConnector.getProvider();
      }
    } else {
      throw new CustomError(errno.failedToInitializeWallet, "getWalletConnectProvider: wagmiConfig is undefined");
    }
  }
  async getWalletConnectProvider() {
    var _a2;
    if ((_a2 = this.torusWallet) == null ? void 0 : _a2.hideTorusButton) {
      this.torusWallet.hideTorusButton();
    }
    if (this.wagmiConfig) {
      let walletConnectConnector;
      if (isMobile) {
        walletConnectConnector = this.wagmiConfig.connectors.find((item) => {
          return item.id === "walletConnect" && item.options.showQrModal === true;
        });
      } else {
        walletConnectConnector = this.wagmiConfig.connectors.find((item) => {
          return item.id === "walletConnect" && item.options.showQrModal === false;
        });
      }
      this.provider = await walletConnectConnector.getProvider();
    } else {
      throw new CustomError(errno.failedToInitializeWallet, "getWalletConnectProvider: wagmiConfig is undefined");
    }
  }
  async getTokenPocketUTXOProvider() {
    var _a2;
    if ((_a2 = this.torusWallet) == null ? void 0 : _a2.hideTorusButton) {
      this.torusWallet.hideTorusButton();
    }
    await sleep(1e3);
    const { bitcoin } = window;
    if (typeof bitcoin !== "undefined") {
      if (bitcoin.isTokenPocket) {
        this.provider = bitcoin;
      } else {
        throw new Error("Please try again after unlocking your TokenPocket wallet");
      }
    } else {
      if (isMobile) {
        if (isAndroid) {
          throw new Error("Please open this page in your crypto wallet App and try again.");
        } else {
          throw new Error("Please download TokenPocket, connect your Dogecoin wallet within the app, and retry.");
        }
      } else {
        throw new Error("Please download TokenPocket, connect your Dogecoin wallet within the app, and retry.");
      }
    }
  }
  async getTorusProvider() {
    if (!this.torusWallet) {
      this.torusWallet = new Torus({
        buttonPosition: "bottom-right"
      });
    }
    try {
      let host;
      if (this.coinType) {
        host = this.isTestNet ? CoinTypeToTorusHostTestNetMap[this.coinType] : CoinTypeToTorusHostMap[this.coinType];
      } else {
        host = this.isTestNet ? CoinTypeToTorusHostTestNetMap[CoinType.eth] : CoinTypeToTorusHostMap[CoinType.eth];
      }
      if (!this.torusWallet.isLoggedIn) {
        await this.torusWallet.init({
          showTorusButton: true,
          network: {
            host
          }
        });
        await this.torusWallet.login();
      }
      this.provider = this.torusWallet.ethereum;
    } catch (error) {
      this.torusWallet.hideTorusButton();
      throw error;
    }
  }
  async getTronLinkProvider() {
    var _a2;
    if ((_a2 = this.torusWallet) == null ? void 0 : _a2.hideTorusButton) {
      this.torusWallet.hideTorusButton();
    }
    await sleep(1e3);
    const { tronWeb } = window;
    if (typeof tronWeb !== "undefined") {
      if (tronWeb.defaultAddress.base58) {
        this.provider = tronWeb;
      } else {
        throw Error("Please try again after unlocking your Tron wallet");
      }
    } else {
      if (isMobile) {
        throw new Error("Please open this page in your crypto wallet App and try again.");
      } else {
        const name = this.coinType && CoinTypeToChainMap[this.coinType].name;
        throw new Error(
          `Please ensure that your browser has the ${String(name)} wallet plugin installed and try again.`
        );
      }
    }
  }
  getConnectDIDProvider() {
    var _a2;
    if ((_a2 = this.torusWallet) == null ? void 0 : _a2.hideTorusButton) {
      this.torusWallet.hideTorusButton();
    }
    let isDebug = false;
    if (typeof window !== "undefined") {
      const urlParams = new globalThis.URLSearchParams(window.location.search);
      isDebug = urlParams.get("debug") === "true";
    }
    this.provider = new ConnectDID(this.isTestNet, isDebug);
  }
}
_emitter = new WeakMap();
var EventEnum = /* @__PURE__ */ ((EventEnum2) => {
  EventEnum2["Connect"] = "walletConnect";
  EventEnum2["Disconnect"] = "walletDisconnect";
  EventEnum2["Change"] = "walletChange";
  EventEnum2["Error"] = "walletError";
  EventEnum2["Signature"] = "signature";
  return EventEnum2;
})(EventEnum || {});
class WalletEventListener {
  constructor(context) {
    __publicField(this, "context");
    this.context = context;
  }
}
class MetaMaskEventListener extends WalletEventListener {
  constructor() {
    super(...arguments);
    __publicField(this, "unwatchAccount");
    __publicField(this, "unwatchNetwork");
  }
  listenEvents() {
    console.log("listenEvents");
    this.unwatchAccount = watchAccount(async (account) => {
      console.log("watchAccount: ", account);
      const { address: oldAddress } = this.context;
      const { address, isConnected } = account;
      if (isConnected) {
        if (!oldAddress) {
          return;
        }
        if (address && oldAddress && oldAddress.toLowerCase() === address.toLowerCase()) {
          return;
        }
        this.context.address = toChecksumAddress(String(address));
        setWalletState({
          address: this.context.address
        });
        this.context.emitEvent(EventEnum.Change);
      }
    });
    this.unwatchNetwork = watchNetwork((network) => {
      console.log("watchNetwork: ", network.chain);
      const { chain } = network;
      if (!chain) {
        return;
      }
      const chainId = chain == null ? void 0 : chain.id;
      const { isTestNet, coinType } = this.context;
      const _chainId = chainIdHexToNumber(chainId);
      const _coinType = isTestNet ? ChainIdToCoinTypeTestNetMap[_chainId] : ChainIdToCoinTypeMap[_chainId];
      if (coinType === _coinType && this.context.chainId === _chainId) {
        return;
      }
      if (_coinType) {
        this.context.chainId = _chainId;
        this.context.coinType = _coinType;
        setWalletState({
          coinType: _coinType
        });
        this.context.emitEvent(EventEnum.Change);
      } else {
        let message;
        switch (coinType) {
          case CoinType.eth:
            message = isTestNet ? "Please switch your wallet to the Goerli test network before connecting" : "Please switch your wallet to the Ethereum main network before connecting";
            break;
          case CoinType.bsc:
            message = isTestNet ? "Please switch your wallet to the BSC Testnet before connecting" : "Please switch your wallet to the BSC main network before connecting";
            break;
          case CoinType.matic:
            message = isTestNet ? "Please switch your wallet to the Polygon Testnet before connecting" : "Please switch your wallet to the Polygon Mainnet before connecting";
            break;
        }
        if (message) {
          this.context.emitEvent(EventEnum.Error, message);
          createTips({
            title: "Tips",
            content: message
          });
        }
      }
    });
  }
  removeEvents() {
    var _a2, _b;
    console.log("removeEvents: ", this.unwatchAccount, this.unwatchNetwork);
    (_a2 = this.unwatchAccount) == null ? void 0 : _a2.call(this);
    (_b = this.unwatchNetwork) == null ? void 0 : _b.call(this);
  }
}
class TorusEventListener extends WalletEventListener {
  listenEvents() {
    const { provider } = this.context;
    provider.on("accountsChanged", async (accounts) => {
      const { address } = this.context;
      const account = accounts == null ? void 0 : accounts[0];
      if (account && address && account.toLowerCase() === address.toLowerCase()) {
        return;
      }
      this.context.address = toChecksumAddress(account);
      setWalletState({
        address: toChecksumAddress(account)
      });
      this.context.emitEvent(EventEnum.Change);
    });
    provider.on("chainChanged", (chainId) => {
      const { isTestNet, coinType } = this.context;
      const _chainId = chainIdHexToNumber(chainId);
      const _coinType = isTestNet ? ChainIdToCoinTypeTestNetMap[_chainId] : ChainIdToCoinTypeMap[_chainId];
      if (coinType === _coinType && this.context.chainId === _chainId) {
        return;
      }
      if (_coinType) {
        this.context.chainId = _chainId;
        this.context.coinType = _coinType;
        setWalletState({
          coinType: _coinType
        });
        this.context.emitEvent(EventEnum.Change);
      } else {
        let message;
        switch (coinType) {
          case CoinType.eth:
            message = isTestNet ? "Please switch your wallet to the Goerli test network before connecting" : "Please switch your wallet to the Ethereum main network before connecting";
            break;
          case CoinType.bsc:
            message = isTestNet ? "Please switch your wallet to the BSC Testnet before connecting" : "Please switch your wallet to the BSC main network before connecting";
            break;
          case CoinType.matic:
            message = isTestNet ? "Please switch your wallet to the Polygon Testnet before connecting" : "Please switch your wallet to the Polygon Mainnet before connecting";
            break;
        }
        if (message) {
          this.context.emitEvent(EventEnum.Error, message);
          createTips({
            title: "Tips",
            content: message
          });
        }
      }
    });
  }
  removeEvents() {
    var _a2, _b;
    const { provider } = this.context;
    (_a2 = provider.removeAllListeners) == null ? void 0 : _a2.call(provider, "accountsChanged");
    (_b = provider.removeAllListeners) == null ? void 0 : _b.call(provider, "chainChanged");
  }
}
class TokenPocketUTXOEventListener extends WalletEventListener {
  listenEvents() {
  }
  removeEvents() {
  }
}
class TronLinkEventListener extends WalletEventListener {
  constructor() {
    super(...arguments);
    __publicField(this, "handleMessageEvent", async (event) => {
      await this.messageEvent(event, this.context);
    });
  }
  async messageEvent(event, context) {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if (!((_a2 = event == null ? void 0 : event.data) == null ? void 0 : _a2.isTronLink)) {
      return;
    }
    if (((_c = (_b = event.data) == null ? void 0 : _b.message) == null ? void 0 : _c.action) === "setAccount") {
      const { address } = context;
      const account = (_f = (_e = (_d = event.data) == null ? void 0 : _d.message) == null ? void 0 : _e.data) == null ? void 0 : _f.address;
      if (account && address && account.toLowerCase() === address.toLowerCase()) {
        return;
      }
      if (account) {
        context.address = account;
        setWalletState({
          address: account
        });
        context.emitEvent(EventEnum.Change);
      }
    }
    if (((_h = (_g = event.data) == null ? void 0 : _g.message) == null ? void 0 : _h.action) === "setNode") {
      const { isTestNet, coinType } = context;
      let _chainId = (_l = (_k = (_j = (_i = event.data) == null ? void 0 : _i.message) == null ? void 0 : _j.data) == null ? void 0 : _k.node) == null ? void 0 : _l.chainId;
      if (_chainId) {
        _chainId = chainIdHexToNumber(_chainId);
      }
      const _coinType = isTestNet ? ChainIdToCoinTypeTestNetMap[_chainId] : ChainIdToCoinTypeMap[_chainId];
      if (coinType === _coinType && this.context.chainId === _chainId) {
        return;
      }
      if (_coinType) {
        context.chainId = _chainId;
        context.coinType = _coinType;
        setWalletState({
          coinType: _coinType
        });
        context.emitEvent(EventEnum.Change);
      } else {
        let message = "";
        switch (coinType) {
          case CoinType.trx:
            message = isTestNet ? "Please switch your wallet to the TRON Nile test network before connecting" : "Please switch your wallet to the TRON main network before connecting";
            break;
        }
        if (message) {
          this.context.emitEvent(EventEnum.Error, message);
          debounce(() => {
            createTips({
              title: "Tips",
              content: message
            });
          }, 1e3);
        }
      }
    }
  }
  listenEvents() {
    window.addEventListener("message", this.handleMessageEvent);
  }
  removeEvents() {
    window.removeEventListener("message", this.handleMessageEvent);
  }
}
class ConnectDidEventListener extends WalletEventListener {
  listenEvents() {
  }
  removeEvents() {
  }
}
class WalletConnector {
  constructor(context) {
    __publicField(this, "context");
    this.context = context;
  }
}
const loginCacheState = proxy({
  coinType: void 0,
  walletConnectDisplayUri: "",
  walletName: void 0,
  signDataParams: null
});
const setLoginCacheState = ({
  coinType,
  walletName,
  walletConnectDisplayUri,
  signDataParams
}) => {
  if (coinType !== void 0) {
    loginCacheState.coinType = coinType;
  }
  if (walletName !== void 0) {
    loginCacheState.walletName = walletName;
  }
  if (walletConnectDisplayUri !== void 0) {
    loginCacheState.walletConnectDisplayUri = walletConnectDisplayUri;
  }
  if (signDataParams !== void 0) {
    loginCacheState.signDataParams = signDataParams;
  }
};
function useLoginCacheState() {
  const loginCacheSnap = useSnapshot(loginCacheState);
  return { loginCacheSnap };
}
class WalletSigner {
  constructor(context) {
    __publicField(this, "context");
    this.context = context;
  }
}
class WalletConnectSigner extends WalletSigner {
  async signData(data, options) {
    if (shouldUseWalletConnect()) {
      const { walletName, provider } = this.context;
      const sessionTopic = provider.session.pairingTopic;
      if (walletName && sessionTopic) {
        const deepLink = getWalletDeepLink(walletName, `wc:${sessionTopic}@2`);
        openDeepLink(deepLink);
      }
    }
    let res;
    if (options == null ? void 0 : options.isEIP712) {
      res = await signTypedData(data);
    } else {
      let _data = data;
      if (isHexStrict("0x" + data)) {
        _data = "0x" + data;
      }
      console.log("signMessage", String(_data));
      res = await signMessage({
        message: String(_data)
      });
    }
    return res;
  }
}
class MetaMaskSigner extends WalletConnectSigner {
}
class TokenPocketUTXOSigner extends WalletSigner {
  async signData(data) {
    const res = await this.context.provider.request({
      method: "btc_signMessage",
      params: [data, this.context.address]
    });
    return res;
  }
}
class TorusSigner extends WalletSigner {
  async signData(data, options) {
    let res;
    if (options == null ? void 0 : options.isEIP712) {
      res = await this.context.provider.request({
        method: "eth_signTypedData_v4",
        params: [this.context.address, JSON.stringify(data)]
      });
    } else {
      let _data = data;
      if (isHexStrict("0x" + data)) {
        _data = "0x" + data;
      }
      console.log("personal_sign", _data);
      res = await this.context.provider.request({
        method: "personal_sign",
        params: [_data, this.context.address]
      });
    }
    return res;
  }
}
class TronLinkSigner extends WalletSigner {
  async signData(data) {
    const res = await this.context.provider.trx.signMessageV2(data);
    return res;
  }
}
class ConnectDidSigner extends WalletSigner {
  async signData(data, options) {
    let provider;
    if (options == null ? void 0 : options.provider) {
      provider = options == null ? void 0 : options.provider;
    } else {
      provider = await this.context.provider.requestWaitingPage((err) => {
        console.error(err);
        throw new CustomError(err.code, err.message);
      });
    }
    const res = await provider.onNext({
      method: EnumRequestMethods.REQUEST_SIGN_DATA,
      params: {
        msg: data
      }
    });
    if (res.code !== errno.connectDidSdkSuccess) {
      throw new CustomError(res.code, res.message);
    }
    return res.data;
  }
}
class TorusConnector extends WalletConnector {
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    const { provider, isTestNet } = this.context;
    const netVersion = provider.networkVersion;
    const ethChainId = provider.chainId;
    const res = await provider.request({ method: "eth_requestAccounts" });
    if (res == null ? void 0 : res[0]) {
      this.context.address = toChecksumAddress(res[0]);
      this.context.chainId = chainIdHexToNumber(netVersion || ethChainId);
      this.context.coinType = isTestNet ? ChainIdToCoinTypeTestNetMap[this.context.chainId] : ChainIdToCoinTypeMap[this.context.chainId];
      setWalletState({
        protocol: this.context.protocol,
        address: this.context.address,
        coinType: this.context.coinType,
        walletName: this.context.walletName
      });
      const { signDataParams } = snapshot(loginCacheState);
      if (signDataParams) {
        const signature = await this.signData(signDataParams.data, signDataParams.isEIP712);
        this.context.emitEvent(EventEnum.Signature, signature);
      } else if (!ignoreEvent) {
        this.context.emitEvent(EventEnum.Connect);
      }
    }
  }
  async disconnect() {
    var _a2, _b;
    if ((_a2 = this.context.torusWallet) == null ? void 0 : _a2.hideTorusButton) {
      (_b = this.context.torusWallet) == null ? void 0 : _b.hideTorusButton();
    }
    this.context.address = void 0;
    this.context.chainId = void 0;
    this.context.coinType = void 0;
    resetWalletState();
    this.context.emitEvent(EventEnum.Disconnect);
  }
  async switchNetwork(chainId) {
  }
  async signData(data, isEIP712) {
    try {
      const signer = new TorusSigner(this.context);
      return await signer.signData(data, {
        isEIP712
      });
    } catch (err) {
      console.error(err);
      return void 0;
    }
  }
}
class TronLinkConnector extends WalletConnector {
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    const { provider } = this.context;
    if (provider.request) {
      const res = await provider.request({
        method: "tron_requestAccounts"
      });
      if (res.code === TronLinkRequestAccountsResponseCode.ok) {
        this.context.address = provider.defaultAddress.base58;
        setWalletState({
          protocol: this.context.protocol,
          address: this.context.address,
          coinType: this.context.coinType,
          walletName: this.context.walletName
        });
        const { signDataParams } = snapshot(loginCacheState);
        if (signDataParams) {
          const signature = await this.signData(signDataParams.data);
          this.context.emitEvent(EventEnum.Signature, signature);
        } else if (!ignoreEvent) {
          this.context.emitEvent(EventEnum.Connect);
        }
      } else {
        throw new CustomError(res.code, res.message);
      }
    } else {
      this.context.address = provider.defaultAddress.base58;
      setWalletState({
        protocol: this.context.protocol,
        address: this.context.address,
        coinType: this.context.coinType,
        walletName: this.context.walletName
      });
      const { signDataParams } = snapshot(loginCacheState);
      if (signDataParams) {
        const signature = await this.signData(signDataParams.data);
        this.context.emitEvent(EventEnum.Signature, signature);
      } else if (!ignoreEvent) {
        this.context.emitEvent(EventEnum.Connect);
      }
    }
  }
  async disconnect() {
    this.context.address = void 0;
    this.context.chainId = void 0;
    this.context.coinType = void 0;
    resetWalletState();
    this.context.emitEvent(EventEnum.Disconnect);
  }
  async switchNetwork(chainId) {
  }
  async signData(data) {
    try {
      const signer = new TronLinkSigner(this.context);
      return await signer.signData(data);
    } catch (err) {
      console.error(err);
      return void 0;
    }
  }
}
class MetaMaskConnector extends WalletConnector {
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    try {
      const { wagmiConfig, chainId, provider, walletName } = this.context;
      let connector;
      if (shouldUseWalletConnect()) {
        connector = wagmiConfig.connectors.find((item) => {
          return item.id === "walletConnect" && item.options.showQrModal === false;
        });
      } else {
        connector = wagmiConfig.connectors.find((item) => {
          return walletName === "MetaMask" ? item.id === "metaMask" : item.id === "injected";
        });
      }
      const walletStateLocalStorage2 = globalThis.localStorage.getItem("WalletState");
      if (walletStateLocalStorage2 && wagmiConfig.status === "connected") {
        await disconnect();
        globalThis.localStorage.removeItem("WalletState");
      }
      if (wagmiConfig && wagmiConfig.status !== "connected" && connector) {
        if (shouldUseWalletConnect()) {
          provider.once("display_uri", async (uri) => {
            if (isMobile) {
              if (walletName) {
                const deepLink = getWalletDeepLink(walletName, uri);
                openDeepLink(deepLink);
              }
            } else {
              console.log("WalletConnect display_uri", uri);
              setLoginCacheState({ walletConnectDisplayUri: uri });
            }
          });
        }
        const { chain, account } = await connect({
          connector,
          chainId
        });
        if (chainId && chainId !== chain.id && !shouldUseWalletConnect()) {
          await this.switchNetwork(chainId);
        }
        const network = getNetwork();
        if (account && network.chain && network.chain.id === chainId) {
          this.context.address = toChecksumAddress(account);
          setWalletState({
            protocol: this.context.protocol,
            address: this.context.address,
            coinType: this.context.coinType,
            walletName: this.context.walletName
          });
          const { signDataParams } = snapshot(loginCacheState);
          if (signDataParams) {
            const signature = await this.signData(signDataParams.data, signDataParams.isEIP712);
            this.context.emitEvent(EventEnum.Signature, signature);
          } else if (!ignoreEvent) {
            this.context.emitEvent(EventEnum.Connect);
          }
        }
      } else if (wagmiConfig.status === "connected") {
        const { signDataParams } = snapshot(loginCacheState);
        if (signDataParams) {
          const signature = await this.signData(signDataParams.data, signDataParams.isEIP712);
          this.context.emitEvent(EventEnum.Signature, signature);
        } else if (!ignoreEvent) {
          this.context.emitEvent(EventEnum.Connect);
        }
      }
    } catch (err) {
      console.error(err);
      if (isMobile) {
        throw new Error("Please open this page in your crypto wallet App and try again.");
      } else {
        const name = this.context.coinType && CoinTypeToChainMap[this.context.coinType].name;
        throw new Error(
          `Please ensure that your browser has the ${String(name)} wallet plugin installed and try again.`
        );
      }
    }
  }
  async disconnect() {
    await disconnect();
    this.context.address = void 0;
    this.context.chainId = void 0;
    this.context.coinType = void 0;
    resetWalletState();
    this.context.emitEvent(EventEnum.Disconnect);
  }
  async switchNetwork(chainId) {
    await switchNetwork({
      chainId
    });
  }
  async signData(data, isEIP712) {
    try {
      const signer = new MetaMaskSigner(this.context);
      await sleep(1e3);
      return await signer.signData(data, {
        isEIP712
      });
    } catch (err) {
      console.error(err);
      return void 0;
    }
  }
}
class TokenPocketUTXOConnector extends WalletConnector {
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    const { provider } = this.context;
    const res = await provider.request({
      method: "btc_accounts"
    });
    if (res == null ? void 0 : res[0]) {
      this.context.address = res[0];
      setWalletState({
        protocol: this.context.protocol,
        address: this.context.address,
        coinType: this.context.coinType,
        walletName: this.context.walletName
      });
      const { signDataParams } = snapshot(loginCacheState);
      if (signDataParams) {
        const signature = await this.signData(signDataParams.data);
        this.context.emitEvent(EventEnum.Signature, signature);
      } else if (!ignoreEvent) {
        this.context.emitEvent(EventEnum.Connect);
      }
    }
  }
  async disconnect() {
    this.context.address = void 0;
    this.context.chainId = void 0;
    this.context.coinType = void 0;
    resetWalletState();
    this.context.emitEvent(EventEnum.Disconnect);
  }
  async switchNetwork(chainId) {
  }
  async signData(data) {
    try {
      const signer = new TokenPocketUTXOSigner(this.context);
      return await signer.signData(data);
    } catch (err) {
      console.error(err);
      return void 0;
    }
  }
}
class ConnectDidConnector extends WalletConnector {
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    const { provider } = this.context;
    const { signDataParams } = snapshot(loginCacheState);
    let res;
    let signature;
    if (signDataParams) {
      res = await provider.requestDeviceSignData({ msg: signDataParams.data });
      signature = res.data.signature;
      res.data = res.data.deviceData;
    } else {
      res = await provider.requestDeviceData();
    }
    if (res.code !== errno.connectDidSdkSuccess) {
      throw new CustomError(res.code, res.message);
    }
    if (res.data) {
      this.context.address = res.data.ckbAddr;
      setWalletState({
        protocol: this.context.protocol,
        address: this.context.address,
        coinType: this.context.coinType,
        walletName: this.context.walletName,
        deviceData: res.data
      });
      await getMastersAddress();
      await getAuthorizeInfo({ detectAssets: true }).then(() => {
        void backupDeviceData();
      });
      if (signature) {
        this.context.emitEvent(EventEnum.Signature, signature);
      } else if (!ignoreEvent) {
        this.context.emitEvent(EventEnum.Connect);
      }
    }
  }
  async disconnect() {
    this.context.address = void 0;
    this.context.chainId = void 0;
    this.context.coinType = void 0;
    resetWalletState();
    this.context.emitEvent(EventEnum.Disconnect);
  }
  async switchNetwork(chainId) {
  }
}
class WalletTransaction {
  constructor(context) {
    __publicField(this, "context");
    this.context = context;
  }
}
class WalletConnectTransaction extends WalletTransaction {
  async sendTrx(data) {
    const { chainId, walletName, provider } = this.context;
    let _data = "";
    if (data.data != null) {
      _data = utf8ToHex(data.data);
    }
    if (shouldUseWalletConnect()) {
      const sessionTopic = provider.session.pairingTopic;
      if (walletName && sessionTopic) {
        const deepLink = getWalletDeepLink(walletName, `wc:${sessionTopic}@2`);
        openDeepLink(deepLink);
      }
    }
    console.log("sendTransaction: ", chainId, data.to, data.value, _data);
    const { hash } = await sendTransaction({
      chainId,
      to: data.to,
      value: parseUnits(data.value, 0),
      data: _data
    });
    return hash;
  }
}
class MetaMaskTransaction extends WalletConnectTransaction {
}
class TokenPocketUTXOTransaction extends WalletTransaction {
  async sendTrx(data) {
    var _a2;
    const from = this.context.address;
    const opReturn = data.data;
    const params = { from, to: data.to, amount: data.value, op_return: opReturn };
    if (!params.from || !params.to || !params.amount) {
      throw new Error('missing params; "from", "to", "amount" is required ');
    }
    const balance = await this.getTPUTXOCurrentBalance();
    if (toDecimal(((_a2 = balance.data) == null ? void 0 : _a2.balance) || 0).lte(params.amount)) {
      throw new Error("insufficient funds for transfer");
    }
    return await new Promise((resolve, reject) => {
      const random = parseInt(String(Math.random() * 1e5));
      const tpCallbackFun = "tp_callback_" + String((/* @__PURE__ */ new Date()).getTime()) + String(random);
      window[tpCallbackFun] = function(result) {
        result = result.replace(/\r/gi, "").replace(/\n/gi, "");
        try {
          const res = JSON.parse(result);
          if (res.result) {
            resolve(res.data);
          } else {
            reject(res.message);
          }
        } catch (err) {
          reject(err);
        }
      };
      this.sendTokenPocketRequest("btcTokenTransfer", JSON.stringify(params), tpCallbackFun);
    });
  }
  async getTPUTXOCurrentBalance() {
    return await new Promise((resolve, reject) => {
      const random = parseInt(String(Math.random() * 1e5));
      const tpCallbackFun = "tp_callback_" + String((/* @__PURE__ */ new Date()).getTime()) + String(random);
      window[tpCallbackFun] = function(result) {
        result = result.replace(/\r/gi, "").replace(/\n/gi, "");
        try {
          const res = JSON.parse(result);
          resolve(res);
        } catch (e) {
          reject(e);
        }
      };
      this.sendTokenPocketRequest("getCurrentBalance", "", tpCallbackFun);
    });
  }
  sendTokenPocketRequest(methodName, params, callback) {
    if (window.TPJSBrigeClient) {
      window.TPJSBrigeClient.callMessage(methodName, params, callback);
    }
    if (window.webkit) {
      window.webkit.messageHandlers[methodName].postMessage({
        body: {
          params,
          callback
        }
      });
    }
  }
}
class TorusTransaction extends WalletTransaction {
  async sendTrx(data) {
    const _from = this.context.address;
    let _data = "";
    if (data.data != null) {
      _data = utf8ToHex(data.data);
    }
    const _value = numberToHex(data.value);
    return this.context.provider.request({
      method: "eth_sendTransaction",
      params: [
        {
          from: _from,
          to: data.to,
          value: _value,
          data: _data
        }
      ]
    });
  }
}
class TronLinkTransaction extends WalletTransaction {
  async sendTrx(data) {
    const _from = this.context.address;
    let res = await this.context.provider.transactionBuilder.sendTrx(data.to, data.value, _from);
    res = await this.context.provider.transactionBuilder.addUpdateData(res, data.data);
    res = await this.context.provider.trx.sign(res);
    res = await this.context.provider.trx.sendRawTransaction(res);
    return res.txid;
  }
}
class ConnectDidTransaction extends WalletTransaction {
  async sendTrx(data) {
    return await Promise.resolve("");
  }
}
class WalletConnectConnector extends WalletConnector {
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    console.log("WalletConnect connect");
    const { wagmiConfig, chainId, provider } = this.context;
    let walletConnectConnector;
    if (isMobile) {
      walletConnectConnector = wagmiConfig.connectors.find((item) => {
        return item.id === "walletConnect" && item.options.showQrModal === true;
      });
    } else {
      walletConnectConnector = wagmiConfig.connectors.find((item) => {
        return item.id === "walletConnect" && item.options.showQrModal === false;
      });
    }
    const walletStateLocalStorage2 = globalThis.localStorage.getItem("WalletState");
    if (walletStateLocalStorage2 && wagmiConfig.status === "connected") {
      await disconnect();
      globalThis.localStorage.removeItem("WalletState");
    }
    if (wagmiConfig && wagmiConfig.status !== "connected" && walletConnectConnector) {
      if (!walletConnectConnector.options.showQrModal) {
        provider.once("display_uri", async (uri) => {
          console.log("WalletConnect display_uri", uri);
          setLoginCacheState({ walletConnectDisplayUri: uri });
        });
      }
      const { chain, account } = await connect({
        connector: walletConnectConnector,
        chainId
      });
      if (account && chain && chain.id === chainId) {
        this.context.address = toChecksumAddress(account);
        setWalletState({
          protocol: this.context.protocol,
          address: this.context.address,
          coinType: this.context.coinType,
          walletName: this.context.walletName
        });
        setLoginCacheState({ walletConnectDisplayUri: "", walletName: "" });
        const { signDataParams } = snapshot(loginCacheState);
        if (signDataParams) {
          const signature = await this.signData(signDataParams.data, signDataParams.isEIP712);
          this.context.emitEvent(EventEnum.Signature, signature);
        } else if (!ignoreEvent) {
          this.context.emitEvent(EventEnum.Connect);
        }
      }
    } else if (wagmiConfig.status === "connected") {
      const { signDataParams } = snapshot(loginCacheState);
      if (signDataParams) {
        const signature = await this.signData(signDataParams.data, signDataParams.isEIP712);
        this.context.emitEvent(EventEnum.Signature, signature);
      } else if (!ignoreEvent) {
        this.context.emitEvent(EventEnum.Connect);
      }
    }
  }
  async disconnect() {
    await disconnect();
    this.context.address = void 0;
    this.context.chainId = void 0;
    this.context.coinType = void 0;
    resetWalletState();
    this.context.emitEvent(EventEnum.Disconnect);
  }
  async switchNetwork(chainId) {
    await switchNetwork({
      chainId
    });
  }
  async signData(data, isEIP712) {
    try {
      const signer = new WalletConnectSigner(this.context);
      await sleep(1e3);
      return await signer.signData(data, {
        isEIP712
      });
    } catch (err) {
      console.error(err);
      return void 0;
    }
  }
}
class WalletConnectEventListener extends WalletEventListener {
  constructor() {
    super(...arguments);
    __publicField(this, "unwatchAccount");
    __publicField(this, "unwatchNetwork");
  }
  listenEvents() {
    console.log("listenEvents");
    this.unwatchAccount = watchAccount(async (account) => {
      console.log("watchAccount: ", account);
      const { address: oldAddress } = this.context;
      const { address, isConnected, isDisconnected } = account;
      if (isConnected) {
        if (!oldAddress) {
          return;
        }
        if (address && oldAddress && oldAddress.toLowerCase() === address.toLowerCase()) {
          return;
        }
        this.context.address = toChecksumAddress(String(address));
        setWalletState({
          address: this.context.address
        });
        this.context.emitEvent(EventEnum.Change);
      } else if (isDisconnected) {
        this.removeEvents();
        this.context.address = void 0;
        this.context.chainId = void 0;
        this.context.coinType = void 0;
        resetWalletState();
        this.context.emitEvent(EventEnum.Disconnect);
      }
    });
    this.unwatchNetwork = watchNetwork((network) => {
      console.log("watchNetwork: ", network.chain);
      const { chain } = network;
      if (!chain) {
        return;
      }
      const chainId = chain == null ? void 0 : chain.id;
      const { isTestNet, coinType } = this.context;
      const _chainId = chainIdHexToNumber(chainId);
      const _coinType = isTestNet ? ChainIdToCoinTypeTestNetMap[_chainId] : ChainIdToCoinTypeMap[_chainId];
      if (coinType === _coinType && this.context.chainId === _chainId) {
        return;
      }
      if (_coinType) {
        this.context.chainId = _chainId;
        this.context.coinType = _coinType;
        setWalletState({
          coinType: _coinType
        });
        this.context.emitEvent(EventEnum.Change);
      } else {
        let message;
        switch (coinType) {
          case CoinType.eth:
            message = isTestNet ? "Please switch your wallet to the Goerli test network before connecting" : "Please switch your wallet to the Ethereum main network before connecting";
            break;
          case CoinType.bsc:
            message = isTestNet ? "Please switch your wallet to the BSC Testnet before connecting" : "Please switch your wallet to the BSC main network before connecting";
            break;
          case CoinType.matic:
            message = isTestNet ? "Please switch your wallet to the Polygon Testnet before connecting" : "Please switch your wallet to the Polygon Mainnet before connecting";
            break;
        }
        if (message) {
          this.context.emitEvent(EventEnum.Error, message);
          createTips({
            title: "Tips",
            content: message
          });
        }
      }
    });
  }
  removeEvents() {
    var _a2, _b;
    console.log("removeEvents: ", this.unwatchAccount, this.unwatchNetwork);
    (_a2 = this.unwatchAccount) == null ? void 0 : _a2.call(this);
    (_b = this.unwatchNetwork) == null ? void 0 : _b.call(this);
  }
}
class WalletHandlerFactory {
  static createConnector(context) {
    if (!context.protocol) {
      throw new Error("createConnector: Please initialize wallet first");
    }
    return new this.handlerMap[context.protocol].Connector(context);
  }
  static createEventListener(context) {
    if (!context.protocol) {
      throw new Error("createConnector: Please initialize wallet first");
    }
    return new this.handlerMap[context.protocol].EventListener(context);
  }
  static createSigner(context) {
    if (!context.protocol) {
      throw new Error("createConnector: Please initialize wallet first");
    }
    return new this.handlerMap[context.protocol].Signer(context);
  }
  static createTransaction(context) {
    if (!context.protocol) {
      throw new Error("createConnector: Please initialize wallet first");
    }
    return new this.handlerMap[context.protocol].Transaction(context);
  }
}
__publicField(WalletHandlerFactory, "handlerMap", {
  [WalletProtocol.metaMask]: {
    Connector: MetaMaskConnector,
    EventListener: MetaMaskEventListener,
    Signer: MetaMaskSigner,
    Transaction: MetaMaskTransaction
  },
  [WalletProtocol.tronLink]: {
    Connector: TronLinkConnector,
    EventListener: TronLinkEventListener,
    Signer: TronLinkSigner,
    Transaction: TronLinkTransaction
  },
  [WalletProtocol.torus]: {
    Connector: TorusConnector,
    EventListener: TorusEventListener,
    Signer: TorusSigner,
    Transaction: TorusTransaction
  },
  [WalletProtocol.tokenPocketUTXO]: {
    Connector: TokenPocketUTXOConnector,
    EventListener: TokenPocketUTXOEventListener,
    Signer: TokenPocketUTXOSigner,
    Transaction: TokenPocketUTXOTransaction
  },
  [WalletProtocol.webAuthn]: {
    Connector: ConnectDidConnector,
    EventListener: ConnectDidEventListener,
    Signer: ConnectDidSigner,
    Transaction: ConnectDidTransaction
  },
  [WalletProtocol.walletConnect]: {
    Connector: WalletConnectConnector,
    EventListener: WalletConnectEventListener,
    Signer: WalletConnectSigner,
    Transaction: WalletConnectTransaction
  }
});
function ChainItem(props) {
  const click = () => {
    var _a2;
    (_a2 = props.onClick) == null ? void 0 : _a2.call(props);
  };
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: clsx(
        "box-border flex cursor-pointer items-center justify-between rounded-2xl border border-[#BEC0C228] py-2 pl-3 pr-5 hover:bg-secondary-5 active:bg-secondary",
        props.className
      ),
      onClick: click,
      children: [
        /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center", children: [
          props.icon,
          /* @__PURE__ */ jsxs("span", { className: "ml-4 inline-flex flex-col", children: [
            /* @__PURE__ */ jsx("span", { className: "text-base font-semibold leading-5", children: props.name }),
            props.tag
          ] })
        ] }),
        props.name === props.currentLogin ? /* @__PURE__ */ jsx(LoadingIcon, { className: "h-2.5 w-2.5 text-font-secondary" }) : /* @__PURE__ */ jsx(ArrowLeftIcon, { className: "h-2.5 w-2.5 rotate-180 text-font-secondary" })
      ]
    }
  );
}
function isUserReject(err) {
  const metaMaskReject = [errno.metaMaskUserRejectedAccountAccess, errno.metaMaskUserDeniedMessageSignature].includes(err.code) && !(err.message.includes(errno.metaMaskReplacementTransactionUnderpriced) || err.message.includes(errno.metaMaskTransactionHasBeenAborted));
  const tronReject = err === errno.tronLinkConfirmationDeclinedByUser;
  const torusReject = [errno.torusUserCancelledLogin, errno.torusUserClosedPopup].includes(err.message);
  const walletConnectReject = err.message === errno.walletConnectUserRejectedTheTransaction;
  const connectDidSdkReject = err.code === errno.connectDidSdkAbort;
  return metaMaskReject || tronReject || walletConnectReject || torusReject || connectDidSdkReject;
}
function handleError(error) {
  var _a2, _b;
  console.error(error);
  let res = {
    isHandle: false,
    title: "",
    message: ""
  };
  if (isUserReject(error)) {
    res = {
      isHandle: true,
      title: "",
      message: ""
    };
  } else if ([errno.metaMaskUserRejectedAccountAccess, errno.metaMaskUserDeniedMessageSignature].includes(error.code) && error.message.includes(errno.metaMaskReplacementTransactionUnderpriced)) {
    res = {
      isHandle: true,
      title: `Tips`,
      message: `Replacement transaction underpriced`
    };
  } else if ([errno.metaMaskUserRejectedAccountAccess, errno.metaMaskUserDeniedMessageSignature].includes(error.code) && error.message.includes(errno.metaMaskTransactionHasBeenAborted)) {
    res = {
      isHandle: true,
      title: `Tips`,
      message: `The transaction has been aborted.`
    };
  } else if (error.code === errno.metaMaskWalletRequestPermissions || error.code === errno.tronLinkAuthorizationRequestsAreBeingProcessed) {
    res = {
      isHandle: true,
      title: `Tips`,
      message: `Other requests for the wallet are not processed, please try again after processing`
    };
  } else if (error.message === errno.coinbaseWalletUsingMultipleWallet) {
    res = {
      isHandle: true,
      title: `Tips`,
      message: `Please check if you are using multiple wallet plugins. Please disable multiple wallet plugins, keep only one wallet plugin and try again.`
    };
  } else if (
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    error.toString() === errno.tronLinkInsufficientBalance || ((_a2 = error.message) == null ? void 0 : _a2.includes(errno.walletConnectInsufficientFundsForTransfer))
  ) {
    res = {
      isHandle: true,
      title: `Tips`,
      message: `Insufficient balance`
    };
  } else if ((_b = error.message) == null ? void 0 : _b.includes(errno.tronLinkTypeErrorAddUpdateDataNotFunction)) {
    res = {
      isHandle: true,
      title: `Tips`,
      message: `The current wallet environment does not support payments using TRX, please upgrade your wallet version or register with another wallet.`
    };
  }
  return res;
}
const routerContext = createContext(null);
function useSimpleRouter() {
  return useContext(routerContext);
}
function SimpleRouter({ routes: routes2, onClose, initialRouteName = "index" }) {
  const history = useMemo(() => [], []);
  const [currentRouteName, setCurrentRouteName] = useState(initialRouteName);
  const currentRoute = routes2[currentRouteName];
  if (currentRoute === void 0)
    throw new Error("Route does not exist");
  const goNext = currentRoute.next ? () => {
    history.push(currentRouteName);
    setCurrentRouteName(currentRoute.next);
  } : void 0;
  const goBack = history.length > 0 || currentRoute.prev ? () => {
    const prevRoute = history.pop();
    if (prevRoute)
      setCurrentRouteName(prevRoute);
    else if (currentRoute.prev)
      setCurrentRouteName(currentRoute.prev);
  } : void 0;
  const goTo = useCallback(
    (routeName) => {
      if (routes2[routeName] === void 0)
        throw new Error("Route does not exist");
      history.push(currentRouteName);
      setCurrentRouteName(routeName);
    },
    [setCurrentRouteName, currentRouteName, history, routes2]
  );
  return /* @__PURE__ */ jsx(
    routerContext.Provider,
    {
      value: {
        currentRouteName,
        prevRouteName: history[history.length - 1],
        goNext,
        goBack,
        goTo,
        onClose
      },
      children: /* @__PURE__ */ jsx(SwapTransition, { className: "max-sm:simple-router-mobile-max-h w-full sm:max-h-[588px]", duration: 300, children: currentRoute.el })
    }
  );
}
const EthIcon = "data:image/svg+xml;base64,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";
const BscIcon = "data:image/svg+xml;base64,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";
const PolygonIcon = "data:image/svg+xml;base64,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";
const TronIcon = "data:image/svg+xml;base64,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";
const DogecoinIcon = "data:image/svg+xml;base64,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";
const TorusIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM2IDcyQzU1Ljg4MjMgNzIgNzIgNTUuODgyMyA3MiAzNkM3MiAxNi4xMTc3IDU1Ljg4MjMgMCAzNiAwQzE2LjExNzcgMCAwIDE2LjExNzcgMCAzNkMwIDU1Ljg4MjMgMTYuMTE3NyA3MiAzNiA3MloiIGZpbGw9IiMwMzY0RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAyNC40NzY1QzIxIDIyLjc1NTkgMjIuMzk0OCAyMS4zNjExIDI0LjExNTQgMjEuMzYxMUgzMi43NDI4SDM2LjM3MjFDMzguMDkyNyAyMS4zNjExIDM5LjQ4NzUgMjIuNzU1OSAzOS40ODc1IDI0LjQ3NjVWMjguMTA1N0wzOS40ODc0IDI4LjEzMjFWNTEuNTIzMkMzOS40ODc0IDUzLjI0MzggMzguMDkyNSA1NC42Mzg2IDM2LjM3MiA1NC42Mzg2SDMyLjc0MjhDMzEuMDIyMiA1NC42Mzg2IDI5LjYyNzQgNTMuMjQzOCAyOS42Mjc0IDUxLjUyMzJWMzEuMjIxMUgyNC4xMTU0QzIyLjM5NDggMzEuMjIxMSAyMSAyOS44MjYzIDIxIDI4LjEwNTdWMjQuNDc2NVpNNTEuODE1NyAyNi4yOTExQzUxLjgxNTcgMjkuMDEzOSA0OS42MDg0IDMxLjIyMTEgNDYuODg1NyAzMS4yMjExQzQ0LjE2MjkgMzEuMjIxMSA0MS45NTU3IDI5LjAxMzkgNDEuOTU1NyAyNi4yOTExQzQxLjk1NTcgMjMuNTY4NCA0NC4xNjI5IDIxLjM2MTEgNDYuODg1NyAyMS4zNjExQzQ5LjYwODQgMjEuMzYxMSA1MS44MTU3IDIzLjU2ODQgNTEuODE1NyAyNi4yOTExWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
const eth = {
  icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: EthIcon, alt: "ETH" }),
  name: CustomChain.eth,
  coinType: CoinType.eth
};
const bsc = {
  icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: BscIcon, alt: "BSC" }),
  name: CustomChain.bsc,
  coinType: CoinType.bsc
};
const polygon = {
  icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: PolygonIcon, alt: "Polygon" }),
  name: CustomChain.polygon,
  coinType: CoinType.matic
};
const tron = {
  icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: TronIcon, alt: "Tron" }),
  name: CustomChain.tron,
  coinType: CoinType.trx
};
const doge = {
  icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: DogecoinIcon, alt: "Dogecoin" }),
  name: CustomChain.doge,
  coinType: CoinType.doge
};
const torus = {
  icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: TorusIcon, alt: "Torus" }),
  name: CustomChain.torus,
  coinType: CoinType.eth
};
const ChainList = ({ transitionStyle, transitionRef }) => {
  const [currentLogin, setCurrentLogin] = useState("");
  const walletSDK = useContext(WalletSDKContext);
  const { goBack, onClose, goTo } = useSimpleRouter();
  const { walletSnap } = useWalletState();
  const showWalletList = () => {
    goTo("WalletList");
  };
  const chains = useMemo(() => {
    const customChains = walletSnap.customChains;
    let walletList = [eth, bsc, polygon, tron, doge];
    let socialList = [torus];
    const list = [];
    if (customChains && customChains.length > 0) {
      walletList = walletList.filter((item) => {
        return customChains.includes(item.name);
      });
      socialList = socialList.filter((item) => {
        return customChains.includes(item.name);
      });
      if (walletList.length > 0) {
        list.push(...walletList);
      }
      if (socialList.length > 0) {
        list.push(...socialList);
      }
    } else {
      list.push(...walletList, ...socialList);
    }
    const onlyEth = [eth];
    return walletSDK.onlyEth ? onlyEth : list;
  }, [walletSDK.onlyEth, walletSnap.customChains]);
  const selectChain = (chain) => {
    const { coinType } = chain;
    setLoginCacheState({
      coinType
    });
    showWalletList();
  };
  const onLogin = async (chain) => {
    const { name, coinType } = chain;
    if (currentLogin) {
      return;
    }
    if (![CustomChain.torus].includes(name)) {
      selectChain(chain);
      return;
    }
    try {
      setCurrentLogin(name);
      await walletSDK.init({
        coinType,
        walletName: name
      });
      await walletSDK.connect();
      onClose();
    } catch (error) {
      console.error(error);
      const handleErrorRes = handleError(error);
      if (handleErrorRes.isHandle) {
        if (handleErrorRes.title && handleErrorRes.message) {
          createTips({
            title: handleErrorRes.title,
            content: handleErrorRes.message
          });
        }
      } else {
        createTips({
          title: `Tips`,
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          content: error.code ? `${error.code}: ${error.message}` : error.message ? error.message : error.toString()
        });
      }
    } finally {
      setCurrentLogin("");
    }
  };
  const close = () => {
    onClose();
    setCurrentLogin("");
  };
  const back = () => {
    goBack == null ? void 0 : goBack();
    setCurrentLogin("");
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        title: "Other Wallets",
        onClose: close,
        goBack: back,
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "w-full px-6 pb-6 pt-[76px]", style: transitionStyle, ref: transitionRef, children: /* @__PURE__ */ jsx("ul", { className: "flex flex-col gap-2", children: chains == null ? void 0 : chains.map((chain) => {
      return /* @__PURE__ */ jsx(
        ChainItem,
        {
          ...chain,
          currentLogin,
          onClick: async () => {
            await onLogin(chain);
          }
        },
        chain.name
      );
    }) }) })
  ] });
};
function WalletItem(props) {
  const click = () => {
    var _a2;
    (_a2 = props.onClick) == null ? void 0 : _a2.call(props);
  };
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: clsx(
        "box-border flex cursor-pointer items-center justify-between rounded-2xl py-2 pl-2 pr-4 hover:bg-secondary active:bg-secondary-active",
        props.className
      ),
      onClick: click,
      children: [
        /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center", children: [
          props.icon,
          /* @__PURE__ */ jsx("span", { className: "ml-4 text-base font-semibold leading-5", children: props.name })
        ] }),
        props.name === props.currentLogin ? /* @__PURE__ */ jsx(LoadingIcon, { className: "h-2.5 w-2.5 text-font-secondary" }) : null
      ]
    }
  );
}
const MetaMaskIcon = "data:image/svg+xml;base64,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";
const TrustWalletIcon = "data:image/svg+xml;base64,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";
const ImTokenIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMTAiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yMjIyXzU5MTMwKSIvPgo8cGF0aCBkPSJNMzIuNjY4IDEyLjA4OTdDMzMuNTA4MiAyMy40NzAxIDI2LjE5MjQgMjguODQ5IDE5LjYzMzkgMjkuNDIyNkMxMy41MzY0IDI5Ljk1NTggNy43OTY5OSAyNi4yMDk1IDcuMjkzNDggMjAuNDUzNEM2Ljg3ODEzIDE1LjY5OCA5LjgxNzQzIDEzLjY3MzQgMTIuMTI2OCAxMy40NzE2QzE0LjUwMjEgMTMuMjYzNCAxNi40OTgxIDE0LjkwMTMgMTYuNjcxMiAxNi44ODQ1QzE2LjgzOCAxOC43OTExIDE1LjY0ODIgMTkuNjU4OSAxNC44MjA3IDE5LjczMTFDMTQuMTY2NCAxOS43ODg1IDEzLjM0MzEgMTkuMzkxMiAxMy4yNjg4IDE4LjUzODNDMTMuMjA1IDE3LjgwNTQgMTMuNDgzMyAxNy43MDU1IDEzLjQxNTMgMTYuOTI3QzEzLjI5NDIgMTUuNTQwOCAxMi4wODU0IDE1LjM3OTMgMTEuNDIzNiAxNS40MzY3QzEwLjYyMjYgMTUuNTA2OCA5LjE2OTQ1IDE2LjQ0MTUgOS4zNzM0IDE4Ljc2OTlDOS41Nzg0MiAyMS4xMTg0IDExLjgzMDQgMjIuOTc0IDE0Ljc4MjUgMjIuNzE1OUMxNy45NjgyIDIyLjQzNzYgMjAuMTg2MyAxOS45NTc0IDIwLjM1MyAxNi40Nzg3QzIwLjM1MTUgMTYuMjk0NSAyMC4zOTAzIDE2LjExMjEgMjAuNDY2NyAxNS45NDQ0TDIwLjQ2NzggMTUuOTQwMkMyMC41MDIxIDE1Ljg2NzMgMjAuNTQyMiAxNS43OTczIDIwLjU4NzggMTUuNzMwOUMyMC42NTU4IDE1LjYyODkgMjAuNzQyOSAxNS41MTY0IDIwLjg1NTUgMTUuMzkzMUMyMC44NTY2IDE1LjM5IDIwLjg1NjYgMTUuMzkgMjAuODU4NyAxNS4zOUMyMC45NDA1IDE1LjI5NzUgMjEuMDM5MyAxNS4xOTc3IDIxLjE1MDggMTUuMDkwNEMyMi41NDI0IDEzLjc3NzUgMjcuNTU0MiAxMC42ODEyIDMyLjI5NCAxMS42NjE2QzMyLjM5NDIgMTEuNjgzMSAzMi40ODQ3IDExLjczNjQgMzIuNTUyMSAxMS44MTM2QzMyLjYxOTUgMTEuODkwNyAzMi42NjAyIDExLjk4NzYgMzIuNjY4IDEyLjA4OTdaIiBmaWxsPSJ3aGl0ZSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzIyMjJfNTkxMzAiIHgxPSI0MCIgeTE9Ii0xLjIyMTllLTA2IiB4Mj0iLTEiIHkyPSI0MCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMTFDNEQxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwNjJBRCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
const TokenPocketIcon = "data:image/svg+xml;base64,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";
const OneKeyIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMTAiIGZpbGw9IiMwMEI4MTIiLz4KPHBhdGggZD0iTTIxLjgwNzYgOC40ODA3MUgxNi4yNDM3TDE1LjI2NzYgMTEuNDMyM0gxOC4zNTc5VjE3LjY0OTVIMjEuODA3NlY4LjQ4MDcxWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi4zNDUgMjUuMTczOUMyNi4zNDUgMjguNjc4NCAyMy41MDQxIDMxLjUxOTMgMTkuOTk5NiAzMS41MTkzQzE2LjQ5NTIgMzEuNTE5MyAxMy42NTQzIDI4LjY3ODQgMTMuNjU0MyAyNS4xNzM5QzEzLjY1NDMgMjEuNjY5NSAxNi40OTUyIDE4LjgyODUgMTkuOTk5NiAxOC44Mjg1QzIzLjUwNDEgMTguODI4NSAyNi4zNDUgMjEuNjY5NSAyNi4zNDUgMjUuMTczOVpNMjMuNDY0MyAyNS4xNzM5QzIzLjQ2NDMgMjcuMDg3NCAyMS45MTMxIDI4LjYzODYgMTkuOTk5NiAyOC42Mzg2QzE4LjA4NjEgMjguNjM4NiAxNi41MzUgMjcuMDg3NCAxNi41MzUgMjUuMTczOUMxNi41MzUgMjMuMjYwNCAxOC4wODYxIDIxLjcwOTIgMTkuOTk5NiAyMS43MDkyQzIxLjkxMzEgMjEuNzA5MiAyMy40NjQzIDIzLjI2MDQgMjMuNDY0MyAyNS4xNzM5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
const TronLinkIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDZfMzE0MzU4KSI+CjxwYXRoIGQ9Ik00MCAwSDBWNDBINDBWMFoiIGZpbGw9IiMxMzVEQ0QiLz4KPHBhdGggZD0iTTM5Ljk5OTQgMjEuODk5N0wxNC45NDkyIDE2LjUzMUwyMy42MSA0MEgyNS44NzU1TDE5LjExNDQgMjEuNjUxOUwzMi44MjUzIDM0LjA0MTNMMzIuMDIzIDQwSDM0LjE3MDVMMzQuODE5NCAzNS4yMDk1TDQwLjAyMyAzMy45MTE1VjMxLjcyODZMMzYuNjI0NyAzMi41NzgyTDQwLjAyMyAyOS4zNTdWMjYuNDMwN0wzMy45NDYzIDMyLjE4ODhMMjAuMjcwOCAxOS44NDY2TDM5Ljk5OTQgMjQuMDcwOFYyMS44OTk3WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDA2XzMxNDM1OCI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjEwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
const WalletConnectIcon = "data:image/svg+xml;base64,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";
const WalletList = ({ transitionRef, transitionStyle }) => {
  const walletSDK = useContext(WalletSDKContext);
  const { goBack, onClose, goNext } = useSimpleRouter();
  const [currentLogin, setCurrentLogin] = useState("");
  const { loginCacheSnap } = useLoginCacheState();
  const { walletSnap } = useWalletState();
  const wallets = useMemo(() => {
    return [
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: WalletConnectIcon, alt: "WalletConnect" }),
        name: CustomWallet.walletConnect,
        supportList: [CoinType.eth, CoinType.bsc, CoinType.matic]
      },
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: MetaMaskIcon, alt: "MetaMask" }),
        name: CustomWallet.metaMask,
        supportList: [CoinType.eth, CoinType.bsc, CoinType.matic]
      },
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: TrustWalletIcon, alt: "TrustWallet" }),
        name: CustomWallet.trustWallet,
        supportList: [CoinType.eth, CoinType.bsc, CoinType.matic]
      },
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: ImTokenIcon, alt: "imToken" }),
        name: CustomWallet.imToken,
        supportList: [CoinType.eth, CoinType.bsc, CoinType.matic, CoinType.trx]
      },
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: TokenPocketIcon, alt: "TokenPocket" }),
        name: CustomWallet.tokenPocket,
        supportList: [CoinType.eth, CoinType.bsc, CoinType.matic, CoinType.trx, CoinType.doge]
      },
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: OneKeyIcon, alt: "OneKey" }),
        name: CustomWallet.oneKey,
        supportList: [CoinType.eth, CoinType.bsc, CoinType.matic]
      },
      // {
      //   icon: <img className="h-10 w-10" src={ITokenIcon} alt="iToken" />,
      //   name: CustomWallet.iToken,
      //   supportList: [CoinType.eth, CoinType.bsc, CoinType.matic],
      // },
      {
        icon: /* @__PURE__ */ jsx("img", { className: "h-10 w-10", src: TronLinkIcon, alt: "TronLink" }),
        name: CustomWallet.tronLink,
        supportList: [CoinType.trx]
      }
    ];
  }, []);
  const showWallets = useMemo(() => {
    const { coinType } = loginCacheSnap;
    if (coinType) {
      return wallets.filter((wallet) => {
        var _a2;
        if (wallet.name === CustomWallet.walletConnect && !walletSDK.context.wagmiConfig) {
          return false;
        }
        return wallet.supportList.includes(coinType) && (walletSnap.customWallets && ((_a2 = walletSnap.customWallets) == null ? void 0 : _a2.length) > 0 ? walletSnap.customWallets.includes(wallet.name) : true);
      });
    }
    return wallets;
  }, [loginCacheSnap, walletSDK.context.wagmiConfig, walletSnap.customWallets, wallets]);
  const onLogin = async (wallet) => {
    const { name } = wallet;
    if (currentLogin) {
      return;
    }
    try {
      setCurrentLogin(name);
      const { coinType } = loginCacheSnap;
      if (coinType) {
        setLoginCacheState({ walletName: name });
        await walletSDK.init({
          coinType,
          walletName: name
        });
        await walletSDK.connect();
      }
      onClose == null ? void 0 : onClose();
      setLoginCacheState({ walletConnectDisplayUri: "", walletName: "" });
    } catch (error) {
      console.error(error);
      const handleErrorRes = handleError(error);
      if (handleErrorRes.isHandle) {
        if (handleErrorRes.title && handleErrorRes.message) {
          createTips({
            title: handleErrorRes.title,
            content: handleErrorRes.message
          });
        }
      } else {
        createTips({
          title: `Tips`,
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          content: error.code ? `${error.code}: ${error.message}` : error.message ? error.message : error.toString()
        });
      }
    } finally {
      setCurrentLogin("");
    }
  };
  const close = () => {
    onClose == null ? void 0 : onClose();
    setCurrentLogin("");
  };
  const back = () => {
    goBack == null ? void 0 : goBack();
    setCurrentLogin("");
  };
  useEffect(() => {
    if (loginCacheSnap.walletConnectDisplayUri) {
      goNext == null ? void 0 : goNext();
    }
  }, [goNext, loginCacheSnap.walletConnectDisplayUri]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        title: "Select Wallet",
        onClose: close,
        goBack: back,
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "w-full px-6 pb-6 pt-[76px]", style: transitionStyle, ref: transitionRef, children: /* @__PURE__ */ jsx("ul", { className: "flex flex-col gap-2", children: showWallets == null ? void 0 : showWallets.map((wallet, index) => {
      return /* @__PURE__ */ jsx(
        WalletItem,
        {
          ...wallet,
          currentLogin,
          onClick: async () => {
            await onLogin(wallet);
          }
        },
        index
      );
    }) }) })
  ] });
};
function QRCode(props) {
  const {
    width = 300,
    height = 300,
    dotsOptions = { color: "#000000", type: "dots" },
    cornersSquareOptions = { color: "#000000", type: "extra-rounded" },
    cornersDotOptions = { color: "#000000", type: "dot" },
    qrOptions = { typeNumber: 0, mode: "Byte", errorCorrectionLevel: "L" },
    margin = 0,
    ...rest
  } = props;
  const [blobUrl, setBlobUrl] = useState();
  useEffect(() => {
    const qr = new QR({
      type: "svg",
      width,
      height,
      dotsOptions,
      cornersDotOptions,
      cornersSquareOptions,
      qrOptions,
      margin,
      ...rest
    });
    qr.getRawData("svg").then((blob) => {
      setBlobUrl(window.URL.createObjectURL(blob));
    }).catch(console.error);
  }, []);
  return /* @__PURE__ */ jsx("img", { width, height, src: blobUrl });
}
function WalletConnectQrCode({ transitionRef, transitionStyle }) {
  const { onClose, goBack } = useSimpleRouter();
  const { loginCacheSnap } = useLoginCacheState();
  const close = () => {
    setLoginCacheState({ walletName: "", walletConnectDisplayUri: "" });
    onClose == null ? void 0 : onClose();
  };
  const back = () => {
    setLoginCacheState({ walletName: "", walletConnectDisplayUri: "" });
    goBack == null ? void 0 : goBack();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: loginCacheSnap.walletName,
        onClose: close,
        goBack: back,
        className: "bg-blur z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsx("div", { className: "text-center text-[14px] leading-tight text-neutral-700", children: loginCacheSnap.walletName === CustomWallet.walletConnect ? "Scan with your phone" : (
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `Scan with ${loginCacheSnap.walletName}`
          ) }),
          /* @__PURE__ */ jsx("div", { className: "relative my-3 mb-9 h-[260px] w-[260px] rounded-2xl border border-stone-300/20 p-2", children: /* @__PURE__ */ jsx(QRCode, { data: loginCacheSnap.walletConnectDisplayUri }) })
        ]
      }
    )
  ] });
}
function Toast({ visible, message, duration = 1e3, customRootId, zIndex = "z-[11]" }) {
  const [removeDOM, setRemoveDOM] = useState(!visible);
  useEffect(() => {
    if (visible) {
      setRemoveDOM(false);
    }
  }, [visible]);
  useEffect(() => {
    window.setTimeout(() => {
      setRemoveDOM(true);
    }, duration);
  }, [duration]);
  return removeDOM ? null : /* @__PURE__ */ jsx(Portal, { customRootId: customRootId ?? "toast-root", children: /* @__PURE__ */ jsx(
    "span",
    {
      className: clsx(
        "fixed inset-0 m-auto h-max w-max min-w-[120px] rounded-lg bg-[#11142D] p-4 text-center text-base font-semibold leading-[22px] text-white shadow-toast",
        zIndex
      ),
      children: message
    }
  ) });
}
const createToast = (props) => {
  const toastProps = {
    ...props,
    visible: true
  };
  const shadowDomRoot2 = getShadowDomRoot();
  const instance = React.createElement(Toast, toastProps);
  createRoot(shadowDomRoot2).render(instance);
};
const BackupTipsIcon = "data:image/svg+xml;base64,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";
const IcloudBackupTipsIcon = "data:image/svg+xml;base64,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";
const BackupTips = ({ onShowQRCode, className }) => {
  const [passkeysSupported, setPasskeysSupported] = useState(false);
  useEffect(() => {
    setPasskeysSupported(checkICloudPasskeySupport());
  }, []);
  return passkeysSupported ? /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("flex flex-col items-center rounded-2xl border border-[#1EA2EC5C] bg-[#7AAEEC29] p-6", className),
      children: [
        /* @__PURE__ */ jsx("img", { className: "w-[90px]", src: IcloudBackupTipsIcon }),
        /* @__PURE__ */ jsx("h3", { className: "mb-2 mt-4 font-bold leading-[normal] text-black", children: "Asset secured with iCloud" }),
        /* @__PURE__ */ jsxs("div", { className: "text-center text-sm leading-[normal] text-black", children: [
          "Need access to this address with Windows or Android devices,",
          " ",
          /* @__PURE__ */ jsx("span", { className: "cursor-pointer underline decoration-1", onClick: onShowQRCode, children: "click here" }),
          "."
        ] })
      ]
    }
  ) : /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("flex flex-col items-center rounded-2xl border border-[#F9CD4E5C] bg-[#F9CD4E29] p-6", className),
      children: [
        /* @__PURE__ */ jsx("img", { className: "w-[90px]", src: BackupTipsIcon }),
        /* @__PURE__ */ jsx("h3", { className: "mb-2 mt-4 font-bold leading-[normal] text-[#AC6E15]", children: "Device Loss Can Lead to Asset Loss" }),
        /* @__PURE__ */ jsx("div", { className: "mb-4 text-center text-sm leading-[normal] text-[#AC6E15]", children: "Secure your assets by adding extra trusted devices like mobile phones, computers or tablets immediately." }),
        /* @__PURE__ */ jsx(Button, { size: ButtonSize.middle, shape: ButtonShape.round, onClick: onShowQRCode, children: "Add Trusted Device" })
      ]
    }
  );
};
const apple = "data:image/png;base64,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";
const basketball = "data:image/png;base64,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";
const cat = "data:image/png;base64,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";
const computer = "data:image/png;base64,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";
const crown = "data:image/png;base64,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";
const dice = "data:image/png;base64,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";
const doughnut = "data:image/png;base64,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";
const fire = "data:image/png;base64,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";
const frog = "data:image/png;base64,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";
const heart = "data:image/png;base64,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";
const laptop = "data:image/png;base64,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";
const pad = "data:image/png;base64,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";
const phone = "data:image/png;base64,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";
const pig = "data:image/png;base64,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";
const rainbow = "data:image/png;base64,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";
const shark = "data:image/png;base64,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";
const smiling = "data:image/png;base64,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";
const snowman = "data:image/png;base64,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";
const soccer = "data:image/png;base64,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";
const sparkles = "data:image/png;base64,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";
const swan = "data:image/png;base64,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";
const unicorn = "data:image/png;base64,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";
const voltage = "data:image/png;base64,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";
const watermelon = "data:image/png;base64,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";
const Android = "data:image/png;base64,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";
const iOS = "data:image/png;base64,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";
const Windows = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABACAYAAABFqxrgAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAxqSURBVHgB7RtdbxxX9ZzZD+/au/6Km7hQkUTiB7RvBV4cgVqlIJB46wOCPvFaJN6hv6AtAiHBQ1IegBfaIkJBlVDgCRWBKFCEaKrEAZKs106ysb32rtczl3Nm7se5d2bsXTv1k080mZn7cb7u+bp31gCncAqncAoOsKjx2WdXLiw3zl9BxAtKKaB72s7PBcCNSF0qihDDMUVzRZvKXrEMtyNC+GnYWGMzsQrH9GYXWq/95K0fvBGOzsHzn/vqlWat/Q2NqXBMSZ+SeFlINBID2GfTboQJBPP6AlqS5qHPIV5uqk/Vep948qmLr139bs90VKEAIowuMIKtL7yIo09+GqqE8sJMBEs1jZjxKacAFi1b05xSULAvGcMcy04MNK8Ks3tCTSpKnzHBDBVjSOwY7s/4SliBcq6+x4Nd7H//VYhHw3mAAV1wsBJS3kiqpL2YXnv0/iFdm6SN86SMRpQfL2UqAzygX65aTgnUZwXG7N0+p+2uP50bife0T2WqbTYVjIY5y46gHFKezJLx/2sDBe/dj+F2X8F+II2CgxUABf0YEsuNcyMQ8/NU0R3zQhiPxBLXjsqYVSrRZq60Czi4vZPAXx7G0BkUMe4C32FQpDQMR2C6nJ5ilOlS/hw71yjU3JQSVpinGpWxp0BQUP50vg9icpHtBP70IIZh4jPiZQIQfWMox4ushrRSgve84nOWY+hI4pAtLF05LRRbAg8mz+N7yKE1LY18QEPeI6u4QS4yTDxWnG87xDApYCCX6xBtyqkjjM0IzpISSNJMG9IoDIysAqMAL82gWGVlGMk8rUPa6I0Qzk0hfKqJdshhEPq3TiE5Ona8829Isiojc1sQChdzdCbL5qkEk3EtwbhDZonqYO4h800mMqT7fylO/PlRAt1RXgmqkJLfHtJUwaxQN5hjSWJEq1SGxOYMH0oCIxuO7wrlFZOyqQz0ynC8ZPf4aNe5yNFAOnTuQYurcuM1G1CkwlAuhkJ3YItRUeL5sHyyadOYoklD6Pr5tbunYIMs4sk6XeQmUwgH1gqeKLoos5mpqDbFbK2VfjEiM+3E9uu4ilmsgwIllLuDSkqWX2O29b9+RhAVhRmZPd+jauufO6SQ2I0ITdmn7lyiyB0RwPf5IgQFDWyzavwUyZpMIymUgnJaL+ZS3jF1C3aPv+4CbCf5WFCmkDBwQlCzlM0OE0cWSEmmcS3BBhAF+ayGzg3CtFyoMvQdgJXxASni5jALpAbK1O1lDcikytUdotw2NAuDcJb6x60TeGic5pZwpVEEHwiLIi1wygK6MJXL3TRug4qtvw0Q7ozc/Dwjxe02CAdFnBBA0PJnqnGzQxYTfNRu4Y3W0aOQG6180tZ6RCu/3tlH+DtZxXoMJZyUgCDhV6IFVZXjA4tiTGmKTCvGIB0Jm3QCSfcAlasos0zhZ/BsZ+ZMlt3iFhVa/6ZrzwsUQgBRHxQCgs0RvizuPUkT5LgxIXWHJJ+ZEL0UF5at1jpkYET/MdL9ZlNjEg1fW8TfP/YjWKUssmdzTahUK50gouy78hgDzxXTc4zxs4PS6SQITEJY4ZKOMEIQSf2S27ZKZSLY/RHq+vc+nYR8SFbxIPFXEiQv6GKQKo4oRnDHI1u4isdTQiZgmiEsw2bJVJAVjLkboRQEhhDGAq0ojNDbHEVWoGzIHv13O47gX2QZm0oMBLcwbn+hQuYhBIN97JiQbaHizMq8DCCqRUkV3Q01s/lgJfJoukEqICsUpjQ+Th7/IWXcIRcZadNBg0fjlpsqzx0taW252XZgzBSZJLYut1YQ4PVWJVh+pfT2S/t6pkiVixE5XMopOUJnF9zeIxf5iDLJBhloLEriQodRxc/eUZmAkq10ku0MA/kEZYvdBDU3ghtkyYvFVSUYBUF6Xg9oYo3bh5igadyMV+x+wu4BsEBzWhVlKHp5rNDIWC6qfTAZMyY4AfxU6BU+CjzTBasMx1gk44ENZOBbF0L4IOiDxeUEpbNS6lsny/gfuUl41pnx5S2baTZ7BxxLCdacBbgTGr1qkUldKCpj1GlUasjMBxewxOYLg9wn6w1lbUC6OtpgzArgYusBK8MXwCdvS22HT0LpkTtITwj8OMOrPAEcEfDiBYqVNqZtlRahZhhDvwPIJT7MxR3U/rJNsW6X3GSa3KNVNa4IXgw6CKIDFYAmp2cMuMXGYtwFzm/PGYQC7LmpknsTVZ5RLEvF3sPc8EeWbXL39VFEChEuGw4u4DwqkcWxZiK7Tc7OX80C+ssLILfZnsWAFBi0yTu3svOiyONXTs97tPIY58yxSXl1k9wktt0uvkzqDm4V9XxtfZ7AaMbJlfLThVaS8C7hr55MNoopyAVOu0NFj543xjEOQ9LAkGqLqQpAo6ZE0M5DiRI0kbCiCVzXmrfNGi4g5pXlONX7J5slihSBQnCJRwbsyDMRVeiOe6SMUcKKEMgDKN07pDDsg6wQ3ap7/II7RzDvrt9bNWlNUiniVSrYL4sx+JeNcueKGBRJ7iUhH9qhrWqSTGAJhK/HWXL/2quIjR/7RmR+VJBxrBOiom+gEWap1cYC84nd+zyfzjKmI8YAenmzkNmc1Vh+UbIlfwLg2Oa3h+s4NTVNb43eoUoYqeorFRw9rQb983SFIdp6V/rFN+MfYyGHaUsyJswnw1wIAN/zNUq781SyHcYErU+5bmh/DgDsQtVX5G8TJBM5WFlZmR8MYB4OgS8//6W36vWpp6empqC32Xv51+++80s4IXjh8y9cbzQaFyqVCty4eePS+x+8v3rQ+OXlZXj77Z/nxoyt4TK4+qOfXidNrywuLsJUo/7Sc1+8dBVOCH74+pVbs+32+dm5Nlank4uXL19ehSNAFY4JEbqPI5WoAicJlUpEVwWnZ5pqeq4NR4UIHhPEcQz9nT6cLLjk34Cjw7EtIeWCgtHuzi67w5Vf/eK3V7w8x1DkdGG4U4eMK+jf3NxON3JMfwBHh8eiBM6/g8GQTLMK9WolX5ipkomTjgv6Z2dnYW+4B8eFYyshTpJeEiepItQ0nCgMdgeQ7CcQ7yeqMYAeHBGOHRN2t5I3htvJ6h59ik/24UThQfcRbG7swsad3veeufTMkZVw7BQp4dqb716leu3rcEIwM926eOnyZ1bhmPBYYoKBQX/fbgC9kg2K49tBpeBhcZJhtHfkxT+FUyiAiWLCO9d+93K9WvsOPR66p/g4AMUGVBxE+Udu9uS78vtLz3320jh4J8oOtWrtK1Smzj961IP19S6lxZjqg930eXPzEVSrVXpeT98Zdvo76XO/vw0RHZl119ZgY2M9LXC2trbSPp7PxU63m/XxZqjXe5g+j0YjSn8xrHe78PDhA4ioTOa+9Y0uVagJzR1Ad30NNrc2ocK0aU43pY1Uwkcr13/zxwvjyDVRYDQa73Yz5tvtWehv78C9e3dhbm4eFhfPpMLwd8zZ2Tl4RIpZJyafeOIstFptuEvjqlRM8TgWhgXD6Cnaf1RSHNVaDc6dW4b79+/DDpXgvDNFWqd7nbvQbDZhaekJrbgBtFtMe1vTnoOF+UXo3OsAf2pj2q2Z1thyTaQEE/EXF87AfjyCer1GBdI0nD17DpqNZrqizChDjQRqk+C8wZppzaRnDcskIB+i8mqz0uq1OqW5GajVWfgn7XHZ0tISCdoi/FNpGyumWqmlOBYXlgTtFpw7uwwNUhADK5u5rNfrMAkcyRJ49xbTsTZXidnXZedVbPZsCXznSx82agTZvdPp2PctMmW+Iv0xh1eWheUdqcVhjvxJyZUq046yg5tIZbT1iRa5QPoJMYomqwGPVCew7w2HA5glM+xv92Ft7V7mDmecO/B7j2LHBvkvr1C73dYCGvnFUbsOdLKNBWk0G+kZO+NndzhHFmfcYY72Df1+HzprmSuyBXZoHKtjfm4BqtPji3Ykd5htzcGQ/JXWCZrkDnNEtN1q2T4Ot+wO07pvZiZzh/n5Bf/DjTy0NYeW5p0so1qt8V/hpDjqhI8FnG3NU6wYpG7VbEynArc07YX5M/zRNaU9CUyUIt/82bXrC0sLK3AMEGeIB7YdiEN8sJF/R+V+3cqZaQCdm52LL33rxdXD8E1kCZ07G727tx6Aiq3PmTNUY+TixNd9UMqGKJ2/UfyVjz1wsHi4L4qyQ2o7zc0rOKkwX3Y8HqDejLBeGW+NJ1JCPFKvqziZ562zZDAHosA3B8eIBzMkcSVj/ijco68EWfpvP6784Zvf/toqnMIpnMIpTAj/B7X7QgDpESWHAAAAAElFTkSuQmCC";
const MacOS = "data:image/png;base64,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";
const iPad = "data:image/png;base64,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";
const emojisTemp = {
  computer,
  laptop,
  pad,
  phone,
  apple,
  doughnut,
  watermelon,
  basketball,
  soccer,
  frog,
  cat,
  pig,
  shark,
  swan,
  unicorn,
  rainbow,
  sparkles,
  voltage,
  dice,
  crown,
  snowman,
  fire,
  heart,
  smiling,
  Android,
  Windows,
  iPad,
  iOS,
  MacOS
};
function defaultLetterFn(data) {
  return data[0].toUpperCase() || "";
}
const pallete = [
  "rgb(226, 95, 81)",
  "rgb(242, 96, 145)",
  "rgb(187, 101, 202)",
  "rgb(149, 114, 207)",
  "rgb(120, 132, 205)",
  "rgb(91, 149, 249)",
  "rgb(72, 194, 249)",
  "rgb(69, 208, 226)",
  "rgb(72, 182, 172)",
  "rgb(82, 188, 137)",
  "rgb(155, 206, 95)",
  "rgb(212, 227, 74)",
  "rgb(254, 218, 16)",
  "rgb(247, 192, 0)",
  "rgb(255, 168, 0)",
  "rgb(255, 138, 96)",
  "rgb(194, 194, 194)",
  "rgb(143, 164, 175)",
  "rgb(162, 136, 126)",
  "rgb(163, 163, 163)",
  "rgb(175, 181, 226)",
  "rgb(179, 155, 221)",
  "rgb(194, 194, 194)",
  "rgb(124, 222, 235)",
  "rgb(188, 170, 164)",
  "rgb(173, 214, 125)"
];
const hasher = new Keccak();
function getDeterminedRandom(s, length) {
  hasher.reset();
  hasher.update(s);
  const hash = hasher.digest("hex");
  const digits = Math.max(hash.length, Math.ceil(Math.log2(length * 16) / 4));
  return parseInt(hash.slice(-digits), 16) % length;
}
function defaultColorFn(data) {
  const base = pallete[getDeterminedRandom(data, pallete.length)];
  const color = Color(base);
  return color.rgb().toString();
}
function defaultBgFn(data) {
  const base = pallete[getDeterminedRandom(data, pallete.length)];
  const color = Color(base);
  return color.fade(0.8).rgb().toString();
}
function LetterAvatar({
  data,
  className = "w-7 h-7 text-[12px]",
  bgFn = defaultBgFn,
  colorFn = defaultColorFn,
  letterFn = defaultLetterFn
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx("inline-flex items-center justify-center rounded-full", className),
      style: { backgroundColor: bgFn(data), color: colorFn(data) },
      children: letterFn(data)
    }
  );
}
function useWebAuthnService(isTestNet) {
  const baseURL = isTestNet ? WebAuthnTestApi : WebAuthnApi;
  async function buildTransaction(data) {
    const cfAccessClient = isTestNet ? CfAccessClient : {};
    const res = await fetch(`${baseURL}/v1/webauthn/authorize`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...cfAccessClient
      },
      body: JSON.stringify(data)
    }).then(async (res2) => await res2.json());
    return res;
  }
  async function sendTransaction2(data) {
    const cfAccessClient = isTestNet ? CfAccessClient : {};
    const res = await fetch(`${baseURL}/v1/transaction/send`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...cfAccessClient
      },
      body: JSON.stringify(data)
    }).then(async (res2) => await res2.json());
    return res;
  }
  async function getTransactionStatus(txHash) {
    const cfAccessClient = isTestNet ? CfAccessClient : {};
    const res = await fetch(`${baseURL}/v1/transaction/status`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...cfAccessClient
      },
      body: JSON.stringify({
        tx_hash: txHash
      })
    }).then(async (res2) => await res2.json());
    return res;
  }
  return {
    sendTransaction: sendTransaction2,
    buildTransaction,
    getTransactionStatus
  };
}
function More({ address, onRevoke }) {
  return /* @__PURE__ */ jsxs(Menu, { as: "div", className: "relative inline-block flex-none", children: [
    /* @__PURE__ */ jsx(Menu.Button, { className: "flex", children: /* @__PURE__ */ jsx(MoreIcon, { className: "h-[16px] w-[16px] flex-none cursor-pointer text-zinc-300 active:opacity-60" }) }),
    /* @__PURE__ */ jsx(
      Transition$1,
      {
        as: Fragment$1,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0 scale-95",
        enterTo: "transform opacity-100 scale-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100 scale-100",
        leaveTo: "transform opacity-0 scale-95",
        children: /* @__PURE__ */ jsx(Menu.Items, { className: "absolute right-[-16px] z-10 mt-2 w-[150px] origin-top-right rounded-xl border border-slate-300/40 bg-white p-3 shadow", children: /* @__PURE__ */ jsx(Menu.Item, { children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: "relative h-[36px] w-full cursor-pointer rounded-lg px-3 py-2 text-center text-gray-700 hover:bg-red-100 hover:text-red-500 active:text-red-500",
            onClick: onRevoke,
            children: [
              /* @__PURE__ */ jsx(RevokeIcon, { className: "absolute left-3 top-1/2 h-[16px] w-[16px] -translate-y-1/2" }),
              /* @__PURE__ */ jsx("div", { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[14px] font-medium leading-tight", children: "Revoke" })
            ]
          }
        ) }) })
      }
    )
  ] });
}
function Device({ item, managingAddress, onDisconnect }) {
  var _a2, _b, _c, _d, _e, _f, _g;
  const { walletSnap } = useWalletState();
  const walletSDK = useContext(WalletSDKContext);
  const webAuthnService = useWebAuthnService(walletSnap.isTestNet);
  const signDataQuery = useQuery({
    queryKey: ["FetchSignDataDelete", { master: walletSnap.address, slave: item.address }],
    retry: false,
    enabled: false,
    queryFn: async () => {
      if (walletSnap.address === void 0)
        throw new Error("unreachable");
      const res = await webAuthnService.buildTransaction({
        master_ckb_address: walletSnap.address,
        slave_ckb_address: item.address,
        operation: "delete"
      });
      if (res.err_no !== 0)
        throw new Error(res.err_msg);
      return res.data;
    }
  });
  const sendTransactionMutation = useMutation({
    retry: false,
    mutationFn: async (signData) => {
      const res = await webAuthnService.sendTransaction(signData);
      if (res.err_no !== 0)
        throw new Error(res.err_msg);
      return res.data;
    }
  });
  const [statusConverged, setStatusConverged] = useState(false);
  const transactionStatusQuery = useQuery({
    enabled: sendTransactionMutation.isSuccess && !statusConverged,
    networkMode: "always",
    queryKey: ["RevokingTransactionStatus", (_a2 = sendTransactionMutation.data) == null ? void 0 : _a2.hash],
    cacheTime: 0,
    refetchInterval: 1e4,
    queryFn: async () => {
      const res = await webAuthnService.getTransactionStatus(sendTransactionMutation.data.hash);
      if (res.err_no !== 0)
        throw new Error(res.err_msg);
      return res.data;
    }
  });
  const isMasterDevice = useMemo(
    () => {
      var _a3;
      return !((_a3 = walletSnap.deviceList) == null ? void 0 : _a3.find((v) => v.address === item.address));
    },
    [item.address, walletSnap.deviceList]
  );
  const isCurrentDevice = useMemo(
    () => {
      var _a3;
      return ((_a3 = walletSnap.deviceData) == null ? void 0 : _a3.ckbAddr) === item.address;
    },
    [item.address, (_b = walletSnap.deviceData) == null ? void 0 : _b.ckbAddr]
  );
  const onRevoke = async () => {
    var _a3;
    if (isMasterDevice) {
      createTips({
        title: "Info",
        content: "For safety concerns, you can not revoke the master device."
      });
      return;
    }
    const { signTxList, onFailed } = await walletSDK.initSignContext();
    try {
      const { data, isError } = await signDataQuery.refetch();
      if (isError) {
        onFailed().catch(console.error);
      } else {
        const res = await signTxList({
          ...data,
          // eslint-disable-next-line
          sign_list: (_a3 = data.sign_list) == null ? void 0 : _a3.map(({ sign_type, sign_msg }) => ({
            sign_type,
            sign_msg: sign_msg.replace("0x", "")
          }))
        });
        await sendTransactionMutation.mutateAsync(res);
      }
    } catch (error) {
      onFailed().catch(console.error);
      const handleErrorRes = handleError(error);
      if (handleErrorRes.isHandle) {
        if (handleErrorRes.title && handleErrorRes.message) {
          createTips({
            title: handleErrorRes.title,
            content: handleErrorRes.message
          });
        }
      } else {
        createTips({
          title: `Tips`,
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          content: error.code ? `${error.code}: ${error.message}` : error.message ? error.message : error.toString()
        });
      }
    }
  };
  const revoking = signDataQuery.isInitialLoading || sendTransactionMutation.isLoading || transactionStatusQuery.isInitialLoading || ((_c = transactionStatusQuery.data) == null ? void 0 : _c.status) === 0;
  const [revokeError, setRevokeError] = useState(false);
  const isRevokingError = signDataQuery.isError || sendTransactionMutation.isError || revokeError;
  useEffect(() => {
    var _a3, _b2, _c2, _d2;
    if (revoking)
      return;
    if (((_a3 = transactionStatusQuery.data) == null ? void 0 : _a3.status) === 1) {
      setWalletState({
        deviceList: (_b2 = walletSnap.deviceList) == null ? void 0 : _b2.filter((a) => a.address !== item.address)
      });
      setStatusConverged(true);
      if (item.address === ((_c2 = walletSnap.deviceData) == null ? void 0 : _c2.ckbAddr)) {
        onDisconnect == null ? void 0 : onDisconnect();
      }
    } else if (((_d2 = transactionStatusQuery.data) == null ? void 0 : _d2.status) === -1) {
      setRevokeError(true);
      setStatusConverged(true);
    }
  }, [
    (_d = transactionStatusQuery.data) == null ? void 0 : _d.status,
    revoking,
    setRevokeError,
    item,
    onDisconnect,
    (_e = walletSnap.deviceData) == null ? void 0 : _e.ckbAddr,
    (_f = sendTransactionMutation.data) == null ? void 0 : _f.hash,
    walletSnap.deviceList
  ]);
  const nameAndEmoji = getNameAndEmojiFromLocalStorage(item.address);
  const deviceEmoji = item.device ? item.device : (_g = item.notes) == null ? void 0 : _g.split("-")[0];
  const currentDeviceName = useMemo(() => {
    var _a3;
    const result = isCurrentDevice ? (_a3 = walletSnap.deviceData) == null ? void 0 : _a3.name : isMasterDevice ? walletSnap.masterNotes || collapseString(walletSnap.address, 8, 4) : item.notes ? item.notes : (nameAndEmoji == null ? void 0 : nameAndEmoji.name) ? nameAndEmoji == null ? void 0 : nameAndEmoji.name : collapseString(item.address, 8, 4);
    return result;
  }, [isCurrentDevice, isMasterDevice, item.address, item.notes, nameAndEmoji == null ? void 0 : nameAndEmoji.name, walletSnap]);
  return /* @__PURE__ */ jsxs("li", { className: "flex h-[48px] items-center gap-4 pl-3 pr-4", children: [
    /* @__PURE__ */ jsx(
      LeadingIcon,
      {
        name: item.notes || (nameAndEmoji == null ? void 0 : nameAndEmoji.name),
        emoji: deviceEmoji || (nameAndEmoji == null ? void 0 : nameAndEmoji.emoji),
        address: item.address
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex-1 text-[14px] font-semibold text-neutral-700", children: [
      /* @__PURE__ */ jsx("div", { children: currentDeviceName }),
      revoking ? /* @__PURE__ */ jsx("span", { className: "text-[12px] font-medium text-red-500", children: "Revoking..." }) : isRevokingError ? /* @__PURE__ */ jsx("span", { className: "text-[12px] font-medium text-red-500", children: "Revoke Failed" }) : isCurrentDevice ? /* @__PURE__ */ jsx("span", { className: "rounded bg-green-100 px-1 py-0.5 text-xs font-medium text-emerald-600", children: "Current Device" }) : null
    ] }),
    /* @__PURE__ */ jsx(More, { address: item.address, onRevoke })
  ] });
}
function LeadingIcon({ name, emoji, address }) {
  const selectedEmoji = emojisTemp[emoji];
  const { walletSnap } = useWalletState();
  const isMasterDevice = useMemo(
    () => {
      var _a2;
      return !((_a2 = walletSnap.deviceList) == null ? void 0 : _a2.find((v) => v.address === address));
    },
    [address, walletSnap.deviceList]
  );
  if (isMasterDevice) {
    return /* @__PURE__ */ jsx(DeviceIcon, { className: "h-6 w-6" });
  } else if (selectedEmoji) {
    return /* @__PURE__ */ jsx("img", { className: "h-6 w-6", src: selectedEmoji });
  } else if (name) {
    return /* @__PURE__ */ jsx(LetterAvatar, { data: name, className: "h-[28px] w-[28px] flex-none" });
  } else {
    return /* @__PURE__ */ jsx(NervosIcon, { className: "h-6 w-6 flex-none rounded-full border border-stone-300/20" });
  }
}
function getNameAndEmojiFromLocalStorage(address) {
  return JSON.parse(globalThis.localStorage.getItem(".bit-memos") ?? "{}")[address];
}
function DeviceList({ onShowQRCode, className, onDisconnect }) {
  var _a2;
  const { walletSnap } = useWalletState();
  const mergedList = useMemo(() => [...walletSnap.deviceList], [walletSnap.deviceList]);
  if (!mergedList.find((addr) => addr.address === walletSnap.address)) {
    mergedList.unshift({
      address: walletSnap.address,
      device: void 0,
      notes: walletState.masterNotes || ((_a2 = walletState.deviceData) == null ? void 0 : _a2.name)
    });
  }
  return /* @__PURE__ */ jsxs("div", { className: clsx("select-none", className), children: [
    /* @__PURE__ */ jsx("div", { className: "mb-3 text-base font-medium leading-[normal] text-[#5F6570]", children: "Trusted Devices of CKB Address" }),
    /* @__PURE__ */ jsxs("ul", { className: "rounded-2xl border border-[#B6C4D966]", children: [
      mergedList == null ? void 0 : mergedList.map((item) => /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Device, { item, managingAddress: walletSnap.address, onDisconnect }, item.address),
        /* @__PURE__ */ jsx("hr", { className: "mx-3 border-[#B6C4D966]" })
      ] }, item.address)),
      /* @__PURE__ */ jsxs(
        "div",
        {
          onClick: onShowQRCode,
          className: "flex h-[48px] cursor-pointer items-center gap-4 pl-3 pr-4 hover:bg-secondary-5 active:bg-secondary",
          children: [
            /* @__PURE__ */ jsx(PlusIcon, { className: "h-6 w-6" }),
            /* @__PURE__ */ jsx("div", { className: "flex-1 text-[14px] font-semibold text-success", children: "Add New" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "mt-3 leading-[normal] text-[#5F6570]", children: "Every trusted device can access the assets on the CKB address." })
  ] });
}
const BscBg = "data:image/svg+xml;base64,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";
const DeviceBg = "data:image/svg+xml;base64,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";
const DogeBg = "data:image/svg+xml;base64,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";
const EthBg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDQwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85NTNfMTEzMTI4KSI+CjxlbGxpcHNlIGN4PSIyMDAiIHJ4PSIyNDkiIHJ5PSI5OCIgZmlsbD0idXJsKCNwYWludDBfcmFkaWFsXzk1M18xMTMxMjgpIi8+CjxwYXRoIGQ9Ik0zMTIuMTU0IC03NS4xNTM5SDMzNy4wNzdNMzEyLjE1NCAtNzUuMTUzOVYtNTAuMjMwOE0zMTIuMTU0IC03NS4xNTM5SDI4Ny4yMzFNMzM3LjA3NyAtNzUuMTUzOVYtNTAuMjMwOE0zMzcuMDc3IC03NS4xNTM5SDM2MlYtNTAuMjMwOE0zMzcuMDc3IC01MC4yMzA4SDMxMi4xNTRNMzM3LjA3NyAtNTAuMjMwOEgzNjJNMzM3LjA3NyAtNTAuMjMwOFYtMjUuMzA3N00zMTIuMTU0IC01MC4yMzA4Vi0yNS4zMDc3TTMxMi4xNTQgLTUwLjIzMDhIMjg3LjIzMU0zNjIgLTUwLjIzMDhWLTI1LjMwNzdNMzM3LjA3NyAtMjUuMzA3N0gzMTIuMTU0TTMzNy4wNzcgLTI1LjMwNzdWLTAuMzg0NjM3TTMzNy4wNzcgLTI1LjMwNzdIMzYyTTMxMi4xNTQgLTI1LjMwNzdWLTAuMzg0NjM3TTMxMi4xNTQgLTI1LjMwNzdIMjg3LjIzMU0zMzcuMDc3IC0wLjM4NDYzN0gzMTIuMTU0TTMzNy4wNzcgLTAuMzg0NjM3VjI0LjUzODRNMzM3LjA3NyAtMC4zODQ2MzdIMzYyTTMxMi4xNTQgLTAuMzg0NjM3VjI0LjUzODRNMzEyLjE1NCAtMC4zODQ2MzdIMjg3LjIzMU0zMzcuMDc3IDI0LjUzODRIMzEyLjE1NE0zMzcuMDc3IDI0LjUzODRWNDkuNDYxNU0zMzcuMDc3IDI0LjUzODRIMzYyTTMxMi4xNTQgMjQuNTM4NFY0OS40NjE1TTMxMi4xNTQgMjQuNTM4NEgyODcuMjMxTTMzNy4wNzcgNDkuNDYxNUgzMTIuMTU0TTMzNy4wNzcgNDkuNDYxNVY3NC4zODQ2TTMzNy4wNzcgNDkuNDYxNUgzNjJNMzEyLjE1NCA0OS40NjE1Vjc0LjM4NDZNMzEyLjE1NCA0OS40NjE1SDI4Ny4yMzFNMzM3LjA3NyA3NC4zODQ2SDMxMi4xNTRNMzM3LjA3NyA3NC4zODQ2Vjk5LjMwNzdNMzM3LjA3NyA3NC4zODQ2SDM2Mk0zMTIuMTU0IDc0LjM4NDZWOTkuMzA3N00zMTIuMTU0IDc0LjM4NDZIMjg3LjIzMU0zMzcuMDc3IDk5LjMwNzdIMzEyLjE1NE0zMzcuMDc3IDk5LjMwNzdWMTI0LjIzMU0zMzcuMDc3IDk5LjMwNzdIMzYyTTMxMi4xNTQgOTkuMzA3N1YxMjQuMjMxTTMxMi4xNTQgOTkuMzA3N0gyODcuMjMxTTMzNy4wNzcgMTI0LjIzMUgzMTIuMTU0TTMzNy4wNzcgMTI0LjIzMVYxNDkuMTU0TTMzNy4wNzcgMTI0LjIzMUgzNjJNMzEyLjE1NCAxMjQuMjMxVjE0OS4xNTRNMzEyLjE1NCAxMjQuMjMxSDI4Ny4yMzFNMzM3LjA3NyAxNDkuMTU0SDMxMi4xNTRNMzM3LjA3NyAxNDkuMTU0SDM2MlYxMjQuMjMxTTMxMi4xNTQgMTQ5LjE1NEgyODcuMjMxTTM2MiAtMjUuMzA3N1YtMC4zODQ2MzdNMzYyIC0wLjM4NDYzN1YyNC41Mzg0TTM2MiAyNC41Mzg0VjQ5LjQ2MTVNMzYyIDQ5LjQ2MTVWNzQuMzg0Nk0zNjIgNzQuMzg0NlY5OS4zMDc3TTM2MiA5OS4zMDc3VjEyNC4yMzFNNjIuOTIzMSAtNzUuMTUzOUgzOFYtNTAuMjMwOE02Mi45MjMxIC03NS4xNTM5Vi01MC4yMzA4TTYyLjkyMzEgLTc1LjE1MzlIODcuODQ2Mk02Mi45MjMxIC01MC4yMzA4SDM4TTYyLjkyMzEgLTUwLjIzMDhIODcuODQ2Mk02Mi45MjMxIC01MC4yMzA4Vi0yNS4zMDc3TTM4IC01MC4yMzA4Vi0yNS4zMDc3TTg3Ljg0NjIgLTc1LjE1MzlWLTUwLjIzMDhNODcuODQ2MiAtNzUuMTUzOUgxMTIuNzY5TTg3Ljg0NjIgLTUwLjIzMDhIMTEyLjc2OU04Ny44NDYyIC01MC4yMzA4Vi0yNS4zMDc3TTExMi43NjkgLTc1LjE1MzlWLTUwLjIzMDhNMTEyLjc2OSAtNzUuMTUzOUgxMzcuNjkyTTExMi43NjkgLTUwLjIzMDhIMTM3LjY5Mk0xMTIuNzY5IC01MC4yMzA4Vi0yNS4zMDc3TTEzNy42OTIgLTc1LjE1MzlWLTUwLjIzMDhNMTM3LjY5MiAtNzUuMTUzOUgxNjIuNjE1TTEzNy42OTIgLTUwLjIzMDhIMTYyLjYxNU0xMzcuNjkyIC01MC4yMzA4Vi0yNS4zMDc3TTE2Mi42MTUgLTc1LjE1MzlWLTUwLjIzMDhNMTYyLjYxNSAtNzUuMTUzOUgxODcuNTM4TTE2Mi42MTUgLTUwLjIzMDhIMTg3LjUzOE0xNjIuNjE1IC01MC4yMzA4Vi0yNS4zMDc3TTE4Ny41MzggLTc1LjE1MzlWLTUwLjIzMDhNMTg3LjUzOCAtNzUuMTUzOUgyMTIuNDYyTTE4Ny41MzggLTUwLjIzMDhIMjEyLjQ2Mk0xODcuNTM4IC01MC4yMzA4Vi0yNS4zMDc3TTIxMi40NjIgLTc1LjE1MzlWLTUwLjIzMDhNMjEyLjQ2MiAtNzUuMTUzOUgyMzcuMzg1TTIxMi40NjIgLTUwLjIzMDhIMjM3LjM4NU0yMTIuNDYyIC01MC4yMzA4Vi0yNS4zMDc3TTIzNy4zODUgLTc1LjE1MzlWLTUwLjIzMDhNMjM3LjM4NSAtNzUuMTUzOUgyNjIuMzA4TTIzNy4zODUgLTUwLjIzMDhIMjYyLjMwOE0yMzcuMzg1IC01MC4yMzA4Vi0yNS4zMDc3TTI2Mi4zMDggLTc1LjE1MzlWLTUwLjIzMDhNMjYyLjMwOCAtNzUuMTUzOUgyODcuMjMxTTI2Mi4zMDggLTUwLjIzMDhIMjg3LjIzMU0yNjIuMzA4IC01MC4yMzA4Vi0yNS4zMDc3TTI4Ny4yMzEgLTc1LjE1MzlWLTUwLjIzMDhNMjg3LjIzMSAtNTAuMjMwOFYtMjUuMzA3N002Mi45MjMxIC0yNS4zMDc3SDM4TTYyLjkyMzEgLTI1LjMwNzdWLTAuMzg0NjM3TTYyLjkyMzEgLTI1LjMwNzdIODcuODQ2Mk0zOCAtMjUuMzA3N1YtMC4zODQ2MzdNNjIuOTIzMSAtMC4zODQ2MzdIMzhNNjIuOTIzMSAtMC4zODQ2MzdWMjQuNTM4NE02Mi45MjMxIC0wLjM4NDYzN0g4Ny44NDYyTTM4IC0wLjM4NDYzN1YyNC41Mzg0TTYyLjkyMzEgMjQuNTM4NEgzOE02Mi45MjMxIDI0LjUzODRWNDkuNDYxNU02Mi45MjMxIDI0LjUzODRIODcuODQ2Mk0zOCAyNC41Mzg0VjQ5LjQ2MTVNNjIuOTIzMSA0OS40NjE1SDM4TTYyLjkyMzEgNDkuNDYxNVY3NC4zODQ2TTYyLjkyMzEgNDkuNDYxNUg4Ny44NDYyTTM4IDQ5LjQ2MTVWNzQuMzg0Nk02Mi45MjMxIDc0LjM4NDZIMzhNNjIuOTIzMSA3NC4zODQ2Vjk5LjMwNzdNNjIuOTIzMSA3NC4zODQ2SDg3Ljg0NjJNMzggNzQuMzg0NlY5OS4zMDc3TTYyLjkyMzEgOTkuMzA3N0gzOE02Mi45MjMxIDk5LjMwNzdWMTI0LjIzMU02Mi45MjMxIDk5LjMwNzdIODcuODQ2Mk0zOCA5OS4zMDc3VjEyNC4yMzFNNjIuOTIzMSAxMjQuMjMxSDM4TTYyLjkyMzEgMTI0LjIzMVYxNDkuMTU0TTYyLjkyMzEgMTI0LjIzMUg4Ny44NDYyTTM4IDEyNC4yMzFWMTQ5LjE1NEg2Mi45MjMxTTYyLjkyMzEgMTQ5LjE1NEg4Ny44NDYyTTg3Ljg0NjIgLTI1LjMwNzdWLTAuMzg0NjM3TTg3Ljg0NjIgLTI1LjMwNzdIMTEyLjc2OU04Ny44NDYyIC0wLjM4NDYzN1YyNC41Mzg0TTg3Ljg0NjIgLTAuMzg0NjM3SDExMi43NjlNODcuODQ2MiAyNC41Mzg0VjQ5LjQ2MTVNODcuODQ2MiAyNC41Mzg0SDExMi43NjlNODcuODQ2MiA0OS40NjE1Vjc0LjM4NDZNODcuODQ2MiA0OS40NjE1SDExMi43NjlNODcuODQ2MiA3NC4zODQ2Vjk5LjMwNzdNODcuODQ2MiA3NC4zODQ2SDExMi43NjlNODcuODQ2MiA5OS4zMDc3VjEyNC4yMzFNODcuODQ2MiA5OS4zMDc3SDExMi43NjlNODcuODQ2MiAxMjQuMjMxVjE0OS4xNTRNODcuODQ2MiAxMjQuMjMxSDExMi43NjlNODcuODQ2MiAxNDkuMTU0SDExMi43NjlNMTEyLjc2OSAtMjUuMzA3N1YtMC4zODQ2MzdNMTEyLjc2OSAtMjUuMzA3N0gxMzcuNjkyTTExMi43NjkgLTAuMzg0NjM3VjI0LjUzODRNMTEyLjc2OSAtMC4zODQ2MzdIMTM3LjY5Mk0xMTIuNzY5IDI0LjUzODRWNDkuNDYxNU0xMTIuNzY5IDI0LjUzODRIMTM3LjY5Mk0xMTIuNzY5IDQ5LjQ2MTVWNzQuMzg0Nk0xMTIuNzY5IDQ5LjQ2MTVIMTM3LjY5Mk0xMTIuNzY5IDc0LjM4NDZWOTkuMzA3N00xMTIuNzY5IDc0LjM4NDZIMTM3LjY5Mk0xMTIuNzY5IDk5LjMwNzdWMTI0LjIzMU0xMTIuNzY5IDk5LjMwNzdIMTM3LjY5Mk0xMTIuNzY5IDEyNC4yMzFWMTQ5LjE1NE0xMTIuNzY5IDEyNC4yMzFIMTM3LjY5Mk0xMTIuNzY5IDE0OS4xNTRIMTM3LjY5Mk0xMzcuNjkyIC0yNS4zMDc3Vi0wLjM4NDYzN00xMzcuNjkyIC0yNS4zMDc3SDE2Mi42MTVNMTM3LjY5MiAtMC4zODQ2MzdWMjQuNTM4NE0xMzcuNjkyIC0wLjM4NDYzN0gxNjIuNjE1TTEzNy42OTIgMjQuNTM4NFY0OS40NjE1TTEzNy42OTIgMjQuNTM4NEgxNjIuNjE1TTEzNy42OTIgNDkuNDYxNVY3NC4zODQ2TTEzNy42OTIgNDkuNDYxNUgxNjIuNjE1TTEzNy42OTIgNzQuMzg0NlY5OS4zMDc3TTEzNy42OTIgNzQuMzg0NkgxNjIuNjE1TTEzNy42OTIgOTkuMzA3N1YxMjQuMjMxTTEzNy42OTIgOTkuMzA3N0gxNjIuNjE1TTEzNy42OTIgMTI0LjIzMVYxNDkuMTU0TTEzNy42OTIgMTI0LjIzMUgxNjIuNjE1TTEzNy42OTIgMTQ5LjE1NEgxNjIuNjE1TTE2Mi42MTUgLTI1LjMwNzdWLTAuMzg0NjM3TTE2Mi42MTUgLTI1LjMwNzdIMTg3LjUzOE0xNjIuNjE1IC0wLjM4NDYzN1YyNC41Mzg0TTE2Mi42MTUgLTAuMzg0NjM3SDE4Ny41MzhNMTYyLjYxNSAyNC41Mzg0VjQ5LjQ2MTVNMTYyLjYxNSAyNC41Mzg0SDE4Ny41MzhNMTYyLjYxNSA0OS40NjE1Vjc0LjM4NDZNMTYyLjYxNSA0OS40NjE1SDE4Ny41MzhNMTYyLjYxNSA3NC4zODQ2Vjk5LjMwNzdNMTYyLjYxNSA3NC4zODQ2SDE4Ny41MzhNMTYyLjYxNSA5OS4zMDc3VjEyNC4yMzFNMTYyLjYxNSA5OS4zMDc3SDE4Ny41MzhNMTYyLjYxNSAxMjQuMjMxVjE0OS4xNTRNMTYyLjYxNSAxMjQuMjMxSDE4Ny41MzhNMTYyLjYxNSAxNDkuMTU0SDE4Ny41MzhNMTg3LjUzOCAtMjUuMzA3N1YtMC4zODQ2MzdNMTg3LjUzOCAtMjUuMzA3N0gyMTIuNDYyTTE4Ny41MzggLTAuMzg0NjM3VjI0LjUzODRNMTg3LjUzOCAtMC4zODQ2MzdIMjEyLjQ2Mk0xODcuNTM4IDI0LjUzODRWNDkuNDYxNU0xODcuNTM4IDI0LjUzODRIMjEyLjQ2Mk0xODcuNTM4IDQ5LjQ2MTVWNzQuMzg0Nk0xODcuNTM4IDQ5LjQ2MTVIMjEyLjQ2Mk0xODcuNTM4IDc0LjM4NDZWOTkuMzA3N00xODcuNTM4IDc0LjM4NDZIMjEyLjQ2Mk0xODcuNTM4IDk5LjMwNzdWMTI0LjIzMU0xODcuNTM4IDk5LjMwNzdIMjEyLjQ2Mk0xODcuNTM4IDEyNC4yMzFWMTQ5LjE1NE0xODcuNTM4IDEyNC4yMzFIMjEyLjQ2Mk0xODcuNTM4IDE0OS4xNTRIMjEyLjQ2Mk0yMTIuNDYyIC0yNS4zMDc3Vi0wLjM4NDYzN00yMTIuNDYyIC0yNS4zMDc3SDIzNy4zODVNMjEyLjQ2MiAtMC4zODQ2MzdWMjQuNTM4NE0yMTIuNDYyIC0wLjM4NDYzN0gyMzcuMzg1TTIxMi40NjIgMjQuNTM4NFY0OS40NjE1TTIxMi40NjIgMjQuNTM4NEgyMzcuMzg1TTIxMi40NjIgNDkuNDYxNVY3NC4zODQ2TTIxMi40NjIgNDkuNDYxNUgyMzcuMzg1TTIxMi40NjIgNzQuMzg0NlY5OS4zMDc3TTIxMi40NjIgNzQuMzg0NkgyMzcuMzg1TTIxMi40NjIgOTkuMzA3N1YxMjQuMjMxTTIxMi40NjIgOTkuMzA3N0gyMzcuMzg1TTIxMi40NjIgMTI0LjIzMVYxNDkuMTU0TTIxMi40NjIgMTI0LjIzMUgyMzcuMzg1TTIxMi40NjIgMTQ5LjE1NEgyMzcuMzg1TTIzNy4zODUgLTI1LjMwNzdWLTAuMzg0NjM3TTIzNy4zODUgLTI1LjMwNzdIMjYyLjMwOE0yMzcuMzg1IC0wLjM4NDYzN1YyNC41Mzg0TTIzNy4zODUgLTAuMzg0NjM3SDI2Mi4zMDhNMjM3LjM4NSAyNC41Mzg0VjQ5LjQ2MTVNMjM3LjM4NSAyNC41Mzg0SDI2Mi4zMDhNMjM3LjM4NSA0OS40NjE1Vjc0LjM4NDZNMjM3LjM4NSA0OS40NjE1SDI2Mi4zMDhNMjM3LjM4NSA3NC4zODQ2Vjk5LjMwNzdNMjM3LjM4NSA3NC4zODQ2SDI2Mi4zMDhNMjM3LjM4NSA5OS4zMDc3VjEyNC4yMzFNMjM3LjM4NSA5OS4zMDc3SDI2Mi4zMDhNMjM3LjM4NSAxMjQuMjMxVjE0OS4xNTRNMjM3LjM4NSAxMjQuMjMxSDI2Mi4zMDhNMjM3LjM4NSAxNDkuMTU0SDI2Mi4zMDhNMjYyLjMwOCAtMjUuMzA3N1YtMC4zODQ2MzdNMjYyLjMwOCAtMjUuMzA3N0gyODcuMjMxTTI2Mi4zMDggLTAuMzg0NjM3VjI0LjUzODRNMjYyLjMwOCAtMC4zODQ2MzdIMjg3LjIzMU0yNjIuMzA4IDI0LjUzODRWNDkuNDYxNU0yNjIuMzA4IDI0LjUzODRIMjg3LjIzMU0yNjIuMzA4IDQ5LjQ2MTVWNzQuMzg0Nk0yNjIuMzA4IDQ5LjQ2MTVIMjg3LjIzMU0yNjIuMzA4IDc0LjM4NDZWOTkuMzA3N00yNjIuMzA4IDc0LjM4NDZIMjg3LjIzMU0yNjIuMzA4IDk5LjMwNzdWMTI0LjIzMU0yNjIuMzA4IDk5LjMwNzdIMjg3LjIzMU0yNjIuMzA4IDEyNC4yMzFWMTQ5LjE1NE0yNjIuMzA4IDEyNC4yMzFIMjg3LjIzMU0yNjIuMzA4IDE0OS4xNTRIMjg3LjIzMU0yODcuMjMxIC0yNS4zMDc3Vi0wLjM4NDYzN00yODcuMjMxIC0wLjM4NDYzN1YyNC41Mzg0TTI4Ny4yMzEgMjQuNTM4NFY0OS40NjE1TTI4Ny4yMzEgNDkuNDYxNVY3NC4zODQ2TTI4Ny4yMzEgNzQuMzg0NlY5OS4zMDc3TTI4Ny4yMzEgOTkuMzA3N1YxMjQuMjMxTTI4Ny4yMzEgMTI0LjIzMVYxNDkuMTU0IiBzdHJva2U9InVybCgjcGFpbnQxX3JhZGlhbF85NTNfMTEzMTI4KSIgc3Ryb2tlLW9wYWNpdHk9IjAuNCIgc3Ryb2tlLXdpZHRoPSIwLjY5MjMwOCIvPgo8cmVjdCBvcGFjaXR5PSIwLjMiIHg9IjUzIiB3aWR0aD0iMjk1IiBoZWlnaHQ9IjIiIGZpbGw9InVybCgjcGFpbnQyX2xpbmVhcl85NTNfMTEzMTI4KSIvPgo8L2c+CjxkZWZzPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfOTUzXzExMzEyOCIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgyMDApIHJvdGF0ZSg5MCkgc2NhbGUoOTggMjQ5KSI+CjxzdG9wIHN0b3AtY29sb3I9IiNENERBRjIiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRDREQUYyIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDFfcmFkaWFsXzk1M18xMTMxMjgiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAwIDI0LjUpIHJvdGF0ZSg5MCkgc2NhbGUoMTI0LjY1NCAxODAuMDU2KSI+CjxzdG9wIHN0b3AtY29sb3I9IiNBN0IyREUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl85NTNfMTEzMTI4IiB4MT0iNTMiIHkxPSIwIiB4Mj0iMzQ4IiB5Mj0iNi4yNDk3M2UtMDkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwMjlDQiIgc3RvcC1vcGFjaXR5PSIwIi8+CjxzdG9wIG9mZnNldD0iMC41MTYzOTYiIHN0b3AtY29sb3I9IiMwMDI5Q0IiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDAyOUNCIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF85NTNfMTEzMTI4Ij4KPHJlY3Qgd2lkdGg9IjQwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
const PolygonBg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDQwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85NTNfMTEzMTQzKSI+CjxlbGxpcHNlIGN4PSIyMDAiIHJ4PSIyNDkiIHJ5PSI5OCIgZmlsbD0idXJsKCNwYWludDBfcmFkaWFsXzk1M18xMTMxNDMpIi8+CjxwYXRoIGQ9Ik0zMTIuMTU0IC03NS4xNTM5SDMzNy4wNzdNMzEyLjE1NCAtNzUuMTUzOVYtNTAuMjMwOE0zMTIuMTU0IC03NS4xNTM5SDI4Ny4yMzFNMzM3LjA3NyAtNzUuMTUzOVYtNTAuMjMwOE0zMzcuMDc3IC03NS4xNTM5SDM2MlYtNTAuMjMwOE0zMzcuMDc3IC01MC4yMzA4SDMxMi4xNTRNMzM3LjA3NyAtNTAuMjMwOEgzNjJNMzM3LjA3NyAtNTAuMjMwOFYtMjUuMzA3N00zMTIuMTU0IC01MC4yMzA4Vi0yNS4zMDc3TTMxMi4xNTQgLTUwLjIzMDhIMjg3LjIzMU0zNjIgLTUwLjIzMDhWLTI1LjMwNzdNMzM3LjA3NyAtMjUuMzA3N0gzMTIuMTU0TTMzNy4wNzcgLTI1LjMwNzdWLTAuMzg0NjM3TTMzNy4wNzcgLTI1LjMwNzdIMzYyTTMxMi4xNTQgLTI1LjMwNzdWLTAuMzg0NjM3TTMxMi4xNTQgLTI1LjMwNzdIMjg3LjIzMU0zMzcuMDc3IC0wLjM4NDYzN0gzMTIuMTU0TTMzNy4wNzcgLTAuMzg0NjM3VjI0LjUzODRNMzM3LjA3NyAtMC4zODQ2MzdIMzYyTTMxMi4xNTQgLTAuMzg0NjM3VjI0LjUzODRNMzEyLjE1NCAtMC4zODQ2MzdIMjg3LjIzMU0zMzcuMDc3IDI0LjUzODRIMzEyLjE1NE0zMzcuMDc3IDI0LjUzODRWNDkuNDYxNU0zMzcuMDc3IDI0LjUzODRIMzYyTTMxMi4xNTQgMjQuNTM4NFY0OS40NjE1TTMxMi4xNTQgMjQuNTM4NEgyODcuMjMxTTMzNy4wNzcgNDkuNDYxNUgzMTIuMTU0TTMzNy4wNzcgNDkuNDYxNVY3NC4zODQ2TTMzNy4wNzcgNDkuNDYxNUgzNjJNMzEyLjE1NCA0OS40NjE1Vjc0LjM4NDZNMzEyLjE1NCA0OS40NjE1SDI4Ny4yMzFNMzM3LjA3NyA3NC4zODQ2SDMxMi4xNTRNMzM3LjA3NyA3NC4zODQ2Vjk5LjMwNzdNMzM3LjA3NyA3NC4zODQ2SDM2Mk0zMTIuMTU0IDc0LjM4NDZWOTkuMzA3N00zMTIuMTU0IDc0LjM4NDZIMjg3LjIzMU0zMzcuMDc3IDk5LjMwNzdIMzEyLjE1NE0zMzcuMDc3IDk5LjMwNzdWMTI0LjIzMU0zMzcuMDc3IDk5LjMwNzdIMzYyTTMxMi4xNTQgOTkuMzA3N1YxMjQuMjMxTTMxMi4xNTQgOTkuMzA3N0gyODcuMjMxTTMzNy4wNzcgMTI0LjIzMUgzMTIuMTU0TTMzNy4wNzcgMTI0LjIzMVYxNDkuMTU0TTMzNy4wNzcgMTI0LjIzMUgzNjJNMzEyLjE1NCAxMjQuMjMxVjE0OS4xNTRNMzEyLjE1NCAxMjQuMjMxSDI4Ny4yMzFNMzM3LjA3NyAxNDkuMTU0SDMxMi4xNTRNMzM3LjA3NyAxNDkuMTU0SDM2MlYxMjQuMjMxTTMxMi4xNTQgMTQ5LjE1NEgyODcuMjMxTTM2MiAtMjUuMzA3N1YtMC4zODQ2MzdNMzYyIC0wLjM4NDYzN1YyNC41Mzg0TTM2MiAyNC41Mzg0VjQ5LjQ2MTVNMzYyIDQ5LjQ2MTVWNzQuMzg0Nk0zNjIgNzQuMzg0NlY5OS4zMDc3TTM2MiA5OS4zMDc3VjEyNC4yMzFNNjIuOTIzMSAtNzUuMTUzOUgzOFYtNTAuMjMwOE02Mi45MjMxIC03NS4xNTM5Vi01MC4yMzA4TTYyLjkyMzEgLTc1LjE1MzlIODcuODQ2Mk02Mi45MjMxIC01MC4yMzA4SDM4TTYyLjkyMzEgLTUwLjIzMDhIODcuODQ2Mk02Mi45MjMxIC01MC4yMzA4Vi0yNS4zMDc3TTM4IC01MC4yMzA4Vi0yNS4zMDc3TTg3Ljg0NjIgLTc1LjE1MzlWLTUwLjIzMDhNODcuODQ2MiAtNzUuMTUzOUgxMTIuNzY5TTg3Ljg0NjIgLTUwLjIzMDhIMTEyLjc2OU04Ny44NDYyIC01MC4yMzA4Vi0yNS4zMDc3TTExMi43NjkgLTc1LjE1MzlWLTUwLjIzMDhNMTEyLjc2OSAtNzUuMTUzOUgxMzcuNjkyTTExMi43NjkgLTUwLjIzMDhIMTM3LjY5Mk0xMTIuNzY5IC01MC4yMzA4Vi0yNS4zMDc3TTEzNy42OTIgLTc1LjE1MzlWLTUwLjIzMDhNMTM3LjY5MiAtNzUuMTUzOUgxNjIuNjE1TTEzNy42OTIgLTUwLjIzMDhIMTYyLjYxNU0xMzcuNjkyIC01MC4yMzA4Vi0yNS4zMDc3TTE2Mi42MTUgLTc1LjE1MzlWLTUwLjIzMDhNMTYyLjYxNSAtNzUuMTUzOUgxODcuNTM4TTE2Mi42MTUgLTUwLjIzMDhIMTg3LjUzOE0xNjIuNjE1IC01MC4yMzA4Vi0yNS4zMDc3TTE4Ny41MzggLTc1LjE1MzlWLTUwLjIzMDhNMTg3LjUzOCAtNzUuMTUzOUgyMTIuNDYyTTE4Ny41MzggLTUwLjIzMDhIMjEyLjQ2Mk0xODcuNTM4IC01MC4yMzA4Vi0yNS4zMDc3TTIxMi40NjIgLTc1LjE1MzlWLTUwLjIzMDhNMjEyLjQ2MiAtNzUuMTUzOUgyMzcuMzg1TTIxMi40NjIgLTUwLjIzMDhIMjM3LjM4NU0yMTIuNDYyIC01MC4yMzA4Vi0yNS4zMDc3TTIzNy4zODUgLTc1LjE1MzlWLTUwLjIzMDhNMjM3LjM4NSAtNzUuMTUzOUgyNjIuMzA4TTIzNy4zODUgLTUwLjIzMDhIMjYyLjMwOE0yMzcuMzg1IC01MC4yMzA4Vi0yNS4zMDc3TTI2Mi4zMDggLTc1LjE1MzlWLTUwLjIzMDhNMjYyLjMwOCAtNzUuMTUzOUgyODcuMjMxTTI2Mi4zMDggLTUwLjIzMDhIMjg3LjIzMU0yNjIuMzA4IC01MC4yMzA4Vi0yNS4zMDc3TTI4Ny4yMzEgLTc1LjE1MzlWLTUwLjIzMDhNMjg3LjIzMSAtNTAuMjMwOFYtMjUuMzA3N002Mi45MjMxIC0yNS4zMDc3SDM4TTYyLjkyMzEgLTI1LjMwNzdWLTAuMzg0NjM3TTYyLjkyMzEgLTI1LjMwNzdIODcuODQ2Mk0zOCAtMjUuMzA3N1YtMC4zODQ2MzdNNjIuOTIzMSAtMC4zODQ2MzdIMzhNNjIuOTIzMSAtMC4zODQ2MzdWMjQuNTM4NE02Mi45MjMxIC0wLjM4NDYzN0g4Ny44NDYyTTM4IC0wLjM4NDYzN1YyNC41Mzg0TTYyLjkyMzEgMjQuNTM4NEgzOE02Mi45MjMxIDI0LjUzODRWNDkuNDYxNU02Mi45MjMxIDI0LjUzODRIODcuODQ2Mk0zOCAyNC41Mzg0VjQ5LjQ2MTVNNjIuOTIzMSA0OS40NjE1SDM4TTYyLjkyMzEgNDkuNDYxNVY3NC4zODQ2TTYyLjkyMzEgNDkuNDYxNUg4Ny44NDYyTTM4IDQ5LjQ2MTVWNzQuMzg0Nk02Mi45MjMxIDc0LjM4NDZIMzhNNjIuOTIzMSA3NC4zODQ2Vjk5LjMwNzdNNjIuOTIzMSA3NC4zODQ2SDg3Ljg0NjJNMzggNzQuMzg0NlY5OS4zMDc3TTYyLjkyMzEgOTkuMzA3N0gzOE02Mi45MjMxIDk5LjMwNzdWMTI0LjIzMU02Mi45MjMxIDk5LjMwNzdIODcuODQ2Mk0zOCA5OS4zMDc3VjEyNC4yMzFNNjIuOTIzMSAxMjQuMjMxSDM4TTYyLjkyMzEgMTI0LjIzMVYxNDkuMTU0TTYyLjkyMzEgMTI0LjIzMUg4Ny44NDYyTTM4IDEyNC4yMzFWMTQ5LjE1NEg2Mi45MjMxTTYyLjkyMzEgMTQ5LjE1NEg4Ny44NDYyTTg3Ljg0NjIgLTI1LjMwNzdWLTAuMzg0NjM3TTg3Ljg0NjIgLTI1LjMwNzdIMTEyLjc2OU04Ny44NDYyIC0wLjM4NDYzN1YyNC41Mzg0TTg3Ljg0NjIgLTAuMzg0NjM3SDExMi43NjlNODcuODQ2MiAyNC41Mzg0VjQ5LjQ2MTVNODcuODQ2MiAyNC41Mzg0SDExMi43NjlNODcuODQ2MiA0OS40NjE1Vjc0LjM4NDZNODcuODQ2MiA0OS40NjE1SDExMi43NjlNODcuODQ2MiA3NC4zODQ2Vjk5LjMwNzdNODcuODQ2MiA3NC4zODQ2SDExMi43NjlNODcuODQ2MiA5OS4zMDc3VjEyNC4yMzFNODcuODQ2MiA5OS4zMDc3SDExMi43NjlNODcuODQ2MiAxMjQuMjMxVjE0OS4xNTRNODcuODQ2MiAxMjQuMjMxSDExMi43NjlNODcuODQ2MiAxNDkuMTU0SDExMi43NjlNMTEyLjc2OSAtMjUuMzA3N1YtMC4zODQ2MzdNMTEyLjc2OSAtMjUuMzA3N0gxMzcuNjkyTTExMi43NjkgLTAuMzg0NjM3VjI0LjUzODRNMTEyLjc2OSAtMC4zODQ2MzdIMTM3LjY5Mk0xMTIuNzY5IDI0LjUzODRWNDkuNDYxNU0xMTIuNzY5IDI0LjUzODRIMTM3LjY5Mk0xMTIuNzY5IDQ5LjQ2MTVWNzQuMzg0Nk0xMTIuNzY5IDQ5LjQ2MTVIMTM3LjY5Mk0xMTIuNzY5IDc0LjM4NDZWOTkuMzA3N00xMTIuNzY5IDc0LjM4NDZIMTM3LjY5Mk0xMTIuNzY5IDk5LjMwNzdWMTI0LjIzMU0xMTIuNzY5IDk5LjMwNzdIMTM3LjY5Mk0xMTIuNzY5IDEyNC4yMzFWMTQ5LjE1NE0xMTIuNzY5IDEyNC4yMzFIMTM3LjY5Mk0xMTIuNzY5IDE0OS4xNTRIMTM3LjY5Mk0xMzcuNjkyIC0yNS4zMDc3Vi0wLjM4NDYzN00xMzcuNjkyIC0yNS4zMDc3SDE2Mi42MTVNMTM3LjY5MiAtMC4zODQ2MzdWMjQuNTM4NE0xMzcuNjkyIC0wLjM4NDYzN0gxNjIuNjE1TTEzNy42OTIgMjQuNTM4NFY0OS40NjE1TTEzNy42OTIgMjQuNTM4NEgxNjIuNjE1TTEzNy42OTIgNDkuNDYxNVY3NC4zODQ2TTEzNy42OTIgNDkuNDYxNUgxNjIuNjE1TTEzNy42OTIgNzQuMzg0NlY5OS4zMDc3TTEzNy42OTIgNzQuMzg0NkgxNjIuNjE1TTEzNy42OTIgOTkuMzA3N1YxMjQuMjMxTTEzNy42OTIgOTkuMzA3N0gxNjIuNjE1TTEzNy42OTIgMTI0LjIzMVYxNDkuMTU0TTEzNy42OTIgMTI0LjIzMUgxNjIuNjE1TTEzNy42OTIgMTQ5LjE1NEgxNjIuNjE1TTE2Mi42MTUgLTI1LjMwNzdWLTAuMzg0NjM3TTE2Mi42MTUgLTI1LjMwNzdIMTg3LjUzOE0xNjIuNjE1IC0wLjM4NDYzN1YyNC41Mzg0TTE2Mi42MTUgLTAuMzg0NjM3SDE4Ny41MzhNMTYyLjYxNSAyNC41Mzg0VjQ5LjQ2MTVNMTYyLjYxNSAyNC41Mzg0SDE4Ny41MzhNMTYyLjYxNSA0OS40NjE1Vjc0LjM4NDZNMTYyLjYxNSA0OS40NjE1SDE4Ny41MzhNMTYyLjYxNSA3NC4zODQ2Vjk5LjMwNzdNMTYyLjYxNSA3NC4zODQ2SDE4Ny41MzhNMTYyLjYxNSA5OS4zMDc3VjEyNC4yMzFNMTYyLjYxNSA5OS4zMDc3SDE4Ny41MzhNMTYyLjYxNSAxMjQuMjMxVjE0OS4xNTRNMTYyLjYxNSAxMjQuMjMxSDE4Ny41MzhNMTYyLjYxNSAxNDkuMTU0SDE4Ny41MzhNMTg3LjUzOCAtMjUuMzA3N1YtMC4zODQ2MzdNMTg3LjUzOCAtMjUuMzA3N0gyMTIuNDYyTTE4Ny41MzggLTAuMzg0NjM3VjI0LjUzODRNMTg3LjUzOCAtMC4zODQ2MzdIMjEyLjQ2Mk0xODcuNTM4IDI0LjUzODRWNDkuNDYxNU0xODcuNTM4IDI0LjUzODRIMjEyLjQ2Mk0xODcuNTM4IDQ5LjQ2MTVWNzQuMzg0Nk0xODcuNTM4IDQ5LjQ2MTVIMjEyLjQ2Mk0xODcuNTM4IDc0LjM4NDZWOTkuMzA3N00xODcuNTM4IDc0LjM4NDZIMjEyLjQ2Mk0xODcuNTM4IDk5LjMwNzdWMTI0LjIzMU0xODcuNTM4IDk5LjMwNzdIMjEyLjQ2Mk0xODcuNTM4IDEyNC4yMzFWMTQ5LjE1NE0xODcuNTM4IDEyNC4yMzFIMjEyLjQ2Mk0xODcuNTM4IDE0OS4xNTRIMjEyLjQ2Mk0yMTIuNDYyIC0yNS4zMDc3Vi0wLjM4NDYzN00yMTIuNDYyIC0yNS4zMDc3SDIzNy4zODVNMjEyLjQ2MiAtMC4zODQ2MzdWMjQuNTM4NE0yMTIuNDYyIC0wLjM4NDYzN0gyMzcuMzg1TTIxMi40NjIgMjQuNTM4NFY0OS40NjE1TTIxMi40NjIgMjQuNTM4NEgyMzcuMzg1TTIxMi40NjIgNDkuNDYxNVY3NC4zODQ2TTIxMi40NjIgNDkuNDYxNUgyMzcuMzg1TTIxMi40NjIgNzQuMzg0NlY5OS4zMDc3TTIxMi40NjIgNzQuMzg0NkgyMzcuMzg1TTIxMi40NjIgOTkuMzA3N1YxMjQuMjMxTTIxMi40NjIgOTkuMzA3N0gyMzcuMzg1TTIxMi40NjIgMTI0LjIzMVYxNDkuMTU0TTIxMi40NjIgMTI0LjIzMUgyMzcuMzg1TTIxMi40NjIgMTQ5LjE1NEgyMzcuMzg1TTIzNy4zODUgLTI1LjMwNzdWLTAuMzg0NjM3TTIzNy4zODUgLTI1LjMwNzdIMjYyLjMwOE0yMzcuMzg1IC0wLjM4NDYzN1YyNC41Mzg0TTIzNy4zODUgLTAuMzg0NjM3SDI2Mi4zMDhNMjM3LjM4NSAyNC41Mzg0VjQ5LjQ2MTVNMjM3LjM4NSAyNC41Mzg0SDI2Mi4zMDhNMjM3LjM4NSA0OS40NjE1Vjc0LjM4NDZNMjM3LjM4NSA0OS40NjE1SDI2Mi4zMDhNMjM3LjM4NSA3NC4zODQ2Vjk5LjMwNzdNMjM3LjM4NSA3NC4zODQ2SDI2Mi4zMDhNMjM3LjM4NSA5OS4zMDc3VjEyNC4yMzFNMjM3LjM4NSA5OS4zMDc3SDI2Mi4zMDhNMjM3LjM4NSAxMjQuMjMxVjE0OS4xNTRNMjM3LjM4NSAxMjQuMjMxSDI2Mi4zMDhNMjM3LjM4NSAxNDkuMTU0SDI2Mi4zMDhNMjYyLjMwOCAtMjUuMzA3N1YtMC4zODQ2MzdNMjYyLjMwOCAtMjUuMzA3N0gyODcuMjMxTTI2Mi4zMDggLTAuMzg0NjM3VjI0LjUzODRNMjYyLjMwOCAtMC4zODQ2MzdIMjg3LjIzMU0yNjIuMzA4IDI0LjUzODRWNDkuNDYxNU0yNjIuMzA4IDI0LjUzODRIMjg3LjIzMU0yNjIuMzA4IDQ5LjQ2MTVWNzQuMzg0Nk0yNjIuMzA4IDQ5LjQ2MTVIMjg3LjIzMU0yNjIuMzA4IDc0LjM4NDZWOTkuMzA3N00yNjIuMzA4IDc0LjM4NDZIMjg3LjIzMU0yNjIuMzA4IDk5LjMwNzdWMTI0LjIzMU0yNjIuMzA4IDk5LjMwNzdIMjg3LjIzMU0yNjIuMzA4IDEyNC4yMzFWMTQ5LjE1NE0yNjIuMzA4IDEyNC4yMzFIMjg3LjIzMU0yNjIuMzA4IDE0OS4xNTRIMjg3LjIzMU0yODcuMjMxIC0yNS4zMDc3Vi0wLjM4NDYzN00yODcuMjMxIC0wLjM4NDYzN1YyNC41Mzg0TTI4Ny4yMzEgMjQuNTM4NFY0OS40NjE1TTI4Ny4yMzEgNDkuNDYxNVY3NC4zODQ2TTI4Ny4yMzEgNzQuMzg0NlY5OS4zMDc3TTI4Ny4yMzEgOTkuMzA3N1YxMjQuMjMxTTI4Ny4yMzEgMTI0LjIzMVYxNDkuMTU0IiBzdHJva2U9InVybCgjcGFpbnQxX3JhZGlhbF85NTNfMTEzMTQzKSIgc3Ryb2tlLW9wYWNpdHk9IjAuNCIgc3Ryb2tlLXdpZHRoPSIwLjY5MjMwOCIvPgo8cmVjdCBvcGFjaXR5PSIwLjMiIHg9IjUzIiB3aWR0aD0iMjk1IiBoZWlnaHQ9IjIiIGZpbGw9InVybCgjcGFpbnQyX2xpbmVhcl85NTNfMTEzMTQzKSIvPgo8L2c+CjxkZWZzPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfOTUzXzExMzE0MyIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgyMDApIHJvdGF0ZSg5MCkgc2NhbGUoOTggMjQ5KSI+CjxzdG9wIHN0b3AtY29sb3I9IiNERkQ0RjIiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjREZENEYyIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDFfcmFkaWFsXzk1M18xMTMxNDMiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAwIDI0LjUpIHJvdGF0ZSg5MCkgc2NhbGUoMTI0LjY1NCAxODAuMDU2KSI+CjxzdG9wIHN0b3AtY29sb3I9IiNDNkE3REUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl85NTNfMTEzMTQzIiB4MT0iNTMiIHkxPSIwIiB4Mj0iMzQ4IiB5Mj0iNi4yNDk3M2UtMDkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzRBMDBDQiIgc3RvcC1vcGFjaXR5PSIwIi8+CjxzdG9wIG9mZnNldD0iMC41MTYzOTYiIHN0b3AtY29sb3I9IiM0QTAwQ0IiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNEEwMENCIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF85NTNfMTEzMTQzIj4KPHJlY3Qgd2lkdGg9IjQwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
const TronBg = "data:image/svg+xml;base64,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";
const LoggedInButton = ({ loading = false, className, icon, ...props }) => {
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ...props,
      className: clsx(
        "box-border flex w-full cursor-pointer flex-col items-center rounded-2xl bg-white px-2 py-3 text-sm font-medium leading-[normal] text-font-tips shadow-loggedin-button outline-0 hover:shadow-none active:bg-secondary active:shadow-none",
        className
      ),
      disabled: props.disabled === true || loading,
      children: [
        loading ? /* @__PURE__ */ jsx("span", { className: "mr-1.5 inline-flex", children: /* @__PURE__ */ jsx(LoadingIcon, { className: "h-5 w-5 text-[#5F6570]" }) }) : icon,
        /* @__PURE__ */ jsx("div", { className: "mt-1", children: props.children })
      ]
    }
  );
};
const LoggedIn = ({ transitionRef, transitionStyle }) => {
  var _a2;
  const { walletSnap } = useWalletState();
  const walletSDK = useContext(WalletSDKContext);
  const { goTo, onClose } = useSimpleRouter();
  const [disconnectLoading, setDisconnectLoading] = useState(false);
  const onSwitchAddress = () => {
    goTo("AddressList");
  };
  const onShowAddressQRCode = () => {
    goTo("AddressQRCode");
  };
  const onShowQRCode = () => {
    goTo("ShowQRCode");
  };
  const icons = {
    [CoinType.btc]: /* @__PURE__ */ jsx(DeviceIcon, { className: "inline-flex h-[68px] w-[68px]" }),
    [CoinType.ckb]: /* @__PURE__ */ jsx(DeviceIcon, { className: "inline-flex h-[68px] w-[68px]" }),
    [CoinType.eth]: /* @__PURE__ */ jsx("img", { className: "inline-flex h-[68px] w-[68px]", src: EthIcon, alt: "ETH" }),
    [CoinType.bsc]: /* @__PURE__ */ jsx("img", { className: "inline-flex h-[68px] w-[68px]", src: BscIcon, alt: "BSC" }),
    [CoinType.matic]: /* @__PURE__ */ jsx("img", { className: "inline-flex h-[68px] w-[68px]", src: PolygonIcon, alt: "Polygon" }),
    [CoinType.trx]: /* @__PURE__ */ jsx("img", { className: "inline-flex h-[68px] w-[68px]", src: TronIcon, alt: "Tron" }),
    [CoinType.doge]: /* @__PURE__ */ jsx("img", { className: "inline-flex h-[68px] w-[68px]", src: DogecoinIcon, alt: "Dogecoin" })
  };
  const bgImage = {
    [CoinType.btc]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: BscBg, alt: "" }),
    [CoinType.ckb]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: DeviceBg, alt: "" }),
    [CoinType.eth]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: EthBg, alt: "" }),
    [CoinType.bsc]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: BscBg, alt: "" }),
    [CoinType.matic]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: PolygonBg, alt: "" }),
    [CoinType.trx]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: TronBg, alt: "" }),
    [CoinType.doge]: /* @__PURE__ */ jsx("img", { className: "absolute top-0 w-full-4px rounded-t-[32px]", src: DogeBg, alt: "" })
  };
  const close = () => {
    onClose();
  };
  const disconnect2 = async () => {
    setDisconnectLoading(true);
    await walletSDK.disconnect();
    goTo("Connect");
    setDisconnectLoading(false);
  };
  const onCopy = (text) => {
    void copyText(text).then(() => {
      createToast({
        message: "👌 Copied"
      });
    });
  };
  useEffect(() => {
    void getMastersAddress();
    void getAuthorizeInfo().then(() => {
      void backupDeviceData();
    });
    void getDotbitAlias();
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: clsx("bg-[#F6F7F9]"), children: [
    walletSnap.coinType && bgImage[walletSnap.coinType],
    /* @__PURE__ */ jsx(
      Header,
      {
        onClose: close,
        className: "z-10 mt-0.5 w-full-4px p-6 pb-0",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "relative w-full px-6 pb-6 pt-[52px]", ref: transitionRef, style: transitionStyle, children: [
      /* @__PURE__ */ jsx("div", { className: "text-center", children: walletSnap.protocol === WalletProtocol.webAuthn ? /* @__PURE__ */ jsxs(Fragment, { children: [
        walletSnap.alias ? /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: "break-all text-2xl font-extrabold leading-[normal] text-font-tips", children: walletSnap.alias }),
          /* @__PURE__ */ jsx("div", { className: "mb-6 mt-2 text-base font-extrabold leading-[normal] text-[#31465C]", children: collapseString(walletSnap.address) })
        ] }) : /* @__PURE__ */ jsx("div", { className: "mx-auto mb-6 w-[180px] break-all text-2xl font-extrabold leading-[normal] text-font-tips", children: collapseString(walletSnap.address, 26, 4) }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-3", children: [
          /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(CopyIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              onClick: () => {
                walletSnap.address && onCopy(walletSnap.address);
              },
              children: "Copy Address"
            }
          ),
          /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(QRCodeIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              onClick: onShowAddressQRCode,
              children: "QR Code"
            }
          ),
          walletSnap.ckbAddresses && ((_a2 = walletSnap.ckbAddresses) == null ? void 0 : _a2.length) > 0 ? /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(SwitchIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              onClick: onSwitchAddress,
              children: "Switch"
            }
          ) : null,
          /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(DisconnectIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              loading: disconnectLoading,
              onClick: disconnect2,
              children: "Disconnect"
            }
          )
        ] })
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        walletSnap.coinType && icons[walletSnap.coinType],
        walletSnap.alias ? /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: "mt-4 break-all text-[32px] font-extrabold leading-[normal] text-font-tips", children: walletSnap.alias }),
          /* @__PURE__ */ jsx("div", { className: "mb-8 mt-2 text-base font-bold leading-[normal] text-[#31465C]", children: collapseString(walletSnap.address) })
        ] }) : /* @__PURE__ */ jsx("div", { className: "mb-8 mt-4 text-[32px] font-extrabold leading-[normal] text-font-tips", children: collapseString(walletSnap.address) }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-3", children: [
          /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(CopyIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              onClick: () => {
                walletSnap.address && onCopy(walletSnap.address);
              },
              children: "Copy Address"
            }
          ),
          /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(QRCodeIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              onClick: onShowAddressQRCode,
              children: "QR Code"
            }
          ),
          /* @__PURE__ */ jsx(
            LoggedInButton,
            {
              className: "flex-loggedin-button",
              icon: /* @__PURE__ */ jsx(DisconnectIcon, { className: "h-5 w-5 text-[#5F6570]" }),
              loading: disconnectLoading,
              onClick: disconnect2,
              children: "Disconnect"
            }
          )
        ] })
      ] }) }),
      walletSnap.protocol === WalletProtocol.webAuthn && walletSnap.canAddDevice ? walletSnap.deviceList && walletSnap.deviceList.length > 0 ? /* @__PURE__ */ jsx(DeviceList, { className: "mt-8", onShowQRCode, onDisconnect: disconnect2 }) : /* @__PURE__ */ jsx(BackupTips, { className: "mt-8", onShowQRCode }) : null
    ] })
  ] });
};
function AddressItem(props) {
  const click = () => {
    var _a2;
    (_a2 = props.onClick) == null ? void 0 : _a2.call(props);
  };
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: clsx(
        "box-border flex cursor-pointer items-center justify-between rounded-2xl border border-[#bec0c229] px-4 py-[15px] hover:bg-secondary active:bg-secondary-active",
        props.className
      ),
      onClick: click,
      children: [
        /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-col", children: [
          /* @__PURE__ */ jsx("span", { className: "text-base font-bold leading-5", children: props.address }),
          /* @__PURE__ */ jsx("span", { className: "inline-flex", children: props.isCurrent ? /* @__PURE__ */ jsx(Tag, { className: "text-sm", children: "Current" }) : null })
        ] }),
        /* @__PURE__ */ jsx(ArrowLeftIcon, { className: "h-2.5 w-2.5 rotate-180 text-font-secondary" })
      ]
    }
  );
}
const AddressList = ({ transitionRef, transitionStyle }) => {
  var _a2, _b, _c, _d;
  const router = useSimpleRouter();
  const walletSDK = useContext(WalletSDKContext);
  const { goBack, onClose, prevRouteName } = router;
  const { walletSnap } = useWalletState();
  const back = () => {
    if (prevRouteName === "Connect") {
      onClose();
    } else {
      goBack == null ? void 0 : goBack();
    }
  };
  const onSwitchAddress = async (address) => {
    if (address.toLowerCase() !== String(walletSnap.address).toLowerCase()) {
      setWalletState({ address, isSwitchAddress: true, masterNotes: "", masterDevice: "" }, true);
      await getAuthorizeInfo();
      walletSDK.context.emitEvent(EventEnum.Change);
    }
    back();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: "Switch Address",
        goBack: back,
        onClose,
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "w-full px-6 pb-6 pt-[76px]", ref: transitionRef, style: transitionStyle, children: [
      /* @__PURE__ */ jsx("label", { className: "mb-2 block text-[13px] text-[#5F6570]", children: "Generated by this device" }),
      /* @__PURE__ */ jsx("ul", { className: "mb-3", children: /* @__PURE__ */ jsx(
        AddressItem,
        {
          address: collapseString((_a2 = walletSnap.deviceData) == null ? void 0 : _a2.ckbAddr, 8, 4),
          isCurrent: ((_b = walletSnap.deviceData) == null ? void 0 : _b.ckbAddr) === walletSnap.address,
          onClick: async () => {
            var _a3;
            await onSwitchAddress((_a3 = walletSnap.deviceData) == null ? void 0 : _a3.ckbAddr);
          }
        }
      ) }),
      walletSnap.ckbAddresses && ((_c = walletSnap.ckbAddresses) == null ? void 0 : _c.length) > 0 ? /* @__PURE__ */ jsx("label", { className: "mb-2 block text-[13px] text-[#5F6570]", children: "Associated with this device" }) : null,
      /* @__PURE__ */ jsx("ul", { className: "mb-6", children: (_d = walletSnap.ckbAddresses) == null ? void 0 : _d.map((address) => {
        return /* @__PURE__ */ jsx(
          AddressItem,
          {
            className: "mb-2",
            address: collapseString(address, 8, 4),
            isCurrent: address === walletSnap.address,
            onClick: async () => {
              await onSwitchAddress(address);
            }
          },
          address
        );
      }) })
    ] })
  ] });
};
function ShowQRCode({ transitionRef, transitionStyle }) {
  const { goNext, onClose, goBack } = useSimpleRouter();
  const { walletSnap } = useWalletState();
  const connectDID = useMemo(() => new ConnectDID(walletSnap.isTestNet), [walletSnap.isTestNet]);
  const url = useMemo(
    () => connectDID.requestBackupData({ ckbAddr: walletSnap.address, isOpen: false }),
    [walletSnap.address, connectDID]
  );
  const handleCopy = useCallback(() => {
    copyText(url).then(() => {
      createToast({
        message: "👌 Copied"
      });
    }).catch(console.error);
  }, [url]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: "Add Trusted Device",
        onClose,
        goBack,
        className: "bg-blur z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsx("div", { className: "text-center text-[14px] leading-tight text-neutral-700", children: "Use the QR code or link below on your other trusted devices and follow the instructions inside." }),
          /* @__PURE__ */ jsx("div", { className: "relative my-3 h-[260px] w-[260px] rounded-2xl border border-stone-300/20 p-2", children: /* @__PURE__ */ jsx(QRCode, { data: url }) }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              id: "copy-url",
              className: "inline-flex w-[260px] items-center gap-1 rounded-md border border-slate-300/40 bg-gray-50 p-1 pl-3",
              children: [
                /* @__PURE__ */ jsx("span", { className: "scrollbar-hide flex-1 overflow-x-scroll whitespace-nowrap text-sm font-normal leading-tight text-gray-500", children: url }),
                /* @__PURE__ */ jsx(Button, { className: "flex-none", onClick: handleCopy, size: ButtonSize.small, children: "Copy" })
              ]
            }
          ),
          /* @__PURE__ */ jsx(Button, { className: "mt-6 w-full", size: ButtonSize.middle, shape: ButtonShape.round, onClick: goNext, children: "Next" })
        ]
      }
    )
  ] });
}
class Exception extends CustomError$1 {
  /**
   * Allows Exception to be constructed directly
   * with some message and prototype definition.
   */
  constructor(message = void 0) {
    super(message);
    __publicField(this, "message");
    this.message = message;
  }
  getKind() {
    const ex = this.constructor;
    return ex.kind;
  }
}
/**
 * It's typed as string so it can be extended and overriden.
 */
__publicField(Exception, "kind", "Exception");
class ArgumentException extends Exception {
}
__publicField(ArgumentException, "kind", "ArgumentException");
class IllegalArgumentException extends Exception {
}
__publicField(IllegalArgumentException, "kind", "IllegalArgumentException");
class BinaryBitmap {
  constructor(binarizer) {
    __publicField(this, "binarizer");
    __publicField(this, "matrix");
    this.binarizer = binarizer;
    if (binarizer === null) {
      throw new IllegalArgumentException("Binarizer must be non-null.");
    }
  }
  /**
   * @return The width of the bitmap.
   */
  getWidth() {
    return this.binarizer.getWidth();
  }
  /**
   * @return The height of the bitmap.
   */
  getHeight() {
    return this.binarizer.getHeight();
  }
  /**
   * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
   * cached data. Callers should assume this method is expensive and call it as seldom as possible.
   * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
   *
   * @param y The row to fetch, which must be in [0, bitmap height)
   * @param row An optional preallocated array. If null or too small, it will be ignored.
   *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
   * @return The array of bits for this row (true means black).
   * @throws NotFoundException if row can't be binarized
   */
  getBlackRow(y, row) {
    return this.binarizer.getBlackRow(y, row);
  }
  /**
   * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
   * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
   * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
   * fetched using getBlackRow(), so don't mix and match between them.
   *
   * @return The 2D array of bits for the image (true means black).
   * @throws NotFoundException if image can't be binarized to make a matrix
   */
  getBlackMatrix() {
    if (this.matrix === null || this.matrix === void 0) {
      this.matrix = this.binarizer.getBlackMatrix();
    }
    return this.matrix;
  }
  /**
   * @return Whether this bitmap can be cropped.
   */
  isCropSupported() {
    return this.binarizer.getLuminanceSource().isCropSupported();
  }
  /**
   * Returns a new object with cropped image data. Implementations may keep a reference to the
   * original data rather than a copy. Only callable if isCropSupported() is true.
   *
   * @param left The left coordinate, which must be in [0,getWidth())
   * @param top The top coordinate, which must be in [0,getHeight())
   * @param width The width of the rectangle to crop.
   * @param height The height of the rectangle to crop.
   * @return A cropped version of this object.
   */
  crop(left, top, width, height) {
    const newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
    return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
  }
  /**
   * @return Whether this bitmap supports counter-clockwise rotation.
   */
  isRotateSupported() {
    return this.binarizer.getLuminanceSource().isRotateSupported();
  }
  /**
   * Returns a new object with rotated image data by 90 degrees counterclockwise.
   * Only callable if {@link #isRotateSupported()} is true.
   *
   * @return A rotated version of this object.
   */
  rotateCounterClockwise() {
    const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
    return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
  }
  /**
   * Returns a new object with rotated image data by 45 degrees counterclockwise.
   * Only callable if {@link #isRotateSupported()} is true.
   *
   * @return A rotated version of this object.
   */
  rotateCounterClockwise45() {
    const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
    return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
  }
  /*@Override*/
  toString() {
    try {
      return this.getBlackMatrix().toString();
    } catch (e) {
      return "";
    }
  }
}
const _ChecksumException = class _ChecksumException extends Exception {
  static getChecksumInstance() {
    return new _ChecksumException();
  }
};
__publicField(_ChecksumException, "kind", "ChecksumException");
let ChecksumException = _ChecksumException;
class Binarizer {
  constructor(source) {
    __publicField(this, "source");
    this.source = source;
  }
  getLuminanceSource() {
    return this.source;
  }
  getWidth() {
    return this.source.getWidth();
  }
  getHeight() {
    return this.source.getHeight();
  }
}
class System {
  // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
  /**
   * Makes a copy of a array.
   */
  static arraycopy(src, srcPos, dest, destPos, length) {
    while (length--) {
      dest[destPos++] = src[srcPos++];
    }
  }
  /**
   * Returns the current time in milliseconds.
   */
  static currentTimeMillis() {
    return Date.now();
  }
}
class IndexOutOfBoundsException extends Exception {
}
__publicField(IndexOutOfBoundsException, "kind", "IndexOutOfBoundsException");
class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
  constructor(index = void 0, message = void 0) {
    super(message);
    __publicField(this, "index");
    __publicField(this, "message");
    this.index = index;
    this.message = message;
  }
}
__publicField(ArrayIndexOutOfBoundsException, "kind", "ArrayIndexOutOfBoundsException");
class Arrays {
  /**
   * Assigns the specified int value to each element of the specified array
   * of ints.
   *
   * @param a the array to be filled
   * @param val the value to be stored in all elements of the array
   */
  static fill(a, val) {
    for (let i = 0, len = a.length; i < len; i++)
      a[i] = val;
  }
  /**
   * Assigns the specified int value to each element of the specified
   * range of the specified array of ints.  The range to be filled
   * extends from index {@code fromIndex}, inclusive, to index
   * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
   * range to be filled is empty.)
   *
   * @param a the array to be filled
   * @param fromIndex the index of the first element (inclusive) to be
   *        filled with the specified value
   * @param toIndex the index of the last element (exclusive) to be
   *        filled with the specified value
   * @param val the value to be stored in all elements of the array
   * @throws IllegalArgumentException if {@code fromIndex > toIndex}
   * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
   *         {@code toIndex > a.length}
   */
  static fillWithin(a, fromIndex, toIndex, val) {
    Arrays.rangeCheck(a.length, fromIndex, toIndex);
    for (let i = fromIndex; i < toIndex; i++)
      a[i] = val;
  }
  /**
   * Checks that {@code fromIndex} and {@code toIndex} are in
   * the range and throws an exception if they aren't.
   */
  static rangeCheck(arrayLength, fromIndex, toIndex) {
    if (fromIndex > toIndex) {
      throw new IllegalArgumentException("fromIndex(" + fromIndex + ") > toIndex(" + toIndex + ")");
    }
    if (fromIndex < 0) {
      throw new ArrayIndexOutOfBoundsException(fromIndex);
    }
    if (toIndex > arrayLength) {
      throw new ArrayIndexOutOfBoundsException(toIndex);
    }
  }
  static asList(...args) {
    return args;
  }
  static create(rows, cols, value) {
    let arr = Array.from({ length: rows });
    return arr.map((x) => Array.from({ length: cols }).fill(value));
  }
  static createInt32Array(rows, cols, value) {
    let arr = Array.from({ length: rows });
    return arr.map((x) => Int32Array.from({ length: cols }).fill(value));
  }
  static equals(first, second) {
    if (!first) {
      return false;
    }
    if (!second) {
      return false;
    }
    if (!first.length) {
      return false;
    }
    if (!second.length) {
      return false;
    }
    if (first.length !== second.length) {
      return false;
    }
    for (let i = 0, length = first.length; i < length; i++) {
      if (first[i] !== second[i]) {
        return false;
      }
    }
    return true;
  }
  static hashCode(a) {
    if (a === null) {
      return 0;
    }
    let result = 1;
    for (const element of a) {
      result = 31 * result + element;
    }
    return result;
  }
  static fillUint8Array(a, value) {
    for (let i = 0; i !== a.length; i++) {
      a[i] = value;
    }
  }
  static copyOf(original, newLength) {
    return original.slice(0, newLength);
  }
  static copyOfUint8Array(original, newLength) {
    if (original.length <= newLength) {
      const newArray = new Uint8Array(newLength);
      newArray.set(original);
      return newArray;
    }
    return original.slice(0, newLength);
  }
  static copyOfRange(original, from, to) {
    const newLength = to - from;
    const copy = new Int32Array(newLength);
    System.arraycopy(original, from, copy, 0, newLength);
    return copy;
  }
  /*
   * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
   * for the new element.
   * Parameters:
   *     ar - A sorted array
   *     el - An element to search for
   *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
   *        a negative number  if a is less than b;
   *        0 if a is equal to b;
   *        a positive number of a is greater than b.
   * The array may contain duplicate elements. If there are more than one equal elements in the array,
   * the returned value can be the index of any one of the equal elements.
   *
   * http://jsfiddle.net/aryzhov/pkfst550/
   */
  static binarySearch(ar, el, comparator) {
    if (void 0 === comparator) {
      comparator = Arrays.numberComparator;
    }
    let m2 = 0;
    let n = ar.length - 1;
    while (m2 <= n) {
      const k = n + m2 >> 1;
      const cmp = comparator(el, ar[k]);
      if (cmp > 0) {
        m2 = k + 1;
      } else if (cmp < 0) {
        n = k - 1;
      } else {
        return k;
      }
    }
    return -m2 - 1;
  }
  static numberComparator(a, b) {
    return a - b;
  }
}
class Integer {
  static numberOfTrailingZeros(i) {
    let y;
    if (i === 0)
      return 32;
    let n = 31;
    y = i << 16;
    if (y !== 0) {
      n -= 16;
      i = y;
    }
    y = i << 8;
    if (y !== 0) {
      n -= 8;
      i = y;
    }
    y = i << 4;
    if (y !== 0) {
      n -= 4;
      i = y;
    }
    y = i << 2;
    if (y !== 0) {
      n -= 2;
      i = y;
    }
    return n - (i << 1 >>> 31);
  }
  static numberOfLeadingZeros(i) {
    if (i === 0) {
      return 32;
    }
    let n = 1;
    if (i >>> 16 === 0) {
      n += 16;
      i <<= 16;
    }
    if (i >>> 24 === 0) {
      n += 8;
      i <<= 8;
    }
    if (i >>> 28 === 0) {
      n += 4;
      i <<= 4;
    }
    if (i >>> 30 === 0) {
      n += 2;
      i <<= 2;
    }
    n -= i >>> 31;
    return n;
  }
  static toHexString(i) {
    return i.toString(16);
  }
  static toBinaryString(intNumber) {
    return String(parseInt(String(intNumber), 2));
  }
  // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
  // Returns:
  // the number of one-bits in the two's complement binary representation of the specified int value.
  static bitCount(i) {
    i = i - (i >>> 1 & 1431655765);
    i = (i & 858993459) + (i >>> 2 & 858993459);
    i = i + (i >>> 4) & 252645135;
    i = i + (i >>> 8);
    i = i + (i >>> 16);
    return i & 63;
  }
  static truncDivision(dividend, divisor) {
    return Math.trunc(dividend / divisor);
  }
  /**
   * Converts A string to an integer.
   * @param s A string to convert into a number.
   * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
   */
  static parseInt(num, radix = void 0) {
    return parseInt(num, radix);
  }
}
__publicField(Integer, "MIN_VALUE_32_BITS", -2147483648);
__publicField(Integer, "MAX_VALUE", Number.MAX_SAFE_INTEGER);
class BitArray {
  // public constructor() {
  //   this.size = 0
  //   this.bits = new Int32Array(1)
  // }
  // public constructor(size?: number /*int*/) {
  //   if (undefined === size) {
  //     this.size = 0
  //   } else {
  //     this.size = size
  //   }
  //   this.bits = this.makeArray(size)
  // }
  // For testing only
  constructor(size, bits) {
    __publicField(this, "size");
    __publicField(this, "bits");
    if (void 0 === size) {
      this.size = 0;
      this.bits = new Int32Array(1);
    } else {
      this.size = size;
      if (void 0 === bits || null === bits) {
        this.bits = BitArray.makeArray(size);
      } else {
        this.bits = bits;
      }
    }
  }
  getSize() {
    return this.size;
  }
  getSizeInBytes() {
    return Math.floor((this.size + 7) / 8);
  }
  ensureCapacity(size) {
    if (size > this.bits.length * 32) {
      const newBits = BitArray.makeArray(size);
      System.arraycopy(this.bits, 0, newBits, 0, this.bits.length);
      this.bits = newBits;
    }
  }
  /**
   * @param i bit to get
   * @return true iff bit i is set
   */
  get(i) {
    return (this.bits[Math.floor(i / 32)] & 1 << (i & 31)) !== 0;
  }
  /**
   * Sets bit i.
   *
   * @param i bit to set
   */
  set(i) {
    this.bits[Math.floor(i / 32)] |= 1 << (i & 31);
  }
  /**
   * Flips bit i.
   *
   * @param i bit to set
   */
  flip(i) {
    this.bits[Math.floor(i / 32)] ^= 1 << (i & 31);
  }
  /**
   * @param from first bit to check
   * @return index of first bit that is set, starting from the given index, or size if none are set
   *  at or beyond this given index
   * @see #getNextUnset(int)
   */
  getNextSet(from) {
    const size = this.size;
    if (from >= size) {
      return size;
    }
    const bits = this.bits;
    let bitsOffset = Math.floor(from / 32);
    let currentBits = bits[bitsOffset];
    currentBits &= ~((1 << (from & 31)) - 1);
    const length = bits.length;
    while (currentBits === 0) {
      if (++bitsOffset === length) {
        return size;
      }
      currentBits = bits[bitsOffset];
    }
    const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
    return result > size ? size : result;
  }
  /**
   * @param from index to start looking for unset bit
   * @return index of next unset bit, or {@code size} if none are unset until the end
   * @see #getNextSet(int)
   */
  getNextUnset(from) {
    const size = this.size;
    if (from >= size) {
      return size;
    }
    const bits = this.bits;
    let bitsOffset = Math.floor(from / 32);
    let currentBits = ~bits[bitsOffset];
    currentBits &= ~((1 << (from & 31)) - 1);
    const length = bits.length;
    while (currentBits === 0) {
      if (++bitsOffset === length) {
        return size;
      }
      currentBits = ~bits[bitsOffset];
    }
    const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
    return result > size ? size : result;
  }
  /**
   * Sets a block of 32 bits, starting at bit i.
   *
   * @param i first bit to set
   * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
   * corresponds to bit i, the next-least-significant to i+1, and so on.
   */
  setBulk(i, newBits) {
    this.bits[Math.floor(i / 32)] = newBits;
  }
  /**
   * Sets a range of bits.
   *
   * @param start start of range, inclusive.
   * @param end end of range, exclusive
   */
  setRange(start, end) {
    if (end < start || start < 0 || end > this.size) {
      throw new IllegalArgumentException();
    }
    if (end === start) {
      return;
    }
    end--;
    const firstInt = Math.floor(start / 32);
    const lastInt = Math.floor(end / 32);
    const bits = this.bits;
    for (let i = firstInt; i <= lastInt; i++) {
      const firstBit = i > firstInt ? 0 : start & 31;
      const lastBit = i < lastInt ? 31 : end & 31;
      const mask = (2 << lastBit) - (1 << firstBit);
      bits[i] |= mask;
    }
  }
  /**
   * Clears all bits (sets to false).
   */
  clear() {
    const max = this.bits.length;
    const bits = this.bits;
    for (let i = 0; i < max; i++) {
      bits[i] = 0;
    }
  }
  /**
   * Efficient method to check if a range of bits is set, or not set.
   *
   * @param start start of range, inclusive.
   * @param end end of range, exclusive
   * @param value if true, checks that bits in range are set, otherwise checks that they are not set
   * @return true iff all bits are set or not set in range, according to value argument
   * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
   */
  isRange(start, end, value) {
    if (end < start || start < 0 || end > this.size) {
      throw new IllegalArgumentException();
    }
    if (end === start) {
      return true;
    }
    end--;
    const firstInt = Math.floor(start / 32);
    const lastInt = Math.floor(end / 32);
    const bits = this.bits;
    for (let i = firstInt; i <= lastInt; i++) {
      const firstBit = i > firstInt ? 0 : start & 31;
      const lastBit = i < lastInt ? 31 : end & 31;
      const mask = (2 << lastBit) - (1 << firstBit) & 4294967295;
      if ((bits[i] & mask) !== (value ? mask : 0)) {
        return false;
      }
    }
    return true;
  }
  appendBit(bit) {
    this.ensureCapacity(this.size + 1);
    if (bit) {
      this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 31);
    }
    this.size++;
  }
  /**
   * Appends the least-significant bits, from value, in order from most-significant to
   * least-significant. For example, appending 6 bits from 0x000001E will append the bits
   * 0, 1, 1, 1, 1, 0 in that order.
   *
   * @param value {@code int} containing bits to append
   * @param numBits bits from value to append
   */
  appendBits(value, numBits) {
    if (numBits < 0 || numBits > 32) {
      throw new IllegalArgumentException("Num bits must be between 0 and 32");
    }
    this.ensureCapacity(this.size + numBits);
    for (let numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--) {
      this.appendBit((value >> numBitsLeft - 1 & 1) === 1);
    }
  }
  appendBitArray(other) {
    const otherSize = other.size;
    this.ensureCapacity(this.size + otherSize);
    for (let i = 0; i < otherSize; i++) {
      this.appendBit(other.get(i));
    }
  }
  xor(other) {
    if (this.size !== other.size) {
      throw new IllegalArgumentException("Sizes don't match");
    }
    const bits = this.bits;
    for (let i = 0, length = bits.length; i < length; i++) {
      bits[i] ^= other.bits[i];
    }
  }
  /**
   *
   * @param bitOffset first bit to start writing
   * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
   *  of the internal representation, which is exposed by {@link #getBitArray()}
   * @param offset position in array to start writing
   * @param numBytes how many bytes to write
   */
  toBytes(bitOffset, array, offset, numBytes) {
    for (let i = 0; i < numBytes; i++) {
      let theByte = 0;
      for (let j = 0; j < 8; j++) {
        if (this.get(bitOffset)) {
          theByte |= 1 << 7 - j;
        }
        bitOffset++;
      }
      array[offset + i] = /*(byte)*/
      theByte;
    }
  }
  /**
   * @return underlying array of ints. The first element holds the first 32 bits, and the least
   *         significant bit is bit 0.
   */
  getBitArray() {
    return this.bits;
  }
  /**
   * Reverses all bits in the array.
   */
  reverse() {
    const newBits = new Int32Array(this.bits.length);
    const len = Math.floor((this.size - 1) / 32);
    const oldBitsLen = len + 1;
    const bits = this.bits;
    for (let i = 0; i < oldBitsLen; i++) {
      let x = bits[i];
      x = x >> 1 & 1431655765 | (x & 1431655765) << 1;
      x = x >> 2 & 858993459 | (x & 858993459) << 2;
      x = x >> 4 & 252645135 | (x & 252645135) << 4;
      x = x >> 8 & 16711935 | (x & 16711935) << 8;
      x = x >> 16 & 65535 | (x & 65535) << 16;
      newBits[len - i] = /*(int)*/
      x;
    }
    if (this.size !== oldBitsLen * 32) {
      const leftOffset = oldBitsLen * 32 - this.size;
      let currentInt = newBits[0] >>> leftOffset;
      for (let i = 1; i < oldBitsLen; i++) {
        const nextInt = newBits[i];
        currentInt |= nextInt << 32 - leftOffset;
        newBits[i - 1] = currentInt;
        currentInt = nextInt >>> leftOffset;
      }
      newBits[oldBitsLen - 1] = currentInt;
    }
    this.bits = newBits;
  }
  static makeArray(size) {
    return new Int32Array(Math.floor((size + 31) / 32));
  }
  /*@Override*/
  equals(o) {
    if (!(o instanceof BitArray)) {
      return false;
    }
    const other = o;
    return this.size === other.size && Arrays.equals(this.bits, other.bits);
  }
  /*@Override*/
  hashCode() {
    return 31 * this.size + Arrays.hashCode(this.bits);
  }
  /*@Override*/
  toString() {
    let result = "";
    for (let i = 0, size = this.size; i < size; i++) {
      if ((i & 7) === 0) {
        result += " ";
      }
      result += this.get(i) ? "X" : ".";
    }
    return result;
  }
  /*@Override*/
  clone() {
    return new BitArray(this.size, this.bits.slice());
  }
  /**
   * converts to boolean array.
   */
  toArray() {
    let result = [];
    for (let i = 0, size = this.size; i < size; i++) {
      result.push(this.get(i));
    }
    return result;
  }
}
var DecodeHintType;
(function(DecodeHintType2) {
  DecodeHintType2[DecodeHintType2["OTHER"] = 0] = "OTHER";
  DecodeHintType2[DecodeHintType2["PURE_BARCODE"] = 1] = "PURE_BARCODE";
  DecodeHintType2[DecodeHintType2["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS";
  DecodeHintType2[DecodeHintType2["TRY_HARDER"] = 3] = "TRY_HARDER";
  DecodeHintType2[DecodeHintType2["CHARACTER_SET"] = 4] = "CHARACTER_SET";
  DecodeHintType2[DecodeHintType2["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS";
  DecodeHintType2[DecodeHintType2["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT";
  DecodeHintType2[DecodeHintType2["ASSUME_GS1"] = 7] = "ASSUME_GS1";
  DecodeHintType2[DecodeHintType2["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END";
  DecodeHintType2[DecodeHintType2["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK";
  DecodeHintType2[DecodeHintType2["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS";
})(DecodeHintType || (DecodeHintType = {}));
const DecodeHintType$1 = DecodeHintType;
const _FormatException = class _FormatException extends Exception {
  static getFormatInstance() {
    return new _FormatException();
  }
};
__publicField(_FormatException, "kind", "FormatException");
let FormatException = _FormatException;
var CharacterSetValueIdentifiers;
(function(CharacterSetValueIdentifiers2) {
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp437"] = 0] = "Cp437";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_1"] = 1] = "ISO8859_1";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_2"] = 2] = "ISO8859_2";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_3"] = 3] = "ISO8859_3";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_4"] = 4] = "ISO8859_4";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_5"] = 5] = "ISO8859_5";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_6"] = 6] = "ISO8859_6";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_7"] = 7] = "ISO8859_7";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_8"] = 8] = "ISO8859_8";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_9"] = 9] = "ISO8859_9";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_10"] = 10] = "ISO8859_10";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_11"] = 11] = "ISO8859_11";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_13"] = 12] = "ISO8859_13";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_14"] = 13] = "ISO8859_14";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_15"] = 14] = "ISO8859_15";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_16"] = 15] = "ISO8859_16";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["SJIS"] = 16] = "SJIS";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1250"] = 17] = "Cp1250";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1251"] = 18] = "Cp1251";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1252"] = 19] = "Cp1252";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1256"] = 20] = "Cp1256";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["UTF8"] = 22] = "UTF8";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ASCII"] = 23] = "ASCII";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Big5"] = 24] = "Big5";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["GB18030"] = 25] = "GB18030";
  CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["EUC_KR"] = 26] = "EUC_KR";
})(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
const _CharacterSetECI = class _CharacterSetECI {
  constructor(valueIdentifier, valuesParam, name, ...otherEncodingNames) {
    __publicField(this, "valueIdentifier");
    __publicField(this, "name");
    __publicField(this, "values");
    __publicField(this, "otherEncodingNames");
    this.valueIdentifier = valueIdentifier;
    this.name = name;
    if (typeof valuesParam === "number") {
      this.values = Int32Array.from([valuesParam]);
    } else {
      this.values = valuesParam;
    }
    this.otherEncodingNames = otherEncodingNames;
    _CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
    _CharacterSetECI.NAME_TO_ECI.set(name, this);
    const values = this.values;
    for (let i = 0, length = values.length; i !== length; i++) {
      const v = values[i];
      _CharacterSetECI.VALUES_TO_ECI.set(v, this);
    }
    for (const otherName of otherEncodingNames) {
      _CharacterSetECI.NAME_TO_ECI.set(otherName, this);
    }
  }
  // CharacterSetECI(value: number /*int*/) {
  //   this(new Int32Array {value})
  // }
  // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
  //   this.values = new Int32Array {value}
  //   this.otherEncodingNames = otherEncodingNames
  // }
  // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
  //   this.values = values
  //   this.otherEncodingNames = otherEncodingNames
  // }
  getValueIdentifier() {
    return this.valueIdentifier;
  }
  getName() {
    return this.name;
  }
  getValue() {
    return this.values[0];
  }
  /**
   * @param value character set ECI value
   * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
   *   unsupported
   * @throws FormatException if ECI value is invalid
   */
  static getCharacterSetECIByValue(value) {
    if (value < 0 || value >= 900) {
      throw new FormatException("incorect value");
    }
    const characterSet = _CharacterSetECI.VALUES_TO_ECI.get(value);
    if (void 0 === characterSet) {
      throw new FormatException("incorect value");
    }
    return characterSet;
  }
  /**
   * @param name character set ECI encoding name
   * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
   *   but unsupported
   */
  static getCharacterSetECIByName(name) {
    const characterSet = _CharacterSetECI.NAME_TO_ECI.get(name);
    if (void 0 === characterSet) {
      throw new FormatException("incorect value");
    }
    return characterSet;
  }
  equals(o) {
    if (!(o instanceof _CharacterSetECI)) {
      return false;
    }
    const other = o;
    return this.getName() === other.getName();
  }
};
__publicField(_CharacterSetECI, "VALUE_IDENTIFIER_TO_ECI", /* @__PURE__ */ new Map());
__publicField(_CharacterSetECI, "VALUES_TO_ECI", /* @__PURE__ */ new Map());
__publicField(_CharacterSetECI, "NAME_TO_ECI", /* @__PURE__ */ new Map());
// Enum name is a Java encoding valid for java.lang and java.io
// TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
// (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
// later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
__publicField(_CharacterSetECI, "Cp437", new _CharacterSetECI(CharacterSetValueIdentifiers.Cp437, Int32Array.from([0, 2]), "Cp437"));
__publicField(_CharacterSetECI, "ISO8859_1", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_1,
  Int32Array.from([1, 3]),
  "ISO-8859-1",
  "ISO88591",
  "ISO8859_1"
));
__publicField(_CharacterSetECI, "ISO8859_2", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_2,
  4,
  "ISO-8859-2",
  "ISO88592",
  "ISO8859_2"
));
__publicField(_CharacterSetECI, "ISO8859_3", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_3,
  5,
  "ISO-8859-3",
  "ISO88593",
  "ISO8859_3"
));
__publicField(_CharacterSetECI, "ISO8859_4", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_4,
  6,
  "ISO-8859-4",
  "ISO88594",
  "ISO8859_4"
));
__publicField(_CharacterSetECI, "ISO8859_5", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_5,
  7,
  "ISO-8859-5",
  "ISO88595",
  "ISO8859_5"
));
__publicField(_CharacterSetECI, "ISO8859_6", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_6,
  8,
  "ISO-8859-6",
  "ISO88596",
  "ISO8859_6"
));
__publicField(_CharacterSetECI, "ISO8859_7", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_7,
  9,
  "ISO-8859-7",
  "ISO88597",
  "ISO8859_7"
));
__publicField(_CharacterSetECI, "ISO8859_8", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_8,
  10,
  "ISO-8859-8",
  "ISO88598",
  "ISO8859_8"
));
__publicField(_CharacterSetECI, "ISO8859_9", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_9,
  11,
  "ISO-8859-9",
  "ISO88599",
  "ISO8859_9"
));
__publicField(_CharacterSetECI, "ISO8859_10", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_10,
  12,
  "ISO-8859-10",
  "ISO885910",
  "ISO8859_10"
));
__publicField(_CharacterSetECI, "ISO8859_11", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_11,
  13,
  "ISO-8859-11",
  "ISO885911",
  "ISO8859_11"
));
__publicField(_CharacterSetECI, "ISO8859_13", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_13,
  15,
  "ISO-8859-13",
  "ISO885913",
  "ISO8859_13"
));
__publicField(_CharacterSetECI, "ISO8859_14", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_14,
  16,
  "ISO-8859-14",
  "ISO885914",
  "ISO8859_14"
));
__publicField(_CharacterSetECI, "ISO8859_15", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_15,
  17,
  "ISO-8859-15",
  "ISO885915",
  "ISO8859_15"
));
__publicField(_CharacterSetECI, "ISO8859_16", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ISO8859_16,
  18,
  "ISO-8859-16",
  "ISO885916",
  "ISO8859_16"
));
__publicField(_CharacterSetECI, "SJIS", new _CharacterSetECI(CharacterSetValueIdentifiers.SJIS, 20, "SJIS", "Shift_JIS"));
__publicField(_CharacterSetECI, "Cp1250", new _CharacterSetECI(CharacterSetValueIdentifiers.Cp1250, 21, "Cp1250", "windows-1250"));
__publicField(_CharacterSetECI, "Cp1251", new _CharacterSetECI(CharacterSetValueIdentifiers.Cp1251, 22, "Cp1251", "windows-1251"));
__publicField(_CharacterSetECI, "Cp1252", new _CharacterSetECI(CharacterSetValueIdentifiers.Cp1252, 23, "Cp1252", "windows-1252"));
__publicField(_CharacterSetECI, "Cp1256", new _CharacterSetECI(CharacterSetValueIdentifiers.Cp1256, 24, "Cp1256", "windows-1256"));
__publicField(_CharacterSetECI, "UnicodeBigUnmarked", new _CharacterSetECI(
  CharacterSetValueIdentifiers.UnicodeBigUnmarked,
  25,
  "UnicodeBigUnmarked",
  "UTF-16BE",
  "UnicodeBig"
));
__publicField(_CharacterSetECI, "UTF8", new _CharacterSetECI(CharacterSetValueIdentifiers.UTF8, 26, "UTF8", "UTF-8"));
__publicField(_CharacterSetECI, "ASCII", new _CharacterSetECI(
  CharacterSetValueIdentifiers.ASCII,
  Int32Array.from([27, 170]),
  "ASCII",
  "US-ASCII"
));
__publicField(_CharacterSetECI, "Big5", new _CharacterSetECI(CharacterSetValueIdentifiers.Big5, 28, "Big5"));
__publicField(_CharacterSetECI, "GB18030", new _CharacterSetECI(CharacterSetValueIdentifiers.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"));
__publicField(_CharacterSetECI, "EUC_KR", new _CharacterSetECI(CharacterSetValueIdentifiers.EUC_KR, 30, "EUC_KR", "EUC-KR"));
let CharacterSetECI = _CharacterSetECI;
class UnsupportedOperationException extends Exception {
}
__publicField(UnsupportedOperationException, "kind", "UnsupportedOperationException");
const _StringEncoding = class _StringEncoding {
  /**
   * Decodes some Uint8Array to a string format.
   */
  static decode(bytes, encoding) {
    const encodingName = this.encodingName(encoding);
    if (this.customDecoder) {
      return this.customDecoder(bytes, encodingName);
    }
    if (typeof TextDecoder === "undefined" || this.shouldDecodeOnFallback(encodingName)) {
      return this.decodeFallback(bytes, encodingName);
    }
    return new TextDecoder(encodingName).decode(bytes);
  }
  /**
   * Checks if the decoding method should use the fallback for decoding
   * once Node TextDecoder doesn't support all encoding formats.
   *
   * @param encodingName
   */
  static shouldDecodeOnFallback(encodingName) {
    return !_StringEncoding.isBrowser() && encodingName === "ISO-8859-1";
  }
  /**
   * Encodes some string into a Uint8Array.
   */
  static encode(s, encoding) {
    const encodingName = this.encodingName(encoding);
    if (this.customEncoder) {
      return this.customEncoder(s, encodingName);
    }
    if (typeof TextEncoder === "undefined") {
      return this.encodeFallback(s);
    }
    return new TextEncoder().encode(s);
  }
  static isBrowser() {
    return typeof window !== "undefined" && {}.toString.call(window) === "[object Window]";
  }
  /**
   * Returns the string value from some encoding character set.
   */
  static encodingName(encoding) {
    return typeof encoding === "string" ? encoding : encoding.getName();
  }
  /**
   * Returns character set from some encoding character set.
   */
  static encodingCharacterSet(encoding) {
    if (encoding instanceof CharacterSetECI) {
      return encoding;
    }
    return CharacterSetECI.getCharacterSetECIByName(encoding);
  }
  /**
   * Runs a fallback for the native decoding funcion.
   */
  static decodeFallback(bytes, encoding) {
    const characterSet = this.encodingCharacterSet(encoding);
    if (_StringEncoding.isDecodeFallbackSupported(characterSet)) {
      let s = "";
      for (let i = 0, length = bytes.length; i < length; i++) {
        let h = bytes[i].toString(16);
        if (h.length < 2) {
          h = "0" + h;
        }
        s += "%" + h;
      }
      return decodeURIComponent(s);
    }
    if (characterSet.equals(CharacterSetECI.UnicodeBigUnmarked)) {
      return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
    }
    throw new UnsupportedOperationException(`Encoding ${this.encodingName(encoding)} not supported by fallback.`);
  }
  static isDecodeFallbackSupported(characterSet) {
    return characterSet.equals(CharacterSetECI.UTF8) || characterSet.equals(CharacterSetECI.ISO8859_1) || characterSet.equals(CharacterSetECI.ASCII);
  }
  /**
   * Runs a fallback for the native encoding funcion.
   *
   * @see https://stackoverflow.com/a/17192845/4367683
   */
  static encodeFallback(s) {
    const encodedURIstring = btoa(unescape(encodeURIComponent(s)));
    const charList = encodedURIstring.split("");
    const uintArray = [];
    for (let i = 0; i < charList.length; i++) {
      uintArray.push(charList[i].charCodeAt(0));
    }
    return new Uint8Array(uintArray);
  }
};
/**
 * Allows the user to set a custom decoding function
 * so more encoding formats the native ones can be supported.
 */
__publicField(_StringEncoding, "customDecoder");
/**
 * Allows the user to set a custom encoding function
 * so more encoding formats the native ones can be supported.
 */
__publicField(_StringEncoding, "customEncoder");
let StringEncoding = _StringEncoding;
const _StringUtils = class _StringUtils {
  // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
  // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
  static castAsNonUtf8Char(code, encoding = null) {
    const e = encoding ? encoding.getName() : this.ISO88591;
    return StringEncoding.decode(new Uint8Array([code]), e);
  }
  /**
   * @param bytes bytes encoding a string, whose encoding should be guessed
   * @param hints decode hints if applicable
   * @return name of guessed encoding; at the moment will only guess one of:
   *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
   *  default encoding if none of these can possibly be correct
   */
  static guessEncoding(bytes, hints) {
    if (hints !== null && hints !== void 0 && void 0 !== hints.get(DecodeHintType$1.CHARACTER_SET)) {
      return hints.get(DecodeHintType$1.CHARACTER_SET).toString();
    }
    const length = bytes.length;
    let canBeISO88591 = true;
    let canBeShiftJIS = true;
    let canBeUTF8 = true;
    let utf8BytesLeft = 0;
    let utf2BytesChars = 0;
    let utf3BytesChars = 0;
    let utf4BytesChars = 0;
    let sjisBytesLeft = 0;
    let sjisKatakanaChars = 0;
    let sjisCurKatakanaWordLength = 0;
    let sjisCurDoubleBytesWordLength = 0;
    let sjisMaxKatakanaWordLength = 0;
    let sjisMaxDoubleBytesWordLength = 0;
    let isoHighOther = 0;
    const utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */
    239 && bytes[1] === /*(byte) */
    187 && bytes[2] === /*(byte) */
    191;
    for (let i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++) {
      const value = bytes[i] & 255;
      if (canBeUTF8) {
        if (utf8BytesLeft > 0) {
          if ((value & 128) === 0) {
            canBeUTF8 = false;
          } else {
            utf8BytesLeft--;
          }
        } else if ((value & 128) !== 0) {
          if ((value & 64) === 0) {
            canBeUTF8 = false;
          } else {
            utf8BytesLeft++;
            if ((value & 32) === 0) {
              utf2BytesChars++;
            } else {
              utf8BytesLeft++;
              if ((value & 16) === 0) {
                utf3BytesChars++;
              } else {
                utf8BytesLeft++;
                if ((value & 8) === 0) {
                  utf4BytesChars++;
                } else {
                  canBeUTF8 = false;
                }
              }
            }
          }
        }
      }
      if (canBeISO88591) {
        if (value > 127 && value < 160) {
          canBeISO88591 = false;
        } else if (value > 159) {
          if (value < 192 || value === 215 || value === 247) {
            isoHighOther++;
          }
        }
      }
      if (canBeShiftJIS) {
        if (sjisBytesLeft > 0) {
          if (value < 64 || value === 127 || value > 252) {
            canBeShiftJIS = false;
          } else {
            sjisBytesLeft--;
          }
        } else if (value === 128 || value === 160 || value > 239) {
          canBeShiftJIS = false;
        } else if (value > 160 && value < 224) {
          sjisKatakanaChars++;
          sjisCurDoubleBytesWordLength = 0;
          sjisCurKatakanaWordLength++;
          if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) {
            sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
          }
        } else if (value > 127) {
          sjisBytesLeft++;
          sjisCurKatakanaWordLength = 0;
          sjisCurDoubleBytesWordLength++;
          if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) {
            sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
          }
        } else {
          sjisCurKatakanaWordLength = 0;
          sjisCurDoubleBytesWordLength = 0;
        }
      }
    }
    if (canBeUTF8 && utf8BytesLeft > 0) {
      canBeUTF8 = false;
    }
    if (canBeShiftJIS && sjisBytesLeft > 0) {
      canBeShiftJIS = false;
    }
    if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) {
      return _StringUtils.UTF8;
    }
    if (canBeShiftJIS && (sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) {
      return _StringUtils.SHIFT_JIS;
    }
    if (canBeISO88591 && canBeShiftJIS) {
      return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? _StringUtils.SHIFT_JIS : _StringUtils.ISO88591;
    }
    if (canBeISO88591) {
      return _StringUtils.ISO88591;
    }
    if (canBeShiftJIS) {
      return _StringUtils.SHIFT_JIS;
    }
    if (canBeUTF8) {
      return _StringUtils.UTF8;
    }
    return _StringUtils.PLATFORM_DEFAULT_ENCODING;
  }
  /**
   *
   * @see https://stackoverflow.com/a/13439711/4367683
   *
   * @param append The new string to append.
   * @param args Argumets values to be formated.
   */
  static format(append, ...args) {
    let i = -1;
    function callback(exp, p0, p1, p2, p3, p4) {
      if (exp === "%%")
        return "%";
      if (args[++i] === void 0)
        return void 0;
      exp = p2 ? parseInt(p2.substr(1)) : void 0;
      let base = p3 ? parseInt(p3.substr(1)) : void 0;
      let val;
      switch (p4) {
        case "s":
          val = args[i];
          break;
        case "c":
          val = args[i][0];
          break;
        case "f":
          val = parseFloat(args[i]).toFixed(exp);
          break;
        case "p":
          val = parseFloat(args[i]).toPrecision(exp);
          break;
        case "e":
          val = parseFloat(args[i]).toExponential(exp);
          break;
        case "x":
          val = parseInt(args[i]).toString(base ? base : 16);
          break;
        case "d":
          val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
          break;
      }
      val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
      let size = parseInt(p1);
      let ch = p1 && p1[0] + "" === "0" ? "0" : " ";
      while (val.length < size)
        val = p0 !== void 0 ? val + ch : ch + val;
      return val;
    }
    let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
    return append.replace(regex, callback);
  }
  /**
   *
   */
  static getBytes(str, encoding) {
    return StringEncoding.encode(str, encoding);
  }
  /**
   * Returns the charcode at the specified index or at index zero.
   */
  static getCharCode(str, index = 0) {
    return str.charCodeAt(index);
  }
  /**
   * Returns char for given charcode
   */
  static getCharAt(charCode) {
    return String.fromCharCode(charCode);
  }
};
__publicField(_StringUtils, "SHIFT_JIS", CharacterSetECI.SJIS.getName());
// "SJIS"
__publicField(_StringUtils, "GB2312", "GB2312");
__publicField(_StringUtils, "ISO88591", CharacterSetECI.ISO8859_1.getName());
// "ISO8859_1"
__publicField(_StringUtils, "EUC_JP", "EUC_JP");
__publicField(_StringUtils, "UTF8", CharacterSetECI.UTF8.getName());
// "UTF8"
__publicField(_StringUtils, "PLATFORM_DEFAULT_ENCODING", _StringUtils.UTF8);
// "UTF8"//Charset.defaultCharset().name()
__publicField(_StringUtils, "ASSUME_SHIFT_JIS", false);
let StringUtils = _StringUtils;
class StringBuilder {
  constructor(value = "") {
    __publicField(this, "value");
    __publicField(this, "encoding");
    this.value = value;
  }
  enableDecoding(encoding) {
    this.encoding = encoding;
    return this;
  }
  append(s) {
    if (typeof s === "string") {
      this.value += s.toString();
    } else if (this.encoding) {
      this.value += StringUtils.castAsNonUtf8Char(s, this.encoding);
    } else {
      this.value += String.fromCharCode(s);
    }
    return this;
  }
  appendChars(str, offset, len) {
    for (let i = offset; offset < offset + len; i++) {
      this.append(str[i]);
    }
    return this;
  }
  length() {
    return this.value.length;
  }
  charAt(n) {
    return this.value.charAt(n);
  }
  deleteCharAt(n) {
    this.value = this.value.substr(0, n) + this.value.substring(n + 1);
  }
  setCharAt(n, c) {
    this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
  }
  substring(start, end) {
    return this.value.substring(start, end);
  }
  /**
   * @note helper method for RSS Expanded
   */
  setLengthToZero() {
    this.value = "";
  }
  toString() {
    return this.value;
  }
  insert(n, c) {
    this.value = this.value.substring(0, n) + c + this.value.substring(n);
  }
}
class BitMatrix {
  /**
   * Creates an empty square {@link BitMatrix}.
   *
   * @param dimension height and width
   */
  // public constructor(dimension: number /*int*/) {
  //   this(dimension, dimension)
  // }
  /**
   * Creates an empty {@link BitMatrix}.
   *
   * @param width bit matrix width
   * @param height bit matrix height
   */
  // public constructor(width: number /*int*/, height: number /*int*/) {
  //   if (width < 1 || height < 1) {
  //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
  //   }
  //   this.width = width
  //   this.height = height
  //   this.rowSize = (width + 31) / 32
  //   bits = new int[rowSize * height];
  // }
  constructor(width, height, rowSize, bits) {
    __publicField(this, "width");
    __publicField(this, "height");
    __publicField(this, "rowSize");
    __publicField(this, "bits");
    this.width = width;
    this.height = height;
    this.rowSize = rowSize;
    this.bits = bits;
    if (void 0 === height || null === height) {
      height = width;
    }
    this.height = height;
    if (width < 1 || height < 1) {
      throw new IllegalArgumentException("Both dimensions must be greater than 0");
    }
    if (void 0 === rowSize || null === rowSize) {
      rowSize = Math.floor((width + 31) / 32);
    }
    this.rowSize = rowSize;
    if (void 0 === bits || null === bits) {
      this.bits = new Int32Array(this.rowSize * this.height);
    }
  }
  /**
   * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
   *
   * @function parse
   * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
   * @return {@link BitMatrix} representation of image
   */
  static parseFromBooleanArray(image) {
    const height = image.length;
    const width = image[0].length;
    const bits = new BitMatrix(width, height);
    for (let i = 0; i < height; i++) {
      const imageI = image[i];
      for (let j = 0; j < width; j++) {
        if (imageI[j]) {
          bits.set(j, i);
        }
      }
    }
    return bits;
  }
  /**
   *
   * @function parse
   * @param stringRepresentation
   * @param setString
   * @param unsetString
   */
  static parseFromString(stringRepresentation, setString, unsetString) {
    if (stringRepresentation === null) {
      throw new IllegalArgumentException("stringRepresentation cannot be null");
    }
    const bits = new Array(stringRepresentation.length);
    let bitsPos = 0;
    let rowStartPos = 0;
    let rowLength = -1;
    let nRows = 0;
    let pos = 0;
    while (pos < stringRepresentation.length) {
      if (stringRepresentation.charAt(pos) === "\n" || stringRepresentation.charAt(pos) === "\r") {
        if (bitsPos > rowStartPos) {
          if (rowLength === -1) {
            rowLength = bitsPos - rowStartPos;
          } else if (bitsPos - rowStartPos !== rowLength) {
            throw new IllegalArgumentException("row lengths do not match");
          }
          rowStartPos = bitsPos;
          nRows++;
        }
        pos++;
      } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
        pos += setString.length;
        bits[bitsPos] = true;
        bitsPos++;
      } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
        pos += unsetString.length;
        bits[bitsPos] = false;
        bitsPos++;
      } else {
        throw new IllegalArgumentException("illegal character encountered: " + stringRepresentation.substring(pos));
      }
    }
    if (bitsPos > rowStartPos) {
      if (rowLength === -1) {
        rowLength = bitsPos - rowStartPos;
      } else if (bitsPos - rowStartPos !== rowLength) {
        throw new IllegalArgumentException("row lengths do not match");
      }
      nRows++;
    }
    const matrix = new BitMatrix(rowLength, nRows);
    for (let i = 0; i < bitsPos; i++) {
      if (bits[i]) {
        matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
      }
    }
    return matrix;
  }
  /**
   * <p>Gets the requested bit, where true means black.</p>
   *
   * @param x The horizontal component (i.e. which column)
   * @param y The vertical component (i.e. which row)
   * @return value of given bit in matrix
   */
  get(x, y) {
    const offset = y * this.rowSize + Math.floor(x / 32);
    return (this.bits[offset] >>> (x & 31) & 1) !== 0;
  }
  /**
   * <p>Sets the given bit to true.</p>
   *
   * @param x The horizontal component (i.e. which column)
   * @param y The vertical component (i.e. which row)
   */
  set(x, y) {
    const offset = y * this.rowSize + Math.floor(x / 32);
    this.bits[offset] |= 1 << (x & 31) & 4294967295;
  }
  unset(x, y) {
    const offset = y * this.rowSize + Math.floor(x / 32);
    this.bits[offset] &= ~(1 << (x & 31) & 4294967295);
  }
  /**
   * <p>Flips the given bit.</p>
   *
   * @param x The horizontal component (i.e. which column)
   * @param y The vertical component (i.e. which row)
   */
  flip(x, y) {
    const offset = y * this.rowSize + Math.floor(x / 32);
    this.bits[offset] ^= 1 << (x & 31) & 4294967295;
  }
  /**
   * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
   * mask bit is set.
   *
   * @param mask XOR mask
   */
  xor(mask) {
    if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) {
      throw new IllegalArgumentException("input matrix dimensions do not match");
    }
    const rowArray = new BitArray(Math.floor(this.width / 32) + 1);
    const rowSize = this.rowSize;
    const bits = this.bits;
    for (let y = 0, height = this.height; y < height; y++) {
      const offset = y * rowSize;
      const row = mask.getRow(y, rowArray).getBitArray();
      for (let x = 0; x < rowSize; x++) {
        bits[offset + x] ^= row[x];
      }
    }
  }
  /**
   * Clears all bits (sets to false).
   */
  clear() {
    const bits = this.bits;
    const max = bits.length;
    for (let i = 0; i < max; i++) {
      bits[i] = 0;
    }
  }
  /**
   * <p>Sets a square region of the bit matrix to true.</p>
   *
   * @param left The horizontal position to begin at (inclusive)
   * @param top The vertical position to begin at (inclusive)
   * @param width The width of the region
   * @param height The height of the region
   */
  setRegion(left, top, width, height) {
    if (top < 0 || left < 0) {
      throw new IllegalArgumentException("Left and top must be nonnegative");
    }
    if (height < 1 || width < 1) {
      throw new IllegalArgumentException("Height and width must be at least 1");
    }
    const right = left + width;
    const bottom = top + height;
    if (bottom > this.height || right > this.width) {
      throw new IllegalArgumentException("The region must fit inside the matrix");
    }
    const rowSize = this.rowSize;
    const bits = this.bits;
    for (let y = top; y < bottom; y++) {
      const offset = y * rowSize;
      for (let x = left; x < right; x++) {
        bits[offset + Math.floor(x / 32)] |= 1 << (x & 31) & 4294967295;
      }
    }
  }
  /**
   * A fast method to retrieve one row of data from the matrix as a BitArray.
   *
   * @param y The row to retrieve
   * @param row An optional caller-allocated BitArray, will be allocated if null or too small
   * @return The resulting BitArray - this reference should always be used even when passing
   *         your own row
   */
  getRow(y, row) {
    if (row === null || row === void 0 || row.getSize() < this.width) {
      row = new BitArray(this.width);
    } else {
      row.clear();
    }
    const rowSize = this.rowSize;
    const bits = this.bits;
    const offset = y * rowSize;
    for (let x = 0; x < rowSize; x++) {
      row.setBulk(x * 32, bits[offset + x]);
    }
    return row;
  }
  /**
   * @param y row to set
   * @param row {@link BitArray} to copy from
   */
  setRow(y, row) {
    System.arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
  }
  /**
   * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
   */
  rotate180() {
    const width = this.getWidth();
    const height = this.getHeight();
    let topRow = new BitArray(width);
    let bottomRow = new BitArray(width);
    for (let i = 0, length = Math.floor((height + 1) / 2); i < length; i++) {
      topRow = this.getRow(i, topRow);
      bottomRow = this.getRow(height - 1 - i, bottomRow);
      topRow.reverse();
      bottomRow.reverse();
      this.setRow(i, bottomRow);
      this.setRow(height - 1 - i, topRow);
    }
  }
  /**
   * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
   *
   * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
   */
  getEnclosingRectangle() {
    const width = this.width;
    const height = this.height;
    const rowSize = this.rowSize;
    const bits = this.bits;
    let left = width;
    let top = height;
    let right = -1;
    let bottom = -1;
    for (let y = 0; y < height; y++) {
      for (let x32 = 0; x32 < rowSize; x32++) {
        const theBits = bits[y * rowSize + x32];
        if (theBits !== 0) {
          if (y < top) {
            top = y;
          }
          if (y > bottom) {
            bottom = y;
          }
          if (x32 * 32 < left) {
            let bit = 0;
            while ((theBits << 31 - bit & 4294967295) === 0) {
              bit++;
            }
            if (x32 * 32 + bit < left) {
              left = x32 * 32 + bit;
            }
          }
          if (x32 * 32 + 31 > right) {
            let bit = 31;
            while (theBits >>> bit === 0) {
              bit--;
            }
            if (x32 * 32 + bit > right) {
              right = x32 * 32 + bit;
            }
          }
        }
      }
    }
    if (right < left || bottom < top) {
      return null;
    }
    return Int32Array.from([left, top, right - left + 1, bottom - top + 1]);
  }
  /**
   * This is useful in detecting a corner of a 'pure' barcode.
   *
   * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
   */
  getTopLeftOnBit() {
    const rowSize = this.rowSize;
    const bits = this.bits;
    let bitsOffset = 0;
    while (bitsOffset < bits.length && bits[bitsOffset] === 0) {
      bitsOffset++;
    }
    if (bitsOffset === bits.length) {
      return null;
    }
    const y = bitsOffset / rowSize;
    let x = bitsOffset % rowSize * 32;
    const theBits = bits[bitsOffset];
    let bit = 0;
    while ((theBits << 31 - bit & 4294967295) === 0) {
      bit++;
    }
    x += bit;
    return Int32Array.from([x, y]);
  }
  getBottomRightOnBit() {
    const rowSize = this.rowSize;
    const bits = this.bits;
    let bitsOffset = bits.length - 1;
    while (bitsOffset >= 0 && bits[bitsOffset] === 0) {
      bitsOffset--;
    }
    if (bitsOffset < 0) {
      return null;
    }
    const y = Math.floor(bitsOffset / rowSize);
    let x = Math.floor(bitsOffset % rowSize) * 32;
    const theBits = bits[bitsOffset];
    let bit = 31;
    while (theBits >>> bit === 0) {
      bit--;
    }
    x += bit;
    return Int32Array.from([x, y]);
  }
  /**
   * @return The width of the matrix
   */
  getWidth() {
    return this.width;
  }
  /**
   * @return The height of the matrix
   */
  getHeight() {
    return this.height;
  }
  /**
   * @return The row size of the matrix
   */
  getRowSize() {
    return this.rowSize;
  }
  /*@Override*/
  equals(o) {
    if (!(o instanceof BitMatrix)) {
      return false;
    }
    const other = o;
    return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && Arrays.equals(this.bits, other.bits);
  }
  /*@Override*/
  hashCode() {
    let hash = this.width;
    hash = 31 * hash + this.width;
    hash = 31 * hash + this.height;
    hash = 31 * hash + this.rowSize;
    hash = 31 * hash + Arrays.hashCode(this.bits);
    return hash;
  }
  /**
   * @return string representation using "X" for set and " " for unset bits
   */
  /*@Override*/
  // public toString(): string {
  //   return toString(": "X, "  ")
  // }
  /**
   * @param setString representation of a set bit
   * @param unsetString representation of an unset bit
   * @return string representation of entire matrix utilizing given strings
   */
  // public toString(setString: string = "X ", unsetString: string = "  "): string {
  //   return this.buildToString(setString, unsetString, "\n")
  // }
  /**
   * @param setString representation of a set bit
   * @param unsetString representation of an unset bit
   * @param lineSeparator newline character in string representation
   * @return string representation of entire matrix utilizing given strings and line separator
   * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
   */
  // @Deprecated
  toString(setString = "X ", unsetString = "  ", lineSeparator = "\n") {
    return this.buildToString(setString, unsetString, lineSeparator);
  }
  buildToString(setString, unsetString, lineSeparator) {
    let result = new StringBuilder();
    for (let y = 0, height = this.height; y < height; y++) {
      for (let x = 0, width = this.width; x < width; x++) {
        result.append(this.get(x, y) ? setString : unsetString);
      }
      result.append(lineSeparator);
    }
    return result.toString();
  }
  /*@Override*/
  clone() {
    return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
  }
}
const _NotFoundException = class _NotFoundException extends Exception {
  static getNotFoundInstance() {
    return new _NotFoundException();
  }
};
__publicField(_NotFoundException, "kind", "NotFoundException");
let NotFoundException = _NotFoundException;
const _GlobalHistogramBinarizer = class _GlobalHistogramBinarizer extends Binarizer {
  constructor(source) {
    super(source);
    __publicField(this, "luminances");
    __publicField(this, "buckets");
    this.luminances = _GlobalHistogramBinarizer.EMPTY;
    this.buckets = new Int32Array(_GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
  }
  // Applies simple sharpening to the row data to improve performance of the 1D Readers.
  /*@Override*/
  getBlackRow(y, row) {
    const source = this.getLuminanceSource();
    const width = source.getWidth();
    if (row === void 0 || row === null || row.getSize() < width) {
      row = new BitArray(width);
    } else {
      row.clear();
    }
    this.initArrays(width);
    const localLuminances = source.getRow(y, this.luminances);
    const localBuckets = this.buckets;
    for (let x = 0; x < width; x++) {
      localBuckets[(localLuminances[x] & 255) >> _GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
    }
    const blackPoint = _GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
    if (width < 3) {
      for (let x = 0; x < width; x++) {
        if ((localLuminances[x] & 255) < blackPoint) {
          row.set(x);
        }
      }
    } else {
      let left = localLuminances[0] & 255;
      let center = localLuminances[1] & 255;
      for (let x = 1; x < width - 1; x++) {
        const right = localLuminances[x + 1] & 255;
        if ((center * 4 - left - right) / 2 < blackPoint) {
          row.set(x);
        }
        left = center;
        center = right;
      }
    }
    return row;
  }
  // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
  /*@Override*/
  getBlackMatrix() {
    const source = this.getLuminanceSource();
    const width = source.getWidth();
    const height = source.getHeight();
    const matrix = new BitMatrix(width, height);
    this.initArrays(width);
    const localBuckets = this.buckets;
    for (let y = 1; y < 5; y++) {
      const row = Math.floor(height * y / 5);
      const localLuminances2 = source.getRow(row, this.luminances);
      const right = Math.floor(width * 4 / 5);
      for (let x = Math.floor(width / 5); x < right; x++) {
        const pixel = localLuminances2[x] & 255;
        localBuckets[pixel >> _GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
      }
    }
    const blackPoint = _GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
    const localLuminances = source.getMatrix();
    for (let y = 0; y < height; y++) {
      const offset = y * width;
      for (let x = 0; x < width; x++) {
        const pixel = localLuminances[offset + x] & 255;
        if (pixel < blackPoint) {
          matrix.set(x, y);
        }
      }
    }
    return matrix;
  }
  /*@Override*/
  createBinarizer(source) {
    return new _GlobalHistogramBinarizer(source);
  }
  initArrays(luminanceSize) {
    if (this.luminances.length < luminanceSize) {
      this.luminances = new Uint8ClampedArray(luminanceSize);
    }
    const buckets = this.buckets;
    for (let x = 0; x < _GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++) {
      buckets[x] = 0;
    }
  }
  static estimateBlackPoint(buckets) {
    const numBuckets = buckets.length;
    let maxBucketCount = 0;
    let firstPeak = 0;
    let firstPeakSize = 0;
    for (let x = 0; x < numBuckets; x++) {
      if (buckets[x] > firstPeakSize) {
        firstPeak = x;
        firstPeakSize = buckets[x];
      }
      if (buckets[x] > maxBucketCount) {
        maxBucketCount = buckets[x];
      }
    }
    let secondPeak = 0;
    let secondPeakScore = 0;
    for (let x = 0; x < numBuckets; x++) {
      const distanceToBiggest = x - firstPeak;
      const score = buckets[x] * distanceToBiggest * distanceToBiggest;
      if (score > secondPeakScore) {
        secondPeak = x;
        secondPeakScore = score;
      }
    }
    if (firstPeak > secondPeak) {
      const temp = firstPeak;
      firstPeak = secondPeak;
      secondPeak = temp;
    }
    if (secondPeak - firstPeak <= numBuckets / 16) {
      throw new NotFoundException();
    }
    let bestValley = secondPeak - 1;
    let bestValleyScore = -1;
    for (let x = secondPeak - 1; x > firstPeak; x--) {
      const fromFirst = x - firstPeak;
      const score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
      if (score > bestValleyScore) {
        bestValley = x;
        bestValleyScore = score;
      }
    }
    return bestValley << _GlobalHistogramBinarizer.LUMINANCE_SHIFT;
  }
};
__publicField(_GlobalHistogramBinarizer, "LUMINANCE_BITS", 5);
__publicField(_GlobalHistogramBinarizer, "LUMINANCE_SHIFT", 8 - _GlobalHistogramBinarizer.LUMINANCE_BITS);
__publicField(_GlobalHistogramBinarizer, "LUMINANCE_BUCKETS", 1 << _GlobalHistogramBinarizer.LUMINANCE_BITS);
__publicField(_GlobalHistogramBinarizer, "EMPTY", Uint8ClampedArray.from([0]));
let GlobalHistogramBinarizer = _GlobalHistogramBinarizer;
const _HybridBinarizer = class _HybridBinarizer extends GlobalHistogramBinarizer {
  constructor(source) {
    super(source);
    __publicField(this, "matrix", null);
  }
  /**
   * Calculates the final BitMatrix once for all requests. This could be called once from the
   * constructor instead, but there are some advantages to doing it lazily, such as making
   * profiling easier, and not doing heavy lifting when callers don't expect it.
   */
  /*@Override*/
  getBlackMatrix() {
    if (this.matrix !== null) {
      return this.matrix;
    }
    const source = this.getLuminanceSource();
    const width = source.getWidth();
    const height = source.getHeight();
    if (width >= _HybridBinarizer.MINIMUM_DIMENSION && height >= _HybridBinarizer.MINIMUM_DIMENSION) {
      const luminances = source.getMatrix();
      let subWidth = width >> _HybridBinarizer.BLOCK_SIZE_POWER;
      if ((width & _HybridBinarizer.BLOCK_SIZE_MASK) !== 0) {
        subWidth++;
      }
      let subHeight = height >> _HybridBinarizer.BLOCK_SIZE_POWER;
      if ((height & _HybridBinarizer.BLOCK_SIZE_MASK) !== 0) {
        subHeight++;
      }
      const blackPoints = _HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
      const newMatrix = new BitMatrix(width, height);
      _HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
      this.matrix = newMatrix;
    } else {
      this.matrix = super.getBlackMatrix();
    }
    return this.matrix;
  }
  /*@Override*/
  createBinarizer(source) {
    return new _HybridBinarizer(source);
  }
  /**
   * For each block in the image, calculate the average black point using a 5x5 grid
   * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
   * on the last pixels in the row/column which are also used in the previous block).
   */
  static calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, matrix) {
    const maxYOffset = height - _HybridBinarizer.BLOCK_SIZE;
    const maxXOffset = width - _HybridBinarizer.BLOCK_SIZE;
    for (let y = 0; y < subHeight; y++) {
      let yoffset = y << _HybridBinarizer.BLOCK_SIZE_POWER;
      if (yoffset > maxYOffset) {
        yoffset = maxYOffset;
      }
      const top = _HybridBinarizer.cap(y, 2, subHeight - 3);
      for (let x = 0; x < subWidth; x++) {
        let xoffset = x << _HybridBinarizer.BLOCK_SIZE_POWER;
        if (xoffset > maxXOffset) {
          xoffset = maxXOffset;
        }
        const left = _HybridBinarizer.cap(x, 2, subWidth - 3);
        let sum = 0;
        for (let z = -2; z <= 2; z++) {
          const blackRow = blackPoints[top + z];
          sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
        }
        const average = sum / 25;
        _HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
      }
    }
  }
  static cap(value, min, max) {
    return value < min ? min : value > max ? max : value;
  }
  /**
   * Applies a single threshold to a block of pixels.
   */
  static thresholdBlock(luminances, xoffset, yoffset, threshold, stride, matrix) {
    for (let y = 0, offset = yoffset * stride + xoffset; y < _HybridBinarizer.BLOCK_SIZE; y++, offset += stride) {
      for (let x = 0; x < _HybridBinarizer.BLOCK_SIZE; x++) {
        if ((luminances[offset + x] & 255) <= threshold) {
          matrix.set(xoffset + x, yoffset + y);
        }
      }
    }
  }
  /**
   * Calculates a single black point for each block of pixels and saves it away.
   * See the following thread for a discussion of this algorithm:
   *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
   */
  static calculateBlackPoints(luminances, subWidth, subHeight, width, height) {
    const maxYOffset = height - _HybridBinarizer.BLOCK_SIZE;
    const maxXOffset = width - _HybridBinarizer.BLOCK_SIZE;
    const blackPoints = new Array(subHeight);
    for (let y = 0; y < subHeight; y++) {
      blackPoints[y] = new Int32Array(subWidth);
      let yoffset = y << _HybridBinarizer.BLOCK_SIZE_POWER;
      if (yoffset > maxYOffset) {
        yoffset = maxYOffset;
      }
      for (let x = 0; x < subWidth; x++) {
        let xoffset = x << _HybridBinarizer.BLOCK_SIZE_POWER;
        if (xoffset > maxXOffset) {
          xoffset = maxXOffset;
        }
        let sum = 0;
        let min = 255;
        let max = 0;
        for (let yy = 0, offset = yoffset * width + xoffset; yy < _HybridBinarizer.BLOCK_SIZE; yy++, offset += width) {
          for (let xx = 0; xx < _HybridBinarizer.BLOCK_SIZE; xx++) {
            const pixel = luminances[offset + xx] & 255;
            sum += pixel;
            if (pixel < min) {
              min = pixel;
            }
            if (pixel > max) {
              max = pixel;
            }
          }
          if (max - min > _HybridBinarizer.MIN_DYNAMIC_RANGE) {
            for (yy++, offset += width; yy < _HybridBinarizer.BLOCK_SIZE; yy++, offset += width) {
              for (let xx = 0; xx < _HybridBinarizer.BLOCK_SIZE; xx++) {
                sum += luminances[offset + xx] & 255;
              }
            }
          }
        }
        let average = sum >> _HybridBinarizer.BLOCK_SIZE_POWER * 2;
        if (max - min <= _HybridBinarizer.MIN_DYNAMIC_RANGE) {
          average = min / 2;
          if (y > 0 && x > 0) {
            const averageNeighborBlackPoint = (blackPoints[y - 1][x] + 2 * blackPoints[y][x - 1] + blackPoints[y - 1][x - 1]) / 4;
            if (min < averageNeighborBlackPoint) {
              average = averageNeighborBlackPoint;
            }
          }
        }
        blackPoints[y][x] = average;
      }
    }
    return blackPoints;
  }
};
// This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
// So this is the smallest dimension in each axis we can accept.
__publicField(_HybridBinarizer, "BLOCK_SIZE_POWER", 3);
__publicField(_HybridBinarizer, "BLOCK_SIZE", 1 << _HybridBinarizer.BLOCK_SIZE_POWER);
// ...0100...00
__publicField(_HybridBinarizer, "BLOCK_SIZE_MASK", _HybridBinarizer.BLOCK_SIZE - 1);
// ...0011...11
__publicField(_HybridBinarizer, "MINIMUM_DIMENSION", _HybridBinarizer.BLOCK_SIZE * 5);
__publicField(_HybridBinarizer, "MIN_DYNAMIC_RANGE", 24);
let HybridBinarizer = _HybridBinarizer;
class LuminanceSource {
  constructor(width, height) {
    __publicField(this, "width");
    __publicField(this, "height");
    this.width = width;
    this.height = height;
  }
  /**
   * @return The width of the bitmap.
   */
  getWidth() {
    return this.width;
  }
  /**
   * @return The height of the bitmap.
   */
  getHeight() {
    return this.height;
  }
  /**
   * @return Whether this subclass supports cropping.
   */
  isCropSupported() {
    return false;
  }
  /**
   * Returns a new object with cropped image data. Implementations may keep a reference to the
   * original data rather than a copy. Only callable if isCropSupported() is true.
   *
   * @param left The left coordinate, which must be in [0,getWidth())
   * @param top The top coordinate, which must be in [0,getHeight())
   * @param width The width of the rectangle to crop.
   * @param height The height of the rectangle to crop.
   * @return A cropped version of this object.
   */
  crop(left, top, width, height) {
    throw new UnsupportedOperationException("This luminance source does not support cropping.");
  }
  /**
   * @return Whether this subclass supports counter-clockwise rotation.
   */
  isRotateSupported() {
    return false;
  }
  /**
   * Returns a new object with rotated image data by 90 degrees counterclockwise.
   * Only callable if {@link #isRotateSupported()} is true.
   *
   * @return A rotated version of this object.
   */
  rotateCounterClockwise() {
    throw new UnsupportedOperationException("This luminance source does not support rotation by 90 degrees.");
  }
  /**
   * Returns a new object with rotated image data by 45 degrees counterclockwise.
   * Only callable if {@link #isRotateSupported()} is true.
   *
   * @return A rotated version of this object.
   */
  rotateCounterClockwise45() {
    throw new UnsupportedOperationException("This luminance source does not support rotation by 45 degrees.");
  }
  /*@Override*/
  toString() {
    const row = new Uint8ClampedArray(this.width);
    let result = new StringBuilder();
    for (let y = 0; y < this.height; y++) {
      const sourceRow = this.getRow(y, row);
      for (let x = 0; x < this.width; x++) {
        const luminance = sourceRow[x] & 255;
        let c;
        if (luminance < 64) {
          c = "#";
        } else if (luminance < 128) {
          c = "+";
        } else if (luminance < 192) {
          c = ".";
        } else {
          c = " ";
        }
        result.append(c);
      }
      result.append("\n");
    }
    return result.toString();
  }
}
class InvertedLuminanceSource extends LuminanceSource {
  constructor(delegate) {
    super(delegate.getWidth(), delegate.getHeight());
    __publicField(this, "delegate");
    this.delegate = delegate;
  }
  /*@Override*/
  getRow(y, row) {
    const sourceRow = this.delegate.getRow(y, row);
    const width = this.getWidth();
    for (let i = 0; i < width; i++) {
      sourceRow[i] = /*(byte)*/
      255 - (sourceRow[i] & 255);
    }
    return sourceRow;
  }
  /*@Override*/
  getMatrix() {
    const matrix = this.delegate.getMatrix();
    const length = this.getWidth() * this.getHeight();
    const invertedMatrix = new Uint8ClampedArray(length);
    for (let i = 0; i < length; i++) {
      invertedMatrix[i] = /*(byte)*/
      255 - (matrix[i] & 255);
    }
    return invertedMatrix;
  }
  /*@Override*/
  isCropSupported() {
    return this.delegate.isCropSupported();
  }
  /*@Override*/
  crop(left, top, width, height) {
    return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
  }
  /*@Override*/
  isRotateSupported() {
    return this.delegate.isRotateSupported();
  }
  /**
   * @return original delegate {@link LuminanceSource} since invert undoes itself
   */
  /*@Override*/
  invert() {
    return this.delegate;
  }
  /*@Override*/
  rotateCounterClockwise() {
    return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
  }
  /*@Override*/
  rotateCounterClockwise45() {
    return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
  }
}
const _HTMLCanvasElementLuminanceSource = class _HTMLCanvasElementLuminanceSource extends LuminanceSource {
  constructor(canvas) {
    super(canvas.width, canvas.height);
    __publicField(this, "canvas");
    __publicField(this, "buffer");
    __publicField(this, "tempCanvasElement", null);
    this.canvas = canvas;
    this.buffer = _HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
  }
  static makeBufferFromCanvasImageData(canvas) {
    const imageData = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
    return _HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
  }
  static toGrayscaleBuffer(imageBuffer, width, height) {
    const grayscaleBuffer = new Uint8ClampedArray(width * height);
    _HTMLCanvasElementLuminanceSource.FRAME_INDEX = !_HTMLCanvasElementLuminanceSource.FRAME_INDEX;
    if (_HTMLCanvasElementLuminanceSource.FRAME_INDEX) {
      for (let i = 0, j = 0, length = imageBuffer.length; i < length; i += 4, j++) {
        let gray;
        const alpha = imageBuffer[i + 3];
        if (alpha === 0) {
          gray = 255;
        } else {
          const pixelR = imageBuffer[i];
          const pixelG = imageBuffer[i + 1];
          const pixelB = imageBuffer[i + 2];
          gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 512 >> 10;
        }
        grayscaleBuffer[j] = gray;
      }
    } else {
      for (let i = 0, j = 0, length = imageBuffer.length; i < length; i += 4, j++) {
        let gray;
        const alpha = imageBuffer[i + 3];
        if (alpha === 0) {
          gray = 255;
        } else {
          const pixelR = imageBuffer[i];
          const pixelG = imageBuffer[i + 1];
          const pixelB = imageBuffer[i + 2];
          gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 512 >> 10;
        }
        grayscaleBuffer[j] = 255 - gray;
      }
    }
    return grayscaleBuffer;
  }
  getRow(y, row) {
    if (y < 0 || y >= this.getHeight()) {
      throw new IllegalArgumentException("Requested row is outside the image: " + y);
    }
    const width = this.getWidth();
    const start = y * width;
    if (row === null) {
      row = this.buffer.slice(start, start + width);
    } else {
      if (row.length < width) {
        row = new Uint8ClampedArray(width);
      }
      row.set(this.buffer.slice(start, start + width));
    }
    return row;
  }
  getMatrix() {
    return this.buffer;
  }
  isCropSupported() {
    return true;
  }
  crop(left, top, width, height) {
    super.crop(left, top, width, height);
    return this;
  }
  /**
   * This is always true, since the image is a gray-scale image.
   *
   * @return true
   */
  isRotateSupported() {
    return true;
  }
  rotateCounterClockwise() {
    this.rotate(-90);
    return this;
  }
  rotateCounterClockwise45() {
    this.rotate(-45);
    return this;
  }
  getTempCanvasElement() {
    if (null === this.tempCanvasElement) {
      const tempCanvasElement = this.canvas.ownerDocument.createElement("canvas");
      tempCanvasElement.width = this.canvas.width;
      tempCanvasElement.height = this.canvas.height;
      this.tempCanvasElement = tempCanvasElement;
    }
    return this.tempCanvasElement;
  }
  rotate(angle) {
    const tempCanvasElement = this.getTempCanvasElement();
    const tempContext = tempCanvasElement.getContext("2d");
    const angleRadians = angle * _HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
    const width = this.canvas.width;
    const height = this.canvas.height;
    const newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
    const newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
    tempCanvasElement.width = newWidth;
    tempCanvasElement.height = newHeight;
    tempContext.translate(newWidth / 2, newHeight / 2);
    tempContext.rotate(angleRadians);
    tempContext.drawImage(this.canvas, width / -2, height / -2);
    this.buffer = _HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
    return this;
  }
  invert() {
    return new InvertedLuminanceSource(this);
  }
};
__publicField(_HTMLCanvasElementLuminanceSource, "DEGREE_TO_RADIANS", Math.PI / 180);
__publicField(_HTMLCanvasElementLuminanceSource, "FRAME_INDEX", true);
let HTMLCanvasElementLuminanceSource = _HTMLCanvasElementLuminanceSource;
class VideoInputDevice {
  /**
   * Creates an instance of VideoInputDevice.
   *
   * @param {string} deviceId the video input device id
   * @param {string} label the label of the device if available
   */
  constructor(deviceId, label, groupId) {
    __publicField(this, "deviceId");
    __publicField(this, "label");
    /** @inheritdoc */
    __publicField(this, "kind", "videoinput");
    /** @inheritdoc */
    __publicField(this, "groupId");
    this.deviceId = deviceId;
    this.label = label;
    this.groupId = groupId || void 0;
  }
  /** @inheritdoc */
  toJSON() {
    return {
      kind: this.kind,
      groupId: this.groupId,
      deviceId: this.deviceId,
      label: this.label
    };
  }
}
class BrowserCodeReader {
  /**
   * Creates an instance of BrowserCodeReader.
   * @param {Reader} reader The reader instance to decode the barcode
   * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
   *
   * @memberOf BrowserCodeReader
   */
  constructor(reader, timeBetweenScansMillis = 500, _hints) {
    __publicField(this, "reader");
    __publicField(this, "timeBetweenScansMillis");
    __publicField(this, "_hints");
    /**
     * This will break the loop.
     */
    __publicField(this, "_stopContinuousDecode", false);
    /**
     * This will break the loop.
     */
    __publicField(this, "_stopAsyncDecode", false);
    /**
     * Delay time between decode attempts made by the scanner.
     */
    __publicField(this, "_timeBetweenDecodingAttempts", 0);
    /**
     * The HTML canvas element, used to draw the video or image's frame for decoding.
     */
    __publicField(this, "captureCanvas");
    /**
     * The HTML canvas element context.
     */
    __publicField(this, "captureCanvasContext");
    /**
     * The HTML image element, used as a fallback for the video element when decoding.
     */
    __publicField(this, "imageElement");
    /**
     * Should contain the current registered listener for image loading,
     * used to unregister that listener when needed.
     */
    __publicField(this, "imageLoadedListener");
    /**
     * The stream output from camera.
     */
    __publicField(this, "stream");
    /**
     * The HTML video element, used to display the camera stream.
     */
    __publicField(this, "videoElement");
    /**
     * Should contain the current registered listener for video loaded-metadata,
     * used to unregister that listener when needed.
     */
    __publicField(this, "videoCanPlayListener");
    /**
     * Should contain the current registered listener for video play-ended,
     * used to unregister that listener when needed.
     */
    __publicField(this, "videoEndedListener");
    /**
     * Should contain the current registered listener for video playing,
     * used to unregister that listener when needed.
     */
    __publicField(this, "videoPlayingEventListener");
    this.reader = reader;
    this.timeBetweenScansMillis = timeBetweenScansMillis;
    this._hints = _hints;
  }
  /**
   * If navigator is present.
   */
  get hasNavigator() {
    return typeof navigator !== "undefined";
  }
  /**
   * If mediaDevices under navigator is supported.
   */
  get isMediaDevicesSuported() {
    return this.hasNavigator && !!navigator.mediaDevices;
  }
  /**
   * If enumerateDevices under navigator is supported.
   */
  get canEnumerateDevices() {
    return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
  }
  /** Time between two decoding tries in milli seconds. */
  get timeBetweenDecodingAttempts() {
    return this._timeBetweenDecodingAttempts;
  }
  /**
   * Change the time span the decoder waits between two decoding tries.
   *
   * @param {number} millis Time between two decoding tries in milli seconds.
   */
  set timeBetweenDecodingAttempts(millis) {
    this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
  }
  /**
   * Sets the hints.
   */
  set hints(hints) {
    this._hints = hints || null;
  }
  /**
   * Sets the hints.
   */
  get hints() {
    return this._hints;
  }
  /**
   * Lists all the available video input devices.
   */
  async listVideoInputDevices() {
    if (!this.hasNavigator) {
      throw new Error("Can't enumerate devices, navigator is not present.");
    }
    if (!this.canEnumerateDevices) {
      throw new Error("Can't enumerate devices, method not supported.");
    }
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = [];
    for (const device of devices) {
      const kind = device.kind === "video" ? "videoinput" : device.kind;
      if (kind !== "videoinput") {
        continue;
      }
      const deviceId = device.deviceId || device.id;
      const label = device.label || `Video device ${videoDevices.length + 1}`;
      const groupId = device.groupId;
      const videoDevice = { deviceId, label, kind, groupId };
      videoDevices.push(videoDevice);
    }
    return videoDevices;
  }
  /**
   * Obtain the list of available devices with type 'videoinput'.
   *
   * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
   *
   * @memberOf BrowserCodeReader
   *
   * @deprecated Use `listVideoInputDevices` instead.
   */
  async getVideoInputDevices() {
    const devices = await this.listVideoInputDevices();
    return devices.map((d) => new VideoInputDevice(d.deviceId, d.label));
  }
  /**
   * Let's you find a device using it's Id.
   */
  async findDeviceById(deviceId) {
    const devices = await this.listVideoInputDevices();
    if (!devices) {
      return null;
    }
    return devices.find((x) => x.deviceId === deviceId);
  }
  /**
   * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
   *
   * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
   * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns The decoding result.
   *
   * @memberOf BrowserCodeReader
   *
   * @deprecated Use `decodeOnceFromVideoDevice` instead.
   */
  async decodeFromInputVideoDevice(deviceId, videoSource) {
    return await this.decodeOnceFromVideoDevice(deviceId, videoSource);
  }
  /**
   * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
   *
   * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
   * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  async decodeOnceFromVideoDevice(deviceId, videoSource) {
    this.reset();
    let videoConstraints;
    if (!deviceId) {
      videoConstraints = { facingMode: "environment" };
    } else {
      videoConstraints = { deviceId: { exact: deviceId } };
    }
    const constraints = { video: videoConstraints };
    return await this.decodeOnceFromConstraints(constraints, videoSource);
  }
  /**
   * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
   *
   * @param constraints the media stream constraints to get s valid media stream to decode from
   * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  async decodeOnceFromConstraints(constraints, videoSource) {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    return await this.decodeOnceFromStream(stream, videoSource);
  }
  /**
   * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
   *
   * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
   * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns {Promise<Result>} The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  async decodeOnceFromStream(stream, videoSource) {
    this.reset();
    const video = await this.attachStreamToVideo(stream, videoSource);
    const result = await this.decodeOnce(video);
    return result;
  }
  /**
   * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
   *
   * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
   * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns {Promise<void>}
   *
   * @memberOf BrowserCodeReader
   *
   * @deprecated Use `decodeFromVideoDevice` instead.
   */
  async decodeFromInputVideoDeviceContinuously(deviceId, videoSource, callbackFn) {
    return await this.decodeFromVideoDevice(deviceId, videoSource, callbackFn);
  }
  /**
   * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
   *
   * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
   * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns {Promise<void>}
   *
   * @memberOf BrowserCodeReader
   */
  async decodeFromVideoDevice(deviceId, videoSource, callbackFn) {
    let videoConstraints;
    if (!deviceId) {
      videoConstraints = { facingMode: "environment" };
    } else {
      videoConstraints = { deviceId: { exact: deviceId } };
    }
    const constraints = { video: videoConstraints };
    return await this.decodeFromConstraints(constraints, videoSource, callbackFn);
  }
  /**
   * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
   *
   * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
   * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns {Promise<Result>} The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  async decodeFromConstraints(constraints, videoSource, callbackFn) {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    return await this.decodeFromStream(stream, videoSource, callbackFn);
  }
  /**
   * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
   *
   * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
   * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
   * @returns {Promise<Result>} The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  async decodeFromStream(stream, videoSource, callbackFn) {
    this.reset();
    const video = await this.attachStreamToVideo(stream, videoSource);
    return await this.decodeContinuously(video, callbackFn);
  }
  /**
   * Breaks the decoding loop.
   */
  stopAsyncDecode() {
    this._stopAsyncDecode = true;
  }
  /**
   * Breaks the decoding loop.
   */
  stopContinuousDecode() {
    this._stopContinuousDecode = true;
  }
  /**
   * Sets the new stream and request a new decoding-with-delay.
   *
   * @param stream The stream to be shown in the video element.
   * @param decodeFn A callback for the decode method.
   */
  async attachStreamToVideo(stream, videoSource) {
    const videoElement = this.prepareVideoElement(videoSource);
    this.addVideoSource(videoElement, stream);
    this.videoElement = videoElement;
    this.stream = stream;
    await this.playVideoOnLoadAsync(videoElement);
    return videoElement;
  }
  /**
   *
   * @param videoElement
   */
  playVideoOnLoadAsync(videoElement) {
    return new Promise((resolve, reject) => this.playVideoOnLoad(videoElement, () => resolve()));
  }
  /**
   * Binds listeners and callbacks to the videoElement.
   *
   * @param element
   * @param callbackFn
   */
  playVideoOnLoad(element, callbackFn) {
    this.videoEndedListener = () => this.stopStreams();
    this.videoCanPlayListener = () => this.tryPlayVideo(element);
    element.addEventListener("ended", this.videoEndedListener);
    element.addEventListener("canplay", this.videoCanPlayListener);
    element.addEventListener("playing", callbackFn);
    this.tryPlayVideo(element);
  }
  /**
   * Checks if the given video element is currently playing.
   */
  isVideoPlaying(video) {
    return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
  }
  /**
   * Just tries to play the video and logs any errors.
   * The play call is only made is the video is not already playing.
   */
  async tryPlayVideo(videoElement) {
    if (this.isVideoPlaying(videoElement)) {
      console.warn("Trying to play video that is already playing.");
      return;
    }
    try {
      await videoElement.play();
    } catch {
      console.warn("It was not possible to play the video.");
    }
  }
  /**
   * Searches and validates a media element.
   */
  getMediaElement(mediaElementId, type) {
    const mediaElement = document.getElementById(mediaElementId);
    if (!mediaElement) {
      throw new ArgumentException(`element with id '${mediaElementId}' not found`);
    }
    if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) {
      throw new ArgumentException(`element with id '${mediaElementId}' must be an ${type} element`);
    }
    return mediaElement;
  }
  /**
   * Decodes the barcode from an image.
   *
   * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
   * @param {string} [url]
   * @returns {Promise<Result>} The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  decodeFromImage(source, url) {
    if (!source && !url) {
      throw new ArgumentException("either imageElement with a src set or an url must be provided");
    }
    if (url && !source) {
      return this.decodeFromImageUrl(url);
    }
    return this.decodeFromImageElement(source);
  }
  /**
   * Decodes the barcode from a video.
   *
   * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
   * @param {string} [url]
   * @returns {Promise<Result>} The decoding result.
   *
   * @memberOf BrowserCodeReader
   */
  decodeFromVideo(source, url) {
    if (!source && !url) {
      throw new ArgumentException("Either an element with a src set or an URL must be provided");
    }
    if (url && !source) {
      return this.decodeFromVideoUrl(url);
    }
    return this.decodeFromVideoElement(source);
  }
  /**
   * Decodes continuously the barcode from a video.
   *
   * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
   * @param {string} [url]
   * @returns {Promise<Result>} The decoding result.
   *
   * @memberOf BrowserCodeReader
   *
   * @experimental
   */
  decodeFromVideoContinuously(source, url, callbackFn) {
    if (void 0 === source && void 0 === url) {
      throw new ArgumentException("Either an element with a src set or an URL must be provided");
    }
    if (url && !source) {
      return this.decodeFromVideoUrlContinuously(url, callbackFn);
    }
    return this.decodeFromVideoElementContinuously(source, callbackFn);
  }
  /**
   * Decodes something from an image HTML element.
   */
  decodeFromImageElement(source) {
    if (!source) {
      throw new ArgumentException("An image element must be provided.");
    }
    this.reset();
    const element = this.prepareImageElement(source);
    this.imageElement = element;
    let task;
    if (this.isImageLoaded(element)) {
      task = this.decodeOnce(element, false, true);
    } else {
      task = this._decodeOnLoadImage(element);
    }
    return task;
  }
  /**
   * Decodes something from an image HTML element.
   */
  decodeFromVideoElement(source) {
    const element = this._decodeFromVideoElementSetup(source);
    return this._decodeOnLoadVideo(element);
  }
  /**
   * Decodes something from an image HTML element.
   */
  decodeFromVideoElementContinuously(source, callbackFn) {
    const element = this._decodeFromVideoElementSetup(source);
    return this._decodeOnLoadVideoContinuously(element, callbackFn);
  }
  /**
   * Sets up the video source so it can be decoded when loaded.
   *
   * @param source The video source element.
   */
  _decodeFromVideoElementSetup(source) {
    if (!source) {
      throw new ArgumentException("A video element must be provided.");
    }
    this.reset();
    const element = this.prepareVideoElement(source);
    this.videoElement = element;
    return element;
  }
  /**
   * Decodes an image from a URL.
   */
  decodeFromImageUrl(url) {
    if (!url) {
      throw new ArgumentException("An URL must be provided.");
    }
    this.reset();
    const element = this.prepareImageElement();
    this.imageElement = element;
    const decodeTask = this._decodeOnLoadImage(element);
    element.src = url;
    return decodeTask;
  }
  /**
   * Decodes an image from a URL.
   */
  decodeFromVideoUrl(url) {
    if (!url) {
      throw new ArgumentException("An URL must be provided.");
    }
    this.reset();
    const element = this.prepareVideoElement();
    const decodeTask = this.decodeFromVideoElement(element);
    element.src = url;
    return decodeTask;
  }
  /**
   * Decodes an image from a URL.
   *
   * @experimental
   */
  decodeFromVideoUrlContinuously(url, callbackFn) {
    if (!url) {
      throw new ArgumentException("An URL must be provided.");
    }
    this.reset();
    const element = this.prepareVideoElement();
    const decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
    element.src = url;
    return decodeTask;
  }
  _decodeOnLoadImage(element) {
    return new Promise((resolve, reject) => {
      this.imageLoadedListener = () => this.decodeOnce(element, false, true).then(resolve, reject);
      element.addEventListener("load", this.imageLoadedListener);
    });
  }
  async _decodeOnLoadVideo(videoElement) {
    await this.playVideoOnLoadAsync(videoElement);
    return await this.decodeOnce(videoElement);
  }
  async _decodeOnLoadVideoContinuously(videoElement, callbackFn) {
    await this.playVideoOnLoadAsync(videoElement);
    this.decodeContinuously(videoElement, callbackFn);
  }
  isImageLoaded(img) {
    if (!img.complete) {
      return false;
    }
    if (img.naturalWidth === 0) {
      return false;
    }
    return true;
  }
  prepareImageElement(imageSource) {
    let imageElement;
    if (typeof imageSource === "undefined") {
      imageElement = document.createElement("img");
      imageElement.width = 200;
      imageElement.height = 200;
    }
    if (typeof imageSource === "string") {
      imageElement = this.getMediaElement(imageSource, "img");
    }
    if (imageSource instanceof HTMLImageElement) {
      imageElement = imageSource;
    }
    return imageElement;
  }
  /**
   * Sets a HTMLVideoElement for scanning or creates a new one.
   *
   * @param videoSource The HTMLVideoElement to be set.
   */
  prepareVideoElement(videoSource) {
    let videoElement;
    if (!videoSource && typeof document !== "undefined") {
      videoElement = document.createElement("video");
      videoElement.width = 200;
      videoElement.height = 200;
    }
    if (typeof videoSource === "string") {
      videoElement = this.getMediaElement(videoSource, "video");
    }
    if (videoSource instanceof HTMLVideoElement) {
      videoElement = videoSource;
    }
    videoElement.setAttribute("autoplay", "true");
    videoElement.setAttribute("muted", "true");
    videoElement.setAttribute("playsinline", "true");
    return videoElement;
  }
  /**
   * Tries to decode from the video input until it finds some value.
   */
  decodeOnce(element, retryIfNotFound = true, retryIfChecksumOrFormatError = true) {
    this._stopAsyncDecode = false;
    const loop = (resolve, reject) => {
      if (this._stopAsyncDecode) {
        reject(new NotFoundException("Video stream has ended before any code could be detected."));
        this._stopAsyncDecode = void 0;
        return;
      }
      try {
        const result = this.decode(element);
        resolve(result);
      } catch (e) {
        const ifNotFound = retryIfNotFound && e instanceof NotFoundException;
        const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
        const ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
        if (ifNotFound || ifChecksumOrFormat) {
          return setTimeout(loop, this._timeBetweenDecodingAttempts, resolve, reject);
        }
        reject(e);
      }
    };
    return new Promise((resolve, reject) => loop(resolve, reject));
  }
  /**
   * Continuously decodes from video input.
   */
  decodeContinuously(element, callbackFn) {
    this._stopContinuousDecode = false;
    const loop = () => {
      if (this._stopContinuousDecode) {
        this._stopContinuousDecode = void 0;
        return;
      }
      try {
        const result = this.decode(element);
        callbackFn(result, null);
        setTimeout(loop, this.timeBetweenScansMillis);
      } catch (e) {
        callbackFn(null, e);
        const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
        const isNotFound = e instanceof NotFoundException;
        if (isChecksumOrFormatError || isNotFound) {
          setTimeout(loop, this._timeBetweenDecodingAttempts);
        }
      }
    };
    loop();
  }
  /**
   * Gets the BinaryBitmap for ya! (and decodes it)
   */
  decode(element) {
    const binaryBitmap = this.createBinaryBitmap(element);
    return this.decodeBitmap(binaryBitmap);
  }
  /**
   * Creates a binaryBitmap based in some image source.
   *
   * @param mediaElement HTML element containing drawable image source.
   */
  createBinaryBitmap(mediaElement) {
    this.getCaptureCanvasContext(mediaElement);
    if (mediaElement instanceof HTMLVideoElement) {
      this.drawFrameOnCanvas(mediaElement);
    } else {
      this.drawImageOnCanvas(mediaElement);
    }
    const canvas = this.getCaptureCanvas(mediaElement);
    const luminanceSource = new HTMLCanvasElementLuminanceSource(canvas);
    const hybridBinarizer = new HybridBinarizer(luminanceSource);
    return new BinaryBitmap(hybridBinarizer);
  }
  /**
   *
   */
  getCaptureCanvasContext(mediaElement) {
    if (!this.captureCanvasContext) {
      const elem = this.getCaptureCanvas(mediaElement);
      let ctx;
      try {
        ctx = elem.getContext("2d", { willReadFrequently: true });
      } catch (e) {
        ctx = elem.getContext("2d");
      }
      this.captureCanvasContext = ctx;
    }
    return this.captureCanvasContext;
  }
  /**
   *
   */
  getCaptureCanvas(mediaElement) {
    if (!this.captureCanvas) {
      const elem = this.createCaptureCanvas(mediaElement);
      this.captureCanvas = elem;
    }
    return this.captureCanvas;
  }
  /**
   * Overwriting this allows you to manipulate the next frame in anyway you want before decode.
   */
  drawFrameOnCanvas(srcElement, dimensions = {
    sx: 0,
    sy: 0,
    sWidth: srcElement.videoWidth,
    sHeight: srcElement.videoHeight,
    dx: 0,
    dy: 0,
    dWidth: srcElement.videoWidth,
    dHeight: srcElement.videoHeight
  }, canvasElementContext = this.captureCanvasContext) {
    canvasElementContext.drawImage(
      srcElement,
      dimensions.sx,
      dimensions.sy,
      dimensions.sWidth,
      dimensions.sHeight,
      dimensions.dx,
      dimensions.dy,
      dimensions.dWidth,
      dimensions.dHeight
    );
  }
  /**
   * Ovewriting this allows you to manipulate the snapshot image in anyway you want before decode.
   */
  drawImageOnCanvas(srcElement, dimensions = {
    sx: 0,
    sy: 0,
    sWidth: srcElement.naturalWidth,
    sHeight: srcElement.naturalHeight,
    dx: 0,
    dy: 0,
    dWidth: srcElement.naturalWidth,
    dHeight: srcElement.naturalHeight
  }, canvasElementContext = this.captureCanvasContext) {
    canvasElementContext.drawImage(
      srcElement,
      dimensions.sx,
      dimensions.sy,
      dimensions.sWidth,
      dimensions.sHeight,
      dimensions.dx,
      dimensions.dy,
      dimensions.dWidth,
      dimensions.dHeight
    );
  }
  /**
   * Call the encapsulated readers decode
   */
  decodeBitmap(binaryBitmap) {
    return this.reader.decode(binaryBitmap, this._hints);
  }
  /**
   * 🖌 Prepares the canvas for capture and scan frames.
   */
  createCaptureCanvas(mediaElement) {
    if (typeof document === "undefined") {
      this._destroyCaptureCanvas();
      return null;
    }
    const canvasElement = document.createElement("canvas");
    let width;
    let height;
    if (typeof mediaElement !== "undefined") {
      if (mediaElement instanceof HTMLVideoElement) {
        width = mediaElement.videoWidth;
        height = mediaElement.videoHeight;
      } else if (mediaElement instanceof HTMLImageElement) {
        width = mediaElement.naturalWidth || mediaElement.width;
        height = mediaElement.naturalHeight || mediaElement.height;
      }
    }
    canvasElement.style.width = width + "px";
    canvasElement.style.height = height + "px";
    canvasElement.width = width;
    canvasElement.height = height;
    return canvasElement;
  }
  /**
   * Stops the continuous scan and cleans the stream.
   */
  stopStreams() {
    if (this.stream) {
      this.stream.getVideoTracks().forEach((t) => t.stop());
      this.stream = void 0;
    }
    if (this._stopAsyncDecode === false) {
      this.stopAsyncDecode();
    }
    if (this._stopContinuousDecode === false) {
      this.stopContinuousDecode();
    }
  }
  /**
   * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
   *
   * @memberOf BrowserCodeReader
   */
  reset() {
    this.stopStreams();
    this._destroyVideoElement();
    this._destroyImageElement();
    this._destroyCaptureCanvas();
  }
  _destroyVideoElement() {
    if (!this.videoElement) {
      return;
    }
    if (typeof this.videoEndedListener !== "undefined") {
      this.videoElement.removeEventListener("ended", this.videoEndedListener);
    }
    if (typeof this.videoPlayingEventListener !== "undefined") {
      this.videoElement.removeEventListener("playing", this.videoPlayingEventListener);
    }
    if (typeof this.videoCanPlayListener !== "undefined") {
      this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener);
    }
    this.cleanVideoSource(this.videoElement);
    this.videoElement = void 0;
  }
  _destroyImageElement() {
    if (!this.imageElement) {
      return;
    }
    if (void 0 !== this.imageLoadedListener) {
      this.imageElement.removeEventListener("load", this.imageLoadedListener);
    }
    this.imageElement.src = void 0;
    this.imageElement.removeAttribute("src");
    this.imageElement = void 0;
  }
  /**
   * Cleans canvas references 🖌
   */
  _destroyCaptureCanvas() {
    this.captureCanvasContext = void 0;
    this.captureCanvas = void 0;
  }
  /**
   * Defines what the videoElement src will be.
   *
   * @param videoElement
   * @param stream
   */
  addVideoSource(videoElement, stream) {
    try {
      videoElement.srcObject = stream;
    } catch (err) {
      videoElement.src = URL.createObjectURL(stream);
    }
  }
  /**
   * Unbinds a HTML video src property.
   *
   * @param videoElement
   */
  cleanVideoSource(videoElement) {
    try {
      videoElement.srcObject = null;
    } catch (err) {
      videoElement.src = "";
    }
    this.videoElement.removeAttribute("src");
  }
}
var BarcodeFormat;
(function(BarcodeFormat2) {
  BarcodeFormat2[BarcodeFormat2["AZTEC"] = 0] = "AZTEC";
  BarcodeFormat2[BarcodeFormat2["CODABAR"] = 1] = "CODABAR";
  BarcodeFormat2[BarcodeFormat2["CODE_39"] = 2] = "CODE_39";
  BarcodeFormat2[BarcodeFormat2["CODE_93"] = 3] = "CODE_93";
  BarcodeFormat2[BarcodeFormat2["CODE_128"] = 4] = "CODE_128";
  BarcodeFormat2[BarcodeFormat2["DATA_MATRIX"] = 5] = "DATA_MATRIX";
  BarcodeFormat2[BarcodeFormat2["EAN_8"] = 6] = "EAN_8";
  BarcodeFormat2[BarcodeFormat2["EAN_13"] = 7] = "EAN_13";
  BarcodeFormat2[BarcodeFormat2["ITF"] = 8] = "ITF";
  BarcodeFormat2[BarcodeFormat2["MAXICODE"] = 9] = "MAXICODE";
  BarcodeFormat2[BarcodeFormat2["PDF_417"] = 10] = "PDF_417";
  BarcodeFormat2[BarcodeFormat2["QR_CODE"] = 11] = "QR_CODE";
  BarcodeFormat2[BarcodeFormat2["RSS_14"] = 12] = "RSS_14";
  BarcodeFormat2[BarcodeFormat2["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
  BarcodeFormat2[BarcodeFormat2["UPC_A"] = 14] = "UPC_A";
  BarcodeFormat2[BarcodeFormat2["UPC_E"] = 15] = "UPC_E";
  BarcodeFormat2[BarcodeFormat2["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})(BarcodeFormat || (BarcodeFormat = {}));
const BarcodeFormat$1 = BarcodeFormat;
class Result {
  // public constructor(private text: string,
  //               Uint8Array rawBytes,
  //               ResultPoconst resultPoints: Int32Array,
  //               BarcodeFormat format) {
  //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
  // }
  // public constructor(text: string,
  //               Uint8Array rawBytes,
  //               ResultPoconst resultPoints: Int32Array,
  //               BarcodeFormat format,
  //               long timestamp) {
  //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
  //        resultPoints, format, timestamp)
  // }
  constructor(text, rawBytes, numBits = rawBytes == null ? 0 : 8 * rawBytes.length, resultPoints, format, timestamp = System.currentTimeMillis()) {
    __publicField(this, "text");
    __publicField(this, "rawBytes");
    __publicField(this, "numBits");
    __publicField(this, "resultPoints");
    __publicField(this, "format");
    __publicField(this, "timestamp");
    __publicField(this, "resultMetadata");
    this.text = text;
    this.rawBytes = rawBytes;
    this.numBits = numBits;
    this.resultPoints = resultPoints;
    this.format = format;
    this.timestamp = timestamp;
    this.text = text;
    this.rawBytes = rawBytes;
    if (void 0 === numBits || null === numBits) {
      this.numBits = rawBytes === null || rawBytes === void 0 ? 0 : 8 * rawBytes.length;
    } else {
      this.numBits = numBits;
    }
    this.resultPoints = resultPoints;
    this.format = format;
    this.resultMetadata = null;
    if (void 0 === timestamp || null === timestamp) {
      this.timestamp = System.currentTimeMillis();
    } else {
      this.timestamp = timestamp;
    }
  }
  /**
   * @return raw text encoded by the barcode
   */
  getText() {
    return this.text;
  }
  /**
   * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
   */
  getRawBytes() {
    return this.rawBytes;
  }
  /**
   * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
   * @since 3.3.0
   */
  getNumBits() {
    return this.numBits;
  }
  /**
   * @return points related to the barcode in the image. These are typically points
   *         identifying finder patterns or the corners of the barcode. The exact meaning is
   *         specific to the type of barcode that was decoded.
   */
  getResultPoints() {
    return this.resultPoints;
  }
  /**
   * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
   */
  getBarcodeFormat() {
    return this.format;
  }
  /**
   * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
   *   {@code null}. This contains optional metadata about what was detected about the barcode,
   *   like orientation.
   */
  getResultMetadata() {
    return this.resultMetadata;
  }
  putMetadata(type, value) {
    if (this.resultMetadata === null) {
      this.resultMetadata = /* @__PURE__ */ new Map();
    }
    this.resultMetadata.set(type, value);
  }
  putAllMetadata(metadata) {
    if (metadata !== null) {
      if (this.resultMetadata === null) {
        this.resultMetadata = metadata;
      } else {
        this.resultMetadata = new Map(metadata);
      }
    }
  }
  addResultPoints(newPoints) {
    const oldPoints = this.resultPoints;
    if (oldPoints === null) {
      this.resultPoints = newPoints;
    } else if (newPoints !== null && newPoints.length > 0) {
      const allPoints = new Array(oldPoints.length + newPoints.length);
      System.arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
      System.arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
      this.resultPoints = allPoints;
    }
  }
  getTimestamp() {
    return this.timestamp;
  }
  /*@Override*/
  toString() {
    return this.text;
  }
}
var ResultMetadataType;
(function(ResultMetadataType2) {
  ResultMetadataType2[ResultMetadataType2["OTHER"] = 0] = "OTHER";
  ResultMetadataType2[ResultMetadataType2["ORIENTATION"] = 1] = "ORIENTATION";
  ResultMetadataType2[ResultMetadataType2["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
  ResultMetadataType2[ResultMetadataType2["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
  ResultMetadataType2[ResultMetadataType2["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
  ResultMetadataType2[ResultMetadataType2["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
  ResultMetadataType2[ResultMetadataType2["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
  ResultMetadataType2[ResultMetadataType2["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
  ResultMetadataType2[ResultMetadataType2["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
  ResultMetadataType2[ResultMetadataType2["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
  ResultMetadataType2[ResultMetadataType2["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
})(ResultMetadataType || (ResultMetadataType = {}));
const ResultMetadataType$1 = ResultMetadataType;
class AbstractGenericGF {
  constructor() {
    __publicField(this, "expTable");
    __publicField(this, "logTable");
  }
  /**
   * @return 2 to the power of a in GF(size)
   */
  exp(a) {
    return this.expTable[a];
  }
  /**
   * @return base 2 log of a in GF(size)
   */
  log(a) {
    if (a === 0) {
      throw new IllegalArgumentException();
    }
    return this.logTable[a];
  }
  /**
   * Implements both addition and subtraction -- they are the same in GF(size).
   *
   * @return sum/difference of a and b
   */
  static addOrSubtract(a, b) {
    return a ^ b;
  }
}
class GenericGFPoly {
  /**
   * @param field the {@link GenericGF} instance representing the field to use
   * to perform computations
   * @param coefficients coefficients as ints representing elements of GF(size), arranged
   * from most significant (highest-power term) coefficient to least significant
   * @throws IllegalArgumentException if argument is null or empty,
   * or if leading coefficient is 0 and this is not a
   * constant polynomial (that is, it is not the monomial "0")
   */
  constructor(field, coefficients) {
    __publicField(this, "field");
    __publicField(this, "coefficients");
    if (coefficients.length === 0) {
      throw new IllegalArgumentException();
    }
    this.field = field;
    const coefficientsLength = coefficients.length;
    if (coefficientsLength > 1 && coefficients[0] === 0) {
      let firstNonZero = 1;
      while (firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0) {
        firstNonZero++;
      }
      if (firstNonZero === coefficientsLength) {
        this.coefficients = Int32Array.from([0]);
      } else {
        this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
        System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
      }
    } else {
      this.coefficients = coefficients;
    }
  }
  getCoefficients() {
    return this.coefficients;
  }
  /**
   * @return degree of this polynomial
   */
  getDegree() {
    return this.coefficients.length - 1;
  }
  /**
   * @return true iff this polynomial is the monomial "0"
   */
  isZero() {
    return this.coefficients[0] === 0;
  }
  /**
   * @return coefficient of x^degree term in this polynomial
   */
  getCoefficient(degree) {
    return this.coefficients[this.coefficients.length - 1 - degree];
  }
  /**
   * @return evaluation of this polynomial at a given point
   */
  evaluateAt(a) {
    if (a === 0) {
      return this.getCoefficient(0);
    }
    const coefficients = this.coefficients;
    let result;
    if (a === 1) {
      result = 0;
      for (let i = 0, length = coefficients.length; i !== length; i++) {
        const coefficient = coefficients[i];
        result = AbstractGenericGF.addOrSubtract(result, coefficient);
      }
      return result;
    }
    result = coefficients[0];
    const size = coefficients.length;
    const field = this.field;
    for (let i = 1; i < size; i++) {
      result = AbstractGenericGF.addOrSubtract(field.multiply(a, result), coefficients[i]);
    }
    return result;
  }
  addOrSubtract(other) {
    if (!this.field.equals(other.field)) {
      throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
    }
    if (this.isZero()) {
      return other;
    }
    if (other.isZero()) {
      return this;
    }
    let smallerCoefficients = this.coefficients;
    let largerCoefficients = other.coefficients;
    if (smallerCoefficients.length > largerCoefficients.length) {
      const temp = smallerCoefficients;
      smallerCoefficients = largerCoefficients;
      largerCoefficients = temp;
    }
    let sumDiff = new Int32Array(largerCoefficients.length);
    const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
    System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
    for (let i = lengthDiff; i < largerCoefficients.length; i++) {
      sumDiff[i] = AbstractGenericGF.addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
    }
    return new GenericGFPoly(this.field, sumDiff);
  }
  multiply(other) {
    if (!this.field.equals(other.field)) {
      throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
    }
    if (this.isZero() || other.isZero()) {
      return this.field.getZero();
    }
    const aCoefficients = this.coefficients;
    const aLength = aCoefficients.length;
    const bCoefficients = other.coefficients;
    const bLength = bCoefficients.length;
    const product = new Int32Array(aLength + bLength - 1);
    const field = this.field;
    for (let i = 0; i < aLength; i++) {
      const aCoeff = aCoefficients[i];
      for (let j = 0; j < bLength; j++) {
        product[i + j] = AbstractGenericGF.addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
      }
    }
    return new GenericGFPoly(field, product);
  }
  multiplyScalar(scalar) {
    if (scalar === 0) {
      return this.field.getZero();
    }
    if (scalar === 1) {
      return this;
    }
    const size = this.coefficients.length;
    const field = this.field;
    const product = new Int32Array(size);
    const coefficients = this.coefficients;
    for (let i = 0; i < size; i++) {
      product[i] = field.multiply(coefficients[i], scalar);
    }
    return new GenericGFPoly(field, product);
  }
  multiplyByMonomial(degree, coefficient) {
    if (degree < 0) {
      throw new IllegalArgumentException();
    }
    if (coefficient === 0) {
      return this.field.getZero();
    }
    const coefficients = this.coefficients;
    const size = coefficients.length;
    const product = new Int32Array(size + degree);
    const field = this.field;
    for (let i = 0; i < size; i++) {
      product[i] = field.multiply(coefficients[i], coefficient);
    }
    return new GenericGFPoly(field, product);
  }
  divide(other) {
    if (!this.field.equals(other.field)) {
      throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
    }
    if (other.isZero()) {
      throw new IllegalArgumentException("Divide by 0");
    }
    const field = this.field;
    let quotient = field.getZero();
    let remainder = this;
    const denominatorLeadingTerm = other.getCoefficient(other.getDegree());
    const inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
    while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
      const degreeDifference = remainder.getDegree() - other.getDegree();
      const scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
      const term = other.multiplyByMonomial(degreeDifference, scale);
      const iterationQuotient = field.buildMonomial(degreeDifference, scale);
      quotient = quotient.addOrSubtract(iterationQuotient);
      remainder = remainder.addOrSubtract(term);
    }
    return [quotient, remainder];
  }
  /*@Override*/
  toString() {
    let result = "";
    for (let degree = this.getDegree(); degree >= 0; degree--) {
      let coefficient = this.getCoefficient(degree);
      if (coefficient !== 0) {
        if (coefficient < 0) {
          result += " - ";
          coefficient = -coefficient;
        } else {
          if (result.length > 0) {
            result += " + ";
          }
        }
        if (degree === 0 || coefficient !== 1) {
          const alphaPower = this.field.log(coefficient);
          if (alphaPower === 0) {
            result += "1";
          } else if (alphaPower === 1) {
            result += "a";
          } else {
            result += "a^";
            result += alphaPower;
          }
        }
        if (degree !== 0) {
          if (degree === 1) {
            result += "x";
          } else {
            result += "x^";
            result += degree;
          }
        }
      }
    }
    return result;
  }
}
class ArithmeticException extends Exception {
}
__publicField(ArithmeticException, "kind", "ArithmeticException");
const _GenericGF = class _GenericGF extends AbstractGenericGF {
  /**
   * Create a representation of GF(size) using the given primitive polynomial.
   *
   * @param primitive irreducible polynomial whose coefficients are represented by
   *  the bits of an int, where the least-significant bit represents the constant
   *  coefficient
   * @param size the size of the field
   * @param b the factor b in the generator polynomial can be 0- or 1-based
   *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
   *  In most cases it should be 1, but for QR code it is 0.
   */
  constructor(primitive, size, generatorBase) {
    super();
    __publicField(this, "primitive");
    __publicField(this, "size");
    __publicField(this, "generatorBase");
    __publicField(this, "zero");
    __publicField(this, "one");
    this.primitive = primitive;
    this.size = size;
    this.generatorBase = generatorBase;
    const expTable = new Int32Array(size);
    let x = 1;
    for (let i = 0; i < size; i++) {
      expTable[i] = x;
      x *= 2;
      if (x >= size) {
        x ^= primitive;
        x &= size - 1;
      }
    }
    this.expTable = expTable;
    const logTable = new Int32Array(size);
    for (let i = 0; i < size - 1; i++) {
      logTable[expTable[i]] = i;
    }
    this.logTable = logTable;
    this.zero = new GenericGFPoly(this, Int32Array.from([0]));
    this.one = new GenericGFPoly(this, Int32Array.from([1]));
  }
  getZero() {
    return this.zero;
  }
  getOne() {
    return this.one;
  }
  /**
   * @return the monomial representing coefficient * x^degree
   */
  buildMonomial(degree, coefficient) {
    if (degree < 0) {
      throw new IllegalArgumentException();
    }
    if (coefficient === 0) {
      return this.zero;
    }
    const coefficients = new Int32Array(degree + 1);
    coefficients[0] = coefficient;
    return new GenericGFPoly(this, coefficients);
  }
  /**
   * @return multiplicative inverse of a
   */
  inverse(a) {
    if (a === 0) {
      throw new ArithmeticException();
    }
    return this.expTable[this.size - this.logTable[a] - 1];
  }
  /**
   * @return product of a and b in GF(size)
   */
  multiply(a, b) {
    if (a === 0 || b === 0) {
      return 0;
    }
    return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
  }
  getSize() {
    return this.size;
  }
  getGeneratorBase() {
    return this.generatorBase;
  }
  /*@Override*/
  toString() {
    return "GF(0x" + Integer.toHexString(this.primitive) + "," + this.size + ")";
  }
  equals(o) {
    return o === this;
  }
};
__publicField(_GenericGF, "AZTEC_DATA_12", new _GenericGF(4201, 4096, 1));
// x^12 + x^6 + x^5 + x^3 + 1
__publicField(_GenericGF, "AZTEC_DATA_10", new _GenericGF(1033, 1024, 1));
// x^10 + x^3 + 1
__publicField(_GenericGF, "AZTEC_DATA_6", new _GenericGF(67, 64, 1));
// x^6 + x + 1
__publicField(_GenericGF, "AZTEC_PARAM", new _GenericGF(19, 16, 1));
// x^4 + x + 1
__publicField(_GenericGF, "QR_CODE_FIELD_256", new _GenericGF(285, 256, 0));
// x^8 + x^4 + x^3 + x^2 + 1
__publicField(_GenericGF, "DATA_MATRIX_FIELD_256", new _GenericGF(301, 256, 1));
// x^8 + x^5 + x^3 + x^2 + 1
__publicField(_GenericGF, "AZTEC_DATA_8", _GenericGF.DATA_MATRIX_FIELD_256);
__publicField(_GenericGF, "MAXICODE_FIELD_64", _GenericGF.AZTEC_DATA_6);
let GenericGF = _GenericGF;
class ReedSolomonException extends Exception {
}
__publicField(ReedSolomonException, "kind", "ReedSolomonException");
class IllegalStateException extends Exception {
}
__publicField(IllegalStateException, "kind", "IllegalStateException");
class ReedSolomonDecoder {
  constructor(field) {
    __publicField(this, "field");
    this.field = field;
  }
  /**
   * <p>Decodes given set of received codewords, which include both data and error-correction
   * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
   * in the input.</p>
   *
   * @param received data and error-correction codewords
   * @param twoS number of error-correction codewords available
   * @throws ReedSolomonException if decoding fails for any reason
   */
  decode(received, twoS) {
    const field = this.field;
    const poly = new GenericGFPoly(field, received);
    const syndromeCoefficients = new Int32Array(twoS);
    let noError = true;
    for (let i = 0; i < twoS; i++) {
      const evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
      syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
      if (evalResult !== 0) {
        noError = false;
      }
    }
    if (noError) {
      return;
    }
    const syndrome = new GenericGFPoly(field, syndromeCoefficients);
    const sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
    const sigma = sigmaOmega[0];
    const omega = sigmaOmega[1];
    const errorLocations = this.findErrorLocations(sigma);
    const errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
    for (let i = 0; i < errorLocations.length; i++) {
      const position = received.length - 1 - field.log(errorLocations[i]);
      if (position < 0) {
        throw new ReedSolomonException("Bad error location");
      }
      received[position] = GenericGF.addOrSubtract(received[position], errorMagnitudes[i]);
    }
  }
  runEuclideanAlgorithm(a, b, R) {
    if (a.getDegree() < b.getDegree()) {
      const temp = a;
      a = b;
      b = temp;
    }
    const field = this.field;
    let rLast = a;
    let r = b;
    let tLast = field.getZero();
    let t = field.getOne();
    while (r.getDegree() >= (R / 2 | 0)) {
      let rLastLast = rLast;
      let tLastLast = tLast;
      rLast = r;
      tLast = t;
      if (rLast.isZero()) {
        throw new ReedSolomonException("r_{i-1} was zero");
      }
      r = rLastLast;
      let q = field.getZero();
      const denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
      const dltInverse = field.inverse(denominatorLeadingTerm);
      while (r.getDegree() >= rLast.getDegree() && !r.isZero()) {
        const degreeDiff = r.getDegree() - rLast.getDegree();
        const scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
        q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
        r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
      }
      t = q.multiply(tLast).addOrSubtract(tLastLast);
      if (r.getDegree() >= rLast.getDegree()) {
        throw new IllegalStateException("Division algorithm failed to reduce polynomial?");
      }
    }
    const sigmaTildeAtZero = t.getCoefficient(0);
    if (sigmaTildeAtZero === 0) {
      throw new ReedSolomonException("sigmaTilde(0) was zero");
    }
    const inverse = field.inverse(sigmaTildeAtZero);
    const sigma = t.multiplyScalar(inverse);
    const omega = r.multiplyScalar(inverse);
    return [sigma, omega];
  }
  findErrorLocations(errorLocator) {
    const numErrors = errorLocator.getDegree();
    if (numErrors === 1) {
      return Int32Array.from([errorLocator.getCoefficient(1)]);
    }
    const result = new Int32Array(numErrors);
    let e = 0;
    const field = this.field;
    for (let i = 1; i < field.getSize() && e < numErrors; i++) {
      if (errorLocator.evaluateAt(i) === 0) {
        result[e] = field.inverse(i);
        e++;
      }
    }
    if (e !== numErrors) {
      throw new ReedSolomonException("Error locator degree does not match number of roots");
    }
    return result;
  }
  findErrorMagnitudes(errorEvaluator, errorLocations) {
    const s = errorLocations.length;
    const result = new Int32Array(s);
    const field = this.field;
    for (let i = 0; i < s; i++) {
      const xiInverse = field.inverse(errorLocations[i]);
      let denominator = 1;
      for (let j = 0; j < s; j++) {
        if (i !== j) {
          const term = field.multiply(errorLocations[j], xiInverse);
          const termPlus1 = (term & 1) === 0 ? term | 1 : term & ~1;
          denominator = field.multiply(denominator, termPlus1);
        }
      }
      result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
      if (field.getGeneratorBase() !== 0) {
        result[i] = field.multiply(result[i], xiInverse);
      }
    }
    return result;
  }
}
var ErrorCorrectionLevelValues;
(function(ErrorCorrectionLevelValues2) {
  ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["L"] = 0] = "L";
  ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["M"] = 1] = "M";
  ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["Q"] = 2] = "Q";
  ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["H"] = 3] = "H";
})(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
const _ErrorCorrectionLevel = class _ErrorCorrectionLevel {
  constructor(value, stringValue, bits) {
    __publicField(this, "value");
    __publicField(this, "stringValue");
    __publicField(this, "bits");
    this.value = value;
    this.stringValue = stringValue;
    this.bits = bits;
    _ErrorCorrectionLevel.FOR_BITS.set(bits, this);
    _ErrorCorrectionLevel.FOR_VALUE.set(value, this);
  }
  getValue() {
    return this.value;
  }
  getBits() {
    return this.bits;
  }
  static fromString(s) {
    switch (s) {
      case "L":
        return _ErrorCorrectionLevel.L;
      case "M":
        return _ErrorCorrectionLevel.M;
      case "Q":
        return _ErrorCorrectionLevel.Q;
      case "H":
        return _ErrorCorrectionLevel.H;
      default:
        throw new ArgumentException(s + "not available");
    }
  }
  toString() {
    return this.stringValue;
  }
  equals(o) {
    if (!(o instanceof _ErrorCorrectionLevel)) {
      return false;
    }
    const other = o;
    return this.value === other.value;
  }
  /**
   * @param bits int containing the two bits encoding a QR Code's error correction level
   * @return ErrorCorrectionLevel representing the encoded error correction level
   */
  static forBits(bits) {
    if (bits < 0 || bits >= _ErrorCorrectionLevel.FOR_BITS.size) {
      throw new IllegalArgumentException();
    }
    return _ErrorCorrectionLevel.FOR_BITS.get(bits);
  }
};
__publicField(_ErrorCorrectionLevel, "FOR_BITS", /* @__PURE__ */ new Map());
__publicField(_ErrorCorrectionLevel, "FOR_VALUE", /* @__PURE__ */ new Map());
/** L = ~7% correction */
__publicField(_ErrorCorrectionLevel, "L", new _ErrorCorrectionLevel(ErrorCorrectionLevelValues.L, "L", 1));
/** M = ~15% correction */
__publicField(_ErrorCorrectionLevel, "M", new _ErrorCorrectionLevel(ErrorCorrectionLevelValues.M, "M", 0));
/** Q = ~25% correction */
__publicField(_ErrorCorrectionLevel, "Q", new _ErrorCorrectionLevel(ErrorCorrectionLevelValues.Q, "Q", 3));
/** H = ~30% correction */
__publicField(_ErrorCorrectionLevel, "H", new _ErrorCorrectionLevel(ErrorCorrectionLevelValues.H, "H", 2));
let ErrorCorrectionLevel = _ErrorCorrectionLevel;
const _FormatInformation = class _FormatInformation {
  /*byte*/
  constructor(formatInfo) {
    __publicField(this, "errorCorrectionLevel");
    __publicField(this, "dataMask");
    this.errorCorrectionLevel = ErrorCorrectionLevel.forBits(formatInfo >> 3 & 3);
    this.dataMask = /*(byte) */
    formatInfo & 7;
  }
  static numBitsDiffering(a, b) {
    return Integer.bitCount(a ^ b);
  }
  /**
   * @param maskedFormatInfo1 format info indicator, with mask still applied
   * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
   *  to establish best match
   * @return information about the format it specifies, or {@code null}
   *  if doesn't seem to match any known pattern
   */
  static decodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2) {
    const formatInfo = _FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
    if (formatInfo !== null) {
      return formatInfo;
    }
    return _FormatInformation.doDecodeFormatInformation(
      maskedFormatInfo1 ^ _FormatInformation.FORMAT_INFO_MASK_QR,
      maskedFormatInfo2 ^ _FormatInformation.FORMAT_INFO_MASK_QR
    );
  }
  static doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2) {
    let bestDifference = Number.MAX_SAFE_INTEGER;
    let bestFormatInfo = 0;
    for (const decodeInfo of _FormatInformation.FORMAT_INFO_DECODE_LOOKUP) {
      const targetInfo = decodeInfo[0];
      if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) {
        return new _FormatInformation(decodeInfo[1]);
      }
      let bitsDifference = _FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
      if (bitsDifference < bestDifference) {
        bestFormatInfo = decodeInfo[1];
        bestDifference = bitsDifference;
      }
      if (maskedFormatInfo1 !== maskedFormatInfo2) {
        bitsDifference = _FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
        if (bitsDifference < bestDifference) {
          bestFormatInfo = decodeInfo[1];
          bestDifference = bitsDifference;
        }
      }
    }
    if (bestDifference <= 3) {
      return new _FormatInformation(bestFormatInfo);
    }
    return null;
  }
  getErrorCorrectionLevel() {
    return this.errorCorrectionLevel;
  }
  getDataMask() {
    return this.dataMask;
  }
  /*@Override*/
  hashCode() {
    return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
  }
  /*@Override*/
  equals(o) {
    if (!(o instanceof _FormatInformation)) {
      return false;
    }
    const other = o;
    return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
  }
};
__publicField(_FormatInformation, "FORMAT_INFO_MASK_QR", 21522);
/**
 * See ISO 18004:2006, Annex C, Table C.1
 */
__publicField(_FormatInformation, "FORMAT_INFO_DECODE_LOOKUP", [
  Int32Array.from([21522, 0]),
  Int32Array.from([20773, 1]),
  Int32Array.from([24188, 2]),
  Int32Array.from([23371, 3]),
  Int32Array.from([17913, 4]),
  Int32Array.from([16590, 5]),
  Int32Array.from([20375, 6]),
  Int32Array.from([19104, 7]),
  Int32Array.from([30660, 8]),
  Int32Array.from([29427, 9]),
  Int32Array.from([32170, 10]),
  Int32Array.from([30877, 11]),
  Int32Array.from([26159, 12]),
  Int32Array.from([25368, 13]),
  Int32Array.from([27713, 14]),
  Int32Array.from([26998, 15]),
  Int32Array.from([5769, 16]),
  Int32Array.from([5054, 17]),
  Int32Array.from([7399, 18]),
  Int32Array.from([6608, 19]),
  Int32Array.from([1890, 20]),
  Int32Array.from([597, 21]),
  Int32Array.from([3340, 22]),
  Int32Array.from([2107, 23]),
  Int32Array.from([13663, 24]),
  Int32Array.from([12392, 25]),
  Int32Array.from([16177, 26]),
  Int32Array.from([14854, 27]),
  Int32Array.from([9396, 28]),
  Int32Array.from([8579, 29]),
  Int32Array.from([11994, 30]),
  Int32Array.from([11245, 31])
]);
let FormatInformation = _FormatInformation;
class ECBlocks {
  constructor(ecCodewordsPerBlock, ...ecBlocks) {
    __publicField(this, "ecCodewordsPerBlock");
    __publicField(this, "ecBlocks");
    this.ecCodewordsPerBlock = ecCodewordsPerBlock;
    this.ecBlocks = ecBlocks;
  }
  getECCodewordsPerBlock() {
    return this.ecCodewordsPerBlock;
  }
  getNumBlocks() {
    let total = 0;
    const ecBlocks = this.ecBlocks;
    for (const ecBlock of ecBlocks) {
      total += ecBlock.getCount();
    }
    return total;
  }
  getTotalECCodewords() {
    return this.ecCodewordsPerBlock * this.getNumBlocks();
  }
  getECBlocks() {
    return this.ecBlocks;
  }
}
class ECB {
  /*int*/
  constructor(count, dataCodewords) {
    __publicField(this, "count");
    /*int*/
    __publicField(this, "dataCodewords");
    this.count = count;
    this.dataCodewords = dataCodewords;
  }
  getCount() {
    return this.count;
  }
  getDataCodewords() {
    return this.dataCodewords;
  }
}
const _Version = class _Version {
  /*int*/
  constructor(versionNumber, alignmentPatternCenters, ...ecBlocks) {
    __publicField(this, "versionNumber");
    __publicField(this, "alignmentPatternCenters");
    __publicField(this, "ecBlocks");
    __publicField(this, "totalCodewords");
    this.versionNumber = versionNumber;
    this.alignmentPatternCenters = alignmentPatternCenters;
    this.ecBlocks = ecBlocks;
    let total = 0;
    const ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
    const ecbArray = ecBlocks[0].getECBlocks();
    for (const ecBlock of ecbArray) {
      total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
    }
    this.totalCodewords = total;
  }
  getVersionNumber() {
    return this.versionNumber;
  }
  getAlignmentPatternCenters() {
    return this.alignmentPatternCenters;
  }
  getTotalCodewords() {
    return this.totalCodewords;
  }
  getDimensionForVersion() {
    return 17 + 4 * this.versionNumber;
  }
  getECBlocksForLevel(ecLevel) {
    return this.ecBlocks[ecLevel.getValue()];
  }
  /**
   * <p>Deduces version information purely from QR Code dimensions.</p>
   *
   * @param dimension dimension in modules
   * @return Version for a QR Code of that dimension
   * @throws FormatException if dimension is not 1 mod 4
   */
  static getProvisionalVersionForDimension(dimension) {
    if (dimension % 4 !== 1) {
      throw new FormatException();
    }
    try {
      return this.getVersionForNumber((dimension - 17) / 4);
    } catch (ignored) {
      throw new FormatException();
    }
  }
  static getVersionForNumber(versionNumber) {
    if (versionNumber < 1 || versionNumber > 40) {
      throw new IllegalArgumentException();
    }
    return _Version.VERSIONS[versionNumber - 1];
  }
  static decodeVersionInformation(versionBits) {
    let bestDifference = Number.MAX_SAFE_INTEGER;
    let bestVersion = 0;
    for (let i = 0; i < _Version.VERSION_DECODE_INFO.length; i++) {
      const targetVersion = _Version.VERSION_DECODE_INFO[i];
      if (targetVersion === versionBits) {
        return _Version.getVersionForNumber(i + 7);
      }
      const bitsDifference = FormatInformation.numBitsDiffering(versionBits, targetVersion);
      if (bitsDifference < bestDifference) {
        bestVersion = i + 7;
        bestDifference = bitsDifference;
      }
    }
    if (bestDifference <= 3) {
      return _Version.getVersionForNumber(bestVersion);
    }
    return null;
  }
  /**
   * See ISO 18004:2006 Annex E
   */
  buildFunctionPattern() {
    const dimension = this.getDimensionForVersion();
    const bitMatrix = new BitMatrix(dimension);
    bitMatrix.setRegion(0, 0, 9, 9);
    bitMatrix.setRegion(dimension - 8, 0, 8, 9);
    bitMatrix.setRegion(0, dimension - 8, 9, 8);
    const max = this.alignmentPatternCenters.length;
    for (let x = 0; x < max; x++) {
      const i = this.alignmentPatternCenters[x] - 2;
      for (let y = 0; y < max; y++) {
        if (x === 0 && (y === 0 || y === max - 1) || x === max - 1 && y === 0) {
          continue;
        }
        bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
      }
    }
    bitMatrix.setRegion(6, 9, 1, dimension - 17);
    bitMatrix.setRegion(9, 6, dimension - 17, 1);
    if (this.versionNumber > 6) {
      bitMatrix.setRegion(dimension - 11, 0, 3, 6);
      bitMatrix.setRegion(0, dimension - 11, 6, 3);
    }
    return bitMatrix;
  }
  /*@Override*/
  toString() {
    return "" + this.versionNumber;
  }
};
/**
 * See ISO 18004:2006 Annex D.
 * Element i represents the raw version bits that specify version i + 7
 */
__publicField(_Version, "VERSION_DECODE_INFO", Int32Array.from([
  31892,
  34236,
  39577,
  42195,
  48118,
  51042,
  55367,
  58893,
  63784,
  68472,
  70749,
  76311,
  79154,
  84390,
  87683,
  92361,
  96236,
  102084,
  102881,
  110507,
  110734,
  117786,
  119615,
  126325,
  127568,
  133589,
  136944,
  141498,
  145311,
  150283,
  152622,
  158308,
  161089,
  167017
]));
/**
 * See ISO 18004:2006 6.5.1 Table 9
 */
__publicField(_Version, "VERSIONS", [
  new _Version(
    1,
    new Int32Array(0),
    new ECBlocks(7, new ECB(1, 19)),
    new ECBlocks(10, new ECB(1, 16)),
    new ECBlocks(13, new ECB(1, 13)),
    new ECBlocks(17, new ECB(1, 9))
  ),
  new _Version(
    2,
    Int32Array.from([6, 18]),
    new ECBlocks(10, new ECB(1, 34)),
    new ECBlocks(16, new ECB(1, 28)),
    new ECBlocks(22, new ECB(1, 22)),
    new ECBlocks(28, new ECB(1, 16))
  ),
  new _Version(
    3,
    Int32Array.from([6, 22]),
    new ECBlocks(15, new ECB(1, 55)),
    new ECBlocks(26, new ECB(1, 44)),
    new ECBlocks(18, new ECB(2, 17)),
    new ECBlocks(22, new ECB(2, 13))
  ),
  new _Version(
    4,
    Int32Array.from([6, 26]),
    new ECBlocks(20, new ECB(1, 80)),
    new ECBlocks(18, new ECB(2, 32)),
    new ECBlocks(26, new ECB(2, 24)),
    new ECBlocks(16, new ECB(4, 9))
  ),
  new _Version(
    5,
    Int32Array.from([6, 30]),
    new ECBlocks(26, new ECB(1, 108)),
    new ECBlocks(24, new ECB(2, 43)),
    new ECBlocks(18, new ECB(2, 15), new ECB(2, 16)),
    new ECBlocks(22, new ECB(2, 11), new ECB(2, 12))
  ),
  new _Version(
    6,
    Int32Array.from([6, 34]),
    new ECBlocks(18, new ECB(2, 68)),
    new ECBlocks(16, new ECB(4, 27)),
    new ECBlocks(24, new ECB(4, 19)),
    new ECBlocks(28, new ECB(4, 15))
  ),
  new _Version(
    7,
    Int32Array.from([6, 22, 38]),
    new ECBlocks(20, new ECB(2, 78)),
    new ECBlocks(18, new ECB(4, 31)),
    new ECBlocks(18, new ECB(2, 14), new ECB(4, 15)),
    new ECBlocks(26, new ECB(4, 13), new ECB(1, 14))
  ),
  new _Version(
    8,
    Int32Array.from([6, 24, 42]),
    new ECBlocks(24, new ECB(2, 97)),
    new ECBlocks(22, new ECB(2, 38), new ECB(2, 39)),
    new ECBlocks(22, new ECB(4, 18), new ECB(2, 19)),
    new ECBlocks(26, new ECB(4, 14), new ECB(2, 15))
  ),
  new _Version(
    9,
    Int32Array.from([6, 26, 46]),
    new ECBlocks(30, new ECB(2, 116)),
    new ECBlocks(22, new ECB(3, 36), new ECB(2, 37)),
    new ECBlocks(20, new ECB(4, 16), new ECB(4, 17)),
    new ECBlocks(24, new ECB(4, 12), new ECB(4, 13))
  ),
  new _Version(
    10,
    Int32Array.from([6, 28, 50]),
    new ECBlocks(18, new ECB(2, 68), new ECB(2, 69)),
    new ECBlocks(26, new ECB(4, 43), new ECB(1, 44)),
    new ECBlocks(24, new ECB(6, 19), new ECB(2, 20)),
    new ECBlocks(28, new ECB(6, 15), new ECB(2, 16))
  ),
  new _Version(
    11,
    Int32Array.from([6, 30, 54]),
    new ECBlocks(20, new ECB(4, 81)),
    new ECBlocks(30, new ECB(1, 50), new ECB(4, 51)),
    new ECBlocks(28, new ECB(4, 22), new ECB(4, 23)),
    new ECBlocks(24, new ECB(3, 12), new ECB(8, 13))
  ),
  new _Version(
    12,
    Int32Array.from([6, 32, 58]),
    new ECBlocks(24, new ECB(2, 92), new ECB(2, 93)),
    new ECBlocks(22, new ECB(6, 36), new ECB(2, 37)),
    new ECBlocks(26, new ECB(4, 20), new ECB(6, 21)),
    new ECBlocks(28, new ECB(7, 14), new ECB(4, 15))
  ),
  new _Version(
    13,
    Int32Array.from([6, 34, 62]),
    new ECBlocks(26, new ECB(4, 107)),
    new ECBlocks(22, new ECB(8, 37), new ECB(1, 38)),
    new ECBlocks(24, new ECB(8, 20), new ECB(4, 21)),
    new ECBlocks(22, new ECB(12, 11), new ECB(4, 12))
  ),
  new _Version(
    14,
    Int32Array.from([6, 26, 46, 66]),
    new ECBlocks(30, new ECB(3, 115), new ECB(1, 116)),
    new ECBlocks(24, new ECB(4, 40), new ECB(5, 41)),
    new ECBlocks(20, new ECB(11, 16), new ECB(5, 17)),
    new ECBlocks(24, new ECB(11, 12), new ECB(5, 13))
  ),
  new _Version(
    15,
    Int32Array.from([6, 26, 48, 70]),
    new ECBlocks(22, new ECB(5, 87), new ECB(1, 88)),
    new ECBlocks(24, new ECB(5, 41), new ECB(5, 42)),
    new ECBlocks(30, new ECB(5, 24), new ECB(7, 25)),
    new ECBlocks(24, new ECB(11, 12), new ECB(7, 13))
  ),
  new _Version(
    16,
    Int32Array.from([6, 26, 50, 74]),
    new ECBlocks(24, new ECB(5, 98), new ECB(1, 99)),
    new ECBlocks(28, new ECB(7, 45), new ECB(3, 46)),
    new ECBlocks(24, new ECB(15, 19), new ECB(2, 20)),
    new ECBlocks(30, new ECB(3, 15), new ECB(13, 16))
  ),
  new _Version(
    17,
    Int32Array.from([6, 30, 54, 78]),
    new ECBlocks(28, new ECB(1, 107), new ECB(5, 108)),
    new ECBlocks(28, new ECB(10, 46), new ECB(1, 47)),
    new ECBlocks(28, new ECB(1, 22), new ECB(15, 23)),
    new ECBlocks(28, new ECB(2, 14), new ECB(17, 15))
  ),
  new _Version(
    18,
    Int32Array.from([6, 30, 56, 82]),
    new ECBlocks(30, new ECB(5, 120), new ECB(1, 121)),
    new ECBlocks(26, new ECB(9, 43), new ECB(4, 44)),
    new ECBlocks(28, new ECB(17, 22), new ECB(1, 23)),
    new ECBlocks(28, new ECB(2, 14), new ECB(19, 15))
  ),
  new _Version(
    19,
    Int32Array.from([6, 30, 58, 86]),
    new ECBlocks(28, new ECB(3, 113), new ECB(4, 114)),
    new ECBlocks(26, new ECB(3, 44), new ECB(11, 45)),
    new ECBlocks(26, new ECB(17, 21), new ECB(4, 22)),
    new ECBlocks(26, new ECB(9, 13), new ECB(16, 14))
  ),
  new _Version(
    20,
    Int32Array.from([6, 34, 62, 90]),
    new ECBlocks(28, new ECB(3, 107), new ECB(5, 108)),
    new ECBlocks(26, new ECB(3, 41), new ECB(13, 42)),
    new ECBlocks(30, new ECB(15, 24), new ECB(5, 25)),
    new ECBlocks(28, new ECB(15, 15), new ECB(10, 16))
  ),
  new _Version(
    21,
    Int32Array.from([6, 28, 50, 72, 94]),
    new ECBlocks(28, new ECB(4, 116), new ECB(4, 117)),
    new ECBlocks(26, new ECB(17, 42)),
    new ECBlocks(28, new ECB(17, 22), new ECB(6, 23)),
    new ECBlocks(30, new ECB(19, 16), new ECB(6, 17))
  ),
  new _Version(
    22,
    Int32Array.from([6, 26, 50, 74, 98]),
    new ECBlocks(28, new ECB(2, 111), new ECB(7, 112)),
    new ECBlocks(28, new ECB(17, 46)),
    new ECBlocks(30, new ECB(7, 24), new ECB(16, 25)),
    new ECBlocks(24, new ECB(34, 13))
  ),
  new _Version(
    23,
    Int32Array.from([6, 30, 54, 78, 102]),
    new ECBlocks(30, new ECB(4, 121), new ECB(5, 122)),
    new ECBlocks(28, new ECB(4, 47), new ECB(14, 48)),
    new ECBlocks(30, new ECB(11, 24), new ECB(14, 25)),
    new ECBlocks(30, new ECB(16, 15), new ECB(14, 16))
  ),
  new _Version(
    24,
    Int32Array.from([6, 28, 54, 80, 106]),
    new ECBlocks(30, new ECB(6, 117), new ECB(4, 118)),
    new ECBlocks(28, new ECB(6, 45), new ECB(14, 46)),
    new ECBlocks(30, new ECB(11, 24), new ECB(16, 25)),
    new ECBlocks(30, new ECB(30, 16), new ECB(2, 17))
  ),
  new _Version(
    25,
    Int32Array.from([6, 32, 58, 84, 110]),
    new ECBlocks(26, new ECB(8, 106), new ECB(4, 107)),
    new ECBlocks(28, new ECB(8, 47), new ECB(13, 48)),
    new ECBlocks(30, new ECB(7, 24), new ECB(22, 25)),
    new ECBlocks(30, new ECB(22, 15), new ECB(13, 16))
  ),
  new _Version(
    26,
    Int32Array.from([6, 30, 58, 86, 114]),
    new ECBlocks(28, new ECB(10, 114), new ECB(2, 115)),
    new ECBlocks(28, new ECB(19, 46), new ECB(4, 47)),
    new ECBlocks(28, new ECB(28, 22), new ECB(6, 23)),
    new ECBlocks(30, new ECB(33, 16), new ECB(4, 17))
  ),
  new _Version(
    27,
    Int32Array.from([6, 34, 62, 90, 118]),
    new ECBlocks(30, new ECB(8, 122), new ECB(4, 123)),
    new ECBlocks(28, new ECB(22, 45), new ECB(3, 46)),
    new ECBlocks(30, new ECB(8, 23), new ECB(26, 24)),
    new ECBlocks(30, new ECB(12, 15), new ECB(28, 16))
  ),
  new _Version(
    28,
    Int32Array.from([6, 26, 50, 74, 98, 122]),
    new ECBlocks(30, new ECB(3, 117), new ECB(10, 118)),
    new ECBlocks(28, new ECB(3, 45), new ECB(23, 46)),
    new ECBlocks(30, new ECB(4, 24), new ECB(31, 25)),
    new ECBlocks(30, new ECB(11, 15), new ECB(31, 16))
  ),
  new _Version(
    29,
    Int32Array.from([6, 30, 54, 78, 102, 126]),
    new ECBlocks(30, new ECB(7, 116), new ECB(7, 117)),
    new ECBlocks(28, new ECB(21, 45), new ECB(7, 46)),
    new ECBlocks(30, new ECB(1, 23), new ECB(37, 24)),
    new ECBlocks(30, new ECB(19, 15), new ECB(26, 16))
  ),
  new _Version(
    30,
    Int32Array.from([6, 26, 52, 78, 104, 130]),
    new ECBlocks(30, new ECB(5, 115), new ECB(10, 116)),
    new ECBlocks(28, new ECB(19, 47), new ECB(10, 48)),
    new ECBlocks(30, new ECB(15, 24), new ECB(25, 25)),
    new ECBlocks(30, new ECB(23, 15), new ECB(25, 16))
  ),
  new _Version(
    31,
    Int32Array.from([6, 30, 56, 82, 108, 134]),
    new ECBlocks(30, new ECB(13, 115), new ECB(3, 116)),
    new ECBlocks(28, new ECB(2, 46), new ECB(29, 47)),
    new ECBlocks(30, new ECB(42, 24), new ECB(1, 25)),
    new ECBlocks(30, new ECB(23, 15), new ECB(28, 16))
  ),
  new _Version(
    32,
    Int32Array.from([6, 34, 60, 86, 112, 138]),
    new ECBlocks(30, new ECB(17, 115)),
    new ECBlocks(28, new ECB(10, 46), new ECB(23, 47)),
    new ECBlocks(30, new ECB(10, 24), new ECB(35, 25)),
    new ECBlocks(30, new ECB(19, 15), new ECB(35, 16))
  ),
  new _Version(
    33,
    Int32Array.from([6, 30, 58, 86, 114, 142]),
    new ECBlocks(30, new ECB(17, 115), new ECB(1, 116)),
    new ECBlocks(28, new ECB(14, 46), new ECB(21, 47)),
    new ECBlocks(30, new ECB(29, 24), new ECB(19, 25)),
    new ECBlocks(30, new ECB(11, 15), new ECB(46, 16))
  ),
  new _Version(
    34,
    Int32Array.from([6, 34, 62, 90, 118, 146]),
    new ECBlocks(30, new ECB(13, 115), new ECB(6, 116)),
    new ECBlocks(28, new ECB(14, 46), new ECB(23, 47)),
    new ECBlocks(30, new ECB(44, 24), new ECB(7, 25)),
    new ECBlocks(30, new ECB(59, 16), new ECB(1, 17))
  ),
  new _Version(
    35,
    Int32Array.from([6, 30, 54, 78, 102, 126, 150]),
    new ECBlocks(30, new ECB(12, 121), new ECB(7, 122)),
    new ECBlocks(28, new ECB(12, 47), new ECB(26, 48)),
    new ECBlocks(30, new ECB(39, 24), new ECB(14, 25)),
    new ECBlocks(30, new ECB(22, 15), new ECB(41, 16))
  ),
  new _Version(
    36,
    Int32Array.from([6, 24, 50, 76, 102, 128, 154]),
    new ECBlocks(30, new ECB(6, 121), new ECB(14, 122)),
    new ECBlocks(28, new ECB(6, 47), new ECB(34, 48)),
    new ECBlocks(30, new ECB(46, 24), new ECB(10, 25)),
    new ECBlocks(30, new ECB(2, 15), new ECB(64, 16))
  ),
  new _Version(
    37,
    Int32Array.from([6, 28, 54, 80, 106, 132, 158]),
    new ECBlocks(30, new ECB(17, 122), new ECB(4, 123)),
    new ECBlocks(28, new ECB(29, 46), new ECB(14, 47)),
    new ECBlocks(30, new ECB(49, 24), new ECB(10, 25)),
    new ECBlocks(30, new ECB(24, 15), new ECB(46, 16))
  ),
  new _Version(
    38,
    Int32Array.from([6, 32, 58, 84, 110, 136, 162]),
    new ECBlocks(30, new ECB(4, 122), new ECB(18, 123)),
    new ECBlocks(28, new ECB(13, 46), new ECB(32, 47)),
    new ECBlocks(30, new ECB(48, 24), new ECB(14, 25)),
    new ECBlocks(30, new ECB(42, 15), new ECB(32, 16))
  ),
  new _Version(
    39,
    Int32Array.from([6, 26, 54, 82, 110, 138, 166]),
    new ECBlocks(30, new ECB(20, 117), new ECB(4, 118)),
    new ECBlocks(28, new ECB(40, 47), new ECB(7, 48)),
    new ECBlocks(30, new ECB(43, 24), new ECB(22, 25)),
    new ECBlocks(30, new ECB(10, 15), new ECB(67, 16))
  ),
  new _Version(
    40,
    Int32Array.from([6, 30, 58, 86, 114, 142, 170]),
    new ECBlocks(30, new ECB(19, 118), new ECB(6, 119)),
    new ECBlocks(28, new ECB(18, 47), new ECB(31, 48)),
    new ECBlocks(30, new ECB(34, 24), new ECB(34, 25)),
    new ECBlocks(30, new ECB(20, 15), new ECB(61, 16))
  )
]);
let Version = _Version;
var DataMaskValues;
(function(DataMaskValues2) {
  DataMaskValues2[DataMaskValues2["DATA_MASK_000"] = 0] = "DATA_MASK_000";
  DataMaskValues2[DataMaskValues2["DATA_MASK_001"] = 1] = "DATA_MASK_001";
  DataMaskValues2[DataMaskValues2["DATA_MASK_010"] = 2] = "DATA_MASK_010";
  DataMaskValues2[DataMaskValues2["DATA_MASK_011"] = 3] = "DATA_MASK_011";
  DataMaskValues2[DataMaskValues2["DATA_MASK_100"] = 4] = "DATA_MASK_100";
  DataMaskValues2[DataMaskValues2["DATA_MASK_101"] = 5] = "DATA_MASK_101";
  DataMaskValues2[DataMaskValues2["DATA_MASK_110"] = 6] = "DATA_MASK_110";
  DataMaskValues2[DataMaskValues2["DATA_MASK_111"] = 7] = "DATA_MASK_111";
})(DataMaskValues || (DataMaskValues = {}));
const _DataMask = class _DataMask {
  // See ISO 18004:2006 6.8.1
  constructor(value, isMasked) {
    __publicField(this, "value");
    __publicField(this, "isMasked");
    this.value = value;
    this.isMasked = isMasked;
  }
  // End of enum constants.
  /**
   * <p>Implementations of this method reverse the data masking process applied to a QR Code and
   * make its bits ready to read.</p>
   *
   * @param bits representation of QR Code bits
   * @param dimension dimension of QR Code, represented by bits, being unmasked
   */
  unmaskBitMatrix(bits, dimension) {
    for (let i = 0; i < dimension; i++) {
      for (let j = 0; j < dimension; j++) {
        if (this.isMasked(i, j)) {
          bits.flip(j, i);
        }
      }
    }
  }
};
__publicField(_DataMask, "values", /* @__PURE__ */ new Map([
  /**
   * 000: mask bits for which (x + y) mod 2 == 0
   */
  [
    DataMaskValues.DATA_MASK_000,
    new _DataMask(DataMaskValues.DATA_MASK_000, (i, j) => {
      return (i + j & 1) === 0;
    })
  ],
  /**
   * 001: mask bits for which x mod 2 == 0
   */
  [
    DataMaskValues.DATA_MASK_001,
    new _DataMask(DataMaskValues.DATA_MASK_001, (i, j) => {
      return (i & 1) === 0;
    })
  ],
  /**
   * 010: mask bits for which y mod 3 == 0
   */
  [
    DataMaskValues.DATA_MASK_010,
    new _DataMask(DataMaskValues.DATA_MASK_010, (i, j) => {
      return j % 3 === 0;
    })
  ],
  /**
   * 011: mask bits for which (x + y) mod 3 == 0
   */
  [
    DataMaskValues.DATA_MASK_011,
    new _DataMask(DataMaskValues.DATA_MASK_011, (i, j) => {
      return (i + j) % 3 === 0;
    })
  ],
  /**
   * 100: mask bits for which (x/2 + y/3) mod 2 == 0
   */
  [
    DataMaskValues.DATA_MASK_100,
    new _DataMask(DataMaskValues.DATA_MASK_100, (i, j) => {
      return (Math.floor(i / 2) + Math.floor(j / 3) & 1) === 0;
    })
  ],
  /**
   * 101: mask bits for which xy mod 2 + xy mod 3 == 0
   * equivalently, such that xy mod 6 == 0
   */
  [
    DataMaskValues.DATA_MASK_101,
    new _DataMask(DataMaskValues.DATA_MASK_101, (i, j) => {
      return i * j % 6 === 0;
    })
  ],
  /**
   * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
   * equivalently, such that xy mod 6 < 3
   */
  [
    DataMaskValues.DATA_MASK_110,
    new _DataMask(DataMaskValues.DATA_MASK_110, (i, j) => {
      return i * j % 6 < 3;
    })
  ],
  /**
   * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
   * equivalently, such that (x + y + xy mod 3) mod 2 == 0
   */
  [
    DataMaskValues.DATA_MASK_111,
    new _DataMask(DataMaskValues.DATA_MASK_111, (i, j) => {
      return (i + j + i * j % 3 & 1) === 0;
    })
  ]
]));
let DataMask = _DataMask;
class BitMatrixParser {
  /**
   * @param bitMatrix {@link BitMatrix} to parse
   * @throws FormatException if dimension is not >= 21 and 1 mod 4
   */
  constructor(bitMatrix) {
    __publicField(this, "bitMatrix");
    __publicField(this, "parsedVersion");
    __publicField(this, "parsedFormatInfo");
    __publicField(this, "isMirror");
    const dimension = bitMatrix.getHeight();
    if (dimension < 21 || (dimension & 3) !== 1) {
      throw new FormatException();
    }
    this.bitMatrix = bitMatrix;
  }
  /**
   * <p>Reads format information from one of its two locations within the QR Code.</p>
   *
   * @return {@link FormatInformation} encapsulating the QR Code's format info
   * @throws FormatException if both format information locations cannot be parsed as
   * the valid encoding of format information
   */
  readFormatInformation() {
    if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== void 0) {
      return this.parsedFormatInfo;
    }
    let formatInfoBits1 = 0;
    for (let i = 0; i < 6; i++) {
      formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
    }
    formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
    formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
    formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
    for (let j = 5; j >= 0; j--) {
      formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
    }
    const dimension = this.bitMatrix.getHeight();
    let formatInfoBits2 = 0;
    const jMin = dimension - 7;
    for (let j = dimension - 1; j >= jMin; j--) {
      formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
    }
    for (let i = dimension - 8; i < dimension; i++) {
      formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
    }
    this.parsedFormatInfo = FormatInformation.decodeFormatInformation(formatInfoBits1, formatInfoBits2);
    if (this.parsedFormatInfo !== null) {
      return this.parsedFormatInfo;
    }
    throw new FormatException();
  }
  /**
   * <p>Reads version information from one of its two locations within the QR Code.</p>
   *
   * @return {@link Version} encapsulating the QR Code's version
   * @throws FormatException if both version information locations cannot be parsed as
   * the valid encoding of version information
   */
  readVersion() {
    if (this.parsedVersion !== null && this.parsedVersion !== void 0) {
      return this.parsedVersion;
    }
    const dimension = this.bitMatrix.getHeight();
    const provisionalVersion = Math.floor((dimension - 17) / 4);
    if (provisionalVersion <= 6) {
      return Version.getVersionForNumber(provisionalVersion);
    }
    let versionBits = 0;
    const ijMin = dimension - 11;
    for (let j = 5; j >= 0; j--) {
      for (let i = dimension - 9; i >= ijMin; i--) {
        versionBits = this.copyBit(i, j, versionBits);
      }
    }
    let theParsedVersion = Version.decodeVersionInformation(versionBits);
    if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
      this.parsedVersion = theParsedVersion;
      return theParsedVersion;
    }
    versionBits = 0;
    for (let i = 5; i >= 0; i--) {
      for (let j = dimension - 9; j >= ijMin; j--) {
        versionBits = this.copyBit(i, j, versionBits);
      }
    }
    theParsedVersion = Version.decodeVersionInformation(versionBits);
    if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
      this.parsedVersion = theParsedVersion;
      return theParsedVersion;
    }
    throw new FormatException();
  }
  copyBit(i, j, versionBits) {
    const bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
    return bit ? versionBits << 1 | 1 : versionBits << 1;
  }
  /**
   * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
   * correct order in order to reconstruct the codewords bytes contained within the
   * QR Code.</p>
   *
   * @return bytes encoded within the QR Code
   * @throws FormatException if the exact number of bytes expected is not read
   */
  readCodewords() {
    const formatInfo = this.readFormatInformation();
    const version = this.readVersion();
    const dataMask = DataMask.values.get(formatInfo.getDataMask());
    const dimension = this.bitMatrix.getHeight();
    dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
    const functionPattern = version.buildFunctionPattern();
    let readingUp = true;
    const result = new Uint8Array(version.getTotalCodewords());
    let resultOffset = 0;
    let currentByte = 0;
    let bitsRead = 0;
    for (let j = dimension - 1; j > 0; j -= 2) {
      if (j === 6) {
        j--;
      }
      for (let count = 0; count < dimension; count++) {
        const i = readingUp ? dimension - 1 - count : count;
        for (let col = 0; col < 2; col++) {
          if (!functionPattern.get(j - col, i)) {
            bitsRead++;
            currentByte <<= 1;
            if (this.bitMatrix.get(j - col, i)) {
              currentByte |= 1;
            }
            if (bitsRead === 8) {
              result[resultOffset++] = /*(byte) */
              currentByte;
              bitsRead = 0;
              currentByte = 0;
            }
          }
        }
      }
      readingUp = !readingUp;
    }
    if (resultOffset !== version.getTotalCodewords()) {
      throw new FormatException();
    }
    return result;
  }
  /**
   * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
   */
  remask() {
    if (this.parsedFormatInfo === null) {
      return;
    }
    const dataMask = DataMask.values[this.parsedFormatInfo.getDataMask()];
    const dimension = this.bitMatrix.getHeight();
    dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
  }
  /**
   * Prepare the parser for a mirrored operation.
   * This flag has effect only on the {@link #readFormatInformation()} and the
   * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
   * {@link #mirror()} method should be called.
   *
   * @param mirror Whether to read version and format information mirrored.
   */
  setMirror(isMirror) {
    this.parsedVersion = null;
    this.parsedFormatInfo = null;
    this.isMirror = isMirror;
  }
  /** Mirror the bit matrix in order to attempt a second reading. */
  mirror() {
    const bitMatrix = this.bitMatrix;
    for (let x = 0, width = bitMatrix.getWidth(); x < width; x++) {
      for (let y = x + 1, height = bitMatrix.getHeight(); y < height; y++) {
        if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
          bitMatrix.flip(y, x);
          bitMatrix.flip(x, y);
        }
      }
    }
  }
}
class DataBlock {
  constructor(numDataCodewords, codewords) {
    __publicField(this, "numDataCodewords");
    __publicField(this, "codewords");
    this.numDataCodewords = numDataCodewords;
    this.codewords = codewords;
  }
  /**
   * <p>When QR Codes use multiple data blocks, they are actually interleaved.
   * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
   * method will separate the data into original blocks.</p>
   *
   * @param rawCodewords bytes as read directly from the QR Code
   * @param version version of the QR Code
   * @param ecLevel error-correction level of the QR Code
   * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
   *         QR Code
   */
  static getDataBlocks(rawCodewords, version, ecLevel) {
    if (rawCodewords.length !== version.getTotalCodewords()) {
      throw new IllegalArgumentException();
    }
    const ecBlocks = version.getECBlocksForLevel(ecLevel);
    let totalBlocks = 0;
    const ecBlockArray = ecBlocks.getECBlocks();
    for (const ecBlock of ecBlockArray) {
      totalBlocks += ecBlock.getCount();
    }
    const result = new Array(totalBlocks);
    let numResultBlocks = 0;
    for (const ecBlock of ecBlockArray) {
      for (let i = 0; i < ecBlock.getCount(); i++) {
        const numDataCodewords = ecBlock.getDataCodewords();
        const numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
        result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
      }
    }
    const shorterBlocksTotalCodewords = result[0].codewords.length;
    let longerBlocksStartAt = result.length - 1;
    while (longerBlocksStartAt >= 0) {
      const numCodewords = result[longerBlocksStartAt].codewords.length;
      if (numCodewords === shorterBlocksTotalCodewords) {
        break;
      }
      longerBlocksStartAt--;
    }
    longerBlocksStartAt++;
    const shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
    let rawCodewordsOffset = 0;
    for (let i = 0; i < shorterBlocksNumDataCodewords; i++) {
      for (let j = 0; j < numResultBlocks; j++) {
        result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
      }
    }
    for (let j = longerBlocksStartAt; j < numResultBlocks; j++) {
      result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
    }
    const max = result[0].codewords.length;
    for (let i = shorterBlocksNumDataCodewords; i < max; i++) {
      for (let j = 0; j < numResultBlocks; j++) {
        const iOffset = j < longerBlocksStartAt ? i : i + 1;
        result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
      }
    }
    return result;
  }
  getNumDataCodewords() {
    return this.numDataCodewords;
  }
  getCodewords() {
    return this.codewords;
  }
}
class BitSource {
  /*int*/
  /**
   * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
   * Bits are read within a byte from most-significant to least-significant bit.
   */
  constructor(bytes) {
    __publicField(this, "bytes");
    __publicField(this, "byteOffset");
    /*int*/
    __publicField(this, "bitOffset");
    this.bytes = bytes;
    this.byteOffset = 0;
    this.bitOffset = 0;
  }
  /**
   * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
   */
  getBitOffset() {
    return this.bitOffset;
  }
  /**
   * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
   */
  getByteOffset() {
    return this.byteOffset;
  }
  /**
   * @param numBits number of bits to read
   * @return int representing the bits read. The bits will appear as the least-significant
   *         bits of the int
   * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
   */
  readBits(numBits) {
    if (numBits < 1 || numBits > 32 || numBits > this.available()) {
      throw new IllegalArgumentException("" + numBits);
    }
    let result = 0;
    let bitOffset = this.bitOffset;
    let byteOffset = this.byteOffset;
    const bytes = this.bytes;
    if (bitOffset > 0) {
      const bitsLeft = 8 - bitOffset;
      const toRead = numBits < bitsLeft ? numBits : bitsLeft;
      const bitsToNotRead = bitsLeft - toRead;
      const mask = 255 >> 8 - toRead << bitsToNotRead;
      result = (bytes[byteOffset] & mask) >> bitsToNotRead;
      numBits -= toRead;
      bitOffset += toRead;
      if (bitOffset === 8) {
        bitOffset = 0;
        byteOffset++;
      }
    }
    if (numBits > 0) {
      while (numBits >= 8) {
        result = result << 8 | bytes[byteOffset] & 255;
        byteOffset++;
        numBits -= 8;
      }
      if (numBits > 0) {
        const bitsToNotRead = 8 - numBits;
        const mask = 255 >> bitsToNotRead << bitsToNotRead;
        result = result << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
        bitOffset += numBits;
      }
    }
    this.bitOffset = bitOffset;
    this.byteOffset = byteOffset;
    return result;
  }
  /**
   * @return number of bits that can be read successfully
   */
  available() {
    return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
  }
}
class DecoderResult {
  // public constructor(rawBytes: Uint8Array,
  //                      text: string,
  //                      List<Uint8Array> byteSegments,
  //                      String ecLevel) {
  //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
  // }
  constructor(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber = -1, structuredAppendParity = -1) {
    __publicField(this, "rawBytes");
    __publicField(this, "text");
    __publicField(this, "byteSegments");
    __publicField(this, "ecLevel");
    __publicField(this, "structuredAppendSequenceNumber");
    __publicField(this, "structuredAppendParity");
    __publicField(this, "numBits");
    /*int*/
    __publicField(this, "errorsCorrected");
    /*Integer*/
    __publicField(this, "erasures");
    /*Integer*/
    __publicField(this, "other");
    this.rawBytes = rawBytes;
    this.text = text;
    this.byteSegments = byteSegments;
    this.ecLevel = ecLevel;
    this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
    this.structuredAppendParity = structuredAppendParity;
    this.numBits = rawBytes === void 0 || rawBytes === null ? 0 : 8 * rawBytes.length;
  }
  /**
   * @return raw bytes representing the result, or {@code null} if not applicable
   */
  getRawBytes() {
    return this.rawBytes;
  }
  /**
   * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
   * @since 3.3.0
   */
  getNumBits() {
    return this.numBits;
  }
  /**
   * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
   * @since 3.3.0
   */
  setNumBits(numBits) {
    this.numBits = numBits;
  }
  /**
   * @return text representation of the result
   */
  getText() {
    return this.text;
  }
  /**
   * @return list of byte segments in the result, or {@code null} if not applicable
   */
  getByteSegments() {
    return this.byteSegments;
  }
  /**
   * @return name of error correction level used, or {@code null} if not applicable
   */
  getECLevel() {
    return this.ecLevel;
  }
  /**
   * @return number of errors corrected, or {@code null} if not applicable
   */
  getErrorsCorrected() {
    return this.errorsCorrected;
  }
  setErrorsCorrected(errorsCorrected) {
    this.errorsCorrected = errorsCorrected;
  }
  /**
   * @return number of erasures corrected, or {@code null} if not applicable
   */
  getErasures() {
    return this.erasures;
  }
  setErasures(erasures) {
    this.erasures = erasures;
  }
  /**
   * @return arbitrary additional metadata
   */
  getOther() {
    return this.other;
  }
  setOther(other) {
    this.other = other;
  }
  hasStructuredAppend() {
    return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
  }
  getStructuredAppendParity() {
    return this.structuredAppendParity;
  }
  getStructuredAppendSequenceNumber() {
    return this.structuredAppendSequenceNumber;
  }
}
var ModeValues;
(function(ModeValues2) {
  ModeValues2[ModeValues2["TERMINATOR"] = 0] = "TERMINATOR";
  ModeValues2[ModeValues2["NUMERIC"] = 1] = "NUMERIC";
  ModeValues2[ModeValues2["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
  ModeValues2[ModeValues2["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
  ModeValues2[ModeValues2["BYTE"] = 4] = "BYTE";
  ModeValues2[ModeValues2["ECI"] = 5] = "ECI";
  ModeValues2[ModeValues2["KANJI"] = 6] = "KANJI";
  ModeValues2[ModeValues2["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
  ModeValues2[ModeValues2["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
  ModeValues2[ModeValues2["HANZI"] = 9] = "HANZI";
})(ModeValues || (ModeValues = {}));
const _Mode = class _Mode {
  constructor(value, stringValue, characterCountBitsForVersions, bits) {
    __publicField(this, "value");
    __publicField(this, "stringValue");
    __publicField(this, "characterCountBitsForVersions");
    __publicField(this, "bits");
    this.value = value;
    this.stringValue = stringValue;
    this.characterCountBitsForVersions = characterCountBitsForVersions;
    this.bits = bits;
    _Mode.FOR_BITS.set(bits, this);
    _Mode.FOR_VALUE.set(value, this);
  }
  /**
   * @param bits four bits encoding a QR Code data mode
   * @return Mode encoded by these bits
   * @throws IllegalArgumentException if bits do not correspond to a known mode
   */
  static forBits(bits) {
    const mode = _Mode.FOR_BITS.get(bits);
    if (void 0 === mode) {
      throw new IllegalArgumentException();
    }
    return mode;
  }
  /**
   * @param version version in question
   * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
   *         count of characters that will follow encoded in this Mode
   */
  getCharacterCountBits(version) {
    const versionNumber = version.getVersionNumber();
    let offset;
    if (versionNumber <= 9) {
      offset = 0;
    } else if (versionNumber <= 26) {
      offset = 1;
    } else {
      offset = 2;
    }
    return this.characterCountBitsForVersions[offset];
  }
  getValue() {
    return this.value;
  }
  getBits() {
    return this.bits;
  }
  equals(o) {
    if (!(o instanceof _Mode)) {
      return false;
    }
    const other = o;
    return this.value === other.value;
  }
  toString() {
    return this.stringValue;
  }
};
__publicField(_Mode, "FOR_BITS", /* @__PURE__ */ new Map());
__publicField(_Mode, "FOR_VALUE", /* @__PURE__ */ new Map());
__publicField(_Mode, "TERMINATOR", new _Mode(ModeValues.TERMINATOR, "TERMINATOR", Int32Array.from([0, 0, 0]), 0));
// Not really a mode...
__publicField(_Mode, "NUMERIC", new _Mode(ModeValues.NUMERIC, "NUMERIC", Int32Array.from([10, 12, 14]), 1));
__publicField(_Mode, "ALPHANUMERIC", new _Mode(ModeValues.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([9, 11, 13]), 2));
__publicField(_Mode, "STRUCTURED_APPEND", new _Mode(
  ModeValues.STRUCTURED_APPEND,
  "STRUCTURED_APPEND",
  Int32Array.from([0, 0, 0]),
  3
));
// Not supported
__publicField(_Mode, "BYTE", new _Mode(ModeValues.BYTE, "BYTE", Int32Array.from([8, 16, 16]), 4));
__publicField(_Mode, "ECI", new _Mode(ModeValues.ECI, "ECI", Int32Array.from([0, 0, 0]), 7));
// character counts don't apply
__publicField(_Mode, "KANJI", new _Mode(ModeValues.KANJI, "KANJI", Int32Array.from([8, 10, 12]), 8));
__publicField(_Mode, "FNC1_FIRST_POSITION", new _Mode(
  ModeValues.FNC1_FIRST_POSITION,
  "FNC1_FIRST_POSITION",
  Int32Array.from([0, 0, 0]),
  5
));
__publicField(_Mode, "FNC1_SECOND_POSITION", new _Mode(
  ModeValues.FNC1_SECOND_POSITION,
  "FNC1_SECOND_POSITION",
  Int32Array.from([0, 0, 0]),
  9
));
/** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */
__publicField(_Mode, "HANZI", new _Mode(ModeValues.HANZI, "HANZI", Int32Array.from([8, 10, 12]), 13));
let Mode = _Mode;
const _DecodedBitStreamParser = class _DecodedBitStreamParser {
  static decode(bytes, version, ecLevel, hints) {
    const bits = new BitSource(bytes);
    let result = new StringBuilder();
    const byteSegments = new Array();
    let symbolSequence = -1;
    let parityData = -1;
    try {
      let currentCharacterSetECI = null;
      let fc1InEffect = false;
      let mode;
      do {
        if (bits.available() < 4) {
          mode = Mode.TERMINATOR;
        } else {
          const modeBits = bits.readBits(4);
          mode = Mode.forBits(modeBits);
        }
        switch (mode) {
          case Mode.TERMINATOR:
            break;
          case Mode.FNC1_FIRST_POSITION:
          case Mode.FNC1_SECOND_POSITION:
            fc1InEffect = true;
            break;
          case Mode.STRUCTURED_APPEND:
            if (bits.available() < 16) {
              throw new FormatException();
            }
            symbolSequence = bits.readBits(8);
            parityData = bits.readBits(8);
            break;
          case Mode.ECI:
            const value = _DecodedBitStreamParser.parseECIValue(bits);
            currentCharacterSetECI = CharacterSetECI.getCharacterSetECIByValue(value);
            if (currentCharacterSetECI === null) {
              throw new FormatException();
            }
            break;
          case Mode.HANZI:
            const subset = bits.readBits(4);
            const countHanzi = bits.readBits(mode.getCharacterCountBits(version));
            if (subset === _DecodedBitStreamParser.GB2312_SUBSET) {
              _DecodedBitStreamParser.decodeHanziSegment(bits, result, countHanzi);
            }
            break;
          default:
            const count = bits.readBits(mode.getCharacterCountBits(version));
            switch (mode) {
              case Mode.NUMERIC:
                _DecodedBitStreamParser.decodeNumericSegment(bits, result, count);
                break;
              case Mode.ALPHANUMERIC:
                _DecodedBitStreamParser.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                break;
              case Mode.BYTE:
                _DecodedBitStreamParser.decodeByteSegment(
                  bits,
                  result,
                  count,
                  currentCharacterSetECI,
                  byteSegments,
                  hints
                );
                break;
              case Mode.KANJI:
                _DecodedBitStreamParser.decodeKanjiSegment(bits, result, count);
                break;
              default:
                throw new FormatException();
            }
            break;
        }
      } while (mode !== Mode.TERMINATOR);
    } catch (iae) {
      throw new FormatException();
    }
    return new DecoderResult(
      bytes,
      result.toString(),
      byteSegments.length === 0 ? null : byteSegments,
      ecLevel === null ? null : ecLevel.toString(),
      symbolSequence,
      parityData
    );
  }
  /**
   * See specification GBT 18284-2000
   */
  static decodeHanziSegment(bits, result, count) {
    if (count * 13 > bits.available()) {
      throw new FormatException();
    }
    const buffer = new Uint8Array(2 * count);
    let offset = 0;
    while (count > 0) {
      const twoBytes = bits.readBits(13);
      let assembledTwoBytes = twoBytes / 96 << 8 & 4294967295 | twoBytes % 96;
      if (assembledTwoBytes < 959) {
        assembledTwoBytes += 41377;
      } else {
        assembledTwoBytes += 42657;
      }
      buffer[offset] = /*(byte) */
      assembledTwoBytes >> 8 & 255;
      buffer[offset + 1] = /*(byte) */
      assembledTwoBytes & 255;
      offset += 2;
      count--;
    }
    try {
      result.append(StringEncoding.decode(buffer, StringUtils.GB2312));
    } catch (ignored) {
      throw new FormatException(ignored);
    }
  }
  static decodeKanjiSegment(bits, result, count) {
    if (count * 13 > bits.available()) {
      throw new FormatException();
    }
    const buffer = new Uint8Array(2 * count);
    let offset = 0;
    while (count > 0) {
      const twoBytes = bits.readBits(13);
      let assembledTwoBytes = twoBytes / 192 << 8 & 4294967295 | twoBytes % 192;
      if (assembledTwoBytes < 7936) {
        assembledTwoBytes += 33088;
      } else {
        assembledTwoBytes += 49472;
      }
      buffer[offset] = /*(byte) */
      assembledTwoBytes >> 8;
      buffer[offset + 1] = /*(byte) */
      assembledTwoBytes;
      offset += 2;
      count--;
    }
    try {
      result.append(StringEncoding.decode(buffer, StringUtils.SHIFT_JIS));
    } catch (ignored) {
      throw new FormatException(ignored);
    }
  }
  static decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints) {
    if (8 * count > bits.available()) {
      throw new FormatException();
    }
    const readBytes = new Uint8Array(count);
    for (let i = 0; i < count; i++) {
      readBytes[i] = /*(byte) */
      bits.readBits(8);
    }
    let encoding;
    if (currentCharacterSetECI === null) {
      encoding = StringUtils.guessEncoding(readBytes, hints);
    } else {
      encoding = currentCharacterSetECI.getName();
    }
    try {
      result.append(StringEncoding.decode(readBytes, encoding));
    } catch (ignored) {
      throw new FormatException(ignored);
    }
    byteSegments.push(readBytes);
  }
  static toAlphaNumericChar(value) {
    if (value >= _DecodedBitStreamParser.ALPHANUMERIC_CHARS.length) {
      throw new FormatException();
    }
    return _DecodedBitStreamParser.ALPHANUMERIC_CHARS[value];
  }
  static decodeAlphanumericSegment(bits, result, count, fc1InEffect) {
    const start = result.length();
    while (count > 1) {
      if (bits.available() < 11) {
        throw new FormatException();
      }
      const nextTwoCharsBits = bits.readBits(11);
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(nextTwoCharsBits % 45));
      count -= 2;
    }
    if (count === 1) {
      if (bits.available() < 6) {
        throw new FormatException();
      }
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(bits.readBits(6)));
    }
    if (fc1InEffect) {
      for (let i = start; i < result.length(); i++) {
        if (result.charAt(i) === "%") {
          if (i < result.length() - 1 && result.charAt(i + 1) === "%") {
            result.deleteCharAt(i + 1);
          } else {
            result.setCharAt(i, String.fromCharCode(29));
          }
        }
      }
    }
  }
  static decodeNumericSegment(bits, result, count) {
    while (count >= 3) {
      if (bits.available() < 10) {
        throw new FormatException();
      }
      const threeDigitsBits = bits.readBits(10);
      if (threeDigitsBits >= 1e3) {
        throw new FormatException();
      }
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(threeDigitsBits % 10));
      count -= 3;
    }
    if (count === 2) {
      if (bits.available() < 7) {
        throw new FormatException();
      }
      const twoDigitsBits = bits.readBits(7);
      if (twoDigitsBits >= 100) {
        throw new FormatException();
      }
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(twoDigitsBits % 10));
    } else if (count === 1) {
      if (bits.available() < 4) {
        throw new FormatException();
      }
      const digitBits = bits.readBits(4);
      if (digitBits >= 10) {
        throw new FormatException();
      }
      result.append(_DecodedBitStreamParser.toAlphaNumericChar(digitBits));
    }
  }
  static parseECIValue(bits) {
    const firstByte = bits.readBits(8);
    if ((firstByte & 128) === 0) {
      return firstByte & 127;
    }
    if ((firstByte & 192) === 128) {
      const secondByte = bits.readBits(8);
      return (firstByte & 63) << 8 & 4294967295 | secondByte;
    }
    if ((firstByte & 224) === 192) {
      const secondThirdBytes = bits.readBits(16);
      return (firstByte & 31) << 16 & 4294967295 | secondThirdBytes;
    }
    throw new FormatException();
  }
};
/**
 * See ISO 18004:2006, 6.4.4 Table 5
 */
__publicField(_DecodedBitStreamParser, "ALPHANUMERIC_CHARS", "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:");
__publicField(_DecodedBitStreamParser, "GB2312_SUBSET", 1);
let DecodedBitStreamParser = _DecodedBitStreamParser;
class QRCodeDecoderMetaData {
  constructor(mirrored) {
    __publicField(this, "mirrored");
    this.mirrored = mirrored;
  }
  /**
   * @return true if the QR Code was mirrored.
   */
  isMirrored() {
    return this.mirrored;
  }
  /**
   * Apply the result points' order correction due to mirroring.
   *
   * @param points Array of points to apply mirror correction to.
   */
  applyMirroredCorrection(points) {
    if (!this.mirrored || points === null || points.length < 3) {
      return;
    }
    const bottomLeft = points[0];
    points[0] = points[2];
    points[2] = bottomLeft;
  }
}
class Decoder {
  constructor() {
    __publicField(this, "rsDecoder");
    this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
  }
  // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
  //   return decode(image, null)
  // }
  /**
   * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
   * "true" is taken to mean a black module.</p>
   *
   * @param image booleans representing white/black QR Code modules
   * @param hints decoding hints that should be used to influence decoding
   * @return text and bytes encoded within the QR Code
   * @throws FormatException if the QR Code cannot be decoded
   * @throws ChecksumException if error correction fails
   */
  decodeBooleanArray(image, hints) {
    return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(image), hints);
  }
  // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
  //   return decode(bits, null)
  // }
  /**
   * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
   *
   * @param bits booleans representing white/black QR Code modules
   * @param hints decoding hints that should be used to influence decoding
   * @return text and bytes encoded within the QR Code
   * @throws FormatException if the QR Code cannot be decoded
   * @throws ChecksumException if error correction fails
   */
  decodeBitMatrix(bits, hints) {
    const parser = new BitMatrixParser(bits);
    let ex = null;
    try {
      return this.decodeBitMatrixParser(parser, hints);
    } catch (e) {
      ex = e;
    }
    try {
      parser.remask();
      parser.setMirror(true);
      parser.readVersion();
      parser.readFormatInformation();
      parser.mirror();
      const result = this.decodeBitMatrixParser(parser, hints);
      result.setOther(new QRCodeDecoderMetaData(true));
      return result;
    } catch (e) {
      if (ex !== null) {
        throw ex;
      }
      throw e;
    }
  }
  decodeBitMatrixParser(parser, hints) {
    const version = parser.readVersion();
    const ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
    const codewords = parser.readCodewords();
    const dataBlocks = DataBlock.getDataBlocks(codewords, version, ecLevel);
    let totalBytes = 0;
    for (const dataBlock of dataBlocks) {
      totalBytes += dataBlock.getNumDataCodewords();
    }
    const resultBytes = new Uint8Array(totalBytes);
    let resultOffset = 0;
    for (const dataBlock of dataBlocks) {
      const codewordBytes = dataBlock.getCodewords();
      const numDataCodewords = dataBlock.getNumDataCodewords();
      this.correctErrors(codewordBytes, numDataCodewords);
      for (let i = 0; i < numDataCodewords; i++) {
        resultBytes[resultOffset++] = codewordBytes[i];
      }
    }
    return DecodedBitStreamParser.decode(resultBytes, version, ecLevel, hints);
  }
  /**
   * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
   * correct the errors in-place using Reed-Solomon error correction.</p>
   *
   * @param codewordBytes data and error correction codewords
   * @param numDataCodewords number of codewords that are data bytes
   * @throws ChecksumException if error correction fails
   */
  correctErrors(codewordBytes, numDataCodewords) {
    const codewordsInts = new Int32Array(codewordBytes);
    try {
      this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
    } catch (ignored) {
      throw new ChecksumException();
    }
    for (let i = 0; i < numDataCodewords; i++) {
      codewordBytes[i] = /*(byte) */
      codewordsInts[i];
    }
  }
}
class MathUtils {
  constructor() {
  }
  /**
   * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
   * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
   * differ slightly from {@link Math#round(float)} in that half rounds down for negative
   * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
   *
   * @param d real value to round
   * @return nearest {@code int}
   */
  static round(d) {
    if (isNaN(d))
      return 0;
    if (d <= Number.MIN_SAFE_INTEGER)
      return Number.MIN_SAFE_INTEGER;
    if (d >= Number.MAX_SAFE_INTEGER)
      return Number.MAX_SAFE_INTEGER;
    return (
      /*(int) */
      d + (d < 0 ? -0.5 : 0.5) | 0
    );
  }
  // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
  /**
   * @param aX point A x coordinate
   * @param aY point A y coordinate
   * @param bX point B x coordinate
   * @param bY point B y coordinate
   * @return Euclidean distance between points A and B
   */
  static distance(aX, aY, bX, bY) {
    const xDiff = aX - bX;
    const yDiff = aY - bY;
    return (
      /*(float) */
      Math.sqrt(xDiff * xDiff + yDiff * yDiff)
    );
  }
  /**
   * @param aX point A x coordinate
   * @param aY point A y coordinate
   * @param bX point B x coordinate
   * @param bY point B y coordinate
   * @return Euclidean distance between points A and B
   */
  // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
  //   const xDiff = aX - bX
  //   const yDiff = aY - bY
  //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
  // }
  /**
   * @param array values to sum
   * @return sum of values in array
   */
  static sum(array) {
    let count = 0;
    for (let i = 0, length = array.length; i !== length; i++) {
      const a = array[i];
      count += a;
    }
    return count;
  }
}
class DetectorResult {
  constructor(bits, points) {
    __publicField(this, "bits");
    __publicField(this, "points");
    this.bits = bits;
    this.points = points;
  }
  getBits() {
    return this.bits;
  }
  getPoints() {
    return this.points;
  }
}
class GridSampler {
  /**
   * <p>Checks a set of points that have been transformed to sample points on an image against
   * the image's dimensions to see if the point are even within the image.</p>
   *
   * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
   * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
   * patterns in an image where the QR Code runs all the way to the image border.</p>
   *
   * <p>For efficiency, the method will check points from either end of the line until one is found
   * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
   *
   * @param image image into which the points should map
   * @param points actual points in x1,y1,...,xn,yn form
   * @throws NotFoundException if an endpoint is lies outside the image boundaries
   */
  static checkAndNudgePoints(image, points) {
    const width = image.getWidth();
    const height = image.getHeight();
    let nudged = true;
    for (let offset = 0; offset < points.length && nudged; offset += 2) {
      const x = Math.floor(points[offset]);
      const y = Math.floor(points[offset + 1]);
      if (x < -1 || x > width || y < -1 || y > height) {
        throw new NotFoundException();
      }
      nudged = false;
      if (x === -1) {
        points[offset] = 0;
        nudged = true;
      } else if (x === width) {
        points[offset] = width - 1;
        nudged = true;
      }
      if (y === -1) {
        points[offset + 1] = 0;
        nudged = true;
      } else if (y === height) {
        points[offset + 1] = height - 1;
        nudged = true;
      }
    }
    nudged = true;
    for (let offset = points.length - 2; offset >= 0 && nudged; offset -= 2) {
      const x = Math.floor(points[offset]);
      const y = Math.floor(points[offset + 1]);
      if (x < -1 || x > width || y < -1 || y > height) {
        throw new NotFoundException();
      }
      nudged = false;
      if (x === -1) {
        points[offset] = 0;
        nudged = true;
      } else if (x === width) {
        points[offset] = width - 1;
        nudged = true;
      }
      if (y === -1) {
        points[offset + 1] = 0;
        nudged = true;
      } else if (y === height) {
        points[offset + 1] = height - 1;
        nudged = true;
      }
    }
  }
}
class PerspectiveTransform {
  constructor(a11, a21, a31, a12, a22, a32, a13, a23, a33) {
    __publicField(this, "a11");
    __publicField(this, "a21");
    __publicField(this, "a31");
    __publicField(this, "a12");
    __publicField(this, "a22");
    __publicField(this, "a32");
    __publicField(this, "a13");
    __publicField(this, "a23");
    __publicField(this, "a33");
    this.a11 = a11;
    this.a21 = a21;
    this.a31 = a31;
    this.a12 = a12;
    this.a22 = a22;
    this.a32 = a32;
    this.a13 = a13;
    this.a23 = a23;
    this.a33 = a33;
  }
  static quadrilateralToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3, x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p) {
    const qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
    const sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
    return sToQ.times(qToS);
  }
  transformPoints(points) {
    const max = points.length;
    const a11 = this.a11;
    const a12 = this.a12;
    const a13 = this.a13;
    const a21 = this.a21;
    const a22 = this.a22;
    const a23 = this.a23;
    const a31 = this.a31;
    const a32 = this.a32;
    const a33 = this.a33;
    for (let i = 0; i < max; i += 2) {
      const x = points[i];
      const y = points[i + 1];
      const denominator = a13 * x + a23 * y + a33;
      points[i] = (a11 * x + a21 * y + a31) / denominator;
      points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
    }
  }
  transformPointsWithValues(xValues, yValues) {
    const a11 = this.a11;
    const a12 = this.a12;
    const a13 = this.a13;
    const a21 = this.a21;
    const a22 = this.a22;
    const a23 = this.a23;
    const a31 = this.a31;
    const a32 = this.a32;
    const a33 = this.a33;
    const n = xValues.length;
    for (let i = 0; i < n; i++) {
      const x = xValues[i];
      const y = yValues[i];
      const denominator = a13 * x + a23 * y + a33;
      xValues[i] = (a11 * x + a21 * y + a31) / denominator;
      yValues[i] = (a12 * x + a22 * y + a32) / denominator;
    }
  }
  static squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3) {
    const dx3 = x0 - x1 + x2 - x3;
    const dy3 = y0 - y1 + y2 - y3;
    if (dx3 === 0 && dy3 === 0) {
      return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0, 0, 1);
    } else {
      const dx1 = x1 - x2;
      const dx2 = x3 - x2;
      const dy1 = y1 - y2;
      const dy2 = y3 - y2;
      const denominator = dx1 * dy2 - dx2 * dy1;
      const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
      const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
      return new PerspectiveTransform(
        x1 - x0 + a13 * x1,
        x3 - x0 + a23 * x3,
        x0,
        y1 - y0 + a13 * y1,
        y3 - y0 + a23 * y3,
        y0,
        a13,
        a23,
        1
      );
    }
  }
  static quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3) {
    return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
  }
  buildAdjoint() {
    return new PerspectiveTransform(
      this.a22 * this.a33 - this.a23 * this.a32,
      this.a23 * this.a31 - this.a21 * this.a33,
      this.a21 * this.a32 - this.a22 * this.a31,
      this.a13 * this.a32 - this.a12 * this.a33,
      this.a11 * this.a33 - this.a13 * this.a31,
      this.a12 * this.a31 - this.a11 * this.a32,
      this.a12 * this.a23 - this.a13 * this.a22,
      this.a13 * this.a21 - this.a11 * this.a23,
      this.a11 * this.a22 - this.a12 * this.a21
    );
  }
  times(other) {
    return new PerspectiveTransform(
      this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13,
      this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23,
      this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33,
      this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13,
      this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23,
      this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33,
      this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13,
      this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23,
      this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33
    );
  }
}
class DefaultGridSampler extends GridSampler {
  /*@Override*/
  sampleGrid(image, dimensionX, dimensionY, p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY) {
    const transform = PerspectiveTransform.quadrilateralToQuadrilateral(
      p1ToX,
      p1ToY,
      p2ToX,
      p2ToY,
      p3ToX,
      p3ToY,
      p4ToX,
      p4ToY,
      p1FromX,
      p1FromY,
      p2FromX,
      p2FromY,
      p3FromX,
      p3FromY,
      p4FromX,
      p4FromY
    );
    return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
  }
  /*@Override*/
  sampleGridWithTransform(image, dimensionX, dimensionY, transform) {
    if (dimensionX <= 0 || dimensionY <= 0) {
      throw new NotFoundException();
    }
    const bits = new BitMatrix(dimensionX, dimensionY);
    const points = new Float32Array(2 * dimensionX);
    for (let y = 0; y < dimensionY; y++) {
      const max = points.length;
      const iValue = y + 0.5;
      for (let x = 0; x < max; x += 2) {
        points[x] = x / 2 + 0.5;
        points[x + 1] = iValue;
      }
      transform.transformPoints(points);
      GridSampler.checkAndNudgePoints(image, points);
      try {
        for (let x = 0; x < max; x += 2) {
          if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) {
            bits.set(x / 2, y);
          }
        }
      } catch (aioobe) {
        throw new NotFoundException();
      }
    }
    return bits;
  }
}
const _GridSamplerInstance = class _GridSamplerInstance {
  /**
   * Sets the implementation of GridSampler used by the library. One global
   * instance is stored, which may sound problematic. But, the implementation provided
   * ought to be appropriate for the entire platform, and all uses of this library
   * in the whole lifetime of the JVM. For instance, an Android activity can swap in
   * an implementation that takes advantage of native platform libraries.
   *
   * @param newGridSampler The platform-specific object to install.
   */
  static setGridSampler(newGridSampler) {
    _GridSamplerInstance.gridSampler = newGridSampler;
  }
  /**
   * @return the current implementation of GridSampler
   */
  static getInstance() {
    return _GridSamplerInstance.gridSampler;
  }
};
__publicField(_GridSamplerInstance, "gridSampler", new DefaultGridSampler());
let GridSamplerInstance = _GridSamplerInstance;
class Float {
  /**
   * SincTS has no difference between int and float, there's all numbers,
   * this is used only to polyfill Java code.
   */
  static floatToIntBits(f) {
    return f;
  }
}
/**
 * The float max value in JS is the number max value.
 */
__publicField(Float, "MAX_VALUE", Number.MAX_SAFE_INTEGER);
class ResultPoint {
  constructor(x, y) {
    __publicField(this, "x");
    __publicField(this, "y");
    this.x = x;
    this.y = y;
  }
  getX() {
    return this.x;
  }
  getY() {
    return this.y;
  }
  /*@Override*/
  equals(other) {
    if (other instanceof ResultPoint) {
      const otherPoint = other;
      return this.x === otherPoint.x && this.y === otherPoint.y;
    }
    return false;
  }
  /*@Override*/
  hashCode() {
    return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
  }
  /*@Override*/
  toString() {
    return "(" + this.x + "," + this.y + ")";
  }
  /**
   * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
   * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
   *
   * @param patterns array of three {@code ResultPoint} to order
   */
  static orderBestPatterns(patterns) {
    const zeroOneDistance = this.distance(patterns[0], patterns[1]);
    const oneTwoDistance = this.distance(patterns[1], patterns[2]);
    const zeroTwoDistance = this.distance(patterns[0], patterns[2]);
    let pointA;
    let pointB;
    let pointC;
    if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
      pointB = patterns[0];
      pointA = patterns[1];
      pointC = patterns[2];
    } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
      pointB = patterns[1];
      pointA = patterns[0];
      pointC = patterns[2];
    } else {
      pointB = patterns[2];
      pointA = patterns[0];
      pointC = patterns[1];
    }
    if (this.crossProductZ(pointA, pointB, pointC) < 0) {
      const temp = pointA;
      pointA = pointC;
      pointC = temp;
    }
    patterns[0] = pointA;
    patterns[1] = pointB;
    patterns[2] = pointC;
  }
  /**
   * @param pattern1 first pattern
   * @param pattern2 second pattern
   * @return distance between two points
   */
  static distance(pattern1, pattern2) {
    return MathUtils.distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
  }
  /**
   * Returns the z component of the cross product between vectors BC and BA.
   */
  static crossProductZ(pointA, pointB, pointC) {
    const bX = pointB.x;
    const bY = pointB.y;
    return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
  }
}
class AlignmentPattern extends ResultPoint {
  constructor(posX, posY, estimatedModuleSize) {
    super(posX, posY);
    __publicField(this, "estimatedModuleSize");
    this.estimatedModuleSize = estimatedModuleSize;
  }
  /**
   * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
   * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
   */
  aboutEquals(moduleSize, i, j) {
    if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
      const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
      return moduleSizeDiff <= 1 || moduleSizeDiff <= this.estimatedModuleSize;
    }
    return false;
  }
  /**
   * Combines this object's current estimate of a finder pattern position and module size
   * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
   */
  combineEstimate(i, j, newModuleSize) {
    const combinedX = (this.getX() + j) / 2;
    const combinedY = (this.getY() + i) / 2;
    const combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2;
    return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
  }
}
class AlignmentPatternFinder {
  /**
   * <p>Creates a finder that will look in a portion of the whole image.</p>
   *
   * @param image image to search
   * @param startX left column from which to start searching
   * @param startY top row from which to start searching
   * @param width width of region to search
   * @param height height of region to search
   * @param moduleSize estimated module size so far
   */
  constructor(image, startX, startY, width, height, moduleSize, resultPointCallback) {
    __publicField(this, "image");
    __publicField(this, "startX");
    __publicField(this, "startY");
    __publicField(this, "width");
    __publicField(this, "height");
    __publicField(this, "moduleSize");
    __publicField(this, "resultPointCallback");
    __publicField(this, "possibleCenters");
    __publicField(this, "crossCheckStateCount");
    this.image = image;
    this.startX = startX;
    this.startY = startY;
    this.width = width;
    this.height = height;
    this.moduleSize = moduleSize;
    this.resultPointCallback = resultPointCallback;
    this.possibleCenters = [];
    this.crossCheckStateCount = new Int32Array(3);
  }
  /**
   * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
   * it's pretty performance-critical and so is written to be fast foremost.</p>
   *
   * @return {@link AlignmentPattern} if found
   * @throws NotFoundException if not found
   */
  find() {
    const startX = this.startX;
    const height = this.height;
    const width = this.width;
    const maxJ = startX + width;
    const middleI = this.startY + height / 2;
    const stateCount = new Int32Array(3);
    const image = this.image;
    for (let iGen = 0; iGen < height; iGen++) {
      const i = middleI + ((iGen & 1) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
      stateCount[0] = 0;
      stateCount[1] = 0;
      stateCount[2] = 0;
      let j = startX;
      while (j < maxJ && !image.get(j, i)) {
        j++;
      }
      let currentState = 0;
      while (j < maxJ) {
        if (image.get(j, i)) {
          if (currentState === 1) {
            stateCount[1]++;
          } else {
            if (currentState === 2) {
              if (this.foundPatternCross(stateCount)) {
                const confirmed = this.handlePossibleCenter(stateCount, i, j);
                if (confirmed !== null) {
                  return confirmed;
                }
              }
              stateCount[0] = stateCount[2];
              stateCount[1] = 1;
              stateCount[2] = 0;
              currentState = 1;
            } else {
              stateCount[++currentState]++;
            }
          }
        } else {
          if (currentState === 1) {
            currentState++;
          }
          stateCount[currentState]++;
        }
        j++;
      }
      if (this.foundPatternCross(stateCount)) {
        const confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
        if (confirmed !== null) {
          return confirmed;
        }
      }
    }
    if (this.possibleCenters.length !== 0) {
      return this.possibleCenters[0];
    }
    throw new NotFoundException();
  }
  /**
   * Given a count of black/white/black pixels just seen and an end position,
   * figures the location of the center of this black/white/black run.
   */
  static centerFromEnd(stateCount, end) {
    return end - stateCount[2] - stateCount[1] / 2;
  }
  /**
   * @param stateCount count of black/white/black pixels just read
   * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
   *         used by alignment patterns to be considered a match
   */
  foundPatternCross(stateCount) {
    const moduleSize = this.moduleSize;
    const maxVariance = moduleSize / 2;
    for (let i = 0; i < 3; i++) {
      if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) {
        return false;
      }
    }
    return true;
  }
  /**
   * <p>After a horizontal scan finds a potential alignment pattern, this method
   * "cross-checks" by scanning down vertically through the center of the possible
   * alignment pattern to see if the same proportion is detected.</p>
   *
   * @param startI row where an alignment pattern was detected
   * @param centerJ center of the section that appears to cross an alignment pattern
   * @param maxCount maximum reasonable number of modules that should be
   * observed in any reading state, based on the results of the horizontal scan
   * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
   */
  crossCheckVertical(startI, centerJ, maxCount, originalStateCountTotal) {
    const image = this.image;
    const maxI = image.getHeight();
    const stateCount = this.crossCheckStateCount;
    stateCount[0] = 0;
    stateCount[1] = 0;
    stateCount[2] = 0;
    let i = startI;
    while (i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount) {
      stateCount[1]++;
      i--;
    }
    if (i < 0 || stateCount[1] > maxCount) {
      return NaN;
    }
    while (i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount) {
      stateCount[0]++;
      i--;
    }
    if (stateCount[0] > maxCount) {
      return NaN;
    }
    i = startI + 1;
    while (i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount) {
      stateCount[1]++;
      i++;
    }
    if (i === maxI || stateCount[1] > maxCount) {
      return NaN;
    }
    while (i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount) {
      stateCount[2]++;
      i++;
    }
    if (stateCount[2] > maxCount) {
      return NaN;
    }
    const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
    if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) {
      return NaN;
    }
    return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
  }
  /**
   * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
   * cross check with a vertical scan, and if successful, will see if this pattern had been
   * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
   * found the alignment pattern.</p>
   *
   * @param stateCount reading state module counts from horizontal scan
   * @param i row where alignment pattern may be found
   * @param j end of possible alignment pattern in row
   * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
   */
  handlePossibleCenter(stateCount, i, j) {
    const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
    const centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
    const centerI = this.crossCheckVertical(
      i,
      /*(int) */
      centerJ,
      2 * stateCount[1],
      stateCountTotal
    );
    if (!isNaN(centerI)) {
      const estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3;
      for (const center of this.possibleCenters) {
        if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
          return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
        }
      }
      const point = new AlignmentPattern(centerJ, centerI, estimatedModuleSize);
      this.possibleCenters.push(point);
      if (this.resultPointCallback !== null && this.resultPointCallback !== void 0) {
        this.resultPointCallback.foundPossibleResultPoint(point);
      }
    }
    return null;
  }
}
class FinderPattern extends ResultPoint {
  // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
  //   this(posX, posY, estimatedModuleSize, 1)
  // }
  constructor(posX, posY, estimatedModuleSize, count) {
    super(posX, posY);
    __publicField(this, "estimatedModuleSize");
    __publicField(this, "count");
    this.estimatedModuleSize = estimatedModuleSize;
    this.count = count;
    if (void 0 === count) {
      this.count = 1;
    }
  }
  getEstimatedModuleSize() {
    return this.estimatedModuleSize;
  }
  getCount() {
    return this.count;
  }
  /*
      void incrementCount() {
        this.count++
      }
       */
  /**
   * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
   * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
   */
  aboutEquals(moduleSize, i, j) {
    if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
      const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
      return moduleSizeDiff <= 1 || moduleSizeDiff <= this.estimatedModuleSize;
    }
    return false;
  }
  /**
   * Combines this object's current estimate of a finder pattern position and module size
   * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
   * based on count.
   */
  combineEstimate(i, j, newModuleSize) {
    const combinedCount = this.count + 1;
    const combinedX = (this.count * this.getX() + j) / combinedCount;
    const combinedY = (this.count * this.getY() + i) / combinedCount;
    const combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
    return new FinderPattern(combinedX, combinedY, combinedModuleSize, combinedCount);
  }
}
class FinderPatternInfo {
  constructor(patternCenters) {
    __publicField(this, "bottomLeft");
    __publicField(this, "topLeft");
    __publicField(this, "topRight");
    this.bottomLeft = patternCenters[0];
    this.topLeft = patternCenters[1];
    this.topRight = patternCenters[2];
  }
  getBottomLeft() {
    return this.bottomLeft;
  }
  getTopLeft() {
    return this.topLeft;
  }
  getTopRight() {
    return this.topRight;
  }
}
const _FinderPatternFinder = class _FinderPatternFinder {
  /**
   * <p>Creates a finder that will search the image for three finder patterns.</p>
   *
   * @param image image to search
   */
  // public constructor(image: BitMatrix) {
  //   this(image, null)
  // }
  constructor(image, resultPointCallback) {
    __publicField(this, "image");
    __publicField(this, "resultPointCallback");
    // support up to version 10 for mobile clients
    __publicField(this, "possibleCenters");
    __publicField(this, "hasSkipped");
    __publicField(this, "crossCheckStateCount");
    this.image = image;
    this.resultPointCallback = resultPointCallback;
    this.possibleCenters = [];
    this.crossCheckStateCount = new Int32Array(5);
    this.resultPointCallback = resultPointCallback;
  }
  getImage() {
    return this.image;
  }
  getPossibleCenters() {
    return this.possibleCenters;
  }
  find(hints) {
    const tryHarder = hints !== null && hints !== void 0 && void 0 !== hints.get(DecodeHintType$1.TRY_HARDER);
    const pureBarcode = hints !== null && hints !== void 0 && void 0 !== hints.get(DecodeHintType$1.PURE_BARCODE);
    const image = this.image;
    const maxI = image.getHeight();
    const maxJ = image.getWidth();
    let iSkip = Math.floor(3 * maxI / (4 * _FinderPatternFinder.MAX_MODULES));
    if (iSkip < _FinderPatternFinder.MIN_SKIP || tryHarder) {
      iSkip = _FinderPatternFinder.MIN_SKIP;
    }
    let done = false;
    const stateCount = new Int32Array(5);
    for (let i = iSkip - 1; i < maxI && !done; i += iSkip) {
      stateCount[0] = 0;
      stateCount[1] = 0;
      stateCount[2] = 0;
      stateCount[3] = 0;
      stateCount[4] = 0;
      let currentState = 0;
      for (let j = 0; j < maxJ; j++) {
        if (image.get(j, i)) {
          if ((currentState & 1) === 1) {
            currentState++;
          }
          stateCount[currentState]++;
        } else {
          if ((currentState & 1) === 0) {
            if (currentState === 4) {
              if (_FinderPatternFinder.foundPatternCross(stateCount)) {
                const confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                if (confirmed === true) {
                  iSkip = 2;
                  if (this.hasSkipped === true) {
                    done = this.haveMultiplyConfirmedCenters();
                  } else {
                    const rowSkip = this.findRowSkip();
                    if (rowSkip > stateCount[2]) {
                      i += rowSkip - stateCount[2] - iSkip;
                      j = maxJ - 1;
                    }
                  }
                } else {
                  stateCount[0] = stateCount[2];
                  stateCount[1] = stateCount[3];
                  stateCount[2] = stateCount[4];
                  stateCount[3] = 1;
                  stateCount[4] = 0;
                  currentState = 3;
                  continue;
                }
                currentState = 0;
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                stateCount[3] = 0;
                stateCount[4] = 0;
              } else {
                stateCount[0] = stateCount[2];
                stateCount[1] = stateCount[3];
                stateCount[2] = stateCount[4];
                stateCount[3] = 1;
                stateCount[4] = 0;
                currentState = 3;
              }
            } else {
              stateCount[++currentState]++;
            }
          } else {
            stateCount[currentState]++;
          }
        }
      }
      if (_FinderPatternFinder.foundPatternCross(stateCount)) {
        const confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
        if (confirmed === true) {
          iSkip = stateCount[0];
          if (this.hasSkipped) {
            done = this.haveMultiplyConfirmedCenters();
          }
        }
      }
    }
    const patternInfo = this.selectBestPatterns();
    ResultPoint.orderBestPatterns(patternInfo);
    return new FinderPatternInfo(patternInfo);
  }
  /**
   * Given a count of black/white/black/white/black pixels just seen and an end position,
   * figures the location of the center of this run.
   */
  static centerFromEnd(stateCount, end) {
    return end - stateCount[4] - stateCount[3] - stateCount[2] / 2;
  }
  /**
   * @param stateCount count of black/white/black/white/black pixels just read
   * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
   *         used by finder patterns to be considered a match
   */
  static foundPatternCross(stateCount) {
    let totalModuleSize = 0;
    for (let i = 0; i < 5; i++) {
      const count = stateCount[i];
      if (count === 0) {
        return false;
      }
      totalModuleSize += count;
    }
    if (totalModuleSize < 7) {
      return false;
    }
    const moduleSize = totalModuleSize / 7;
    const maxVariance = moduleSize / 2;
    return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
  }
  getCrossCheckStateCount() {
    const crossCheckStateCount = this.crossCheckStateCount;
    crossCheckStateCount[0] = 0;
    crossCheckStateCount[1] = 0;
    crossCheckStateCount[2] = 0;
    crossCheckStateCount[3] = 0;
    crossCheckStateCount[4] = 0;
    return crossCheckStateCount;
  }
  /**
   * After a vertical and horizontal scan finds a potential finder pattern, this method
   * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
   * finder pattern to see if the same proportion is detected.
   *
   * @param startI row where a finder pattern was detected
   * @param centerJ center of the section that appears to cross a finder pattern
   * @param maxCount maximum reasonable number of modules that should be
   *  observed in any reading state, based on the results of the horizontal scan
   * @param originalStateCountTotal The original state count total.
   * @return true if proportions are withing expected limits
   */
  crossCheckDiagonal(startI, centerJ, maxCount, originalStateCountTotal) {
    const stateCount = this.getCrossCheckStateCount();
    let i = 0;
    const image = this.image;
    while (startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)) {
      stateCount[2]++;
      i++;
    }
    if (startI < i || centerJ < i) {
      return false;
    }
    while (startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) && stateCount[1] <= maxCount) {
      stateCount[1]++;
      i++;
    }
    if (startI < i || centerJ < i || stateCount[1] > maxCount) {
      return false;
    }
    while (startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) && stateCount[0] <= maxCount) {
      stateCount[0]++;
      i++;
    }
    if (stateCount[0] > maxCount) {
      return false;
    }
    const maxI = image.getHeight();
    const maxJ = image.getWidth();
    i = 1;
    while (startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)) {
      stateCount[2]++;
      i++;
    }
    if (startI + i >= maxI || centerJ + i >= maxJ) {
      return false;
    }
    while (startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) && stateCount[3] < maxCount) {
      stateCount[3]++;
      i++;
    }
    if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) {
      return false;
    }
    while (startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) && stateCount[4] < maxCount) {
      stateCount[4]++;
      i++;
    }
    if (stateCount[4] >= maxCount) {
      return false;
    }
    const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
    return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && _FinderPatternFinder.foundPatternCross(stateCount);
  }
  /**
   * <p>After a horizontal scan finds a potential finder pattern, this method
   * "cross-checks" by scanning down vertically through the center of the possible
   * finder pattern to see if the same proportion is detected.</p>
   *
   * @param startI row where a finder pattern was detected
   * @param centerJ center of the section that appears to cross a finder pattern
   * @param maxCount maximum reasonable number of modules that should be
   * observed in any reading state, based on the results of the horizontal scan
   * @return vertical center of finder pattern, or {@link Float#NaN} if not found
   */
  crossCheckVertical(startI, centerJ, maxCount, originalStateCountTotal) {
    const image = this.image;
    const maxI = image.getHeight();
    const stateCount = this.getCrossCheckStateCount();
    let i = startI;
    while (i >= 0 && image.get(centerJ, i)) {
      stateCount[2]++;
      i--;
    }
    if (i < 0) {
      return NaN;
    }
    while (i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount) {
      stateCount[1]++;
      i--;
    }
    if (i < 0 || stateCount[1] > maxCount) {
      return NaN;
    }
    while (i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount) {
      stateCount[0]++;
      i--;
    }
    if (stateCount[0] > maxCount) {
      return NaN;
    }
    i = startI + 1;
    while (i < maxI && image.get(centerJ, i)) {
      stateCount[2]++;
      i++;
    }
    if (i === maxI) {
      return NaN;
    }
    while (i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount) {
      stateCount[3]++;
      i++;
    }
    if (i === maxI || stateCount[3] >= maxCount) {
      return NaN;
    }
    while (i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount) {
      stateCount[4]++;
      i++;
    }
    if (stateCount[4] >= maxCount) {
      return NaN;
    }
    const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
    if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) {
      return NaN;
    }
    return _FinderPatternFinder.foundPatternCross(stateCount) ? _FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
  }
  /**
   * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
   * except it reads horizontally instead of vertically. This is used to cross-cross
   * check a vertical cross check and locate the real center of the alignment pattern.</p>
   */
  crossCheckHorizontal(startJ, centerI, maxCount, originalStateCountTotal) {
    const image = this.image;
    const maxJ = image.getWidth();
    const stateCount = this.getCrossCheckStateCount();
    let j = startJ;
    while (j >= 0 && image.get(j, centerI)) {
      stateCount[2]++;
      j--;
    }
    if (j < 0) {
      return NaN;
    }
    while (j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount) {
      stateCount[1]++;
      j--;
    }
    if (j < 0 || stateCount[1] > maxCount) {
      return NaN;
    }
    while (j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount) {
      stateCount[0]++;
      j--;
    }
    if (stateCount[0] > maxCount) {
      return NaN;
    }
    j = startJ + 1;
    while (j < maxJ && image.get(j, centerI)) {
      stateCount[2]++;
      j++;
    }
    if (j === maxJ) {
      return NaN;
    }
    while (j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount) {
      stateCount[3]++;
      j++;
    }
    if (j === maxJ || stateCount[3] >= maxCount) {
      return NaN;
    }
    while (j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount) {
      stateCount[4]++;
      j++;
    }
    if (stateCount[4] >= maxCount) {
      return NaN;
    }
    const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
    if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) {
      return NaN;
    }
    return _FinderPatternFinder.foundPatternCross(stateCount) ? _FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
  }
  /**
   * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
   * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
   * with another horizontal scan. This is needed primarily to locate the real horizontal
   * center of the pattern in cases of extreme skew.
   * And then we cross-cross-cross check with another diagonal scan.</p>
   *
   * <p>If that succeeds the finder pattern location is added to a list that tracks
   * the number of times each location has been nearly-matched as a finder pattern.
   * Each additional find is more evidence that the location is in fact a finder
   * pattern center
   *
   * @param stateCount reading state module counts from horizontal scan
   * @param i row where finder pattern may be found
   * @param j end of possible finder pattern in row
   * @param pureBarcode true if in "pure barcode" mode
   * @return true if a finder pattern candidate was found this time
   */
  handlePossibleCenter(stateCount, i, j, pureBarcode) {
    const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
    let centerJ = _FinderPatternFinder.centerFromEnd(stateCount, j);
    let centerI = this.crossCheckVertical(
      i,
      /*(int) */
      Math.floor(centerJ),
      stateCount[2],
      stateCountTotal
    );
    if (!isNaN(centerI)) {
      centerJ = this.crossCheckHorizontal(
        /*(int) */
        Math.floor(centerJ),
        /*(int) */
        Math.floor(centerI),
        stateCount[2],
        stateCountTotal
      );
      if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(
        /*(int) */
        Math.floor(centerI),
        /*(int) */
        Math.floor(centerJ),
        stateCount[2],
        stateCountTotal
      ))) {
        const estimatedModuleSize = stateCountTotal / 7;
        let found = false;
        const possibleCenters = this.possibleCenters;
        for (let index = 0, length = possibleCenters.length; index < length; index++) {
          const center = possibleCenters[index];
          if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
            possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
            found = true;
            break;
          }
        }
        if (!found) {
          const point = new FinderPattern(centerJ, centerI, estimatedModuleSize);
          possibleCenters.push(point);
          if (this.resultPointCallback !== null && this.resultPointCallback !== void 0) {
            this.resultPointCallback.foundPossibleResultPoint(point);
          }
        }
        return true;
      }
    }
    return false;
  }
  /**
   * @return number of rows we could safely skip during scanning, based on the first
   *         two finder patterns that have been located. In some cases their position will
   *         allow us to infer that the third pattern must lie below a certain point farther
   *         down in the image.
   */
  findRowSkip() {
    const max = this.possibleCenters.length;
    if (max <= 1) {
      return 0;
    }
    let firstConfirmedCenter = null;
    for (const center of this.possibleCenters) {
      if (center.getCount() >= _FinderPatternFinder.CENTER_QUORUM) {
        if (firstConfirmedCenter == null) {
          firstConfirmedCenter = center;
        } else {
          this.hasSkipped = true;
          return (
            /*(int) */
            Math.floor(
              (Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2
            )
          );
        }
      }
    }
    return 0;
  }
  /**
   * @return true iff we have found at least 3 finder patterns that have been detected
   *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
   *         candidates is "pretty similar"
   */
  haveMultiplyConfirmedCenters() {
    let confirmedCount = 0;
    let totalModuleSize = 0;
    const max = this.possibleCenters.length;
    for (const pattern of this.possibleCenters) {
      if (pattern.getCount() >= _FinderPatternFinder.CENTER_QUORUM) {
        confirmedCount++;
        totalModuleSize += pattern.getEstimatedModuleSize();
      }
    }
    if (confirmedCount < 3) {
      return false;
    }
    const average = totalModuleSize / max;
    let totalDeviation = 0;
    for (const pattern of this.possibleCenters) {
      totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
    }
    return totalDeviation <= 0.05 * totalModuleSize;
  }
  /**
   * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
   *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
   *         size differs from the average among those patterns the least
   * @throws NotFoundException if 3 such finder patterns do not exist
   */
  selectBestPatterns() {
    const startSize = this.possibleCenters.length;
    if (startSize < 3) {
      throw new NotFoundException();
    }
    const possibleCenters = this.possibleCenters;
    let average;
    if (startSize > 3) {
      let totalModuleSize = 0;
      let square = 0;
      for (const center of this.possibleCenters) {
        const size = center.getEstimatedModuleSize();
        totalModuleSize += size;
        square += size * size;
      }
      average = totalModuleSize / startSize;
      let stdDev = Math.sqrt(square / startSize - average * average);
      possibleCenters.sort(
        /**
         * <p>Orders by furthest from average</p>
         */
        // FurthestFromAverageComparator implements Comparator<FinderPattern>
        (center1, center2) => {
          const dA = Math.abs(center2.getEstimatedModuleSize() - average);
          const dB = Math.abs(center1.getEstimatedModuleSize() - average);
          return dA < dB ? -1 : dA > dB ? 1 : 0;
        }
      );
      const limit = Math.max(0.2 * average, stdDev);
      for (let i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++) {
        const pattern = possibleCenters[i];
        if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
          possibleCenters.splice(i, 1);
          i--;
        }
      }
    }
    if (possibleCenters.length > 3) {
      let totalModuleSize = 0;
      for (const possibleCenter of possibleCenters) {
        totalModuleSize += possibleCenter.getEstimatedModuleSize();
      }
      average = totalModuleSize / possibleCenters.length;
      possibleCenters.sort(
        /**
         * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
         */
        // CenterComparator implements Comparator<FinderPattern>
        (center1, center2) => {
          if (center2.getCount() === center1.getCount()) {
            const dA = Math.abs(center2.getEstimatedModuleSize() - average);
            const dB = Math.abs(center1.getEstimatedModuleSize() - average);
            return dA < dB ? 1 : dA > dB ? -1 : 0;
          } else {
            return center2.getCount() - center1.getCount();
          }
        }
      );
      possibleCenters.splice(3);
    }
    return [possibleCenters[0], possibleCenters[1], possibleCenters[2]];
  }
};
__publicField(_FinderPatternFinder, "CENTER_QUORUM", 2);
__publicField(_FinderPatternFinder, "MIN_SKIP", 3);
// 1 pixel/module times 3 modules/center
__publicField(_FinderPatternFinder, "MAX_MODULES", 57);
let FinderPatternFinder = _FinderPatternFinder;
class Detector {
  constructor(image) {
    __publicField(this, "image");
    __publicField(this, "resultPointCallback");
    this.image = image;
  }
  getImage() {
    return this.image;
  }
  getResultPointCallback() {
    return this.resultPointCallback;
  }
  /**
   * <p>Detects a QR Code in an image.</p>
   *
   * @return {@link DetectorResult} encapsulating results of detecting a QR Code
   * @throws NotFoundException if QR Code cannot be found
   * @throws FormatException if a QR Code cannot be decoded
   */
  // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
  //   return detect(null)
  // }
  /**
   * <p>Detects a QR Code in an image.</p>
   *
   * @param hints optional hints to detector
   * @return {@link DetectorResult} encapsulating results of detecting a QR Code
   * @throws NotFoundException if QR Code cannot be found
   * @throws FormatException if a QR Code cannot be decoded
   */
  detect(hints) {
    this.resultPointCallback = hints === null || hints === void 0 ? null : (
      /*(ResultPointCallback) */
      hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK)
    );
    const finder = new FinderPatternFinder(this.image, this.resultPointCallback);
    const info = finder.find(hints);
    return this.processFinderPatternInfo(info);
  }
  processFinderPatternInfo(info) {
    const topLeft = info.getTopLeft();
    const topRight = info.getTopRight();
    const bottomLeft = info.getBottomLeft();
    const moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
    if (moduleSize < 1) {
      throw new NotFoundException("No pattern found in proccess finder.");
    }
    const dimension = Detector.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
    const provisionalVersion = Version.getProvisionalVersionForDimension(dimension);
    const modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
    let alignmentPattern = null;
    if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
      const bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
      const bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
      const correctionToTopLeft = 1 - 3 / modulesBetweenFPCenters;
      const estAlignmentX = (
        /*(int) */
        Math.floor(
          topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX())
        )
      );
      const estAlignmentY = (
        /*(int) */
        Math.floor(
          topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY())
        )
      );
      for (let i = 4; i <= 16; i <<= 1) {
        try {
          alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
          break;
        } catch (re) {
          if (!(re instanceof NotFoundException)) {
            throw re;
          }
        }
      }
    }
    const transform = Detector.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
    const bits = Detector.sampleGrid(this.image, transform, dimension);
    let points;
    if (alignmentPattern === null) {
      points = [bottomLeft, topLeft, topRight];
    } else {
      points = [bottomLeft, topLeft, topRight, alignmentPattern];
    }
    return new DetectorResult(bits, points);
  }
  static createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension) {
    const dimMinusThree = dimension - 3.5;
    let bottomRightX;
    let bottomRightY;
    let sourceBottomRightX;
    let sourceBottomRightY;
    if (alignmentPattern !== null) {
      bottomRightX = alignmentPattern.getX();
      bottomRightY = alignmentPattern.getY();
      sourceBottomRightX = dimMinusThree - 3;
      sourceBottomRightY = sourceBottomRightX;
    } else {
      bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
      bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
      sourceBottomRightX = dimMinusThree;
      sourceBottomRightY = dimMinusThree;
    }
    return PerspectiveTransform.quadrilateralToQuadrilateral(
      3.5,
      3.5,
      dimMinusThree,
      3.5,
      sourceBottomRightX,
      sourceBottomRightY,
      3.5,
      dimMinusThree,
      topLeft.getX(),
      topLeft.getY(),
      topRight.getX(),
      topRight.getY(),
      bottomRightX,
      bottomRightY,
      bottomLeft.getX(),
      bottomLeft.getY()
    );
  }
  static sampleGrid(image, transform, dimension) {
    const sampler = GridSamplerInstance.getInstance();
    return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
  }
  /**
   * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
   * of the finder patterns and estimated module size.</p>
   */
  static computeDimension(topLeft, topRight, bottomLeft, moduleSize) {
    const tltrCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, topRight) / moduleSize);
    const tlblCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, bottomLeft) / moduleSize);
    let dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
    switch (dimension & 3) {
      case 0:
        dimension++;
        break;
      case 2:
        dimension--;
        break;
      case 3:
        throw new NotFoundException("Dimensions could be not found.");
    }
    return dimension;
  }
  /**
   * <p>Computes an average estimated module size based on estimated derived from the positions
   * of the three finder patterns.</p>
   *
   * @param topLeft detected top-left finder pattern center
   * @param topRight detected top-right finder pattern center
   * @param bottomLeft detected bottom-left finder pattern center
   * @return estimated module size
   */
  calculateModuleSize(topLeft, topRight, bottomLeft) {
    return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2;
  }
  /**
   * <p>Estimates module size based on two finder patterns -- it uses
   * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
   * width of each, measuring along the axis between their centers.</p>
   */
  calculateModuleSizeOneWay(pattern, otherPattern) {
    const moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(
      /*(int) */
      Math.floor(pattern.getX()),
      /*(int) */
      Math.floor(pattern.getY()),
      /*(int) */
      Math.floor(otherPattern.getX()),
      /*(int) */
      Math.floor(otherPattern.getY())
    );
    const moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(
      /*(int) */
      Math.floor(otherPattern.getX()),
      /*(int) */
      Math.floor(otherPattern.getY()),
      /*(int) */
      Math.floor(pattern.getX()),
      /*(int) */
      Math.floor(pattern.getY())
    );
    if (isNaN(moduleSizeEst1)) {
      return moduleSizeEst2 / 7;
    }
    if (isNaN(moduleSizeEst2)) {
      return moduleSizeEst1 / 7;
    }
    return (moduleSizeEst1 + moduleSizeEst2) / 14;
  }
  /**
   * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
   * a finder pattern by looking for a black-white-black run from the center in the direction
   * of another point (another finder pattern center), and in the opposite direction too.
   */
  sizeOfBlackWhiteBlackRunBothWays(fromX, fromY, toX, toY) {
    let result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
    let scale = 1;
    let otherToX = fromX - (toX - fromX);
    if (otherToX < 0) {
      scale = fromX / /*(float) */
      (fromX - otherToX);
      otherToX = 0;
    } else if (otherToX >= this.image.getWidth()) {
      scale = (this.image.getWidth() - 1 - fromX) / /*(float) */
      (otherToX - fromX);
      otherToX = this.image.getWidth() - 1;
    }
    let otherToY = (
      /*(int) */
      Math.floor(fromY - (toY - fromY) * scale)
    );
    scale = 1;
    if (otherToY < 0) {
      scale = fromY / /*(float) */
      (fromY - otherToY);
      otherToY = 0;
    } else if (otherToY >= this.image.getHeight()) {
      scale = (this.image.getHeight() - 1 - fromY) / /*(float) */
      (otherToY - fromY);
      otherToY = this.image.getHeight() - 1;
    }
    otherToX = /*(int) */
    Math.floor(fromX + (otherToX - fromX) * scale);
    result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
    return result - 1;
  }
  /**
   * <p>This method traces a line from a point in the image, in the direction towards another point.
   * It begins in a black region, and keeps going until it finds white, then black, then white again.
   * It reports the distance from the start to this point.</p>
   *
   * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
   * may be skewed or rotated.</p>
   */
  sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY) {
    const steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
    if (steep) {
      let temp = fromX;
      fromX = fromY;
      fromY = temp;
      temp = toX;
      toX = toY;
      toY = temp;
    }
    const dx = Math.abs(toX - fromX);
    const dy = Math.abs(toY - fromY);
    let error = -dx / 2;
    const xstep = fromX < toX ? 1 : -1;
    const ystep = fromY < toY ? 1 : -1;
    let state = 0;
    const xLimit = toX + xstep;
    for (let x = fromX, y = fromY; x !== xLimit; x += xstep) {
      const realX = steep ? y : x;
      const realY = steep ? x : y;
      if (state === 1 === this.image.get(realX, realY)) {
        if (state === 2) {
          return MathUtils.distance(x, y, fromX, fromY);
        }
        state++;
      }
      error += dy;
      if (error > 0) {
        if (y === toY) {
          break;
        }
        y += ystep;
        error -= dx;
      }
    }
    if (state === 2) {
      return MathUtils.distance(toX + xstep, toY, fromX, fromY);
    }
    return NaN;
  }
  /**
   * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
   * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
   *
   * @param overallEstModuleSize estimated module size so far
   * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
   * @param estAlignmentY y coordinate of above
   * @param allowanceFactor number of pixels in all directions to search from the center
   * @return {@link AlignmentPattern} if found, or null otherwise
   * @throws NotFoundException if an unexpected error occurs during detection
   */
  findAlignmentInRegion(overallEstModuleSize, estAlignmentX, estAlignmentY, allowanceFactor) {
    const allowance = (
      /*(int) */
      Math.floor(allowanceFactor * overallEstModuleSize)
    );
    const alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
    const alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
    if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) {
      throw new NotFoundException("Alignment top exceeds estimated module size.");
    }
    const alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
    const alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
    if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) {
      throw new NotFoundException("Alignment bottom exceeds estimated module size.");
    }
    const alignmentFinder = new AlignmentPatternFinder(
      this.image,
      alignmentAreaLeftX,
      alignmentAreaTopY,
      alignmentAreaRightX - alignmentAreaLeftX,
      alignmentAreaBottomY - alignmentAreaTopY,
      overallEstModuleSize,
      this.resultPointCallback
    );
    return alignmentFinder.find();
  }
}
const _QRCodeReader = class _QRCodeReader {
  constructor() {
    __publicField(this, "decoder", new Decoder());
  }
  getDecoder() {
    return this.decoder;
  }
  /**
   * Locates and decodes a QR code in an image.
   *
   * @return a representing: string the content encoded by the QR code
   * @throws NotFoundException if a QR code cannot be found
   * @throws FormatException if a QR code cannot be decoded
   * @throws ChecksumException if error correction fails
   */
  /*@Override*/
  // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
  //   return this.decode(image, null)
  // }
  /*@Override*/
  decode(image, hints) {
    let decoderResult;
    let points;
    if (hints !== void 0 && hints !== null && void 0 !== hints.get(DecodeHintType$1.PURE_BARCODE)) {
      const bits = _QRCodeReader.extractPureBits(image.getBlackMatrix());
      decoderResult = this.decoder.decodeBitMatrix(bits, hints);
      points = _QRCodeReader.NO_POINTS;
    } else {
      const detectorResult = new Detector(image.getBlackMatrix()).detect(hints);
      decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
      points = detectorResult.getPoints();
    }
    if (decoderResult.getOther() instanceof QRCodeDecoderMetaData) {
      decoderResult.getOther().applyMirroredCorrection(points);
    }
    const result = new Result(
      decoderResult.getText(),
      decoderResult.getRawBytes(),
      void 0,
      points,
      BarcodeFormat$1.QR_CODE,
      void 0
    );
    const byteSegments = decoderResult.getByteSegments();
    if (byteSegments !== null) {
      result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
    }
    const ecLevel = decoderResult.getECLevel();
    if (ecLevel !== null) {
      result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
    }
    if (decoderResult.hasStructuredAppend()) {
      result.putMetadata(
        ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE,
        decoderResult.getStructuredAppendSequenceNumber()
      );
      result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
    }
    return result;
  }
  /*@Override*/
  reset() {
  }
  /**
   * This method detects a code in a "pure" image -- that is, pure monochrome image
   * which contains only an unrotated, unskewed, image of a code, with some white border
   * around it. This is a specialized method that works exceptionally fast in this special
   * case.
   *
   * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
   */
  static extractPureBits(image) {
    const leftTopBlack = image.getTopLeftOnBit();
    const rightBottomBlack = image.getBottomRightOnBit();
    if (leftTopBlack === null || rightBottomBlack === null) {
      throw new NotFoundException();
    }
    const moduleSize = this.moduleSize(leftTopBlack, image);
    let top = leftTopBlack[1];
    let bottom = rightBottomBlack[1];
    let left = leftTopBlack[0];
    let right = rightBottomBlack[0];
    if (left >= right || top >= bottom) {
      throw new NotFoundException();
    }
    if (bottom - top !== right - left) {
      right = left + (bottom - top);
      if (right >= image.getWidth()) {
        throw new NotFoundException();
      }
    }
    const matrixWidth = Math.round((right - left + 1) / moduleSize);
    const matrixHeight = Math.round((bottom - top + 1) / moduleSize);
    if (matrixWidth <= 0 || matrixHeight <= 0) {
      throw new NotFoundException();
    }
    if (matrixHeight !== matrixWidth) {
      throw new NotFoundException();
    }
    const nudge = (
      /*(int) */
      Math.floor(moduleSize / 2)
    );
    top += nudge;
    left += nudge;
    const nudgedTooFarRight = left + /*(int) */
    Math.floor((matrixWidth - 1) * moduleSize) - right;
    if (nudgedTooFarRight > 0) {
      if (nudgedTooFarRight > nudge) {
        throw new NotFoundException();
      }
      left -= nudgedTooFarRight;
    }
    const nudgedTooFarDown = top + /*(int) */
    Math.floor((matrixHeight - 1) * moduleSize) - bottom;
    if (nudgedTooFarDown > 0) {
      if (nudgedTooFarDown > nudge) {
        throw new NotFoundException();
      }
      top -= nudgedTooFarDown;
    }
    const bits = new BitMatrix(matrixWidth, matrixHeight);
    for (let y = 0; y < matrixHeight; y++) {
      const iOffset = top + /*(int) */
      Math.floor(y * moduleSize);
      for (let x = 0; x < matrixWidth; x++) {
        if (image.get(left + /*(int) */
        Math.floor(x * moduleSize), iOffset)) {
          bits.set(x, y);
        }
      }
    }
    return bits;
  }
  static moduleSize(leftTopBlack, image) {
    const height = image.getHeight();
    const width = image.getWidth();
    let x = leftTopBlack[0];
    let y = leftTopBlack[1];
    let inBlack = true;
    let transitions = 0;
    while (x < width && y < height) {
      if (inBlack !== image.get(x, y)) {
        if (++transitions === 5) {
          break;
        }
        inBlack = !inBlack;
      }
      x++;
      y++;
    }
    if (x === width || y === height) {
      throw new NotFoundException();
    }
    return (x - leftTopBlack[0]) / 7;
  }
};
__publicField(_QRCodeReader, "NO_POINTS", new Array());
let QRCodeReader = _QRCodeReader;
class BrowserQRCodeReader extends BrowserCodeReader {
  /**
   * Creates an instance of BrowserQRCodeReader.
   * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
   */
  constructor(timeBetweenScansMillis = 500) {
    super(new QRCodeReader(), timeBetweenScansMillis);
  }
}
class StandardCharsets {
}
__publicField(StandardCharsets, "ISO_8859_1", CharacterSetECI.ISO8859_1);
var EncodeHintType;
(function(EncodeHintType2) {
  EncodeHintType2[EncodeHintType2["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
  EncodeHintType2[EncodeHintType2["CHARACTER_SET"] = 1] = "CHARACTER_SET";
  EncodeHintType2[EncodeHintType2["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
  EncodeHintType2[EncodeHintType2["DATA_MATRIX_COMPACT"] = 3] = "DATA_MATRIX_COMPACT";
  EncodeHintType2[EncodeHintType2["MIN_SIZE"] = 4] = "MIN_SIZE";
  EncodeHintType2[EncodeHintType2["MAX_SIZE"] = 5] = "MAX_SIZE";
  EncodeHintType2[EncodeHintType2["MARGIN"] = 6] = "MARGIN";
  EncodeHintType2[EncodeHintType2["PDF417_COMPACT"] = 7] = "PDF417_COMPACT";
  EncodeHintType2[EncodeHintType2["PDF417_COMPACTION"] = 8] = "PDF417_COMPACTION";
  EncodeHintType2[EncodeHintType2["PDF417_DIMENSIONS"] = 9] = "PDF417_DIMENSIONS";
  EncodeHintType2[EncodeHintType2["AZTEC_LAYERS"] = 10] = "AZTEC_LAYERS";
  EncodeHintType2[EncodeHintType2["QR_VERSION"] = 11] = "QR_VERSION";
  EncodeHintType2[EncodeHintType2["GS1_FORMAT"] = 12] = "GS1_FORMAT";
  EncodeHintType2[EncodeHintType2["FORCE_C40"] = 13] = "FORCE_C40";
})(EncodeHintType || (EncodeHintType = {}));
async function getCamera(constraints) {
  constraints.audio = false;
  return await navigator.mediaDevices.getUserMedia(constraints);
}
function QrCodeScanner(props) {
  const nodeRef = useRef(null);
  const { stream, timeBetweenScansMillis, onSuccess, onError = console.error, className } = props;
  const codeReader = useMemo(() => new BrowserQRCodeReader(timeBetweenScansMillis), [timeBetweenScansMillis]);
  useEffect(() => {
    if (nodeRef.current == null)
      return;
    codeReader.decodeOnceFromStream(stream, nodeRef.current).then(onSuccess, onError);
    return () => {
      stream.getTracks().forEach((track) => {
        track.stop();
      });
    };
  }, [stream, nodeRef, codeReader, onSuccess, onError]);
  return /* @__PURE__ */ jsx("video", { className: clsx("object-cover", className), ref: nodeRef });
}
const webAuthnState = proxy({
  backupDeviceData: void 0,
  selectedEmoji: void 0,
  pendingTxHash: void 0,
  qrCodeData: "",
  mediaStream: ref({ inner: void 0 })
});
const setBackupDeviceData = (data) => {
  webAuthnState.backupDeviceData = data;
};
const setQrCodeData = (data) => {
  webAuthnState.qrCodeData = data;
};
const setPendingTx = (tx) => {
  webAuthnState.pendingTxHash = tx;
};
const setMediaStream = (mediaStream) => {
  webAuthnState.mediaStream.inner = mediaStream;
};
const setSignData = (signData) => {
  webAuthnState.signData = signData;
};
function useWebAuthnState() {
  return useSnapshot(webAuthnState);
}
function exceptionToMessage(err) {
  if (err.name === "NotAllowedError") {
    return {
      title: "No Camera Permission",
      desc: "Scanning QR code requires access to the camera. Please enable camera permission."
    };
  } else if (err.name === "NotFoundError") {
    return {
      title: "No Camera Found",
      desc: "No available camera was found to scan QR code. Please try pasting the data directly."
    };
  } else {
    return {
      title: "Unknown Error",
      desc: "Unknown error happened. Please try again or paste the data directly."
    };
  }
}
function DomException({ err, className }) {
  const { title, desc } = exceptionToMessage(err);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "flex w-full flex-row items-start justify-start gap-2 rounded-xl border border-amber-300/40 bg-amber-300/5 p-3",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(WarningOutlineIcon, { className: "h-5 w-5 flex-none text-yellow-500" }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ jsx("div", { className: "text-[16px] leading-[20px] text-yellow-700", children: title }),
          /* @__PURE__ */ jsx("div", { className: "shrink grow basis-0 text-[14px] font-normal text-yellow-700", children: desc })
        ] })
      ]
    }
  );
}
function verifyData(data, isTestNet) {
  const connectDID = new ConnectDID(isTestNet);
  let result = true;
  try {
    connectDID.decodeQRCode(data);
  } catch (err) {
    result = false;
  }
  return result;
}
function InputSignature({ transitionRef, transitionStyle }) {
  const { goNext, goBack, goTo, onClose } = useSimpleRouter();
  const { walletSnap } = useWalletState();
  const connectDID = useMemo(() => new ConnectDID(walletSnap.isTestNet), [walletSnap.isTestNet]);
  const [permissionError, setPermissionError] = useState(void 0);
  const [requiringPermission, setRequiringPermission] = useState(false);
  const { qrCodeData: data } = useWebAuthnState();
  const onChange = useCallback((e) => {
    setQrCodeData(e.target.value);
  }, []);
  const onPaste = useCallback(() => {
    navigator.clipboard.readText().then(setQrCodeData, console.error);
  }, []);
  const webAuthnService = useWebAuthnService(walletSnap.isTestNet);
  const onClickScan = useCallback(async () => {
    try {
      setRequiringPermission(true);
      const media = await getCamera({ video: { facingMode: "environment" } });
      setMediaStream(media);
      goTo("ShowScanner");
    } catch (err) {
      if (err instanceof DOMException) {
        setPermissionError(err);
      } else {
        console.error(err);
      }
    } finally {
      setRequiringPermission(false);
    }
  }, [setPermissionError, setRequiringPermission, goTo]);
  const isValidData = verifyData(data, walletSnap.isTestNet);
  const [isLoading, setIsLoading] = useState(false);
  const onConfirmInput = useCallback(async () => {
    setIsLoading(true);
    const decodeData = connectDID.decodeQRCode(data);
    setBackupDeviceData(decodeData);
    try {
      if (walletSnap.address === void 0 || decodeData.ckbAddr === void 0 || decodeData.name === void 0) {
        throw new Error("unreachable");
      }
      const res = await webAuthnService.buildTransaction({
        master_ckb_address: walletSnap.address,
        slave_ckb_address: decodeData.ckbAddr,
        operation: "add"
      });
      if (res.err_no !== 0)
        throw new Error(res.err_msg);
      setSignData(res.data);
      setIsLoading(false);
      goNext == null ? void 0 : goNext();
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  }, [connectDID, data, walletSnap.address, webAuthnService, goNext]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: "Add Trusted Device",
        goBack,
        onClose,
        className: "bg-blur z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsx("div", { className: "text-center text-[14px] leading-tight text-neutral-700", children: "Scan the QR code generated by your another device using this device, or paste the data here." }),
          /* @__PURE__ */ jsxs("div", { className: "relative mt-6 w-full", children: [
            /* @__PURE__ */ jsx(
              "textarea",
              {
                className: "block h-[146px] w-full resize-none rounded-xl border border-stone-300/20 bg-neutral-100 py-3 pl-4 pr-3 text-[16px] text-neutral-700 focus:border-emerald-400 focus:bg-white focus:outline-offset-1 focus:outline-emerald-400/20 focus:ring-0",
                placeholder: "Paste data or scan QR code",
                value: data,
                onChange
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "absolute bottom-0 right-0 p-3 align-middle", children: [
              /* @__PURE__ */ jsx("div", { className: "inline-flex h-[30px] w-[30px] items-center justify-center  rounded-lg border border-slate-600/10 bg-white", children: /* @__PURE__ */ jsx(PasteIcon, { onClick: onPaste, className: "w-[16px] cursor-pointer" }) }),
              requiringPermission ? /* @__PURE__ */ jsx("div", { className: "ml-4 inline-flex h-[30px] w-[30px] items-center justify-center  rounded-lg border border-slate-600/10 bg-white", children: /* @__PURE__ */ jsx(LoadingIcon, { className: "animation-rotate-360-deg w-[18px] cursor-pointer" }) }) : /* @__PURE__ */ jsx("div", { className: "ml-4 inline-flex h-[30px] w-[30px] items-center justify-center  rounded-lg border border-slate-600/10 bg-white", children: /* @__PURE__ */ jsx(ScanIcon, { onClick: onClickScan, className: "w-[18px] cursor-pointer" }) })
            ] })
          ] }),
          data.length > 0 && !isValidData && /* @__PURE__ */ jsx("div", { className: "mt-1 w-full text-[14px] font-normal text-red-400", children: "Incorrect data" }),
          permissionError != null && /* @__PURE__ */ jsx(DomException, { className: "mt-6", err: permissionError }),
          /* @__PURE__ */ jsx(
            Button,
            {
              disabled: data.length === 0 || !isValidData,
              className: "mt-6 w-full",
              size: ButtonSize.middle,
              shape: ButtonShape.round,
              onClick: onConfirmInput,
              loading: isLoading,
              children: "Next"
            }
          )
        ]
      }
    )
  ] });
}
function Emoji({ name, ...rest }) {
  return /* @__PURE__ */ jsx("img", { ...rest, src: emojisTemp[name] || "" });
}
function FinalConfirm({ transitionRef, transitionStyle }) {
  var _a2, _b;
  const { goNext, goBack, onClose } = useSimpleRouter();
  const { walletSnap } = useWalletState();
  const webAuthnState2 = useWebAuthnState();
  const [checked, setChecked] = useState(false);
  const walletSDK = useContext(WalletSDKContext);
  const webAuthnService = useWebAuthnService(walletSnap.isTestNet);
  const sendTransactionMutation = useMutation({
    retry: false,
    mutationFn: async (signData) => {
      var _a3, _b2;
      const signList = await (walletSDK == null ? void 0 : walletSDK.signTxList({
        ...signData,
        // eslint-disable-next-line
        sign_list: (_a3 = signData.sign_list) == null ? void 0 : _a3.map(({ sign_type, sign_msg }) => ({
          sign_type,
          sign_msg: sign_msg.replace("0x", "")
        }))
      }));
      const res = await webAuthnService.sendTransaction({
        sign_key: signData.sign_key,
        sign_list: signList == null ? void 0 : signList.sign_list,
        sign_address: (_b2 = walletSnap.deviceData) == null ? void 0 : _b2.ckbAddr
      });
      if (res.err_no !== 0)
        throw new Error(res.err_msg);
      return res.data;
    }
  });
  const onClickNext = async () => {
    const signData = webAuthnState2.signData;
    sendTransactionMutation.mutate(signData);
  };
  const deviceEmoji = useMemo(() => {
    var _a3, _b2;
    return ((_a3 = webAuthnState2.backupDeviceData) == null ? void 0 : _a3.device) || ((_b2 = webAuthnState2.backupDeviceData) == null ? void 0 : _b2.name.split("-")[0]) || "";
  }, [webAuthnState2.backupDeviceData]);
  useEffect(() => {
    var _a3;
    if ((_a3 = sendTransactionMutation.data) == null ? void 0 : _a3.hash) {
      setPendingTx(sendTransactionMutation.data.hash);
      goNext == null ? void 0 : goNext();
    }
  }, [(_a2 = sendTransactionMutation.data) == null ? void 0 : _a2.hash]);
  useEffect(() => {
    if (sendTransactionMutation.isError) {
      const error = sendTransactionMutation.error;
      const handleErrorRes = handleError(error);
      if (handleErrorRes.isHandle) {
        if (handleErrorRes.title && handleErrorRes.message) {
          createTips({
            title: handleErrorRes.title,
            content: handleErrorRes.message
          });
        }
      } else {
        createTips({
          title: `Tips`,
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          content: error.code ? `${error.code}: ${error.message}` : error.message ? error.message : error.toString()
        });
      }
    }
  }, [sendTransactionMutation.error, sendTransactionMutation.isError]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: "Add Trusted Device",
        onClose,
        goBack,
        className: "bg-blur z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "relative flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsxs("div", { className: "mt-6 flex w-full items-center gap-4 rounded-2xl border border-slate-300/40 bg-gray-50 p-6", children: [
            /* @__PURE__ */ jsx("div", { className: "flex-none text-center text-neutral-700", children: /* @__PURE__ */ jsx(Emoji, { name: deviceEmoji, className: "w-8" }) }),
            /* @__PURE__ */ jsx("div", { className: "h-[19px] text-[16px] font-semibold leading-[19px] text-neutral-700", children: (_b = webAuthnState2.backupDeviceData) == null ? void 0 : _b.name })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "mt-16 inline-flex w-full items-center justify-center gap-3", children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "checkbox",
                className: "h-5 w-5 cursor-pointer rounded-md border-2 border-slate-300/40 text-emerald-400 focus:ring-transparent",
                checked,
                onChange: (e) => {
                  setChecked(e.target.checked);
                }
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "text-[14px] text-neutral-700", children: "I Trust This Device." })
          ] }),
          /* @__PURE__ */ jsx(
            Button,
            {
              disabled: !checked,
              className: "mt-6 w-full",
              size: ButtonSize.middle,
              shape: ButtonShape.round,
              loading: sendTransactionMutation.isLoading,
              onClick: onClickNext,
              children: "Next"
            }
          )
        ]
      }
    )
  ] });
}
function TransactionStatus({ transitionRef, transitionStyle }) {
  const { walletSnap } = useWalletState();
  const webAuthnState2 = useWebAuthnState();
  const { goTo, goNext, onClose } = useSimpleRouter();
  const webAuthnService = useWebAuthnService(walletSnap.isTestNet);
  const query = useQuery({
    networkMode: "always",
    queryKey: ["TransactionStatus", webAuthnState2.pendingTxHash],
    cacheTime: 0,
    refetchInterval: 1e4,
    queryFn: async () => {
      const res = await webAuthnService.getTransactionStatus(webAuthnState2.pendingTxHash);
      if (res.err_no !== 0)
        throw new Error(res.err_msg);
      return res.data;
    }
  });
  useEffect(() => {
    var _a2, _b, _c;
    if (query.isLoading)
      return;
    if (((_a2 = query.data) == null ? void 0 : _a2.hash) === webAuthnState2.pendingTxHash) {
      if (((_b = query.data) == null ? void 0 : _b.status) === 1) {
        setWalletState({
          deviceList: walletSnap.deviceList.concat([
            {
              address: webAuthnState2.backupDeviceData.ckbAddr,
              notes: webAuthnState2.backupDeviceData.name
            }
          ])
        });
        goNext == null ? void 0 : goNext();
      } else if (((_c = query.data) == null ? void 0 : _c.status) === -1) {
        goTo("TransactionFailed");
      }
    } else {
      goTo("TransactionFailed");
    }
  }, [query.data, query.isLoading, webAuthnState2.pendingTxHash]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        onClose,
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "relative flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsx(LoadingIconGradient, { className: "animation-rotate-360-deg h-[64px] w-[64px] text-emerald-500" }),
          /* @__PURE__ */ jsx("div", { className: "mt-4 text-center text-[16px] font-bold text-neutral-700", children: "Adding Trusted Device" }),
          /* @__PURE__ */ jsx("div", { className: "mt-3 text-center text-[16px] leading-normal text-neutral-700", children: "Approximately 3 minutes." }),
          /* @__PURE__ */ jsxs("div", { className: "mb-8 mt-3 text-[12px] font-normal leading-[12px]", children: [
            /* @__PURE__ */ jsx(
              "a",
              {
                target: "_blank",
                rel: "noreferrer",
                href: `https://${walletSnap.isTestNet ? "pudge." : ""}explorer.nervos.org/transaction/${webAuthnState2.pendingTxHash ?? ""}`,
                className: "inline-block align-middle text-font-secondary",
                children: collapseString(webAuthnState2.pendingTxHash, 6, 3)
              }
            ),
            /* @__PURE__ */ jsx(ArrowLeftIcon, { className: "h-[12px] rotate-180 text-font-secondary" })
          ] })
        ]
      }
    )
  ] });
}
function TransactionSucceeded({ transitionRef, transitionStyle }) {
  const { goNext, onClose } = useSimpleRouter();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        onClose,
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "relative flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsx(SafeIcon, { className: "h-[80px] w-[80px] text-green-500" }),
          /* @__PURE__ */ jsx("div", { className: "mt-3 text-center text-[16px] font-bold text-neutral-700", children: "New Trusted Device Added" }),
          /* @__PURE__ */ jsx("div", { className: "mt-3 text-center text-[16px] leading-normal text-neutral-700", children: "The new trusted device has full control over this address." }),
          /* @__PURE__ */ jsx(
            Button,
            {
              className: "mb-8 mt-4 min-w-[130px] px-5",
              size: ButtonSize.middle,
              shape: ButtonShape.round,
              onClick: goNext,
              children: "Done"
            }
          )
        ]
      }
    )
  ] });
}
function ShowScanner({ transitionRef, transitionStyle }) {
  const webAuthnState2 = useWebAuthnState();
  const { goBack, onClose } = useSimpleRouter();
  const onSuccess = useCallback(
    (result) => {
      setQrCodeData(result.getText());
      goBack();
    },
    [goBack]
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        goBack,
        onClose,
        title: "Scan QR Code",
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "w-full px-6 pb-6 pt-[76px]", ref: transitionRef, style: transitionStyle, children: /* @__PURE__ */ jsx(
      QrCodeScanner,
      {
        stream: webAuthnState2.mediaStream.inner,
        className: clsx("h-[400px] w-full rounded-xl bg-black"),
        onSuccess
      }
    ) })
  ] });
}
function TransactionFailed({ transitionRef, transitionStyle }) {
  const { onClose } = useSimpleRouter();
  const webAuthnState2 = useWebAuthnState();
  const { walletSnap } = useWalletState();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        onClose,
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "relative flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: [
          /* @__PURE__ */ jsx(Exlaimation, { className: "h-[80px] w-[80px] text-red-500" }),
          /* @__PURE__ */ jsx("div", { className: "mt-3 text-center text-[16px] font-bold text-red-500", children: "Failed" }),
          /* @__PURE__ */ jsxs("div", { className: "mt-3 text-center text-[16px] leading-normal text-neutral-700", children: [
            /* @__PURE__ */ jsx("div", { children: "The contract verification failed." }),
            /* @__PURE__ */ jsx("div", { children: "Please try again." })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "mb-8 mt-3 text-[12px] font-normal leading-[12px] text-gray-400", children: [
            /* @__PURE__ */ jsx(
              "a",
              {
                target: "_blank",
                rel: "noreferrer",
                href: `https://${walletSnap.isTestNet ? "pudge." : ""}explorer.nervos.org/transaction/${webAuthnState2.pendingTxHash ?? ""}`,
                className: "inline-block align-middle",
                children: collapseString(webAuthnState2.pendingTxHash, 6, 3)
              }
            ),
            /* @__PURE__ */ jsx(ArrowLeftIcon, { className: "h-[12px] rotate-180" })
          ] })
        ]
      }
    )
  ] });
}
function Sheet({ isOpen, children, customRootId, zIndex = "z-[10]", className }) {
  const [removeDOM, setRemoveDOM] = useState(!isOpen);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      setRemoveDOM(false);
    } else {
      setTimeout(() => {
        setRemoveDOM(true);
        document.body.style.overflow = "auto";
      }, 150);
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  return removeDOM ? null : /* @__PURE__ */ jsxs(Portal, { customRootId, className, children: [
    /* @__PURE__ */ jsx(Mask, { zIndex, isOpen }),
    /* @__PURE__ */ jsx("div", { className: clsx("fixed left-0 top-0 flex h-full w-full items-end justify-center", zIndex), children })
  ] });
}
const passkey = {
  icon: void 0,
  name: CustomChain.passkey,
  coinType: CoinType.ckb
};
const Connect = ({ transitionStyle, transitionRef }) => {
  const [currentLogin, setCurrentLogin] = useState("");
  const [isSupportWebAuthn, setIsSupportWebAuthn] = useState(true);
  const walletSDK = useContext(WalletSDKContext);
  const router = useSimpleRouter();
  const { walletSnap } = useWalletState();
  const showChainList = () => {
    if (currentLogin) {
      return;
    }
    router == null ? void 0 : router.goTo("ChainList");
  };
  const showAddressList = () => {
    router == null ? void 0 : router.goTo("AddressList");
  };
  const onClose = router == null ? void 0 : router.onClose;
  const showPasskey = useMemo(() => {
    return !walletSDK.onlyEth && (walletSnap.customChains && walletSnap.customChains.length > 0 ? walletSnap.customChains.includes(CustomChain.passkey) : true);
  }, [walletSDK.onlyEth, walletSnap.customChains]);
  useEffect(() => {
    checkWebAuthnSupport().then((res) => {
      setIsSupportWebAuthn(res);
    }).catch((err) => {
      console.error(err);
      setIsSupportWebAuthn(false);
    });
  }, []);
  const onLogin = async (chain) => {
    const { name, coinType } = chain;
    if (currentLogin) {
      return;
    }
    try {
      setCurrentLogin(name);
      await walletSDK.init({
        coinType,
        walletName: name
      });
      await walletSDK.connect();
      const { ckbAddresses, loggedInSelectAddress } = walletSnap;
      if (name === CustomChain.passkey && ckbAddresses && ckbAddresses.length > 0 && loggedInSelectAddress) {
        showAddressList();
      } else {
        onClose();
      }
    } catch (error) {
      console.error(error);
      const handleErrorRes = handleError(error);
      if (handleErrorRes.isHandle) {
        if (handleErrorRes.title && handleErrorRes.message) {
          createTips({
            title: handleErrorRes.title,
            content: handleErrorRes.message
          });
        }
      } else {
        createTips({
          title: `Tips`,
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          content: error.code ? `${error.code}: ${error.message}` : error.message ? error.message : error.toString()
        });
      }
    } finally {
      setCurrentLogin("");
    }
  };
  const close = () => {
    onClose();
    setCurrentLogin("");
  };
  const viewPasskeyDocs = () => {
    window.open("https://developer.apple.com/passkeys/");
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        className: "z-10 mt-0.5 w-full-4px bg-white p-6",
        title: "Connect",
        onClose: close,
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "w-full px-6 pb-6 pt-[76px]", style: transitionStyle, ref: transitionRef, children: [
      showPasskey ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center pt-[82px]", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            className: "w-[218px]",
            loading: currentLogin === passkey.name,
            disabled: !isSupportWebAuthn,
            variant: ButtonVariant.passkey,
            size: ButtonSize.super,
            shape: ButtonShape.round,
            onClick: async () => {
              await onLogin(passkey);
            },
            children: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center text-xl font-bold", children: [
              currentLogin === passkey.name ? null : /* @__PURE__ */ jsx(FaceIcon, { className: "mr-1.5 h-6 w-6 text-white" }),
              "Continue"
            ] })
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "mt-4 w-[216px] text-center text-sm font-normal text-font-tips", children: [
          "Most friendly and secure way base on",
          " ",
          /* @__PURE__ */ jsx(
            "span",
            {
              className: "cursor-pointer border-b border-dashed border-black hover:opacity-70",
              onClick: viewPasskeyDocs,
              children: "Passkey"
            }
          ),
          "."
        ] }),
        /* @__PURE__ */ jsx(
          Alert,
          {
            className: clsx("mt-5", isSupportWebAuthn ? "invisible" : "visible"),
            type: AlertType.warning,
            icon: /* @__PURE__ */ jsx(NoticeIcon, { className: "h-[18px] w-[18px] text-[#FFB02E]" }),
            children: "This device or browser unsupported. Try connect by social or wallet."
          }
        )
      ] }) : null,
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: clsx(
            "mt-11 box-border flex h-[52px] cursor-pointer items-center justify-between rounded-2xl border border-[#B6C4D966] px-4 py-2 hover:bg-secondary active:bg-secondary-active",
            { "cursor-no-drop": !!currentLogin }
          ),
          onClick: showChainList,
          children: [
            /* @__PURE__ */ jsx("span", { className: "text-base font-bold", children: "Continue with wallets" }),
            /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center", children: [
              /* @__PURE__ */ jsxs("span", { className: "relative mr-1 inline-flex w-[102px]", children: [
                /* @__PURE__ */ jsx("img", { className: "h-6 w-6 rounded-full border-2 border-white bg-white", src: EthIcon, alt: "ETH" }),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: "absolute left-[16px] h-6 w-6 rounded-full border-2 border-white bg-white",
                    src: BscIcon,
                    alt: "BSC"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: "absolute left-[32px] h-6 w-6 rounded-full border-2 border-white bg-white",
                    src: PolygonIcon,
                    alt: "Polygon"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: "absolute left-[48px] h-6 w-6 rounded-full border-2 border-white bg-white",
                    src: TronIcon,
                    alt: "Tron"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: "absolute left-[64px] h-6 w-6 rounded-full border-2 border-white bg-white",
                    src: DogecoinIcon,
                    alt: "Dogecoin"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: "absolute left-[80px] h-6 w-6 rounded-full border-2 border-white bg-white",
                    src: TorusIcon,
                    alt: "Torus"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(ArrowLeftIcon, { className: "h-2.5 w-2.5 rotate-180 text-font-secondary" })
            ] })
          ]
        }
      )
    ] })
  ] });
};
function AddressQRCode({ transitionRef, transitionStyle }) {
  const { walletSnap } = useWalletState();
  const { onClose, goBack } = useSimpleRouter();
  const close = () => {
    onClose == null ? void 0 : onClose();
  };
  const back = () => {
    goBack == null ? void 0 : goBack();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: "QR Code",
        onClose: close,
        goBack: back,
        className: "bg-blur z-10 mt-0.5 w-full-4px bg-white p-6",
        style: { ...transitionStyle, position: "fixed", top: 0 }
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex w-full flex-col items-center justify-start px-6 pb-6 pt-[76px]",
        ref: transitionRef,
        style: transitionStyle,
        children: /* @__PURE__ */ jsx("div", { className: "relative my-3 mb-9 h-[270px] w-[270px]", children: /* @__PURE__ */ jsx(QRCode, { data: walletSnap.address }) })
      }
    )
  ] });
}
const routes = {
  Connect: {
    el: /* @__PURE__ */ jsx(Connect, {}, "Connect"),
    next: "ChainList"
  },
  ChainList: {
    el: /* @__PURE__ */ jsx(ChainList, {}, "ChainList"),
    prev: "Connect",
    next: "WalletList"
  },
  WalletList: {
    el: /* @__PURE__ */ jsx(WalletList, {}, "WalletList"),
    prev: "ChainList",
    next: "WalletConnectQrCode"
  },
  WalletConnectQrCode: {
    el: /* @__PURE__ */ jsx(WalletConnectQrCode, {}, "WalletConnectQrCode"),
    prev: "WalletList"
  },
  AddressList: {
    el: /* @__PURE__ */ jsx(AddressList, {}, "AddressList"),
    prev: "ChainList"
  },
  LoggedIn: {
    el: /* @__PURE__ */ jsx(LoggedIn, {}, "LoggedIn")
  },
  AddressQRCode: {
    el: /* @__PURE__ */ jsx(AddressQRCode, {}, "AddressQRCode"),
    prev: "LoggedIn"
  },
  ShowQRCode: {
    el: /* @__PURE__ */ jsx(ShowQRCode, {}, "ShowQRCode"),
    prev: "LoggedIn",
    next: "InputSignature"
  },
  InputSignature: {
    el: /* @__PURE__ */ jsx(InputSignature, {}, "InputSignature"),
    prev: "ShowQRCode",
    next: "FinalConfirm"
  },
  FinalConfirm: {
    el: /* @__PURE__ */ jsx(FinalConfirm, {}, "FinalConfirm"),
    prev: "InputSignature",
    next: "TransactionStatus"
  },
  TransactionStatus: {
    el: /* @__PURE__ */ jsx(TransactionStatus, {}, "TransactionStatus"),
    next: "TransactionSucceeded"
  },
  TransactionSucceeded: {
    el: /* @__PURE__ */ jsx(TransactionSucceeded, {}, "TransactionSucceeded"),
    next: "LoggedIn"
  },
  TransactionFailed: {
    el: /* @__PURE__ */ jsx(TransactionFailed, {}, "TransactionFailed")
  },
  ShowScanner: {
    el: /* @__PURE__ */ jsx(ShowScanner, {}, "ShowScanner")
  }
};
const WalletSDKContext = createContext(null);
const queryClient = new QueryClient();
const ConnectWallet = ({ visible, walletSDK, initComponent = "Connect" }) => {
  const [isOpen, setIsOpen] = useState(visible);
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= 768);
  const onClose = () => {
    setIsOpen(false);
  };
  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
  const el = /* @__PURE__ */ jsx(SimpleRouter, { routes, initialRouteName: initComponent, onClose });
  return /* @__PURE__ */ jsx(WalletSDKContext.Provider, { value: walletSDK, children: /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children: isMobile2 ? /* @__PURE__ */ jsx(Sheet, { isOpen, customRootId: "ConnectWalletSheet", children: /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        "relative box-border w-full overflow-hidden rounded-t-[32px] bg-[unset]",
        isOpen ? "animation-fade-in-up" : "animation-fade-out-down"
      ),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: clsx(
            "box-border w-full overflow-hidden rounded-t-[32px] border-2 border-b-0 border-solid border-[#5262791A] bg-white"
          ),
          children: el
        }
      )
    }
  ) }) : /* @__PURE__ */ jsx(Modal, { isOpen, customRootId: "ConnectWalletModal", children: /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        "relative box-border w-[92%] max-w-[400px] overflow-hidden rounded-[32px] bg-[unset]",
        isOpen ? "animation-fade-in-up" : "animation-fade-out-down"
      ),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: clsx(
            "box-border w-full overflow-hidden rounded-[32px] border-2 border-solid border-[#5262791A] bg-white"
          ),
          children: el
        }
      )
    }
  ) }) }) });
};
Axios.defaults.withCredentials = true;
class WalletSDK {
  constructor({
    isTestNet,
    wagmiConfig,
    gtag,
    event
  }) {
    __publicField(this, "walletConnector");
    __publicField(this, "walletSigner");
    __publicField(this, "walletTransaction");
    __publicField(this, "eventListener");
    __publicField(this, "context");
    __publicField(this, "onlyEth", false);
    this.context = new WalletContext({ isTestNet, wagmiConfig, gtag, event });
  }
  async init({
    coinType,
    walletName
  } = {}) {
    var _a2, _b;
    await this.context.retrieveProvider({
      coinType,
      walletName
    });
    (_a2 = this.eventListener) == null ? void 0 : _a2.removeEvents();
    this.walletConnector = WalletHandlerFactory.createConnector(this.context);
    this.walletSigner = WalletHandlerFactory.createSigner(this.context);
    this.walletTransaction = WalletHandlerFactory.createTransaction(this.context);
    this.eventListener = WalletHandlerFactory.createEventListener(this.context);
    (_b = this.eventListener) == null ? void 0 : _b.listenEvents();
  }
  async connect({ ignoreEvent } = { ignoreEvent: false }) {
    var _a2;
    await ((_a2 = this.walletConnector) == null ? void 0 : _a2.connect({ ignoreEvent }));
    this.context.reportEvent("click", {
      category: "wallet-bridge",
      label: "connect wallet",
      coinType: this.context.coinType,
      walletName: this.context.walletName,
      value: 1,
      nonInteraction: true
    });
  }
  async disconnect() {
    var _a2, _b;
    const isInit = await this.initWallet({ involution: false, isDisconnect: true });
    if (!isInit) {
      throw new CustomError(errno.failedToInitializeWallet, "disconnect: Please initialize wallet first");
    }
    (_a2 = this.eventListener) == null ? void 0 : _a2.removeEvents();
    await ((_b = this.walletConnector) == null ? void 0 : _b.disconnect());
  }
  connectWallet(params = {}) {
    const shadowDomRoot2 = getShadowDomRoot();
    this.onlyEth = params.onlyEth ?? false;
    const connectWalletInstance = React.createElement(ConnectWallet, {
      visible: true,
      walletSDK: this,
      ...params
    });
    createRoot(shadowDomRoot2).render(connectWalletInstance);
  }
  async connectWalletAndSignData(params) {
    return await new Promise((resolve) => {
      if (params.signData) {
        setLoginCacheState({ signDataParams: params.signData });
        this.connectWallet();
        void this.context.once(EventEnum.Signature).then((res) => {
          if (res !== void 0) {
            setLoginCacheState({ signDataParams: null });
          }
          resolve({ signature: res });
          this.context.emitEvent(EventEnum.Connect);
        });
      }
    });
  }
  onInvolution(involution) {
    if (involution) {
      this.connectWallet();
    }
  }
  async initWallet({
    involution = true,
    isDisconnect = false
  } = {}) {
    try {
      const { protocol, coinType, deviceData, walletName } = snapshot(walletState);
      if (walletName && protocol && coinType) {
        await this.init();
        if (protocol === WalletProtocol.webAuthn && deviceData) {
          if (!isDisconnect) {
            void getAuthorizeInfo().then(() => {
              void backupDeviceData();
            });
            void getMastersAddress();
          }
          return true;
        } else {
          if (involution) {
            await this.connect({ ignoreEvent: true });
          }
          return true;
        }
      }
      this.onInvolution(involution);
      return false;
    } catch (error) {
      console.error(error);
      this.onInvolution(involution);
      return false;
    }
  }
  async signData(data, options) {
    var _a2;
    const isInit = await this.initWallet();
    if (!isInit && !this.walletSigner) {
      throw new CustomError(errno.failedToInitializeWallet, "signData: Please initialize wallet first");
    }
    return await ((_a2 = this.walletSigner) == null ? void 0 : _a2.signData(data, options));
  }
  async sendTransaction(data) {
    var _a2;
    const isInit = await this.initWallet();
    if (!isInit && !this.walletTransaction) {
      throw new CustomError(errno.failedToInitializeWallet, "sendTransaction: Please initialize wallet first");
    }
    return await ((_a2 = this.walletTransaction) == null ? void 0 : _a2.sendTrx(data));
  }
  async signTx(signInfo, options) {
    let signDataRes = await this.signData(signInfo.sign_msg, options);
    if (signDataRes && this.context.coinType && isDogecoinChain(this.context.coinType)) {
      signDataRes = convertTpUTXOSignature(signDataRes);
    }
    if (signDataRes) {
      signInfo.sign_msg = signDataRes;
    }
    await sleep(1e3);
    return signInfo;
  }
  async signTxList(txs, options) {
    const isInit = await this.initWallet();
    if (!isInit) {
      throw new CustomError(errno.failedToInitializeWallet, "signTxList: Please initialize wallet first");
    }
    let provider;
    if (this.context.protocol === WalletProtocol.webAuthn) {
      if (options == null ? void 0 : options.provider) {
        provider = options == null ? void 0 : options.provider;
      } else {
        provider = await this.context.provider.requestWaitingPage((err) => {
          console.error(err);
          throw new CustomError(err.code, err.message);
        });
      }
    }
    if ("sign_list" in txs) {
      for (const signItem of txs.sign_list) {
        if (!(signItem.sign_msg && signItem.sign_type !== SIGN_TYPE.noSign)) {
          continue;
        }
        if (signItem.sign_type === SIGN_TYPE.eth712 && txs.mm_json != null) {
          const mmJson = cloneDeep(txs.mm_json);
          mmJson.message.digest = signItem.sign_msg;
          const signDataRes = await this.signData(mmJson, { isEIP712: true });
          if (signDataRes && mmJson.domain.chainId) {
            signItem.sign_msg = signDataRes + mmJsonHashAndChainIdHex(mmJson, mmJson.domain.chainId);
          }
          await sleep(1e3);
        } else {
          await this.signTx(signItem, { provider });
        }
      }
    } else if ("list" in txs) {
      for (const list of txs.list) {
        for (const signItem of list.sign_list) {
          if (!(signItem.sign_msg && signItem.sign_type !== SIGN_TYPE.noSign)) {
            continue;
          }
          await this.signTx(signItem, { provider });
        }
      }
    }
    const { deviceData } = snapshot(walletState);
    if (deviceData == null ? void 0 : deviceData.ckbAddr) {
      txs.sign_address = deviceData.ckbAddr;
    }
    return txs;
  }
  async initSignContext() {
    const isInit = await this.initWallet();
    if (!isInit) {
      throw new CustomError(errno.failedToInitializeWallet, "initSignContext: Please initialize wallet first");
    }
    let provider;
    if (this.context.protocol === WalletProtocol.webAuthn) {
      const timestamp = Date.now();
      provider = await this.context.provider.requestWaitingPage((err) => {
        console.error(err);
        throw new CustomError(err.code, err.message);
      });
      console.log("requestWaitingPage", Date.now() - timestamp);
    }
    return {
      signTxList: async (txs) => {
        return await this.signTxList(txs, { provider });
      },
      signData: async (data, options) => {
        return await this.signData(data, { ...options, provider });
      },
      onFailed: (provider == null ? void 0 : provider.onFailed) || (async (k) => {
        console.log(k);
        return void 0;
      }),
      onClose: (provider == null ? void 0 : provider.onClose) || (async () => {
        return void 0;
      })
    };
  }
  async _verifyPasskeySignature({ message, signature }) {
    var _a2, _b, _c, _d, _e;
    const isInit = await this.initWallet();
    if (!isInit) {
      throw new CustomError(errno.failedToInitializeWallet, "_verifyPasskeySignature: Please initialize wallet first");
    }
    const { isTestNet, address, deviceData } = snapshot(walletState);
    const api = isTestNet ? WebAuthnTestApi : WebAuthnApi;
    const res = await Axios.post(
      `${api}/v1/webauthn/verify`,
      {
        master_addr: address,
        backup_addr: deviceData == null ? void 0 : deviceData.ckbAddr,
        msg: message,
        signature
      },
      {
        headers: isTestNet ? { ...CfAccessClient } : {}
      }
    );
    if (((_a2 = res.data) == null ? void 0 : _a2.err_no) !== errno.success) {
      throw new CustomError((_b = res.data) == null ? void 0 : _b.err_no, (_c = res.data) == null ? void 0 : _c.err_msg);
    }
    return (_e = (_d = res.data) == null ? void 0 : _d.data) == null ? void 0 : _e.is_valid;
  }
}
class Wallet {
  constructor({
    isTestNet = false,
    loggedInSelectAddress = true,
    customChains = [],
    customWallets = [],
    wagmiConfig,
    gtag,
    event
  }) {
    __publicField(this, "walletSDK");
    __publicField(this, "useWalletState", useWalletState);
    __publicField(this, "getWalletState", getWalletState);
    setWalletState({ isTestNet, loggedInSelectAddress, customChains, customWallets });
    this.walletSDK = new WalletSDK({ isTestNet, wagmiConfig, gtag, event });
  }
  connectWallet(params = {}) {
    this.walletSDK.connectWallet(params);
  }
  async connectWalletAndSignData(params) {
    return await this.walletSDK.connectWalletAndSignData(params);
  }
  loggedInfo() {
    this.walletSDK.connectWallet({ initComponent: "LoggedIn" });
  }
  async sendTransaction(data) {
    return await this.walletSDK.sendTransaction(data);
  }
  async initWallet({ involution = true } = {}) {
    return await this.walletSDK.initWallet({ involution });
  }
  async initSignContext() {
    return await this.walletSDK.initSignContext();
  }
  async _verifyPasskeySignature(params) {
    return await this.walletSDK._verifyPasskeySignature(params);
  }
}
export {
  Alert,
  AlertType,
  ArrowLeftIcon,
  ArrowRightTopIcon,
  BSC,
  BTC,
  Button,
  ButtonShape,
  ButtonSize,
  ButtonVariant,
  CKB,
  CKB_TOKEN_DECIMAL_PLACES,
  CYCLE_CALL_FUNCTION_TIME,
  CfAccessClient,
  ChainId,
  ChainIdToChainInfoMap,
  ChainIdToCoinTypeMap,
  ChainIdToCoinTypeTestNetMap,
  ChainType,
  CloseIcon,
  CoinType,
  CoinTypeToChainIdMap,
  CoinTypeToChainMap,
  CoinTypeToGenesisHash,
  CoinTypeToTestNetChainIdMap,
  CoinTypeToTorusHostMap,
  CoinTypeToTorusHostTestNetMap,
  CopyIcon,
  CustomChain,
  CustomWallet,
  DOGE,
  DeviceIcon,
  DevicesIcon,
  Dialog,
  DisconnectIcon,
  DotbitIndexerApi,
  DotbitIndexerTestApi,
  ETH,
  Exlaimation,
  FaceIcon,
  Header,
  InfoIcon,
  LoadingIcon,
  LoadingIconGradient,
  MoreIcon,
  NervosIcon,
  NoticeIcon,
  PasteIcon,
  PlusIcon,
  Polygon,
  QRCodeIcon,
  RevokeIcon,
  SIGN_TYPE,
  SafeIcon,
  ScanIcon,
  SwapTransition,
  SwitchIcon,
  TOKEN_DECIMAL_PLACES,
  TRON,
  Tag,
  TagVariant,
  Tips,
  TronLinkRequestAccountsResponseCode,
  Wallet,
  WalletProtocol,
  WarningIcon,
  WarningOutlineIcon,
  WebAuthnApi,
  WebAuthnTestApi,
  backupDeviceData,
  chainIdHexToNumber,
  checkICloudPasskeySupport,
  checkWebAuthnSupport,
  collapseString,
  convertTpUTXOSignature,
  copyText,
  createTips,
  getAuthorizeInfo,
  getDotbitAlias,
  getMastersAddress,
  getShadowDomRoot,
  getWalletDeepLink,
  getWalletState,
  hexToNumber,
  isDogecoinChain,
  isHexStrict,
  isMetaMask,
  loadScript,
  mmJsonHashAndChainIdHex,
  numberToHex,
  openDeepLink,
  resetWalletState,
  setWalletState,
  shouldUseWalletConnect,
  sizeClasses,
  sleep,
  smartOpen,
  toBN,
  toChecksumAddress,
  toDecimal,
  useWalletState,
  utf8ToHex,
  walletState
};
